// Generated by scripts/content/assemble-audio.py. Published files are immutable.
export const ORDINARY_RECORDINGS = {
    "The fish leading our meeting is wearing a large hat and holding a gift.": {
        "file": "bda18c67ea264e05207d.mp3",
        "bank": "en-oo1",
        "durationMs": 4700
    },
    "The fish leading our meeting is wearing a large hat and holding a glass.": {
        "file": "3874bfda9393a522f9a1.mp3",
        "bank": "en-oo1",
        "durationMs": 4700
    },
    "The fish leading our meeting is wearing a small hat and holding a gift.": {
        "file": "a252860f29f37a532be3.mp3",
        "bank": "en-oo1",
        "durationMs": 4675
    },
    "The fish leading our meeting is wearing a small hat and holding a glass.": {
        "file": "27fcedfd3e1b3cb520d2.mp3",
        "bank": "en-oo1",
        "durationMs": 4725
    },
    "The fish leading our meeting is wearing a long scarf and holding a book.": {
        "file": "bde5d20e135cf40d38fc.mp3",
        "bank": "en-oo1",
        "durationMs": 4625
    },
    "The fish leading our meeting is wearing a long scarf and holding a computer.": {
        "file": "72bbd8866a98fe6b7f60.mp3",
        "bank": "en-oo1",
        "durationMs": 5000
    },
    "The fish leading our meeting is wearing a short scarf and holding a book.": {
        "file": "10108a6b8fa912cdec06.mp3",
        "bank": "en-oo1",
        "durationMs": 4625
    },
    "The fish leading our meeting is wearing a short scarf and holding a computer.": {
        "file": "e8cc60cad9b9137360ce.mp3",
        "bank": "en-oo1",
        "durationMs": 4975
    },
    "The fish leading our meeting is wearing round glasses and holding a hat.": {
        "file": "4b6ea58c2f9112977e4b.mp3",
        "bank": "en-oo1",
        "durationMs": 4775
    },
    "The fish leading our meeting is wearing round glasses and holding a shoe.": {
        "file": "58fdf894b2d1466432ed.mp3",
        "bank": "en-oo1",
        "durationMs": 4800
    },
    "The fish leading our meeting is wearing square glasses and holding a hat.": {
        "file": "a25ac14f5596aab44b70.mp3",
        "bank": "en-oo1",
        "durationMs": 4725
    },
    "The fish leading our meeting is wearing square glasses and holding a shoe.": {
        "file": "f4e6227e3194e27820a6.mp3",
        "bank": "en-oo1",
        "durationMs": 4750
    },
    "The fish leading our meeting is wearing a jacket with two pockets and holding a picture.": {
        "file": "d23e09d7f673b786537a.mp3",
        "bank": "en-oo1",
        "durationMs": 5550
    },
    "The fish leading our meeting is wearing a jacket with two pockets and holding a cat.": {
        "file": "ab7c0ab0621346421651.mp3",
        "bank": "en-oo1",
        "durationMs": 5426
    },
    "The fish leading our meeting is wearing a jacket with four pockets and holding a picture.": {
        "file": "8e1630a9e49948e2393d.mp3",
        "bank": "en-oo1",
        "durationMs": 5625
    },
    "The fish leading our meeting is wearing a jacket with four pockets and holding a cat.": {
        "file": "e8bd8cd90de580e42111.mp3",
        "bank": "en-oo1",
        "durationMs": 5500
    },
    "The fish leading our meeting is wearing a shirt with long sleeves and holding a fish.": {
        "file": "06763d5a06b10e8f0f08.mp3",
        "bank": "en-oo1",
        "durationMs": 5450
    },
    "The fish leading our meeting is wearing a shirt with long sleeves and holding an egg.": {
        "file": "eb6d8fd942b29c4e5e19.mp3",
        "bank": "en-oo1",
        "durationMs": 5325
    },
    "The fish leading our meeting is wearing a shirt with short sleeves and holding a fish.": {
        "file": "b8e696c399d040fd5875.mp3",
        "bank": "en-oo1",
        "durationMs": 5375
    },
    "The fish leading our meeting is wearing a shirt with short sleeves and holding an egg.": {
        "file": "7da55e8d3c4bf3cb5faf.mp3",
        "bank": "en-oo1",
        "durationMs": 5250
    },
    "Our printer has a day off, with a glass on its head.": {
        "file": "d5cae4659e5d48a4c2cf.mp3",
        "bank": "en-oo1",
        "durationMs": 3500
    },
    "Our printer has a day off, with a glass under its arm.": {
        "file": "af51f5c46e79e323a5d6.mp3",
        "bank": "en-oo1",
        "durationMs": 3600
    },
    "Our printer has a day off, with a bag on its head.": {
        "file": "f84ba841b4478f88c114.mp3",
        "bank": "en-oo1",
        "durationMs": 3425
    },
    "Our printer has a day off, with a bag under its arm.": {
        "file": "f950fb32e69bb5206567.mp3",
        "bank": "en-oo1",
        "durationMs": 3450
    },
    "Our printer has a day off, with a gift on its head.": {
        "file": "c6a2ba6b8349cb9a4f52.mp3",
        "bank": "en-oo1",
        "durationMs": 3500
    },
    "Our printer has a day off, with a gift under its arm.": {
        "file": "98d68ff150a1a87aac97.mp3",
        "bank": "en-oo1",
        "durationMs": 3600
    },
    "Our printer has a day off, with a fish on its head.": {
        "file": "c9888e79e88f278ad442.mp3",
        "bank": "en-oo1",
        "durationMs": 3450
    },
    "Our printer has a day off, with a fish under its arm.": {
        "file": "ee08ee744532548ec684.mp3",
        "bank": "en-oo1",
        "durationMs": 3500
    },
    "Our printer has a day off, with a box on its head.": {
        "file": "0c5ab705d2458e5ef7b6.mp3",
        "bank": "en-oo1",
        "durationMs": 3450
    },
    "Our printer has a day off, with a box under its arm.": {
        "file": "e15b18a00df77ad11832.mp3",
        "bank": "en-oo1",
        "durationMs": 3550
    },
    "Our printer has a day off, with a picture on its head.": {
        "file": "c0421d6991bbf99e1c8b.mp3",
        "bank": "en-oo1",
        "durationMs": 3525
    },
    "Our printer has a day off, with a picture under its arm.": {
        "file": "877be5fbae7ef2b616c7.mp3",
        "bank": "en-oo1",
        "durationMs": 3700
    },
    "Our printer has a day off, with a ticket on its head.": {
        "file": "3f791b1ea1a5b21ba024.mp3",
        "bank": "en-oo1",
        "durationMs": 3600
    },
    "Our printer has a day off, with a ticket under its arm.": {
        "file": "30627dc1769b287b9bad.mp3",
        "bank": "en-oo1",
        "durationMs": 3675
    },
    "Our printer has a day off, with a book on its head.": {
        "file": "6b8ad3bba74382f41f40.mp3",
        "bank": "en-oo1",
        "durationMs": 3325
    },
    "Our printer has a day off, with a book under its arm.": {
        "file": "7313e4dd8f3630af69ed.mp3",
        "bank": "en-oo1",
        "durationMs": 3475
    },
    "Our printer has a day off, with a hat on its head.": {
        "file": "03af314c5e3d2c20af26.mp3",
        "bank": "en-oo1",
        "durationMs": 3375
    },
    "Our printer has a day off, with a hat under its arm.": {
        "file": "f27278c180266699ce93.mp3",
        "bank": "en-oo1",
        "durationMs": 3475
    },
    "Our printer has a day off, with an apple on its head.": {
        "file": "bcf3d4f6abfe74eb520c.mp3",
        "bank": "en-oo1",
        "durationMs": 3525
    },
    "Our printer has a day off, with an apple under its arm.": {
        "file": "2b91356c70da6d14d120.mp3",
        "bank": "en-oo1",
        "durationMs": 3675
    },
    "After everyone leaves, the office chair is reading two papers.": {
        "file": "43728796c71ff4a9bb7d.mp3",
        "bank": "en-oo1",
        "durationMs": 4425
    },
    "After everyone leaves, the office chair is reading two receipts.": {
        "file": "9a216b2ce50f5e0ab45d.mp3",
        "bank": "en-oo1",
        "durationMs": 4375
    },
    "After everyone leaves, the office chair is reading three papers.": {
        "file": "4aab5ad882c13422c4aa.mp3",
        "bank": "en-oo1",
        "durationMs": 4475
    },
    "After everyone leaves, the office chair is reading three receipts.": {
        "file": "aeaf12ba726d877415e5.mp3",
        "bank": "en-oo1",
        "durationMs": 4450
    },
    "After everyone leaves, the office chair is reading two pictures.": {
        "file": "2e2c2b1b80fccf005c1a.mp3",
        "bank": "en-oo1",
        "durationMs": 4500
    },
    "After everyone leaves, the office chair is reading two books.": {
        "file": "15d0bb0a5e432d9e1347.mp3",
        "bank": "en-oo1",
        "durationMs": 4226
    },
    "After everyone leaves, the office chair is reading four pictures.": {
        "file": "b5d085aa88a51842379d.mp3",
        "bank": "en-oo1",
        "durationMs": 4550
    },
    "After everyone leaves, the office chair is reading four books.": {
        "file": "9834a6e296d3834fd311.mp3",
        "bank": "en-oo1",
        "durationMs": 4275
    },
    "After everyone leaves, the office chair is reading two tickets.": {
        "file": "f3cb5d03ad4755ead2e5.mp3",
        "bank": "en-oo1",
        "durationMs": 4325
    },
    "After everyone leaves, the office chair is reading two newspapers.": {
        "file": "0e0d06e1dd22c630cb49.mp3",
        "bank": "en-oo1",
        "durationMs": 4625
    },
    "After everyone leaves, the office chair is reading three tickets.": {
        "file": "ee34529bafd6a69259a1.mp3",
        "bank": "en-oo1",
        "durationMs": 4400
    },
    "After everyone leaves, the office chair is reading three newspapers.": {
        "file": "bdf55ca543e7cc4d269c.mp3",
        "bank": "en-oo1",
        "durationMs": 4650
    },
    "After everyone leaves, the office chair is reading two cards.": {
        "file": "2c5d61c9ed9e2f61119a.mp3",
        "bank": "en-oo1",
        "durationMs": 4325
    },
    "After everyone leaves, the office chair is reading two letters.": {
        "file": "606df4bbffedcfb15b56.mp3",
        "bank": "en-oo1",
        "durationMs": 4375
    },
    "After everyone leaves, the office chair is reading four cards.": {
        "file": "758534421c779dfaf58d.mp3",
        "bank": "en-oo1",
        "durationMs": 4375
    },
    "After everyone leaves, the office chair is reading four letters.": {
        "file": "e3c792f71d626e776542.mp3",
        "bank": "en-oo1",
        "durationMs": 4500
    },
    "After everyone leaves, the office chair is reading two magazines.": {
        "file": "f792673b0cae85aef9f7.mp3",
        "bank": "en-oo1",
        "durationMs": 4600
    },
    "After everyone leaves, the office chair is reading two menus.": {
        "file": "f0d31faae179f5ed6722.mp3",
        "bank": "en-oo1",
        "durationMs": 4400
    },
    "After everyone leaves, the office chair is reading three magazines.": {
        "file": "81921e27c7b7d8c48da3.mp3",
        "bank": "en-oo1",
        "durationMs": 4650
    },
    "After everyone leaves, the office chair is reading three menus.": {
        "file": "7462f9b141c2e0e193e3.mp3",
        "bank": "en-oo1",
        "durationMs": 4425
    },
    "The man interviewing his own picture puts a glass on the desk.": {
        "file": "48b2fc175185dd074b31.mp3",
        "bank": "en-oo1",
        "durationMs": 4300
    },
    "The man interviewing his own picture puts a glass under the desk.": {
        "file": "98bc75238a628dbbdcab.mp3",
        "bank": "en-oo1",
        "durationMs": 4475
    },
    "The man interviewing his own picture puts an egg on the desk.": {
        "file": "cdab61b96fbb9d283363.mp3",
        "bank": "en-oo1",
        "durationMs": 4175
    },
    "The man interviewing his own picture puts an egg under the desk.": {
        "file": "18cd17ba79fd8350235e.mp3",
        "bank": "en-oo1",
        "durationMs": 4400
    },
    "The man interviewing his own picture puts a robot on the desk.": {
        "file": "b89548f15af5a063d758.mp3",
        "bank": "en-oo1",
        "durationMs": 4350
    },
    "The man interviewing his own picture puts a robot under the desk.": {
        "file": "7e2c62b58497b2b219f0.mp3",
        "bank": "en-oo1",
        "durationMs": 4500
    },
    "The man interviewing his own picture puts a box on the desk.": {
        "file": "54c703bb9bbef88d0bc0.mp3",
        "bank": "en-oo1",
        "durationMs": 4226
    },
    "The man interviewing his own picture puts a box under the desk.": {
        "file": "0a8e7e0e7a3edc99310d.mp3",
        "bank": "en-oo1",
        "durationMs": 4375
    },
    "The man interviewing his own picture puts a fish on the desk.": {
        "file": "11535836406c05c4d83a.mp3",
        "bank": "en-oo1",
        "durationMs": 4226
    },
    "The man interviewing his own picture puts a fish under the desk.": {
        "file": "8cb25ef5ea1d97a67104.mp3",
        "bank": "en-oo1",
        "durationMs": 4375
    },
    "The man interviewing his own picture puts a bottle on the desk.": {
        "file": "1f073faf65d607afad86.mp3",
        "bank": "en-oo1",
        "durationMs": 4275
    },
    "The man interviewing his own picture puts a bottle under the desk.": {
        "file": "45d3bf219d7f8a868f87.mp3",
        "bank": "en-oo1",
        "durationMs": 4450
    },
    "The man interviewing his own picture puts a hat on the desk.": {
        "file": "58a80aed398e4176e764.mp3",
        "bank": "en-oo1",
        "durationMs": 4175
    },
    "The man interviewing his own picture puts a hat under the desk.": {
        "file": "0448cb565f030b5e17a5.mp3",
        "bank": "en-oo1",
        "durationMs": 4400
    },
    "The man interviewing his own picture puts a book on the desk.": {
        "file": "6170b53aa5c50d4bca82.mp3",
        "bank": "en-oo1",
        "durationMs": 4075
    },
    "The man interviewing his own picture puts a book under the desk.": {
        "file": "246524e75e24f1da9f44.mp3",
        "bank": "en-oo1",
        "durationMs": 4275
    },
    "The man interviewing his own picture puts a picture on the desk.": {
        "file": "b11d008e2e43e8fc1128.mp3",
        "bank": "en-oo1",
        "durationMs": 4350
    },
    "The man interviewing his own picture puts a picture under the desk.": {
        "file": "7fb0dbf9fdcbb2035b58.mp3",
        "bank": "en-oo1",
        "durationMs": 4500
    },
    "The man interviewing his own picture puts a ticket on the desk.": {
        "file": "d1b6ec06d2c3a4bb1765.mp3",
        "bank": "en-oo1",
        "durationMs": 4300
    },
    "The man interviewing his own picture puts a ticket under the desk.": {
        "file": "e45b5314dcd4d976f8cc.mp3",
        "bank": "en-oo1",
        "durationMs": 4500
    },
    "At our meeting about taking breaks, the woman is washing a computer.": {
        "file": "7072ba88fec2a4c47566.mp3",
        "bank": "en-oo1",
        "durationMs": 4525
    },
    "At our meeting about taking breaks, the woman is washing a glass.": {
        "file": "3495bb968dd79a1eca23.mp3",
        "bank": "en-oo1",
        "durationMs": 4350
    },
    "At our meeting about taking breaks, the woman is drawing a computer.": {
        "file": "ca92d66fa4fe56174799.mp3",
        "bank": "en-oo1",
        "durationMs": 4450
    },
    "At our meeting about taking breaks, the woman is drawing a glass.": {
        "file": "8cde407540e0f1d6bf86.mp3",
        "bank": "en-oo1",
        "durationMs": 4200
    },
    "At our meeting about taking breaks, the woman is washing a robot.": {
        "file": "61ca977d52510dd164c5.mp3",
        "bank": "en-oo1",
        "durationMs": 4425
    },
    "At our meeting about taking breaks, the woman is washing a fish.": {
        "file": "969a8fbf5e9e233117b7.mp3",
        "bank": "en-oo1",
        "durationMs": 4300
    },
    "At our meeting about taking breaks, the woman is drawing a robot.": {
        "file": "a0cf394dd971bfe4760f.mp3",
        "bank": "en-oo1",
        "durationMs": 4325
    },
    "At our meeting about taking breaks, the woman is drawing a fish.": {
        "file": "c431cfa69c2d0743df24.mp3",
        "bank": "en-oo1",
        "durationMs": 4075
    },
    "At our meeting about taking breaks, the woman is washing a dog.": {
        "file": "d81f9189e9e003bf1136.mp3",
        "bank": "en-oo1",
        "durationMs": 4226
    },
    "At our meeting about taking breaks, the woman is washing an egg.": {
        "file": "595a7b288e4a8a6a1112.mp3",
        "bank": "en-oo1",
        "durationMs": 4226
    },
    "At our meeting about taking breaks, the woman is drawing a dog.": {
        "file": "db33791a8fff76c62abd.mp3",
        "bank": "en-oo1",
        "durationMs": 4050
    },
    "At our meeting about taking breaks, the woman is drawing an egg.": {
        "file": "c7f02d770623822c6c6f.mp3",
        "bank": "en-oo1",
        "durationMs": 4125
    },
    "At our meeting about taking breaks, the woman is washing a flower.": {
        "file": "e7ce4fd6eafe8fa00668.mp3",
        "bank": "en-oo1",
        "durationMs": 4325
    },
    "At our meeting about taking breaks, the woman is washing a gift.": {
        "file": "80df8e7128b7d22dc6c5.mp3",
        "bank": "en-oo1",
        "durationMs": 4275
    },
    "At our meeting about taking breaks, the woman is drawing a flower.": {
        "file": "f1382323d10cce9fa6b5.mp3",
        "bank": "en-oo1",
        "durationMs": 4200
    },
    "At our meeting about taking breaks, the woman is drawing a gift.": {
        "file": "de317994c0338427cb7b.mp3",
        "bank": "en-oo1",
        "durationMs": 4175
    },
    "At our meeting about taking breaks, the woman is washing a phone.": {
        "file": "433e0015015392292c75.mp3",
        "bank": "en-oo1",
        "durationMs": 4350
    },
    "At our meeting about taking breaks, the woman is washing a bottle.": {
        "file": "3369759cb227fb9f6e87.mp3",
        "bank": "en-oo1",
        "durationMs": 4275
    },
    "At our meeting about taking breaks, the woman is drawing a phone.": {
        "file": "175c7527939abe051bfa.mp3",
        "bank": "en-oo1",
        "durationMs": 4175
    },
    "At our meeting about taking breaks, the woman is drawing a bottle.": {
        "file": "5ff6f84859f61fd9391e.mp3",
        "bank": "en-oo1",
        "durationMs": 4150
    },
    "To get a better office, the man climbs onto a large glass.": {
        "file": "e3046c1c7bf9985d8b74.mp3",
        "bank": "en-oo1",
        "durationMs": 4075
    },
    "To get a better office, the man climbs onto a large fish.": {
        "file": "58eb32b7b1d53c064e2f.mp3",
        "bank": "en-oo1",
        "durationMs": 4050
    },
    "To get a better office, the man climbs onto a small glass.": {
        "file": "70514d32d3890fa2a50d.mp3",
        "bank": "en-oo1",
        "durationMs": 4100
    },
    "To get a better office, the man climbs onto a small fish.": {
        "file": "ecee0e62688c80bd27b5.mp3",
        "bank": "en-oo1",
        "durationMs": 3950
    },
    "To get a better office, the man climbs onto a large cup.": {
        "file": "1903c58018890acb6756.mp3",
        "bank": "en-oo1",
        "durationMs": 3950
    },
    "To get a better office, the man climbs onto a large clock.": {
        "file": "8e93e56475890d45459b.mp3",
        "bank": "en-oo1",
        "durationMs": 4075
    },
    "To get a better office, the man climbs onto a small cup.": {
        "file": "e34a21cfd498c038a7f7.mp3",
        "bank": "en-oo1",
        "durationMs": 4000
    },
    "To get a better office, the man climbs onto a small clock.": {
        "file": "0235cb4bb20551fe30b0.mp3",
        "bank": "en-oo1",
        "durationMs": 4000
    },
    "To get a better office, the man climbs onto a large book.": {
        "file": "c355c4be74bae8925395.mp3",
        "bank": "en-oo1",
        "durationMs": 4025
    },
    "To get a better office, the man climbs onto a large gift.": {
        "file": "56c6fb1cd904f509213d.mp3",
        "bank": "en-oo1",
        "durationMs": 4075
    },
    "To get a better office, the man climbs onto a small book.": {
        "file": "8d01567b97b4f6b6e6e6.mp3",
        "bank": "en-oo1",
        "durationMs": 3975
    },
    "To get a better office, the man climbs onto a small gift.": {
        "file": "6d8aa531fee0b13e8803.mp3",
        "bank": "en-oo1",
        "durationMs": 4000
    },
    "To get a better office, the man climbs onto a large hat.": {
        "file": "44219201d6d06d5546b4.mp3",
        "bank": "en-oo1",
        "durationMs": 4025
    },
    "To get a better office, the man climbs onto a large bottle.": {
        "file": "752cbb67fa2ccde8efb6.mp3",
        "bank": "en-oo1",
        "durationMs": 4100
    },
    "To get a better office, the man climbs onto a small hat.": {
        "file": "2c00465c5b619baa751e.mp3",
        "bank": "en-oo1",
        "durationMs": 4025
    },
    "To get a better office, the man climbs onto a small bottle.": {
        "file": "2aa51e65b8d6b320b47a.mp3",
        "bank": "en-oo1",
        "durationMs": 4050
    },
    "To get a better office, the man climbs onto a large pencil.": {
        "file": "6944fb90f0dc9bfad00f.mp3",
        "bank": "en-oo1",
        "durationMs": 4200
    },
    "To get a better office, the man climbs onto a large cat.": {
        "file": "5c56e022ddefce922154.mp3",
        "bank": "en-oo1",
        "durationMs": 4025
    },
    "To get a better office, the man climbs onto a small pencil.": {
        "file": "b14329cfe0babcaf97e8.mp3",
        "bank": "en-oo1",
        "durationMs": 4125
    },
    "To get a better office, the man climbs onto a small cat.": {
        "file": "8f41a211a9c5307fe316.mp3",
        "bank": "en-oo1",
        "durationMs": 4000
    },
    "The cat approving our work keeps a fish beside the computer.": {
        "file": "6d1ee2c1437917c39fc6.mp3",
        "bank": "en-oo1",
        "durationMs": 3950
    },
    "The cat approving our work keeps a fish behind the computer.": {
        "file": "e5a905964370e23bdd4e.mp3",
        "bank": "en-oo1",
        "durationMs": 3950
    },
    "The cat approving our work keeps a glass beside the computer.": {
        "file": "c6216cddb150203bfd94.mp3",
        "bank": "en-oo1",
        "durationMs": 4050
    },
    "The cat approving our work keeps a glass behind the computer.": {
        "file": "86954ee881239530b19a.mp3",
        "bank": "en-oo1",
        "durationMs": 4025
    },
    "The cat approving our work keeps a book beside the computer.": {
        "file": "31e195a930be3722c1b9.mp3",
        "bank": "en-oo1",
        "durationMs": 3825
    },
    "The cat approving our work keeps a book behind the computer.": {
        "file": "89e068e45493a4e27c47.mp3",
        "bank": "en-oo1",
        "durationMs": 3900
    },
    "The cat approving our work keeps a shoe beside the computer.": {
        "file": "e05d23a8f2482006333b.mp3",
        "bank": "en-oo1",
        "durationMs": 3950
    },
    "The cat approving our work keeps a shoe behind the computer.": {
        "file": "dabd52d01dde5d7a88f0.mp3",
        "bank": "en-oo1",
        "durationMs": 3900
    },
    "The cat approving our work keeps a gift beside the computer.": {
        "file": "1aeccd45904312524795.mp3",
        "bank": "en-oo1",
        "durationMs": 4025
    },
    "The cat approving our work keeps a gift behind the computer.": {
        "file": "4823217cac426faf9622.mp3",
        "bank": "en-oo1",
        "durationMs": 4025
    },
    "The cat approving our work keeps a hat beside the computer.": {
        "file": "234ee9e31c7ba62faa48.mp3",
        "bank": "en-oo1",
        "durationMs": 4000
    },
    "The cat approving our work keeps a hat behind the computer.": {
        "file": "4784f743b2b448737794.mp3",
        "bank": "en-oo1",
        "durationMs": 3950
    },
    "The cat approving our work keeps a coin beside the computer.": {
        "file": "07b4e0941632bf59bf1a.mp3",
        "bank": "en-oo1",
        "durationMs": 4100
    },
    "The cat approving our work keeps a coin behind the computer.": {
        "file": "00bc8781331d361ad0d2.mp3",
        "bank": "en-oo1",
        "durationMs": 4050
    },
    "The cat approving our work keeps a box beside the computer.": {
        "file": "f6408281e90962e59ca6.mp3",
        "bank": "en-oo1",
        "durationMs": 3925
    },
    "The cat approving our work keeps a box behind the computer.": {
        "file": "28d1fb9df84657ea7f7c.mp3",
        "bank": "en-oo1",
        "durationMs": 3975
    },
    "The cat approving our work keeps a phone beside the computer.": {
        "file": "02a2b61aee11c24440be.mp3",
        "bank": "en-oo1",
        "durationMs": 4025
    },
    "The cat approving our work keeps a phone behind the computer.": {
        "file": "e9dfb683b19ca04d5445.mp3",
        "bank": "en-oo1",
        "durationMs": 4050
    },
    "The cat approving our work keeps a ticket beside the computer.": {
        "file": "db293dd0e2889792eaa7.mp3",
        "bank": "en-oo1",
        "durationMs": 4150
    },
    "The cat approving our work keeps a ticket behind the computer.": {
        "file": "16601cf78f493d2075ce.mp3",
        "bank": "en-oo1",
        "durationMs": 4050
    },
    "At work, the lunch box contains more bottles than the gift box.": {
        "file": "7c42114e4fa728804e2a.mp3",
        "bank": "en-oo1",
        "durationMs": 4350
    },
    "At work, the lunch box contains more gifts than the gift box.": {
        "file": "3b279763f121ab9dcbc0.mp3",
        "bank": "en-oo1",
        "durationMs": 4175
    },
    "At work, the lunch box contains fewer bottles than the gift box.": {
        "file": "14b9953c190f0a735895.mp3",
        "bank": "en-oo1",
        "durationMs": 4425
    },
    "At work, the lunch box contains fewer gifts than the gift box.": {
        "file": "735cc5ec4d8dabbeafb5.mp3",
        "bank": "en-oo1",
        "durationMs": 4275
    },
    "At work, the lunch box contains more books than the gift box.": {
        "file": "081f9047da556d339b3f.mp3",
        "bank": "en-oo1",
        "durationMs": 4100
    },
    "At work, the lunch box contains more computers than the gift box.": {
        "file": "1f1049a85d873a353cf7.mp3",
        "bank": "en-oo1",
        "durationMs": 4400
    },
    "At work, the lunch box contains fewer books than the gift box.": {
        "file": "dfaeb377ff6056348023.mp3",
        "bank": "en-oo1",
        "durationMs": 4150
    },
    "At work, the lunch box contains fewer computers than the gift box.": {
        "file": "7e1c6f6832d59d357e29.mp3",
        "bank": "en-oo1",
        "durationMs": 4550
    },
    "At work, the lunch box contains more robots than the gift box.": {
        "file": "07b2d725bceefbc8f9e7.mp3",
        "bank": "en-oo1",
        "durationMs": 4350
    },
    "At work, the lunch box contains more coins than the gift box.": {
        "file": "baef45dcf357375083f5.mp3",
        "bank": "en-oo1",
        "durationMs": 4275
    },
    "At work, the lunch box contains fewer robots than the gift box.": {
        "file": "eb5ed9e177dca3757ae8.mp3",
        "bank": "en-oo1",
        "durationMs": 4450
    },
    "At work, the lunch box contains fewer coins than the gift box.": {
        "file": "057749a7bd9a5bf36a90.mp3",
        "bank": "en-oo1",
        "durationMs": 4325
    },
    "At work, the lunch box contains more chairs than the gift box.": {
        "file": "6da73e1cd9bc277e9d48.mp3",
        "bank": "en-oo1",
        "durationMs": 4200
    },
    "At work, the lunch box contains more dogs than the gift box.": {
        "file": "63dfed5fc7ab5dcf32b4.mp3",
        "bank": "en-oo1",
        "durationMs": 4275
    },
    "At work, the lunch box contains fewer chairs than the gift box.": {
        "file": "22b784594abeace67859.mp3",
        "bank": "en-oo1",
        "durationMs": 4325
    },
    "At work, the lunch box contains fewer dogs than the gift box.": {
        "file": "f0a5f7937bb83ee2319c.mp3",
        "bank": "en-oo1",
        "durationMs": 4325
    },
    "At work, the lunch box contains more tickets than the gift box.": {
        "file": "e4b09db8179d95ead6b5.mp3",
        "bank": "en-oo1",
        "durationMs": 4275
    },
    "At work, the lunch box contains more balls than the gift box.": {
        "file": "ef0f185b9413667dad75.mp3",
        "bank": "en-oo1",
        "durationMs": 4275
    },
    "At work, the lunch box contains fewer tickets than the gift box.": {
        "file": "8f8a4a94ced514319e28.mp3",
        "bank": "en-oo1",
        "durationMs": 4375
    },
    "At work, the lunch box contains fewer balls than the gift box.": {
        "file": "5710bdd3103952aa4e06.mp3",
        "bank": "en-oo1",
        "durationMs": 4300
    },
    "My friend joins our online meeting with a fish on his head.": {
        "file": "aecbde93ff971d322532.mp3",
        "bank": "en-oo1",
        "durationMs": 4050
    },
    "My friend joins our online meeting with a fish under his arm.": {
        "file": "3b3896bfcd978b7aeda6.mp3",
        "bank": "en-oo1",
        "durationMs": 4325
    },
    "My friend joins our online meeting with a dog on his head.": {
        "file": "5652017c4d8c361b8af6.mp3",
        "bank": "en-oo1",
        "durationMs": 4075
    },
    "My friend joins our online meeting with a dog under his arm.": {
        "file": "a4d3f9d88186ce2ca4ac.mp3",
        "bank": "en-oo1",
        "durationMs": 4350
    },
    "My friend joins our online meeting with a glass on his head.": {
        "file": "ae158e2c67b0b93efe04.mp3",
        "bank": "en-oo1",
        "durationMs": 4250
    },
    "My friend joins our online meeting with a glass under his arm.": {
        "file": "bbb66e669827cbd81e34.mp3",
        "bank": "en-oo1",
        "durationMs": 4400
    },
    "My friend joins our online meeting with a book on his head.": {
        "file": "ddfc208ad42cb7410350.mp3",
        "bank": "en-oo1",
        "durationMs": 4000
    },
    "My friend joins our online meeting with a book under his arm.": {
        "file": "65137bacbd83b2d58c03.mp3",
        "bank": "en-oo1",
        "durationMs": 4200
    },
    "My friend joins our online meeting with a magazine on his head.": {
        "file": "4cf6485ff58ba439315d.mp3",
        "bank": "en-oo1",
        "durationMs": 4375
    },
    "My friend joins our online meeting with a magazine under his arm.": {
        "file": "7791181269c002b89e67.mp3",
        "bank": "en-oo1",
        "durationMs": 4625
    },
    "My friend joins our online meeting with an egg on his head.": {
        "file": "e231fe5aa2ec00f199c1.mp3",
        "bank": "en-oo1",
        "durationMs": 4075
    },
    "My friend joins our online meeting with an egg under his arm.": {
        "file": "8786d02543600883b447.mp3",
        "bank": "en-oo1",
        "durationMs": 4350
    },
    "My friend joins our online meeting with an umbrella on his head.": {
        "file": "cddd6dd793b5246a53e9.mp3",
        "bank": "en-oo1",
        "durationMs": 4475
    },
    "My friend joins our online meeting with an umbrella under his arm.": {
        "file": "ed6d48d0bc77938198c3.mp3",
        "bank": "en-oo1",
        "durationMs": 4625
    },
    "My friend joins our online meeting with a bottle on his head.": {
        "file": "6e7c0fb5aec142ecf1be.mp3",
        "bank": "en-oo1",
        "durationMs": 4250
    },
    "My friend joins our online meeting with a bottle under his arm.": {
        "file": "6da35575fc9c2d66cfdc.mp3",
        "bank": "en-oo1",
        "durationMs": 4425
    },
    "My friend joins our online meeting with a key on his head.": {
        "file": "621ac0a0dbf2abe007d9.mp3",
        "bank": "en-oo1",
        "durationMs": 4050
    },
    "My friend joins our online meeting with a key under his arm.": {
        "file": "a02ae01c200f4ef3e91f.mp3",
        "bank": "en-oo1",
        "durationMs": 4226
    },
    "My friend joins our online meeting with a computer on his head.": {
        "file": "f8c7a61f045fff76750e.mp3",
        "bank": "en-oo1",
        "durationMs": 4475
    },
    "My friend joins our online meeting with a computer under his arm.": {
        "file": "f41f0648abff3defdbdd.mp3",
        "bank": "en-oo1",
        "durationMs": 4625
    },
    "The tree running our office has two gifts hanging from its branches.": {
        "file": "71a490b6570c42ed1f01.mp3",
        "bank": "en-oo1",
        "durationMs": 4375
    },
    "The tree running our office has two glasses hanging from its branches.": {
        "file": "687d47ded0a7db617e61.mp3",
        "bank": "en-oo1",
        "durationMs": 4675
    },
    "The tree running our office has three gifts hanging from its branches.": {
        "file": "bf2aaa140af1ee63c836.mp3",
        "bank": "en-oo1",
        "durationMs": 4425
    },
    "The tree running our office has three glasses hanging from its branches.": {
        "file": "6786ea8fd1a95a3e522e.mp3",
        "bank": "en-oo1",
        "durationMs": 4826
    },
    "The tree running our office has two fish hanging from its branches.": {
        "file": "713c26d63c067131693a.mp3",
        "bank": "en-oo1",
        "durationMs": 4375
    },
    "The tree running our office has two bottles hanging from its branches.": {
        "file": "76815c6e7dcff9e2571c.mp3",
        "bank": "en-oo1",
        "durationMs": 4400
    },
    "The tree running our office has four fish hanging from its branches.": {
        "file": "4362fc33f362f5a6fb69.mp3",
        "bank": "en-oo1",
        "durationMs": 4400
    },
    "The tree running our office has four bottles hanging from its branches.": {
        "file": "63b23e828d3099d5c162.mp3",
        "bank": "en-oo1",
        "durationMs": 4525
    },
    "The tree running our office has two eggs hanging from its branches.": {
        "file": "a955f1b6dbc461a14990.mp3",
        "bank": "en-oo1",
        "durationMs": 4500
    },
    "The tree running our office has two bags hanging from its branches.": {
        "file": "cda1476d9a2ab5b9c9c2.mp3",
        "bank": "en-oo1",
        "durationMs": 4550
    },
    "The tree running our office has three eggs hanging from its branches.": {
        "file": "2987d9d9b4b7bdd91f02.mp3",
        "bank": "en-oo1",
        "durationMs": 4625
    },
    "The tree running our office has three bags hanging from its branches.": {
        "file": "b09d275c4f5a2520d767.mp3",
        "bank": "en-oo1",
        "durationMs": 4675
    },
    "The tree running our office has two boxes hanging from its branches.": {
        "file": "85a5d3b84eea04c72b13.mp3",
        "bank": "en-oo1",
        "durationMs": 4700
    },
    "The tree running our office has two magazines hanging from its branches.": {
        "file": "11595c85e5d26e181258.mp3",
        "bank": "en-oo1",
        "durationMs": 4725
    },
    "The tree running our office has four boxes hanging from its branches.": {
        "file": "86bcfb93b91686ce5b4a.mp3",
        "bank": "en-oo1",
        "durationMs": 4650
    },
    "The tree running our office has four magazines hanging from its branches.": {
        "file": "8c82a1f82e70ebd10164.mp3",
        "bank": "en-oo1",
        "durationMs": 4875
    },
    "The tree running our office has two chairs hanging from its branches.": {
        "file": "36813a8edb8e153179b7.mp3",
        "bank": "en-oo1",
        "durationMs": 4425
    },
    "The tree running our office has two hats hanging from its branches.": {
        "file": "4c3435f1089140b4d285.mp3",
        "bank": "en-oo1",
        "durationMs": 4300
    },
    "The tree running our office has three chairs hanging from its branches.": {
        "file": "74520059a484b9c36735.mp3",
        "bank": "en-oo1",
        "durationMs": 4675
    },
    "The tree running our office has three hats hanging from its branches.": {
        "file": "fb9ea917a2986e51bda5.mp3",
        "bank": "en-oo1",
        "durationMs": 4450
    },
    "The dog checking my homework keeps a robot on the table.": {
        "file": "948d5aeeeb6009fe098a.mp3",
        "bank": "en-oo1",
        "durationMs": 3875
    },
    "The dog checking my homework keeps a robot under the table.": {
        "file": "229b24f8e4986408d910.mp3",
        "bank": "en-oo1",
        "durationMs": 3875
    },
    "The dog checking my homework keeps a flower on the table.": {
        "file": "9c8e28d07943b9ea3ea1.mp3",
        "bank": "en-oo1",
        "durationMs": 3675
    },
    "The dog checking my homework keeps a flower under the table.": {
        "file": "de2d076234c08436f75c.mp3",
        "bank": "en-oo1",
        "durationMs": 3775
    },
    "The dog checking my homework keeps a box on the table.": {
        "file": "00950ff46f869bf61227.mp3",
        "bank": "en-oo1",
        "durationMs": 3600
    },
    "The dog checking my homework keeps a box under the table.": {
        "file": "1458bf9429160e2a85ce.mp3",
        "bank": "en-oo1",
        "durationMs": 3700
    },
    "The dog checking my homework keeps a computer on the table.": {
        "file": "ecd1ac7b7daccf645ded.mp3",
        "bank": "en-oo1",
        "durationMs": 3975
    },
    "The dog checking my homework keeps a computer under the table.": {
        "file": "01de62f7947e0c4720b2.mp3",
        "bank": "en-oo1",
        "durationMs": 4025
    },
    "The dog checking my homework keeps a gift on the table.": {
        "file": "18863ad8ac7bb762ec43.mp3",
        "bank": "en-oo1",
        "durationMs": 3600
    },
    "The dog checking my homework keeps a gift under the table.": {
        "file": "39b01ff9b377a4b47cbd.mp3",
        "bank": "en-oo1",
        "durationMs": 3775
    },
    "The dog checking my homework keeps a shoe on the table.": {
        "file": "46d81f45711279e537b1.mp3",
        "bank": "en-oo1",
        "durationMs": 3525
    },
    "The dog checking my homework keeps a shoe under the table.": {
        "file": "742311e9214ea13fe749.mp3",
        "bank": "en-oo1",
        "durationMs": 3725
    },
    "The dog checking my homework keeps a glass on the table.": {
        "file": "e7ce2d44d868167cf9a6.mp3",
        "bank": "en-oo1",
        "durationMs": 3600
    },
    "The dog checking my homework keeps a glass under the table.": {
        "file": "3ebf3f71b5b254de1b6d.mp3",
        "bank": "en-oo1",
        "durationMs": 3725
    },
    "The dog checking my homework keeps a newspaper on the table.": {
        "file": "9843e7155d906accada9.mp3",
        "bank": "en-oo1",
        "durationMs": 4050
    },
    "The dog checking my homework keeps a newspaper under the table.": {
        "file": "37c6c1ef7afae3bd0160.mp3",
        "bank": "en-oo1",
        "durationMs": 4150
    },
    "The dog checking my homework keeps a ticket on the table.": {
        "file": "eb0304e7aa09caf73319.mp3",
        "bank": "en-oo1",
        "durationMs": 3600
    },
    "The dog checking my homework keeps a ticket under the table.": {
        "file": "2b6390831d4e40b1223d.mp3",
        "bank": "en-oo1",
        "durationMs": 3775
    },
    "The dog checking my homework keeps a cat on the table.": {
        "file": "ac3d3853d738916eb29a.mp3",
        "bank": "en-oo1",
        "durationMs": 3525
    },
    "The dog checking my homework keeps a cat under the table.": {
        "file": "5b79120ca20e62664f21.mp3",
        "bank": "en-oo1",
        "durationMs": 3700
    },
    "My bed comes to school with two cats on it.": {
        "file": "5f734301bc4a818dfcd9.mp3",
        "bank": "en-oo1",
        "durationMs": 3000
    },
    "My bed comes to school with two books on it.": {
        "file": "488b91d0d4d152b07844.mp3",
        "bank": "en-oo1",
        "durationMs": 3026
    },
    "My bed comes to school with three cats on it.": {
        "file": "a869853208a1bcdd7037.mp3",
        "bank": "en-oo1",
        "durationMs": 3125
    },
    "My bed comes to school with three books on it.": {
        "file": "70b8eac4476013a4c048.mp3",
        "bank": "en-oo1",
        "durationMs": 3150
    },
    "My bed comes to school with two glasses on it.": {
        "file": "db3459447cb735380fd2.mp3",
        "bank": "en-oo1",
        "durationMs": 3300
    },
    "My bed comes to school with two tickets on it.": {
        "file": "28480f861ac8a64cea26.mp3",
        "bank": "en-oo1",
        "durationMs": 3125
    },
    "My bed comes to school with four glasses on it.": {
        "file": "4679bdb125119029c021.mp3",
        "bank": "en-oo1",
        "durationMs": 3350
    },
    "My bed comes to school with four tickets on it.": {
        "file": "2c954bfe5960a45058c1.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "My bed comes to school with two cups on it.": {
        "file": "b9b12166dfa536212485.mp3",
        "bank": "en-oo1",
        "durationMs": 3050
    },
    "My bed comes to school with two computers on it.": {
        "file": "cac2b30a6089c2731dd6.mp3",
        "bank": "en-oo1",
        "durationMs": 3350
    },
    "My bed comes to school with three cups on it.": {
        "file": "1c55608aa95738656404.mp3",
        "bank": "en-oo1",
        "durationMs": 3175
    },
    "My bed comes to school with three computers on it.": {
        "file": "b269e09f8beb35acd697.mp3",
        "bank": "en-oo1",
        "durationMs": 3525
    },
    "My bed comes to school with two fish on it.": {
        "file": "40580316b1b74afa896a.mp3",
        "bank": "en-oo1",
        "durationMs": 2975
    },
    "My bed comes to school with two umbrellas on it.": {
        "file": "fe0a3317f10c3a033ffa.mp3",
        "bank": "en-oo1",
        "durationMs": 3375
    },
    "My bed comes to school with four fish on it.": {
        "file": "d6462402d7c06070d699.mp3",
        "bank": "en-oo1",
        "durationMs": 3075
    },
    "My bed comes to school with four umbrellas on it.": {
        "file": "9ecd0f7c5a67305af00a.mp3",
        "bank": "en-oo1",
        "durationMs": 3400
    },
    "My bed comes to school with two bottles on it.": {
        "file": "bae3c030f7ebf1a21142.mp3",
        "bank": "en-oo1",
        "durationMs": 3250
    },
    "My bed comes to school with two pictures on it.": {
        "file": "675946b79aae650c3efd.mp3",
        "bank": "en-oo1",
        "durationMs": 3225
    },
    "My bed comes to school with three bottles on it.": {
        "file": "3fb07a88945d5bcf855e.mp3",
        "bank": "en-oo1",
        "durationMs": 3350
    },
    "My bed comes to school with three pictures on it.": {
        "file": "b331704e2627375f2187.mp3",
        "bank": "en-oo1",
        "durationMs": 3375
    },
    "The fish taking swimming lessons has a magazine beside the pool.": {
        "file": "7a8d26c724bac4a3113c.mp3",
        "bank": "en-oo1",
        "durationMs": 4350
    },
    "The fish taking swimming lessons has a magazine inside the pool.": {
        "file": "03f501cc8c0861935303.mp3",
        "bank": "en-oo1",
        "durationMs": 4425
    },
    "The fish taking swimming lessons has a glass beside the pool.": {
        "file": "305e35c78c804eebbed9.mp3",
        "bank": "en-oo1",
        "durationMs": 4200
    },
    "The fish taking swimming lessons has a glass inside the pool.": {
        "file": "77d8f78d8ab6323db425.mp3",
        "bank": "en-oo1",
        "durationMs": 4226
    },
    "The fish taking swimming lessons has a computer beside the pool.": {
        "file": "033acca7679b46ad77dc.mp3",
        "bank": "en-oo1",
        "durationMs": 4400
    },
    "The fish taking swimming lessons has a computer inside the pool.": {
        "file": "8b48cf7a2bd8be1b1bfb.mp3",
        "bank": "en-oo1",
        "durationMs": 4375
    },
    "The fish taking swimming lessons has a bottle beside the pool.": {
        "file": "e3aec235bcb62b2c3af8.mp3",
        "bank": "en-oo1",
        "durationMs": 4125
    },
    "The fish taking swimming lessons has a bottle inside the pool.": {
        "file": "6315a25f8f46b97a60fc.mp3",
        "bank": "en-oo1",
        "durationMs": 4150
    },
    "The fish taking swimming lessons has a dog beside the pool.": {
        "file": "ede187aa76bf0445a351.mp3",
        "bank": "en-oo1",
        "durationMs": 4125
    },
    "The fish taking swimming lessons has a dog inside the pool.": {
        "file": "2e5fd2283433f0cb8e6f.mp3",
        "bank": "en-oo1",
        "durationMs": 4226
    },
    "The fish taking swimming lessons has a fish beside the pool.": {
        "file": "834740c44a70a2aba9e0.mp3",
        "bank": "en-oo1",
        "durationMs": 4100
    },
    "The fish taking swimming lessons has a fish inside the pool.": {
        "file": "2330f8d036f4ccaa281a.mp3",
        "bank": "en-oo1",
        "durationMs": 4150
    },
    "The fish taking swimming lessons has a gift beside the pool.": {
        "file": "99caf5e008683855963c.mp3",
        "bank": "en-oo1",
        "durationMs": 4175
    },
    "The fish taking swimming lessons has a gift inside the pool.": {
        "file": "6f183894be91f4a9c000.mp3",
        "bank": "en-oo1",
        "durationMs": 4226
    },
    "The fish taking swimming lessons has a cup beside the pool.": {
        "file": "8bb4e81f0955be89ad67.mp3",
        "bank": "en-oo1",
        "durationMs": 3975
    },
    "The fish taking swimming lessons has a cup inside the pool.": {
        "file": "bab45171622d3f771dba.mp3",
        "bank": "en-oo1",
        "durationMs": 4050
    },
    "The fish taking swimming lessons has a picture beside the pool.": {
        "file": "594ca1bbbe259cc816a3.mp3",
        "bank": "en-oo1",
        "durationMs": 4200
    },
    "The fish taking swimming lessons has a picture inside the pool.": {
        "file": "12b6d17a54c340f6764e.mp3",
        "bank": "en-oo1",
        "durationMs": 4226
    },
    "The fish taking swimming lessons has a ticket beside the pool.": {
        "file": "85dd6763d18603f3f339.mp3",
        "bank": "en-oo1",
        "durationMs": 4125
    },
    "The fish taking swimming lessons has a ticket inside the pool.": {
        "file": "6c7a54c1ffc86500f43a.mp3",
        "bank": "en-oo1",
        "durationMs": 4226
    },
    "The paper doing my homework is carrying a glass.": {
        "file": "bf607214b5ca5d9585d3.mp3",
        "bank": "en-oo1",
        "durationMs": 3250
    },
    "The paper doing my homework is carrying a box.": {
        "file": "10808f7169f17411065c.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The paper doing my homework is painting a glass.": {
        "file": "6ca22166fce4ef2dbc69.mp3",
        "bank": "en-oo1",
        "durationMs": 3225
    },
    "The paper doing my homework is painting a box.": {
        "file": "51a7b7eda4ff9994a26a.mp3",
        "bank": "en-oo1",
        "durationMs": 3150
    },
    "The paper doing my homework is carrying a gift.": {
        "file": "285cecff9f93c2cdbf64.mp3",
        "bank": "en-oo1",
        "durationMs": 3225
    },
    "The paper doing my homework is carrying a bottle.": {
        "file": "d05986175516ac6fdccc.mp3",
        "bank": "en-oo1",
        "durationMs": 3250
    },
    "The paper doing my homework is painting a gift.": {
        "file": "f6390c79616a5bdd2281.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The paper doing my homework is painting a bottle.": {
        "file": "8b878765c7c90a9401e2.mp3",
        "bank": "en-oo1",
        "durationMs": 3250
    },
    "The paper doing my homework is carrying a computer.": {
        "file": "45ec3a674e928b90a65d.mp3",
        "bank": "en-oo1",
        "durationMs": 3525
    },
    "The paper doing my homework is carrying a cup.": {
        "file": "05cc80fcb5da5001cf0d.mp3",
        "bank": "en-oo1",
        "durationMs": 3150
    },
    "The paper doing my homework is painting a computer.": {
        "file": "2e382b867814b5adca57.mp3",
        "bank": "en-oo1",
        "durationMs": 3500
    },
    "The paper doing my homework is painting a cup.": {
        "file": "bc28fe8ae0fc3e266f4e.mp3",
        "bank": "en-oo1",
        "durationMs": 3075
    },
    "The paper doing my homework is carrying a book.": {
        "file": "e5c85efc62ebdddac47e.mp3",
        "bank": "en-oo1",
        "durationMs": 3075
    },
    "The paper doing my homework is carrying a robot.": {
        "file": "ad828a31720f6db5d31f.mp3",
        "bank": "en-oo1",
        "durationMs": 3375
    },
    "The paper doing my homework is painting a book.": {
        "file": "ce15da4bdb6e6f465f03.mp3",
        "bank": "en-oo1",
        "durationMs": 3026
    },
    "The paper doing my homework is painting a robot.": {
        "file": "6c0c7c41861de895b32d.mp3",
        "bank": "en-oo1",
        "durationMs": 3400
    },
    "The paper doing my homework is carrying a pencil.": {
        "file": "8901a464a2740bc2a370.mp3",
        "bank": "en-oo1",
        "durationMs": 3400
    },
    "The paper doing my homework is carrying a bag.": {
        "file": "04902e67dadd70a1a462.mp3",
        "bank": "en-oo1",
        "durationMs": 3125
    },
    "The paper doing my homework is painting a pencil.": {
        "file": "75b55a3b65c910fe79f5.mp3",
        "bank": "en-oo1",
        "durationMs": 3350
    },
    "The paper doing my homework is painting a bag.": {
        "file": "4557f5a2591fec993b7a.mp3",
        "bank": "en-oo1",
        "durationMs": 3100
    },
    "The book borrowing a student leaves a hat on the desk.": {
        "file": "8db1f11c7b0fefafd41d.mp3",
        "bank": "en-oo1",
        "durationMs": 3475
    },
    "The book borrowing a student leaves a hat under the desk.": {
        "file": "60f8bfd8fe0f6e06c7ba.mp3",
        "bank": "en-oo1",
        "durationMs": 3650
    },
    "The book borrowing a student leaves a bag on the desk.": {
        "file": "58862a8f864e2915d9c4.mp3",
        "bank": "en-oo1",
        "durationMs": 3475
    },
    "The book borrowing a student leaves a bag under the desk.": {
        "file": "fb03143eb174c771b4e4.mp3",
        "bank": "en-oo1",
        "durationMs": 3675
    },
    "The book borrowing a student leaves a book on the desk.": {
        "file": "a5a0e0442030a310be31.mp3",
        "bank": "en-oo1",
        "durationMs": 3350
    },
    "The book borrowing a student leaves a book under the desk.": {
        "file": "341f7258573391e364d4.mp3",
        "bank": "en-oo1",
        "durationMs": 3600
    },
    "The book borrowing a student leaves a gift on the desk.": {
        "file": "3dbb8621f0c88289f17e.mp3",
        "bank": "en-oo1",
        "durationMs": 3550
    },
    "The book borrowing a student leaves a gift under the desk.": {
        "file": "8b8b4a1124eb0cf8a6a9.mp3",
        "bank": "en-oo1",
        "durationMs": 3775
    },
    "The book borrowing a student leaves a glass on the desk.": {
        "file": "5e76b7726bf2a96af27b.mp3",
        "bank": "en-oo1",
        "durationMs": 3626
    },
    "The book borrowing a student leaves a glass under the desk.": {
        "file": "3b5bc63d97ac97dd48f3.mp3",
        "bank": "en-oo1",
        "durationMs": 3750
    },
    "The book borrowing a student leaves a fish on the desk.": {
        "file": "d2a7edf15652679564b5.mp3",
        "bank": "en-oo1",
        "durationMs": 3525
    },
    "The book borrowing a student leaves a fish under the desk.": {
        "file": "ee9a2e4f4c627272acb4.mp3",
        "bank": "en-oo1",
        "durationMs": 3675
    },
    "The book borrowing a student leaves a ticket on the desk.": {
        "file": "761814e5026a086cafc1.mp3",
        "bank": "en-oo1",
        "durationMs": 3600
    },
    "The book borrowing a student leaves a ticket under the desk.": {
        "file": "ba274caf9b013896fd5c.mp3",
        "bank": "en-oo1",
        "durationMs": 3750
    },
    "The book borrowing a student leaves a cup on the desk.": {
        "file": "f08971743d39e715c2b3.mp3",
        "bank": "en-oo1",
        "durationMs": 3450
    },
    "The book borrowing a student leaves a cup under the desk.": {
        "file": "a473bb8d2be84ea2ccef.mp3",
        "bank": "en-oo1",
        "durationMs": 3600
    },
    "The book borrowing a student leaves a computer on the desk.": {
        "file": "f1558ef32d7b5aa7a576.mp3",
        "bank": "en-oo1",
        "durationMs": 3875
    },
    "The book borrowing a student leaves a computer under the desk.": {
        "file": "0c60c713f5d2c33f2fc8.mp3",
        "bank": "en-oo1",
        "durationMs": 4000
    },
    "The book borrowing a student leaves a box on the desk.": {
        "file": "e73b30168af277183656.mp3",
        "bank": "en-oo1",
        "durationMs": 3550
    },
    "The book borrowing a student leaves a box under the desk.": {
        "file": "ab664ca480e2cab3ca08.mp3",
        "bank": "en-oo1",
        "durationMs": 3700
    },
    "The student testing an eraser gives it a large fish.": {
        "file": "ef0e935183583bbd3a9a.mp3",
        "bank": "en-oo1",
        "durationMs": 3725
    },
    "The student testing an eraser gives it a large book.": {
        "file": "939bb4f5c9ba99e8d640.mp3",
        "bank": "en-oo1",
        "durationMs": 3700
    },
    "The student testing an eraser gives it a small fish.": {
        "file": "dece3d4ec1c55b6452db.mp3",
        "bank": "en-oo1",
        "durationMs": 3775
    },
    "The student testing an eraser gives it a small book.": {
        "file": "3b1ca14991e57a940b38.mp3",
        "bank": "en-oo1",
        "durationMs": 3700
    },
    "The student testing an eraser gives it a large glass.": {
        "file": "a60724016ad4c2947a78.mp3",
        "bank": "en-oo1",
        "durationMs": 3775
    },
    "The student testing an eraser gives it a large phone.": {
        "file": "0c042ea33dd3acdd5ee1.mp3",
        "bank": "en-oo1",
        "durationMs": 3775
    },
    "The student testing an eraser gives it a small glass.": {
        "file": "5b6f55ddbafeaebd6a1c.mp3",
        "bank": "en-oo1",
        "durationMs": 3800
    },
    "The student testing an eraser gives it a small phone.": {
        "file": "404091b43a18e901fa5f.mp3",
        "bank": "en-oo1",
        "durationMs": 3825
    },
    "The student testing an eraser gives it a large apple.": {
        "file": "dde3a381a51e30ee8d4f.mp3",
        "bank": "en-oo1",
        "durationMs": 3825
    },
    "The student testing an eraser gives it a large box.": {
        "file": "f28e94cfb3306ca2a3cf.mp3",
        "bank": "en-oo1",
        "durationMs": 3750
    },
    "The student testing an eraser gives it a small apple.": {
        "file": "fd888ddc2fdcea8a3d5a.mp3",
        "bank": "en-oo1",
        "durationMs": 3850
    },
    "The student testing an eraser gives it a small box.": {
        "file": "eecb0ace0c5d8fa6349f.mp3",
        "bank": "en-oo1",
        "durationMs": 3750
    },
    "The student testing an eraser gives it a large flower.": {
        "file": "463956fc9dde745cfd22.mp3",
        "bank": "en-oo1",
        "durationMs": 3825
    },
    "The student testing an eraser gives it a large ticket.": {
        "file": "947d94c865541f907d20.mp3",
        "bank": "en-oo1",
        "durationMs": 3825
    },
    "The student testing an eraser gives it a small flower.": {
        "file": "23c5ae959a5f6b354ea4.mp3",
        "bank": "en-oo1",
        "durationMs": 3875
    },
    "The student testing an eraser gives it a small ticket.": {
        "file": "acc302eaf3478e4a5fca.mp3",
        "bank": "en-oo1",
        "durationMs": 3800
    },
    "The student testing an eraser gives it a large gift.": {
        "file": "843748f360f54329fa65.mp3",
        "bank": "en-oo1",
        "durationMs": 3850
    },
    "The student testing an eraser gives it a large magazine.": {
        "file": "e40e2da93a81f9c7f7f1.mp3",
        "bank": "en-oo1",
        "durationMs": 4075
    },
    "The student testing an eraser gives it a small gift.": {
        "file": "fa9e225eaddecee5aa99.mp3",
        "bank": "en-oo1",
        "durationMs": 3800
    },
    "The student testing an eraser gives it a small magazine.": {
        "file": "4f25a74fb536105f0166.mp3",
        "bank": "en-oo1",
        "durationMs": 4075
    },
    "The students teaching their teacher display two boxes.": {
        "file": "5c17e12bed477699e8c7.mp3",
        "bank": "en-oo1",
        "durationMs": 3575
    },
    "The students teaching their teacher display two glasses.": {
        "file": "27cfcf8fa45d4f8de8b2.mp3",
        "bank": "en-oo1",
        "durationMs": 3700
    },
    "The students teaching their teacher display three boxes.": {
        "file": "4db010840392708877a5.mp3",
        "bank": "en-oo1",
        "durationMs": 3675
    },
    "The students teaching their teacher display three glasses.": {
        "file": "b96953286285e78dbfd8.mp3",
        "bank": "en-oo1",
        "durationMs": 3850
    },
    "The students teaching their teacher display two gifts.": {
        "file": "2232823ab51193d20798.mp3",
        "bank": "en-oo1",
        "durationMs": 3450
    },
    "The students teaching their teacher display two fish.": {
        "file": "dcb02ecb6df740ea6dbd.mp3",
        "bank": "en-oo1",
        "durationMs": 3375
    },
    "The students teaching their teacher display four gifts.": {
        "file": "6982a04bcef429955ce9.mp3",
        "bank": "en-oo1",
        "durationMs": 3650
    },
    "The students teaching their teacher display four fish.": {
        "file": "36565215111c0738f060.mp3",
        "bank": "en-oo1",
        "durationMs": 3500
    },
    "The students teaching their teacher display two flowers.": {
        "file": "754f8c3dc82b78367112.mp3",
        "bank": "en-oo1",
        "durationMs": 3575
    },
    "The students teaching their teacher display two cups.": {
        "file": "87a470dd99bc1c94be50.mp3",
        "bank": "en-oo1",
        "durationMs": 3325
    },
    "The students teaching their teacher display three flowers.": {
        "file": "1dbd329d4ad3f3d00ab6.mp3",
        "bank": "en-oo1",
        "durationMs": 3725
    },
    "The students teaching their teacher display three cups.": {
        "file": "7a27f0839049eca19ef0.mp3",
        "bank": "en-oo1",
        "durationMs": 3475
    },
    "The students teaching their teacher display two books.": {
        "file": "be4dcc13a311de95c6f2.mp3",
        "bank": "en-oo1",
        "durationMs": 3350
    },
    "The students teaching their teacher display two shoes.": {
        "file": "9800719bd6210c63e02f.mp3",
        "bank": "en-oo1",
        "durationMs": 3450
    },
    "The students teaching their teacher display four books.": {
        "file": "388c4725769e2530b389.mp3",
        "bank": "en-oo1",
        "durationMs": 3500
    },
    "The students teaching their teacher display four shoes.": {
        "file": "c34268a3e55a9488bee2.mp3",
        "bank": "en-oo1",
        "durationMs": 3550
    },
    "The students teaching their teacher display two pictures.": {
        "file": "dca604af8af34b94daa6.mp3",
        "bank": "en-oo1",
        "durationMs": 3650
    },
    "The students teaching their teacher display two computers.": {
        "file": "c6ac08a999538b682367.mp3",
        "bank": "en-oo1",
        "durationMs": 3825
    },
    "The students teaching their teacher display three pictures.": {
        "file": "c30466eb02ecb2f76fe4.mp3",
        "bank": "en-oo1",
        "durationMs": 3825
    },
    "The students teaching their teacher display three computers.": {
        "file": "b532a4f998ccee7f1702.mp3",
        "bank": "en-oo1",
        "durationMs": 3850
    },
    "The fish choosing a seat for lunch puts a fish on the table.": {
        "file": "31ee1249bb4c5db987c1.mp3",
        "bank": "en-oo1",
        "durationMs": 3925
    },
    "The fish choosing a seat for lunch puts a fish under the table.": {
        "file": "c4575279fdd0a1d8e269.mp3",
        "bank": "en-oo1",
        "durationMs": 4125
    },
    "The fish choosing a seat for lunch puts a computer on the table.": {
        "file": "2f642c3fc0fd651fad70.mp3",
        "bank": "en-oo1",
        "durationMs": 4275
    },
    "The fish choosing a seat for lunch puts a computer under the table.": {
        "file": "820996b290ac297239b6.mp3",
        "bank": "en-oo1",
        "durationMs": 4375
    },
    "The fish choosing a seat for lunch puts a box on the table.": {
        "file": "91913f3608b76bab281a.mp3",
        "bank": "en-oo1",
        "durationMs": 3975
    },
    "The fish choosing a seat for lunch puts a box under the table.": {
        "file": "eb59bb89233937406b2a.mp3",
        "bank": "en-oo1",
        "durationMs": 4150
    },
    "The fish choosing a seat for lunch puts a bag on the table.": {
        "file": "40888477c9561344f23d.mp3",
        "bank": "en-oo1",
        "durationMs": 3925
    },
    "The fish choosing a seat for lunch puts a bag under the table.": {
        "file": "c437b1fde5f680df8814.mp3",
        "bank": "en-oo1",
        "durationMs": 4125
    },
    "The fish choosing a seat for lunch puts a glass on the table.": {
        "file": "f855e9833d56c0a546b9.mp3",
        "bank": "en-oo1",
        "durationMs": 4050
    },
    "The fish choosing a seat for lunch puts a glass under the table.": {
        "file": "cf0adc045fa5d4b14ff2.mp3",
        "bank": "en-oo1",
        "durationMs": 4175
    },
    "The fish choosing a seat for lunch puts a bottle on the table.": {
        "file": "e37be935f5173c2d0ed6.mp3",
        "bank": "en-oo1",
        "durationMs": 4000
    },
    "The fish choosing a seat for lunch puts a bottle under the table.": {
        "file": "478ba61abc363a1e62b0.mp3",
        "bank": "en-oo1",
        "durationMs": 4200
    },
    "The fish choosing a seat for lunch puts a ticket on the table.": {
        "file": "43821a2f65644ea1a644.mp3",
        "bank": "en-oo1",
        "durationMs": 4025
    },
    "The fish choosing a seat for lunch puts a ticket under the table.": {
        "file": "fc65f83f6d0a413082b9.mp3",
        "bank": "en-oo1",
        "durationMs": 4226
    },
    "The fish choosing a seat for lunch puts a hat on the table.": {
        "file": "a4f4a3bbead9a543628d.mp3",
        "bank": "en-oo1",
        "durationMs": 3900
    },
    "The fish choosing a seat for lunch puts a hat under the table.": {
        "file": "44c36529c67600fae53a.mp3",
        "bank": "en-oo1",
        "durationMs": 4075
    },
    "The fish choosing a seat for lunch puts a picture on the table.": {
        "file": "3c3e0a3b1cd47b58c408.mp3",
        "bank": "en-oo1",
        "durationMs": 4050
    },
    "The fish choosing a seat for lunch puts a picture under the table.": {
        "file": "dc5ebd6ed0c3e7c63dbc.mp3",
        "bank": "en-oo1",
        "durationMs": 4226
    },
    "The fish choosing a seat for lunch puts a gift on the table.": {
        "file": "cf4120bfc87a166a384c.mp3",
        "bank": "en-oo1",
        "durationMs": 3925
    },
    "The fish choosing a seat for lunch puts a gift under the table.": {
        "file": "e21b26bbcf7a534b3b48.mp3",
        "bank": "en-oo1",
        "durationMs": 4200
    },
    "The clock arriving late for class is wearing a large hat and carrying a ticket.": {
        "file": "0a4d253dbb4cdfb5c48b.mp3",
        "bank": "en-oo1",
        "durationMs": 5225
    },
    "The clock arriving late for class is wearing a large hat and carrying a bottle.": {
        "file": "424f5caecdb2dbaf1ea6.mp3",
        "bank": "en-oo1",
        "durationMs": 5150
    },
    "The clock arriving late for class is wearing a small hat and carrying a ticket.": {
        "file": "cea58c878c1baad763b0.mp3",
        "bank": "en-oo1",
        "durationMs": 5300
    },
    "The clock arriving late for class is wearing a small hat and carrying a bottle.": {
        "file": "2a01e5ded60ad346e8d9.mp3",
        "bank": "en-oo1",
        "durationMs": 5300
    },
    "The clock arriving late for class is wearing a long scarf and carrying a dog.": {
        "file": "c035b2c0f050bf79c855.mp3",
        "bank": "en-oo1",
        "durationMs": 5175
    },
    "The clock arriving late for class is wearing a long scarf and carrying a cup.": {
        "file": "fbf1c94e525b2e5ab221.mp3",
        "bank": "en-oo1",
        "durationMs": 5150
    },
    "The clock arriving late for class is wearing a short scarf and carrying a dog.": {
        "file": "3a934a0f29900f97cf89.mp3",
        "bank": "en-oo1",
        "durationMs": 5200
    },
    "The clock arriving late for class is wearing a short scarf and carrying a cup.": {
        "file": "9c33bfca388ac0b4c048.mp3",
        "bank": "en-oo1",
        "durationMs": 5225
    },
    "The clock arriving late for class is wearing round glasses and carrying a box.": {
        "file": "0659c17c794d5fda0f48.mp3",
        "bank": "en-oo1",
        "durationMs": 5375
    },
    "The clock arriving late for class is wearing round glasses and carrying a flower.": {
        "file": "5d71a8b555b8f819558e.mp3",
        "bank": "en-oo1",
        "durationMs": 5550
    },
    "The clock arriving late for class is wearing square glasses and carrying a box.": {
        "file": "4b5b7cb743b750526f7e.mp3",
        "bank": "en-oo1",
        "durationMs": 5400
    },
    "The clock arriving late for class is wearing square glasses and carrying a flower.": {
        "file": "1085a5b773eb4531609a.mp3",
        "bank": "en-oo1",
        "durationMs": 5525
    },
    "The clock arriving late for class is wearing a jacket with two pockets and carrying a shoe.": {
        "file": "8b4d25d7420021cc486d.mp3",
        "bank": "en-oo1",
        "durationMs": 5975
    },
    "The clock arriving late for class is wearing a jacket with two pockets and carrying a fish.": {
        "file": "4e514450bba1f6f5f2f6.mp3",
        "bank": "en-oo1",
        "durationMs": 6026
    },
    "The clock arriving late for class is wearing a jacket with four pockets and carrying a shoe.": {
        "file": "3a3eff0ff33f7a180002.mp3",
        "bank": "en-oo1",
        "durationMs": 6026
    },
    "The clock arriving late for class is wearing a jacket with four pockets and carrying a fish.": {
        "file": "aaea721c837e5cfbe34b.mp3",
        "bank": "en-oo1",
        "durationMs": 6150
    },
    "The clock arriving late for class is wearing a shirt with long sleeves and carrying a book.": {
        "file": "76ec60b9c67339cd8849.mp3",
        "bank": "en-oo1",
        "durationMs": 6026
    },
    "The clock arriving late for class is wearing a shirt with long sleeves and carrying a coin.": {
        "file": "85b5cb81239b37291bf5.mp3",
        "bank": "en-oo1",
        "durationMs": 6050
    },
    "The clock arriving late for class is wearing a shirt with short sleeves and carrying a book.": {
        "file": "72bf8ea5b74e343db249.mp3",
        "bank": "en-oo1",
        "durationMs": 5925
    },
    "The clock arriving late for class is wearing a shirt with short sleeves and carrying a coin.": {
        "file": "be32c877b9f73d1e6134.mp3",
        "bank": "en-oo1",
        "durationMs": 5950
    },
    "In our class for tired shoes, there are two glasses by the door.": {
        "file": "28e123db3135335576ce.mp3",
        "bank": "en-oo1",
        "durationMs": 4300
    },
    "In our class for tired shoes, there are two tickets by the door.": {
        "file": "9611b719bd7f3e696559.mp3",
        "bank": "en-oo1",
        "durationMs": 4200
    },
    "In our class for tired shoes, there are three glasses by the door.": {
        "file": "93dbc39935bc3a368785.mp3",
        "bank": "en-oo1",
        "durationMs": 4450
    },
    "In our class for tired shoes, there are three tickets by the door.": {
        "file": "816e84ec5746d534d6ea.mp3",
        "bank": "en-oo1",
        "durationMs": 4200
    },
    "In our class for tired shoes, there are two boxes by the door.": {
        "file": "d18d1469724b79083300.mp3",
        "bank": "en-oo1",
        "durationMs": 4325
    },
    "In our class for tired shoes, there are two flowers by the door.": {
        "file": "46d267f2aa42b0eb3e1b.mp3",
        "bank": "en-oo1",
        "durationMs": 4200
    },
    "In our class for tired shoes, there are four boxes by the door.": {
        "file": "1db70d76b2073804e4f9.mp3",
        "bank": "en-oo1",
        "durationMs": 4350
    },
    "In our class for tired shoes, there are four flowers by the door.": {
        "file": "5c55d74d1a1dd10bc503.mp3",
        "bank": "en-oo1",
        "durationMs": 4250
    },
    "In our class for tired shoes, there are two cups by the door.": {
        "file": "16474e21e2ea170d32c9.mp3",
        "bank": "en-oo1",
        "durationMs": 4000
    },
    "In our class for tired shoes, there are two pencils by the door.": {
        "file": "60d262ed15d605c29b73.mp3",
        "bank": "en-oo1",
        "durationMs": 4325
    },
    "In our class for tired shoes, there are three cups by the door.": {
        "file": "e54f9b61b8797eaa7115.mp3",
        "bank": "en-oo1",
        "durationMs": 4100
    },
    "In our class for tired shoes, there are three pencils by the door.": {
        "file": "867eb9cb7c410503e720.mp3",
        "bank": "en-oo1",
        "durationMs": 4325
    },
    "In our class for tired shoes, there are two fish by the door.": {
        "file": "cf51293dc4160fcfb615.mp3",
        "bank": "en-oo1",
        "durationMs": 3975
    },
    "In our class for tired shoes, there are two shoes by the door.": {
        "file": "d5631048441e54036172.mp3",
        "bank": "en-oo1",
        "durationMs": 4075
    },
    "In our class for tired shoes, there are four fish by the door.": {
        "file": "345d7c419d6388eb2793.mp3",
        "bank": "en-oo1",
        "durationMs": 4100
    },
    "In our class for tired shoes, there are four shoes by the door.": {
        "file": "38dc43715c5be17689ac.mp3",
        "bank": "en-oo1",
        "durationMs": 4150
    },
    "In our class for tired shoes, there are two coins by the door.": {
        "file": "aa0c82c2f061d3af0892.mp3",
        "bank": "en-oo1",
        "durationMs": 4200
    },
    "In our class for tired shoes, there are two bottles by the door.": {
        "file": "45731fee1bf061e73351.mp3",
        "bank": "en-oo1",
        "durationMs": 4200
    },
    "In our class for tired shoes, there are three coins by the door.": {
        "file": "04d5f93bb2b106290605.mp3",
        "bank": "en-oo1",
        "durationMs": 4175
    },
    "In our class for tired shoes, there are three bottles by the door.": {
        "file": "f0edfe3692feddfe68e7.mp3",
        "bank": "en-oo1",
        "durationMs": 4300
    },
    "At the museum for one lost sock, a cup is on the table.": {
        "file": "84cc4acc757eb1066820.mp3",
        "bank": "en-oo1",
        "durationMs": 3975
    },
    "At the museum for one lost sock, a cup is under the table.": {
        "file": "66ecde9693ca30ab41c9.mp3",
        "bank": "en-oo1",
        "durationMs": 4125
    },
    "At the museum for one lost sock, a glass is on the table.": {
        "file": "f3bb35d5a7b5fe286c4b.mp3",
        "bank": "en-oo1",
        "durationMs": 4150
    },
    "At the museum for one lost sock, a glass is under the table.": {
        "file": "72b137fe238291d20ed4.mp3",
        "bank": "en-oo1",
        "durationMs": 4300
    },
    "At the museum for one lost sock, a ticket is on the table.": {
        "file": "39bc884644b3af69e2e7.mp3",
        "bank": "en-oo1",
        "durationMs": 4175
    },
    "At the museum for one lost sock, a ticket is under the table.": {
        "file": "2f64bea5eae553ec14e8.mp3",
        "bank": "en-oo1",
        "durationMs": 4275
    },
    "At the museum for one lost sock, a box is on the table.": {
        "file": "56b7ff75366a6135b771.mp3",
        "bank": "en-oo1",
        "durationMs": 4125
    },
    "At the museum for one lost sock, a box is under the table.": {
        "file": "89817d463a98fec54de8.mp3",
        "bank": "en-oo1",
        "durationMs": 4226
    },
    "At the museum for one lost sock, a bottle is on the table.": {
        "file": "1d12356ff6a54a363db2.mp3",
        "bank": "en-oo1",
        "durationMs": 4125
    },
    "At the museum for one lost sock, a bottle is under the table.": {
        "file": "ba853df1459b86257db4.mp3",
        "bank": "en-oo1",
        "durationMs": 4250
    },
    "At the museum for one lost sock, a gift is on the table.": {
        "file": "f044287337841d5e87ea.mp3",
        "bank": "en-oo1",
        "durationMs": 4125
    },
    "At the museum for one lost sock, a gift is under the table.": {
        "file": "a490ac12c205a1b03b50.mp3",
        "bank": "en-oo1",
        "durationMs": 4250
    },
    "At the museum for one lost sock, a dog is on the table.": {
        "file": "4f99adff0ae3420f6f77.mp3",
        "bank": "en-oo1",
        "durationMs": 4125
    },
    "At the museum for one lost sock, a dog is under the table.": {
        "file": "bb51fb68a04e612cdda3.mp3",
        "bank": "en-oo1",
        "durationMs": 4275
    },
    "At the museum for one lost sock, a fish is on the table.": {
        "file": "a1c02c3a8494f64b3d43.mp3",
        "bank": "en-oo1",
        "durationMs": 4000
    },
    "At the museum for one lost sock, a fish is under the table.": {
        "file": "28bd5c1516c50ebc4387.mp3",
        "bank": "en-oo1",
        "durationMs": 4200
    },
    "At the museum for one lost sock, a hat is on the table.": {
        "file": "926d09c8c1aca479d143.mp3",
        "bank": "en-oo1",
        "durationMs": 4000
    },
    "At the museum for one lost sock, a hat is under the table.": {
        "file": "60bd8702b7a04ebceb0a.mp3",
        "bank": "en-oo1",
        "durationMs": 4125
    },
    "At the museum for one lost sock, a book is on the table.": {
        "file": "182e0202abd5aa4b99b7.mp3",
        "bank": "en-oo1",
        "durationMs": 3950
    },
    "At the museum for one lost sock, a book is under the table.": {
        "file": "79e020eaad2a3359f881.mp3",
        "bank": "en-oo1",
        "durationMs": 4075
    },
    "The museum's favorite picture frame surrounds a large glass.": {
        "file": "2780db185cd337adb4dc.mp3",
        "bank": "en-oo1",
        "durationMs": 4175
    },
    "The museum's favorite picture frame surrounds a large fish.": {
        "file": "907478b22ed7f202d180.mp3",
        "bank": "en-oo1",
        "durationMs": 4050
    },
    "The museum's favorite picture frame surrounds a small glass.": {
        "file": "b60197e9ca17f45ac683.mp3",
        "bank": "en-oo1",
        "durationMs": 4125
    },
    "The museum's favorite picture frame surrounds a small fish.": {
        "file": "be9b24c065421414477c.mp3",
        "bank": "en-oo1",
        "durationMs": 4125
    },
    "The museum's favorite picture frame surrounds a large bag.": {
        "file": "195c5a5f66e962d8e137.mp3",
        "bank": "en-oo1",
        "durationMs": 4100
    },
    "The museum's favorite picture frame surrounds a large magazine.": {
        "file": "9d5f5906697825d6c126.mp3",
        "bank": "en-oo1",
        "durationMs": 4525
    },
    "The museum's favorite picture frame surrounds a small bag.": {
        "file": "7982f4667aeb27f52b74.mp3",
        "bank": "en-oo1",
        "durationMs": 4150
    },
    "The museum's favorite picture frame surrounds a small magazine.": {
        "file": "010e955453a7573ee2f3.mp3",
        "bank": "en-oo1",
        "durationMs": 4525
    },
    "The museum's favorite picture frame surrounds a large clock.": {
        "file": "9a1639fef87f54e30d2e.mp3",
        "bank": "en-oo1",
        "durationMs": 4125
    },
    "The museum's favorite picture frame surrounds a large box.": {
        "file": "6a87bff10a5e94382d95.mp3",
        "bank": "en-oo1",
        "durationMs": 4125
    },
    "The museum's favorite picture frame surrounds a small clock.": {
        "file": "08e165bc7aafa3ed198f.mp3",
        "bank": "en-oo1",
        "durationMs": 4100
    },
    "The museum's favorite picture frame surrounds a small box.": {
        "file": "1f75046a2a3f4ab75bd7.mp3",
        "bank": "en-oo1",
        "durationMs": 4075
    },
    "The museum's favorite picture frame surrounds a large dog.": {
        "file": "5e417d4076b62f1dc9a5.mp3",
        "bank": "en-oo1",
        "durationMs": 4125
    },
    "The museum's favorite picture frame surrounds a large shoe.": {
        "file": "15c626037fcf0a9c4103.mp3",
        "bank": "en-oo1",
        "durationMs": 3975
    },
    "The museum's favorite picture frame surrounds a small dog.": {
        "file": "7b242915cda5ad09f83a.mp3",
        "bank": "en-oo1",
        "durationMs": 4100
    },
    "The museum's favorite picture frame surrounds a small shoe.": {
        "file": "55e25a4ece0420716a6c.mp3",
        "bank": "en-oo1",
        "durationMs": 4075
    },
    "The museum's favorite picture frame surrounds a large flower.": {
        "file": "8fd49a789e2b526d4666.mp3",
        "bank": "en-oo1",
        "durationMs": 4250
    },
    "The museum's favorite picture frame surrounds a large robot.": {
        "file": "1674ba05ed24245b3120.mp3",
        "bank": "en-oo1",
        "durationMs": 4325
    },
    "The museum's favorite picture frame surrounds a small flower.": {
        "file": "a0087456351849c432ee.mp3",
        "bank": "en-oo1",
        "durationMs": 4250
    },
    "The museum's favorite picture frame surrounds a small robot.": {
        "file": "37c2d94677ecdf624b26.mp3",
        "bank": "en-oo1",
        "durationMs": 4325
    },
    "The museum of unfinished homework has two tickets on the floor.": {
        "file": "68337b443943d5527fd5.mp3",
        "bank": "en-oo1",
        "durationMs": 4226
    },
    "The museum of unfinished homework has two pencils on the floor.": {
        "file": "31b57ca1b2d593e6eb5b.mp3",
        "bank": "en-oo1",
        "durationMs": 4375
    },
    "The museum of unfinished homework has three tickets on the floor.": {
        "file": "b30ba40cf95a0903027e.mp3",
        "bank": "en-oo1",
        "durationMs": 4300
    },
    "The museum of unfinished homework has three pencils on the floor.": {
        "file": "b80b11d6b2bd846177e3.mp3",
        "bank": "en-oo1",
        "durationMs": 4475
    },
    "The museum of unfinished homework has two glasses on the floor.": {
        "file": "ebd60fa78561d3a43a3e.mp3",
        "bank": "en-oo1",
        "durationMs": 4450
    },
    "The museum of unfinished homework has two books on the floor.": {
        "file": "a45e1ec81c8ca7be59f6.mp3",
        "bank": "en-oo1",
        "durationMs": 4050
    },
    "The museum of unfinished homework has four glasses on the floor.": {
        "file": "412ed3bcbca492498d4a.mp3",
        "bank": "en-oo1",
        "durationMs": 4500
    },
    "The museum of unfinished homework has four books on the floor.": {
        "file": "53c6e6411f5a42893db1.mp3",
        "bank": "en-oo1",
        "durationMs": 4125
    },
    "The museum of unfinished homework has two flowers on the floor.": {
        "file": "1091fdd311b0cff1abd7.mp3",
        "bank": "en-oo1",
        "durationMs": 4275
    },
    "The museum of unfinished homework has two robots on the floor.": {
        "file": "84dfb890d0e102885364.mp3",
        "bank": "en-oo1",
        "durationMs": 4375
    },
    "The museum of unfinished homework has three flowers on the floor.": {
        "file": "74b0e9bf7a9eebfd22e1.mp3",
        "bank": "en-oo1",
        "durationMs": 4350
    },
    "The museum of unfinished homework has three robots on the floor.": {
        "file": "139c15718f487a3bc8a8.mp3",
        "bank": "en-oo1",
        "durationMs": 4500
    },
    "The museum of unfinished homework has two pictures on the floor.": {
        "file": "bb1605b1dae68074ae0c.mp3",
        "bank": "en-oo1",
        "durationMs": 4325
    },
    "The museum of unfinished homework has two eggs on the floor.": {
        "file": "6fcafce60c9f955454fc.mp3",
        "bank": "en-oo1",
        "durationMs": 4150
    },
    "The museum of unfinished homework has four pictures on the floor.": {
        "file": "60f4f5145c6eb6e5daad.mp3",
        "bank": "en-oo1",
        "durationMs": 4400
    },
    "The museum of unfinished homework has four eggs on the floor.": {
        "file": "f942889e0e45d8afbeb0.mp3",
        "bank": "en-oo1",
        "durationMs": 4226
    },
    "The museum of unfinished homework has two cups on the floor.": {
        "file": "b08bece322a75bf8c0de.mp3",
        "bank": "en-oo1",
        "durationMs": 4100
    },
    "The museum of unfinished homework has two cats on the floor.": {
        "file": "9ee1e93243d0a1ab3767.mp3",
        "bank": "en-oo1",
        "durationMs": 4200
    },
    "The museum of unfinished homework has three cups on the floor.": {
        "file": "6410cff38a6b94ebff9d.mp3",
        "bank": "en-oo1",
        "durationMs": 4175
    },
    "The museum of unfinished homework has three cats on the floor.": {
        "file": "9d9c4937965c8f686f06.mp3",
        "bank": "en-oo1",
        "durationMs": 4250
    },
    "At the museum of air, the guard keeps a gift beside the box.": {
        "file": "5d07987e9b442c1143a8.mp3",
        "bank": "en-oo1",
        "durationMs": 4275
    },
    "At the museum of air, the guard keeps a gift inside the box.": {
        "file": "8e1814e7a890610dbefb.mp3",
        "bank": "en-oo1",
        "durationMs": 4350
    },
    "At the museum of air, the guard keeps a ticket beside the box.": {
        "file": "a5b0f69e55152227e4bf.mp3",
        "bank": "en-oo1",
        "durationMs": 4300
    },
    "At the museum of air, the guard keeps a ticket inside the box.": {
        "file": "7457696a55dd3aa29d3d.mp3",
        "bank": "en-oo1",
        "durationMs": 4375
    },
    "At the museum of air, the guard keeps a box beside the box.": {
        "file": "1766af78bb423fd31be7.mp3",
        "bank": "en-oo1",
        "durationMs": 4300
    },
    "At the museum of air, the guard keeps a box inside the box.": {
        "file": "15c21ce84827bf0302d7.mp3",
        "bank": "en-oo1",
        "durationMs": 4325
    },
    "At the museum of air, the guard keeps a robot beside the box.": {
        "file": "3e93ca0a3ef9175cbc43.mp3",
        "bank": "en-oo1",
        "durationMs": 4425
    },
    "At the museum of air, the guard keeps a robot inside the box.": {
        "file": "25402d1242d64d74ec4a.mp3",
        "bank": "en-oo1",
        "durationMs": 4475
    },
    "At the museum of air, the guard keeps a cup beside the box.": {
        "file": "f2d69c6303c71e49cacd.mp3",
        "bank": "en-oo1",
        "durationMs": 4125
    },
    "At the museum of air, the guard keeps a cup inside the box.": {
        "file": "04db4b56bd7358bc9636.mp3",
        "bank": "en-oo1",
        "durationMs": 4226
    },
    "At the museum of air, the guard keeps a fish beside the box.": {
        "file": "14f50b45e683fa55c27e.mp3",
        "bank": "en-oo1",
        "durationMs": 4250
    },
    "At the museum of air, the guard keeps a fish inside the box.": {
        "file": "1be7f0c2c61f21087911.mp3",
        "bank": "en-oo1",
        "durationMs": 4300
    },
    "At the museum of air, the guard keeps a bag beside the box.": {
        "file": "13bc75af5b063d9fd84d.mp3",
        "bank": "en-oo1",
        "durationMs": 4250
    },
    "At the museum of air, the guard keeps a bag inside the box.": {
        "file": "80fbceb607fcd8b9d6e8.mp3",
        "bank": "en-oo1",
        "durationMs": 4275
    },
    "At the museum of air, the guard keeps a hat beside the box.": {
        "file": "6a5750147d62360bb269.mp3",
        "bank": "en-oo1",
        "durationMs": 4150
    },
    "At the museum of air, the guard keeps a hat inside the box.": {
        "file": "95d6241c8dbea2bfe6fe.mp3",
        "bank": "en-oo1",
        "durationMs": 4175
    },
    "At the museum of air, the guard keeps an egg beside the box.": {
        "file": "ac19c7277b21fd4a3361.mp3",
        "bank": "en-oo1",
        "durationMs": 4226
    },
    "At the museum of air, the guard keeps an egg inside the box.": {
        "file": "3b1d1d63a9ba4d0f3a86.mp3",
        "bank": "en-oo1",
        "durationMs": 4300
    },
    "At the museum of air, the guard keeps a book beside the box.": {
        "file": "2872592e662904bded74.mp3",
        "bank": "en-oo1",
        "durationMs": 4125
    },
    "At the museum of air, the guard keeps a book inside the box.": {
        "file": "e54e09da2b7335587daf.mp3",
        "bank": "en-oo1",
        "durationMs": 4175
    },
    "The visitors admiring the floor watch a woman wash a bottle.": {
        "file": "8adde77e9afe59bf2f15.mp3",
        "bank": "en-oo1",
        "durationMs": 4100
    },
    "The visitors admiring the floor watch a woman wash a glass.": {
        "file": "b6a9551b667389bde172.mp3",
        "bank": "en-oo1",
        "durationMs": 4200
    },
    "The visitors admiring the floor watch a woman draw a bottle.": {
        "file": "a4bc9b7742395f63c120.mp3",
        "bank": "en-oo1",
        "durationMs": 4200
    },
    "The visitors admiring the floor watch a woman draw a glass.": {
        "file": "bcaae69a4abaa08b9fbf.mp3",
        "bank": "en-oo1",
        "durationMs": 4200
    },
    "The visitors admiring the floor watch a woman wash a fish.": {
        "file": "1c9df4b6ccec6f2df8f6.mp3",
        "bank": "en-oo1",
        "durationMs": 4100
    },
    "The visitors admiring the floor watch a woman wash a phone.": {
        "file": "cccd9ac9ab7c896ea3bd.mp3",
        "bank": "en-oo1",
        "durationMs": 4125
    },
    "The visitors admiring the floor watch a woman draw a fish.": {
        "file": "f2c1221988f9ff4eac96.mp3",
        "bank": "en-oo1",
        "durationMs": 4150
    },
    "The visitors admiring the floor watch a woman draw a phone.": {
        "file": "1e6e29ce72b6f0b60a5a.mp3",
        "bank": "en-oo1",
        "durationMs": 4226
    },
    "The visitors admiring the floor watch a woman wash a gift.": {
        "file": "cc9d5da188ba7a257d79.mp3",
        "bank": "en-oo1",
        "durationMs": 4100
    },
    "The visitors admiring the floor watch a woman wash a book.": {
        "file": "0428e97d976a312ab210.mp3",
        "bank": "en-oo1",
        "durationMs": 4000
    },
    "The visitors admiring the floor watch a woman draw a gift.": {
        "file": "286bf185bd9fc622290e.mp3",
        "bank": "en-oo1",
        "durationMs": 4125
    },
    "The visitors admiring the floor watch a woman draw a book.": {
        "file": "9dd08848183f74e92c3f.mp3",
        "bank": "en-oo1",
        "durationMs": 4075
    },
    "The visitors admiring the floor watch a woman wash a cup.": {
        "file": "7ed52d5684d9eab0eafa.mp3",
        "bank": "en-oo1",
        "durationMs": 4025
    },
    "The visitors admiring the floor watch a woman wash a box.": {
        "file": "4d2c6299ccd9acb0df27.mp3",
        "bank": "en-oo1",
        "durationMs": 4075
    },
    "The visitors admiring the floor watch a woman draw a cup.": {
        "file": "7c889a1fb6e7114a7cf8.mp3",
        "bank": "en-oo1",
        "durationMs": 4075
    },
    "The visitors admiring the floor watch a woman draw a box.": {
        "file": "f6cbb5f44bd3253be349.mp3",
        "bank": "en-oo1",
        "durationMs": 4050
    },
    "The visitors admiring the floor watch a woman wash a flower.": {
        "file": "857b6a7673cd2b519c8f.mp3",
        "bank": "en-oo1",
        "durationMs": 4250
    },
    "The visitors admiring the floor watch a woman wash a bag.": {
        "file": "2ef9a19e4cb45de840ee.mp3",
        "bank": "en-oo1",
        "durationMs": 4050
    },
    "The visitors admiring the floor watch a woman draw a flower.": {
        "file": "612b5f0c087562a14221.mp3",
        "bank": "en-oo1",
        "durationMs": 4200
    },
    "The visitors admiring the floor watch a woman draw a bag.": {
        "file": "e3f34769bfd5dbc70e23.mp3",
        "bank": "en-oo1",
        "durationMs": 4100
    },
    "The winner at our museum of boring things is wearing a large hat and holding a fish.": {
        "file": "5930064452f955008d3f.mp3",
        "bank": "en-oo1",
        "durationMs": 5525
    },
    "The winner at our museum of boring things is wearing a large hat and holding a glass.": {
        "file": "8e42f5edd97e62274091.mp3",
        "bank": "en-oo1",
        "durationMs": 5575
    },
    "The winner at our museum of boring things is wearing a small hat and holding a fish.": {
        "file": "38ad78c40e4f431a3025.mp3",
        "bank": "en-oo1",
        "durationMs": 5550
    },
    "The winner at our museum of boring things is wearing a small hat and holding a glass.": {
        "file": "4f36a3f8c4a713aded17.mp3",
        "bank": "en-oo1",
        "durationMs": 5675
    },
    "The winner at our museum of boring things is wearing a long scarf and holding a gift.": {
        "file": "4e856aa430629d49696f.mp3",
        "bank": "en-oo1",
        "durationMs": 5650
    },
    "The winner at our museum of boring things is wearing a long scarf and holding a cup.": {
        "file": "f83abbc53830cfada48a.mp3",
        "bank": "en-oo1",
        "durationMs": 5625
    },
    "The winner at our museum of boring things is wearing a short scarf and holding a gift.": {
        "file": "63ae5bc15848407dd8c5.mp3",
        "bank": "en-oo1",
        "durationMs": 5650
    },
    "The winner at our museum of boring things is wearing a short scarf and holding a cup.": {
        "file": "a9c5c5981c5be8517a38.mp3",
        "bank": "en-oo1",
        "durationMs": 5575
    },
    "The winner at our museum of boring things is wearing round glasses and holding a clock.": {
        "file": "d641a6fd54ff67d31daa.mp3",
        "bank": "en-oo1",
        "durationMs": 5825
    },
    "The winner at our museum of boring things is wearing round glasses and holding a newspaper.": {
        "file": "007a0e0848a023a96ecb.mp3",
        "bank": "en-oo1",
        "durationMs": 6175
    },
    "The winner at our museum of boring things is wearing square glasses and holding a clock.": {
        "file": "5d614163756c2e9a9d7f.mp3",
        "bank": "en-oo1",
        "durationMs": 5775
    },
    "The winner at our museum of boring things is wearing square glasses and holding a newspaper.": {
        "file": "a96aaf54628d1116417b.mp3",
        "bank": "en-oo1",
        "durationMs": 6100
    },
    "The winner at our museum of boring things is wearing a jacket with two pockets and holding a bag.": {
        "file": "b5e03e98d8213e416788.mp3",
        "bank": "en-oo1",
        "durationMs": 6350
    },
    "The winner at our museum of boring things is wearing a jacket with two pockets and holding a dog.": {
        "file": "f2eef21ace4ab019a657.mp3",
        "bank": "en-oo1",
        "durationMs": 6425
    },
    "The winner at our museum of boring things is wearing a jacket with four pockets and holding a bag.": {
        "file": "1dda8933cef1129c0863.mp3",
        "bank": "en-oo1",
        "durationMs": 6450
    },
    "The winner at our museum of boring things is wearing a jacket with four pockets and holding a dog.": {
        "file": "4fa6cae85a23ef984fbb.mp3",
        "bank": "en-oo1",
        "durationMs": 6500
    },
    "The winner at our museum of boring things is wearing a shirt with long sleeves and holding a bottle.": {
        "file": "08b4bfcce7fcba71f6d5.mp3",
        "bank": "en-oo1",
        "durationMs": 6400
    },
    "The winner at our museum of boring things is wearing a shirt with long sleeves and holding a pencil.": {
        "file": "1cdb0255f5f1e98e0b83.mp3",
        "bank": "en-oo1",
        "durationMs": 6525
    },
    "The winner at our museum of boring things is wearing a shirt with short sleeves and holding a bottle.": {
        "file": "3ed7e0b78efc63262384.mp3",
        "bank": "en-oo1",
        "durationMs": 6350
    },
    "The winner at our museum of boring things is wearing a shirt with short sleeves and holding a pencil.": {
        "file": "cc4024fdeec686c64e8d.mp3",
        "bank": "en-oo1",
        "durationMs": 6475
    },
    "The museum's tiny dust display is surrounded by two books.": {
        "file": "00b3577099c268191b69.mp3",
        "bank": "en-oo1",
        "durationMs": 4275
    },
    "The museum's tiny dust display is surrounded by two glasses.": {
        "file": "dce2583f71ea893f9ed1.mp3",
        "bank": "en-oo1",
        "durationMs": 4600
    },
    "The museum's tiny dust display is surrounded by three books.": {
        "file": "4cca9edcf4d209323618.mp3",
        "bank": "en-oo1",
        "durationMs": 4350
    },
    "The museum's tiny dust display is surrounded by three glasses.": {
        "file": "fe1ba7be9c75bd17d314.mp3",
        "bank": "en-oo1",
        "durationMs": 4725
    },
    "The museum's tiny dust display is surrounded by two keys.": {
        "file": "0b827584ae208051cf1b.mp3",
        "bank": "en-oo1",
        "durationMs": 4325
    },
    "The museum's tiny dust display is surrounded by two fish.": {
        "file": "30bdf311adab2a4389e2.mp3",
        "bank": "en-oo1",
        "durationMs": 4226
    },
    "The museum's tiny dust display is surrounded by four keys.": {
        "file": "ab27b3935fab927db5d7.mp3",
        "bank": "en-oo1",
        "durationMs": 4325
    },
    "The museum's tiny dust display is surrounded by four fish.": {
        "file": "94381db77856b02546f0.mp3",
        "bank": "en-oo1",
        "durationMs": 4300
    },
    "The museum's tiny dust display is surrounded by two clocks.": {
        "file": "fce317b011a50da5d224.mp3",
        "bank": "en-oo1",
        "durationMs": 4400
    },
    "The museum's tiny dust display is surrounded by two bags.": {
        "file": "b3a08fe6cc5115d3c690.mp3",
        "bank": "en-oo1",
        "durationMs": 4375
    },
    "The museum's tiny dust display is surrounded by three clocks.": {
        "file": "80a2299f25876563a670.mp3",
        "bank": "en-oo1",
        "durationMs": 4500
    },
    "The museum's tiny dust display is surrounded by three bags.": {
        "file": "af7648958ec96945ec0d.mp3",
        "bank": "en-oo1",
        "durationMs": 4475
    },
    "The museum's tiny dust display is surrounded by two boxes.": {
        "file": "f2ee2fc9a8c4808d6dec.mp3",
        "bank": "en-oo1",
        "durationMs": 4525
    },
    "The museum's tiny dust display is surrounded by two computers.": {
        "file": "e55d3b0d50d5836eb510.mp3",
        "bank": "en-oo1",
        "durationMs": 4625
    },
    "The museum's tiny dust display is surrounded by four boxes.": {
        "file": "6beffc378700ce238422.mp3",
        "bank": "en-oo1",
        "durationMs": 4600
    },
    "The museum's tiny dust display is surrounded by four computers.": {
        "file": "5c472877712df8ffe3d6.mp3",
        "bank": "en-oo1",
        "durationMs": 4700
    },
    "The museum's tiny dust display is surrounded by two bottles.": {
        "file": "09f790cbc9fa938166bc.mp3",
        "bank": "en-oo1",
        "durationMs": 4475
    },
    "The museum's tiny dust display is surrounded by two cats.": {
        "file": "9db15b1bd47d40b05186.mp3",
        "bank": "en-oo1",
        "durationMs": 4325
    },
    "The museum's tiny dust display is surrounded by three bottles.": {
        "file": "75658f8e2884ecf43e72.mp3",
        "bank": "en-oo1",
        "durationMs": 4600
    },
    "The museum's tiny dust display is surrounded by three cats.": {
        "file": "b10145fa3e5e269ada46.mp3",
        "bank": "en-oo1",
        "durationMs": 4425
    },
    "At the show about museum tickets, a bag is above the door.": {
        "file": "5025ae8a2c74d3595584.mp3",
        "bank": "en-oo1",
        "durationMs": 4100
    },
    "At the show about museum tickets, a bag is beside the door.": {
        "file": "32b58f7ebf25cf8334f1.mp3",
        "bank": "en-oo1",
        "durationMs": 4275
    },
    "At the show about museum tickets, an umbrella is above the door.": {
        "file": "467e9ad16790b818651c.mp3",
        "bank": "en-oo1",
        "durationMs": 4525
    },
    "At the show about museum tickets, an umbrella is beside the door.": {
        "file": "8c15462205269fef1183.mp3",
        "bank": "en-oo1",
        "durationMs": 4550
    },
    "At the show about museum tickets, a fish is above the door.": {
        "file": "4b26121a61cc45ec56e3.mp3",
        "bank": "en-oo1",
        "durationMs": 4125
    },
    "At the show about museum tickets, a fish is beside the door.": {
        "file": "815f2e742c1e75b2314b.mp3",
        "bank": "en-oo1",
        "durationMs": 4300
    },
    "At the show about museum tickets, a gift is above the door.": {
        "file": "afad1fac0992de39472b.mp3",
        "bank": "en-oo1",
        "durationMs": 4200
    },
    "At the show about museum tickets, a gift is beside the door.": {
        "file": "832dccc52fd34fc5a691.mp3",
        "bank": "en-oo1",
        "durationMs": 4325
    },
    "At the show about museum tickets, a ticket is above the door.": {
        "file": "4666d5247c7b5e1c34a1.mp3",
        "bank": "en-oo1",
        "durationMs": 4275
    },
    "At the show about museum tickets, a ticket is beside the door.": {
        "file": "31585fb4fae03a7b9952.mp3",
        "bank": "en-oo1",
        "durationMs": 4400
    },
    "At the show about museum tickets, a hat is above the door.": {
        "file": "9fc888c90f505bef348f.mp3",
        "bank": "en-oo1",
        "durationMs": 4100
    },
    "At the show about museum tickets, a hat is beside the door.": {
        "file": "0c691af7371f63ef1026.mp3",
        "bank": "en-oo1",
        "durationMs": 4250
    },
    "At the show about museum tickets, a bottle is above the door.": {
        "file": "dbbeedf9d1350fae3205.mp3",
        "bank": "en-oo1",
        "durationMs": 4200
    },
    "At the show about museum tickets, a bottle is beside the door.": {
        "file": "59bfda54c76726bf1a4b.mp3",
        "bank": "en-oo1",
        "durationMs": 4325
    },
    "At the show about museum tickets, a book is above the door.": {
        "file": "be2cc3473a5ad439865d.mp3",
        "bank": "en-oo1",
        "durationMs": 4000
    },
    "At the show about museum tickets, a book is beside the door.": {
        "file": "1595cacdd48c8d1d21cf.mp3",
        "bank": "en-oo1",
        "durationMs": 4200
    },
    "At the show about museum tickets, a key is above the door.": {
        "file": "d6db66dcf2c73ed5a445.mp3",
        "bank": "en-oo1",
        "durationMs": 4000
    },
    "At the show about museum tickets, a key is beside the door.": {
        "file": "4c4976b1559c7347da3c.mp3",
        "bank": "en-oo1",
        "durationMs": 4100
    },
    "At the show about museum tickets, a computer is above the door.": {
        "file": "ec82dcd38d5729bda2d8.mp3",
        "bank": "en-oo1",
        "durationMs": 4425
    },
    "At the show about museum tickets, a computer is beside the door.": {
        "file": "0a28e8e36fef05d5cc92.mp3",
        "bank": "en-oo1",
        "durationMs": 4525
    },
    "The picture taking a picture keeps a computer on its head.": {
        "file": "ddaa2d13c04325e3565e.mp3",
        "bank": "en-oo1",
        "durationMs": 3900
    },
    "The picture taking a picture keeps a computer under its arm.": {
        "file": "b662e5cf53c8dc2cc120.mp3",
        "bank": "en-oo1",
        "durationMs": 4025
    },
    "The picture taking a picture keeps a gift on its head.": {
        "file": "6efe6296b7a5ca2ba8e1.mp3",
        "bank": "en-oo1",
        "durationMs": 3600
    },
    "The picture taking a picture keeps a gift under its arm.": {
        "file": "707a30365aa3439ed196.mp3",
        "bank": "en-oo1",
        "durationMs": 3775
    },
    "The picture taking a picture keeps a dog on its head.": {
        "file": "9fa7cdfeda6f1b91ea72.mp3",
        "bank": "en-oo1",
        "durationMs": 3550
    },
    "The picture taking a picture keeps a dog under its arm.": {
        "file": "8cd1c879a22d00480221.mp3",
        "bank": "en-oo1",
        "durationMs": 3750
    },
    "The picture taking a picture keeps a glass on its head.": {
        "file": "a74475cb41880880d317.mp3",
        "bank": "en-oo1",
        "durationMs": 3626
    },
    "The picture taking a picture keeps a glass under its arm.": {
        "file": "41e29f3716a9d7d17ad3.mp3",
        "bank": "en-oo1",
        "durationMs": 3750
    },
    "The picture taking a picture keeps a book on its head.": {
        "file": "e428a20675bed2be5d74.mp3",
        "bank": "en-oo1",
        "durationMs": 3400
    },
    "The picture taking a picture keeps a book under its arm.": {
        "file": "c9cc0a181b53c8101ee5.mp3",
        "bank": "en-oo1",
        "durationMs": 3550
    },
    "The picture taking a picture keeps a phone on its head.": {
        "file": "85719078d0a519cc503c.mp3",
        "bank": "en-oo1",
        "durationMs": 3575
    },
    "The picture taking a picture keeps a phone under its arm.": {
        "file": "09e8ba1b89191b3688a4.mp3",
        "bank": "en-oo1",
        "durationMs": 3750
    },
    "The picture taking a picture keeps a fish on its head.": {
        "file": "fe3eb61b9b20b6c2e23b.mp3",
        "bank": "en-oo1",
        "durationMs": 3550
    },
    "The picture taking a picture keeps a fish under its arm.": {
        "file": "b60f32c53a76bb942994.mp3",
        "bank": "en-oo1",
        "durationMs": 3700
    },
    "The picture taking a picture keeps a bottle on its head.": {
        "file": "30933a7cd1256f40c2c0.mp3",
        "bank": "en-oo1",
        "durationMs": 3575
    },
    "The picture taking a picture keeps a bottle under its arm.": {
        "file": "bbe9857f8e4da44c1679.mp3",
        "bank": "en-oo1",
        "durationMs": 3725
    },
    "The picture taking a picture keeps a cup on its head.": {
        "file": "6d5a5b390bcc0460e427.mp3",
        "bank": "en-oo1",
        "durationMs": 3425
    },
    "The picture taking a picture keeps a cup under its arm.": {
        "file": "7fd789194e123f868a35.mp3",
        "bank": "en-oo1",
        "durationMs": 3600
    },
    "The picture taking a picture keeps a box on its head.": {
        "file": "aabf7f7543a25ffe6187.mp3",
        "bank": "en-oo1",
        "durationMs": 3525
    },
    "The picture taking a picture keeps a box under its arm.": {
        "file": "719abac52d5dcde8eb05.mp3",
        "bank": "en-oo1",
        "durationMs": 3700
    },
    "People admiring the museum exit find two phones beside it.": {
        "file": "13f44784fff136fd10dd.mp3",
        "bank": "en-oo1",
        "durationMs": 4300
    },
    "People admiring the museum exit find two cups beside it.": {
        "file": "5819c7495e51e5f08f92.mp3",
        "bank": "en-oo1",
        "durationMs": 4150
    },
    "People admiring the museum exit find three phones beside it.": {
        "file": "a00a0f6a483e94b5c8b5.mp3",
        "bank": "en-oo1",
        "durationMs": 4400
    },
    "People admiring the museum exit find three cups beside it.": {
        "file": "ede71f27908b175971f4.mp3",
        "bank": "en-oo1",
        "durationMs": 4275
    },
    "People admiring the museum exit find two keys beside it.": {
        "file": "0b126b547debaf074d88.mp3",
        "bank": "en-oo1",
        "durationMs": 4125
    },
    "People admiring the museum exit find two glasses beside it.": {
        "file": "f1098b6b146d7887811e.mp3",
        "bank": "en-oo1",
        "durationMs": 4400
    },
    "People admiring the museum exit find four keys beside it.": {
        "file": "6b2b336480d3cf9f8aa9.mp3",
        "bank": "en-oo1",
        "durationMs": 4275
    },
    "People admiring the museum exit find four glasses beside it.": {
        "file": "ac9f3a8d57e184ffedc5.mp3",
        "bank": "en-oo1",
        "durationMs": 4500
    },
    "People admiring the museum exit find two boxes beside it.": {
        "file": "c86e07bd4d642c857ae6.mp3",
        "bank": "en-oo1",
        "durationMs": 4375
    },
    "People admiring the museum exit find two robots beside it.": {
        "file": "675782e70fd3f48ea3b6.mp3",
        "bank": "en-oo1",
        "durationMs": 4400
    },
    "People admiring the museum exit find three boxes beside it.": {
        "file": "c47f3852dc1a888c665b.mp3",
        "bank": "en-oo1",
        "durationMs": 4450
    },
    "People admiring the museum exit find three robots beside it.": {
        "file": "280ce5f493236bd07eb8.mp3",
        "bank": "en-oo1",
        "durationMs": 4550
    },
    "People admiring the museum exit find two tickets beside it.": {
        "file": "1bbccd61df7288e8c37d.mp3",
        "bank": "en-oo1",
        "durationMs": 4275
    },
    "People admiring the museum exit find two books beside it.": {
        "file": "dea76729123d550d2511.mp3",
        "bank": "en-oo1",
        "durationMs": 4125
    },
    "People admiring the museum exit find four tickets beside it.": {
        "file": "04c3a4f5bc0e9ea270e6.mp3",
        "bank": "en-oo1",
        "durationMs": 4375
    },
    "People admiring the museum exit find four books beside it.": {
        "file": "677888b272e4f99efa3e.mp3",
        "bank": "en-oo1",
        "durationMs": 4175
    },
    "People admiring the museum exit find two computers beside it.": {
        "file": "6a3d2a62b986c4cda550.mp3",
        "bank": "en-oo1",
        "durationMs": 4450
    },
    "People admiring the museum exit find two eggs beside it.": {
        "file": "32a5c65494936e2abdbc.mp3",
        "bank": "en-oo1",
        "durationMs": 4125
    },
    "People admiring the museum exit find three computers beside it.": {
        "file": "802e0550d194eeb9ac00.mp3",
        "bank": "en-oo1",
        "durationMs": 4600
    },
    "People admiring the museum exit find three eggs beside it.": {
        "file": "856f27d67802fd308a95.mp3",
        "bank": "en-oo1",
        "durationMs": 4325
    },
    "The fish waiting for the morning train is wearing a large hat and holding a phone.": {
        "file": "db8eb807a5014e603a27.mp3",
        "bank": "en-oo1",
        "durationMs": 5200
    },
    "The fish waiting for the morning train is wearing a large hat and holding a computer.": {
        "file": "c832d829a6dd6a88b462.mp3",
        "bank": "en-oo1",
        "durationMs": 5375
    },
    "The fish waiting for the morning train is wearing a small hat and holding a phone.": {
        "file": "096253a0d710899ff13b.mp3",
        "bank": "en-oo1",
        "durationMs": 5250
    },
    "The fish waiting for the morning train is wearing a small hat and holding a computer.": {
        "file": "55239603ac12de011253.mp3",
        "bank": "en-oo1",
        "durationMs": 5375
    },
    "The fish waiting for the morning train is wearing a long scarf and holding a picture.": {
        "file": "b7ea4d8f47b4d79121bf.mp3",
        "bank": "en-oo1",
        "durationMs": 5375
    },
    "The fish waiting for the morning train is wearing a long scarf and holding a hat.": {
        "file": "9084156cadd31bb9e648.mp3",
        "bank": "en-oo1",
        "durationMs": 5175
    },
    "The fish waiting for the morning train is wearing a short scarf and holding a picture.": {
        "file": "11eceac33568e74d7703.mp3",
        "bank": "en-oo1",
        "durationMs": 5325
    },
    "The fish waiting for the morning train is wearing a short scarf and holding a hat.": {
        "file": "82cbc9b74e54b03fdfd1.mp3",
        "bank": "en-oo1",
        "durationMs": 5150
    },
    "The fish waiting for the morning train is wearing round glasses and holding a bag.": {
        "file": "ab5fba38fa21db814d50.mp3",
        "bank": "en-oo1",
        "durationMs": 5400
    },
    "The fish waiting for the morning train is wearing round glasses and holding a glass.": {
        "file": "0a02bf84cddccdf9e725.mp3",
        "bank": "en-oo1",
        "durationMs": 5426
    },
    "The fish waiting for the morning train is wearing square glasses and holding a bag.": {
        "file": "63aec738fa5318d82cba.mp3",
        "bank": "en-oo1",
        "durationMs": 5350
    },
    "The fish waiting for the morning train is wearing square glasses and holding a glass.": {
        "file": "28f030d6acc447a205ad.mp3",
        "bank": "en-oo1",
        "durationMs": 5426
    },
    "The fish waiting for the morning train is wearing a jacket with two pockets and holding an egg.": {
        "file": "eb546dece00ffabf4576.mp3",
        "bank": "en-oo1",
        "durationMs": 5800
    },
    "The fish waiting for the morning train is wearing a jacket with two pockets and holding a dog.": {
        "file": "152096976243cc8e1009.mp3",
        "bank": "en-oo1",
        "durationMs": 5875
    },
    "The fish waiting for the morning train is wearing a jacket with four pockets and holding an egg.": {
        "file": "afc50410a7549cff6915.mp3",
        "bank": "en-oo1",
        "durationMs": 5850
    },
    "The fish waiting for the morning train is wearing a jacket with four pockets and holding a dog.": {
        "file": "921ccb7a2b29a50f5d6b.mp3",
        "bank": "en-oo1",
        "durationMs": 5925
    },
    "The fish waiting for the morning train is wearing a shirt with long sleeves and holding a bottle.": {
        "file": "f9916371b44fc8823e7b.mp3",
        "bank": "en-oo1",
        "durationMs": 5850
    },
    "The fish waiting for the morning train is wearing a shirt with long sleeves and holding a cup.": {
        "file": "45a748be9106f3e3727b.mp3",
        "bank": "en-oo1",
        "durationMs": 5800
    },
    "The fish waiting for the morning train is wearing a shirt with short sleeves and holding a bottle.": {
        "file": "b24d2ee9984440767901.mp3",
        "bank": "en-oo1",
        "durationMs": 5775
    },
    "The fish waiting for the morning train is wearing a shirt with short sleeves and holding a cup.": {
        "file": "cef5ce6aed6dd9570af3.mp3",
        "bank": "en-oo1",
        "durationMs": 5700
    },
    "The man riding his bed to work has two bottles beside his pillow.": {
        "file": "89e25433da818e55cbf1.mp3",
        "bank": "en-oo1",
        "durationMs": 4525
    },
    "The man riding his bed to work has two dogs beside his pillow.": {
        "file": "f2ab271b5b0ea84abb65.mp3",
        "bank": "en-oo1",
        "durationMs": 4425
    },
    "The man riding his bed to work has three bottles beside his pillow.": {
        "file": "cbd8afbd0f8441278d74.mp3",
        "bank": "en-oo1",
        "durationMs": 4575
    },
    "The man riding his bed to work has three dogs beside his pillow.": {
        "file": "f3ce88fa95a7f4700771.mp3",
        "bank": "en-oo1",
        "durationMs": 4500
    },
    "The man riding his bed to work has two glasses beside his pillow.": {
        "file": "591822decaede395f573.mp3",
        "bank": "en-oo1",
        "durationMs": 4650
    },
    "The man riding his bed to work has two computers beside his pillow.": {
        "file": "6abebeaaf2614f313d68.mp3",
        "bank": "en-oo1",
        "durationMs": 4650
    },
    "The man riding his bed to work has four glasses beside his pillow.": {
        "file": "26e8e548bdc3f3c9c6e2.mp3",
        "bank": "en-oo1",
        "durationMs": 4700
    },
    "The man riding his bed to work has four computers beside his pillow.": {
        "file": "974163ff7c6582469964.mp3",
        "bank": "en-oo1",
        "durationMs": 4625
    },
    "The man riding his bed to work has two robots beside his pillow.": {
        "file": "01bd08e311c6ab1b6cc3.mp3",
        "bank": "en-oo1",
        "durationMs": 4600
    },
    "The man riding his bed to work has two boxes beside his pillow.": {
        "file": "aa2c26173481a45c45f6.mp3",
        "bank": "en-oo1",
        "durationMs": 4625
    },
    "The man riding his bed to work has three robots beside his pillow.": {
        "file": "8e1c34d5cfdf6dab8475.mp3",
        "bank": "en-oo1",
        "durationMs": 4775
    },
    "The man riding his bed to work has three boxes beside his pillow.": {
        "file": "7a56f091b8db477e4755.mp3",
        "bank": "en-oo1",
        "durationMs": 4725
    },
    "The man riding his bed to work has two fish beside his pillow.": {
        "file": "f6abbf6e80bb548f3cce.mp3",
        "bank": "en-oo1",
        "durationMs": 4450
    },
    "The man riding his bed to work has two bags beside his pillow.": {
        "file": "1c134e5c3218570dea50.mp3",
        "bank": "en-oo1",
        "durationMs": 4450
    },
    "The man riding his bed to work has four fish beside his pillow.": {
        "file": "b38644cd8427c14c08c4.mp3",
        "bank": "en-oo1",
        "durationMs": 4375
    },
    "The man riding his bed to work has four bags beside his pillow.": {
        "file": "4b52dd8590a773d06e30.mp3",
        "bank": "en-oo1",
        "durationMs": 4500
    },
    "The man riding his bed to work has two tickets beside his pillow.": {
        "file": "dc965637eddb7791c812.mp3",
        "bank": "en-oo1",
        "durationMs": 4500
    },
    "The man riding his bed to work has two cats beside his pillow.": {
        "file": "1b482bd795e531b26dcb.mp3",
        "bank": "en-oo1",
        "durationMs": 4375
    },
    "The man riding his bed to work has three tickets beside his pillow.": {
        "file": "f022bdf61b323e1cbbcd.mp3",
        "bank": "en-oo1",
        "durationMs": 4600
    },
    "The man riding his bed to work has three cats beside his pillow.": {
        "file": "17cd8868140d21c7c074.mp3",
        "bank": "en-oo1",
        "durationMs": 4425
    },
    "The train seat offering its seat keeps a book on the floor.": {
        "file": "ccf1d145eac19796e6f9.mp3",
        "bank": "en-oo1",
        "durationMs": 3775
    },
    "The train seat offering its seat keeps a book above the window.": {
        "file": "bca8f94131170dfe3f98.mp3",
        "bank": "en-oo1",
        "durationMs": 4200
    },
    "The train seat offering its seat keeps a computer on the floor.": {
        "file": "aaa43f86cc65a42d63e1.mp3",
        "bank": "en-oo1",
        "durationMs": 4200
    },
    "The train seat offering its seat keeps a computer above the window.": {
        "file": "d7036676b67699037330.mp3",
        "bank": "en-oo1",
        "durationMs": 4600
    },
    "The train seat offering its seat keeps a ticket on the floor.": {
        "file": "f6695fbbb4a8db3e11e2.mp3",
        "bank": "en-oo1",
        "durationMs": 3950
    },
    "The train seat offering its seat keeps a ticket above the window.": {
        "file": "4ddd01990eefe280a58a.mp3",
        "bank": "en-oo1",
        "durationMs": 4325
    },
    "The train seat offering its seat keeps a box on the floor.": {
        "file": "3c10da73b2e31b1b2c09.mp3",
        "bank": "en-oo1",
        "durationMs": 3925
    },
    "The train seat offering its seat keeps a box above the window.": {
        "file": "6d40adcd4c153cfb78c1.mp3",
        "bank": "en-oo1",
        "durationMs": 4226
    },
    "The train seat offering its seat keeps a glass on the floor.": {
        "file": "ad86df54612befe59433.mp3",
        "bank": "en-oo1",
        "durationMs": 3950
    },
    "The train seat offering its seat keeps a glass above the window.": {
        "file": "e385f87bef6558e92414.mp3",
        "bank": "en-oo1",
        "durationMs": 4275
    },
    "The train seat offering its seat keeps a gift on the floor.": {
        "file": "b7f27a078cb1794256d1.mp3",
        "bank": "en-oo1",
        "durationMs": 3900
    },
    "The train seat offering its seat keeps a gift above the window.": {
        "file": "ff25edcfe06b1b4885c5.mp3",
        "bank": "en-oo1",
        "durationMs": 4300
    },
    "The train seat offering its seat keeps a picture on the floor.": {
        "file": "f84f62f91bf46bf891c3.mp3",
        "bank": "en-oo1",
        "durationMs": 4050
    },
    "The train seat offering its seat keeps a picture above the window.": {
        "file": "64c031fe34015e7bb466.mp3",
        "bank": "en-oo1",
        "durationMs": 4375
    },
    "The train seat offering its seat keeps a fish on the floor.": {
        "file": "f50977d11b1057d9ca0d.mp3",
        "bank": "en-oo1",
        "durationMs": 3900
    },
    "The train seat offering its seat keeps a fish above the window.": {
        "file": "6812ff18777070df9b1d.mp3",
        "bank": "en-oo1",
        "durationMs": 4200
    },
    "The train seat offering its seat keeps a dog on the floor.": {
        "file": "53dcc41b545908677e89.mp3",
        "bank": "en-oo1",
        "durationMs": 3950
    },
    "The train seat offering its seat keeps a dog above the window.": {
        "file": "d9ddc7479adc79487609.mp3",
        "bank": "en-oo1",
        "durationMs": 4275
    },
    "The train seat offering its seat keeps a cat on the floor.": {
        "file": "e8dbe0689bd158350009.mp3",
        "bank": "en-oo1",
        "durationMs": 3900
    },
    "The train seat offering its seat keeps a cat above the window.": {
        "file": "f756623e1ba035418a48.mp3",
        "bank": "en-oo1",
        "durationMs": 4250
    },
    "The snail waiting for the bus has an egg on its shell.": {
        "file": "1009137de9eee4ac2f75.mp3",
        "bank": "en-oo1",
        "durationMs": 3475
    },
    "The snail waiting for the bus has an egg beside its shell.": {
        "file": "899544c172b861c0ace1.mp3",
        "bank": "en-oo1",
        "durationMs": 3800
    },
    "The snail waiting for the bus has a fish on its shell.": {
        "file": "036300e985eecf08d3b7.mp3",
        "bank": "en-oo1",
        "durationMs": 3425
    },
    "The snail waiting for the bus has a fish beside its shell.": {
        "file": "5aac65c1add76d1b1520.mp3",
        "bank": "en-oo1",
        "durationMs": 3775
    },
    "The snail waiting for the bus has a glass on its shell.": {
        "file": "f3278a4550e5c601604d.mp3",
        "bank": "en-oo1",
        "durationMs": 3550
    },
    "The snail waiting for the bus has a glass beside its shell.": {
        "file": "d465a9e1623ea0629643.mp3",
        "bank": "en-oo1",
        "durationMs": 3825
    },
    "The snail waiting for the bus has a cup on its shell.": {
        "file": "14c2c3da732281ec9490.mp3",
        "bank": "en-oo1",
        "durationMs": 3375
    },
    "The snail waiting for the bus has a cup beside its shell.": {
        "file": "ef6809dffd002e2e1bba.mp3",
        "bank": "en-oo1",
        "durationMs": 3626
    },
    "The snail waiting for the bus has a gift on its shell.": {
        "file": "5ac471edf3cbb444d2a9.mp3",
        "bank": "en-oo1",
        "durationMs": 3500
    },
    "The snail waiting for the bus has a gift beside its shell.": {
        "file": "a107b0e5aed5c3f02eda.mp3",
        "bank": "en-oo1",
        "durationMs": 3875
    },
    "The snail waiting for the bus has a bag on its shell.": {
        "file": "21ba98f5b5162afcf2ec.mp3",
        "bank": "en-oo1",
        "durationMs": 3425
    },
    "The snail waiting for the bus has a bag beside its shell.": {
        "file": "fa7a2a042a583614878c.mp3",
        "bank": "en-oo1",
        "durationMs": 3850
    },
    "The snail waiting for the bus has a dog on its shell.": {
        "file": "133ef18369e15312e044.mp3",
        "bank": "en-oo1",
        "durationMs": 3425
    },
    "The snail waiting for the bus has a dog beside its shell.": {
        "file": "42a9786750a730d6ae08.mp3",
        "bank": "en-oo1",
        "durationMs": 3800
    },
    "The snail waiting for the bus has a ticket on its shell.": {
        "file": "1069db02617885bc9d67.mp3",
        "bank": "en-oo1",
        "durationMs": 3475
    },
    "The snail waiting for the bus has a ticket beside its shell.": {
        "file": "2b7d9a74367dac263f28.mp3",
        "bank": "en-oo1",
        "durationMs": 3825
    },
    "The snail waiting for the bus has a key on its shell.": {
        "file": "f09bb85fc9fa4e46ab71.mp3",
        "bank": "en-oo1",
        "durationMs": 3325
    },
    "The snail waiting for the bus has a key beside its shell.": {
        "file": "10846b3ef5e56bc241d3.mp3",
        "bank": "en-oo1",
        "durationMs": 3675
    },
    "The snail waiting for the bus has a picture on its shell.": {
        "file": "8576ce3444c185ff954d.mp3",
        "bank": "en-oo1",
        "durationMs": 3550
    },
    "The snail waiting for the bus has a picture beside its shell.": {
        "file": "0b97e1bed6b872bd0adf.mp3",
        "bank": "en-oo1",
        "durationMs": 3900
    },
    "The student going through a gate at home carries a large computer.": {
        "file": "157a61c92192b62cf7f1.mp3",
        "bank": "en-oo1",
        "durationMs": 4300
    },
    "The student going through a gate at home carries a large glass.": {
        "file": "be9b090a2f9ab826060a.mp3",
        "bank": "en-oo1",
        "durationMs": 4000
    },
    "The student going through a gate at home carries a small computer.": {
        "file": "7b690c60743db034156b.mp3",
        "bank": "en-oo1",
        "durationMs": 4226
    },
    "The student going through a gate at home carries a small glass.": {
        "file": "15e1ade41605d69a4f19.mp3",
        "bank": "en-oo1",
        "durationMs": 4050
    },
    "The student going through a gate at home carries a large ticket.": {
        "file": "c0aa2f8733557268681a.mp3",
        "bank": "en-oo1",
        "durationMs": 4025
    },
    "The student going through a gate at home carries a large cup.": {
        "file": "66ee75fd869ca1c99838.mp3",
        "bank": "en-oo1",
        "durationMs": 3975
    },
    "The student going through a gate at home carries a small ticket.": {
        "file": "e8419733e63dc519b3a7.mp3",
        "bank": "en-oo1",
        "durationMs": 4075
    },
    "The student going through a gate at home carries a small cup.": {
        "file": "d7b34bc923732ac85603.mp3",
        "bank": "en-oo1",
        "durationMs": 3925
    },
    "The student going through a gate at home carries a large box.": {
        "file": "215a08a86ffcf6e751b0.mp3",
        "bank": "en-oo1",
        "durationMs": 4025
    },
    "The student going through a gate at home carries a large fish.": {
        "file": "bc1376b843acba74b5ea.mp3",
        "bank": "en-oo1",
        "durationMs": 3975
    },
    "The student going through a gate at home carries a small box.": {
        "file": "2f05059ba3a020400693.mp3",
        "bank": "en-oo1",
        "durationMs": 3950
    },
    "The student going through a gate at home carries a small fish.": {
        "file": "4ad9707061ee7aa0371d.mp3",
        "bank": "en-oo1",
        "durationMs": 3950
    },
    "The student going through a gate at home carries a large umbrella.": {
        "file": "bfb0ed402c7cec256f83.mp3",
        "bank": "en-oo1",
        "durationMs": 4200
    },
    "The student going through a gate at home carries a large robot.": {
        "file": "d489d02433d5c4d24ecb.mp3",
        "bank": "en-oo1",
        "durationMs": 4150
    },
    "The student going through a gate at home carries a small umbrella.": {
        "file": "071fcb56dc0fd2b46a38.mp3",
        "bank": "en-oo1",
        "durationMs": 4300
    },
    "The student going through a gate at home carries a small robot.": {
        "file": "b5b310031c9ecb8615f4.mp3",
        "bank": "en-oo1",
        "durationMs": 4150
    },
    "The student going through a gate at home carries a large book.": {
        "file": "27d577ab91b89c15fca6.mp3",
        "bank": "en-oo1",
        "durationMs": 3975
    },
    "The student going through a gate at home carries a large egg.": {
        "file": "73e22d943bf8fb01d4c0.mp3",
        "bank": "en-oo1",
        "durationMs": 3875
    },
    "The student going through a gate at home carries a small book.": {
        "file": "2b41eeb098920f72cde5.mp3",
        "bank": "en-oo1",
        "durationMs": 3900
    },
    "The student going through a gate at home carries a small egg.": {
        "file": "8c6b5acc54667edf8bb0.mp3",
        "bank": "en-oo1",
        "durationMs": 3900
    },
    "The buses waiting for a person have two bottles between them.": {
        "file": "c60d784dae5e17085517.mp3",
        "bank": "en-oo1",
        "durationMs": 4175
    },
    "The buses waiting for a person have two tickets between them.": {
        "file": "64432ebfa7913eaf2bfa.mp3",
        "bank": "en-oo1",
        "durationMs": 4050
    },
    "The buses waiting for a person have three bottles between them.": {
        "file": "8f1cfb07b30710799858.mp3",
        "bank": "en-oo1",
        "durationMs": 4300
    },
    "The buses waiting for a person have three tickets between them.": {
        "file": "2a11e8b9d60f500fe5be.mp3",
        "bank": "en-oo1",
        "durationMs": 4150
    },
    "The buses waiting for a person have two boxes between them.": {
        "file": "8efb89201df71eb40daf.mp3",
        "bank": "en-oo1",
        "durationMs": 4175
    },
    "The buses waiting for a person have two fish between them.": {
        "file": "3d8ad6cb070789e716d2.mp3",
        "bank": "en-oo1",
        "durationMs": 3950
    },
    "The buses waiting for a person have four boxes between them.": {
        "file": "2b0c8f10dc9bfffbf3bd.mp3",
        "bank": "en-oo1",
        "durationMs": 4275
    },
    "The buses waiting for a person have four fish between them.": {
        "file": "2d9d1a513ce665226913.mp3",
        "bank": "en-oo1",
        "durationMs": 4050
    },
    "The buses waiting for a person have two shoes between them.": {
        "file": "06005556ada3cf969e7e.mp3",
        "bank": "en-oo1",
        "durationMs": 4000
    },
    "The buses waiting for a person have two pictures between them.": {
        "file": "53f713d3432ed7e8bd38.mp3",
        "bank": "en-oo1",
        "durationMs": 4125
    },
    "The buses waiting for a person have three shoes between them.": {
        "file": "376a363f670454a088e9.mp3",
        "bank": "en-oo1",
        "durationMs": 4050
    },
    "The buses waiting for a person have three pictures between them.": {
        "file": "a9d6022b7e7867b8105a.mp3",
        "bank": "en-oo1",
        "durationMs": 4200
    },
    "The buses waiting for a person have two robots between them.": {
        "file": "e8d8f51e631e2effd256.mp3",
        "bank": "en-oo1",
        "durationMs": 4200
    },
    "The buses waiting for a person have two bags between them.": {
        "file": "136a03b1f1e953613f43.mp3",
        "bank": "en-oo1",
        "durationMs": 4075
    },
    "The buses waiting for a person have four robots between them.": {
        "file": "34eaaa90b2061ac0a461.mp3",
        "bank": "en-oo1",
        "durationMs": 4300
    },
    "The buses waiting for a person have four bags between them.": {
        "file": "cff202dd2f2c5209d6f1.mp3",
        "bank": "en-oo1",
        "durationMs": 4175
    },
    "The buses waiting for a person have two dogs between them.": {
        "file": "075eda4ce899f817b568.mp3",
        "bank": "en-oo1",
        "durationMs": 4050
    },
    "The buses waiting for a person have two computers between them.": {
        "file": "2cf8ae5f8a94fc712f76.mp3",
        "bank": "en-oo1",
        "durationMs": 4325
    },
    "The buses waiting for a person have three dogs between them.": {
        "file": "85c1018ea71304f4766d.mp3",
        "bank": "en-oo1",
        "durationMs": 4125
    },
    "The buses waiting for a person have three computers between them.": {
        "file": "cdac89e40d3cfe9ba102.mp3",
        "bank": "en-oo1",
        "durationMs": 4400
    },
    "The bicycle taking a holiday is carrying a glass.": {
        "file": "ef0915463672ca3e50e7.mp3",
        "bank": "en-oo1",
        "durationMs": 3550
    },
    "The bicycle taking a holiday is carrying a cup.": {
        "file": "faec2085223771a12103.mp3",
        "bank": "en-oo1",
        "durationMs": 3475
    },
    "The bicycle taking a holiday is pulling a glass.": {
        "file": "ab762ecee65d0a4d02d7.mp3",
        "bank": "en-oo1",
        "durationMs": 3575
    },
    "The bicycle taking a holiday is pulling a cup.": {
        "file": "4e78eba30611565f11f4.mp3",
        "bank": "en-oo1",
        "durationMs": 3400
    },
    "The bicycle taking a holiday is carrying a bottle.": {
        "file": "5bb0fbdd1cdb41f2aa82.mp3",
        "bank": "en-oo1",
        "durationMs": 3626
    },
    "The bicycle taking a holiday is carrying a fish.": {
        "file": "6bf36a6d2d4fab1d0e11.mp3",
        "bank": "en-oo1",
        "durationMs": 3550
    },
    "The bicycle taking a holiday is pulling a bottle.": {
        "file": "3d5fdfe0421151488bd7.mp3",
        "bank": "en-oo1",
        "durationMs": 3600
    },
    "The bicycle taking a holiday is pulling a fish.": {
        "file": "2cecaedc6c6495aebe6c.mp3",
        "bank": "en-oo1",
        "durationMs": 3500
    },
    "The bicycle taking a holiday is carrying a ticket.": {
        "file": "13d043682c40d0a1cd01.mp3",
        "bank": "en-oo1",
        "durationMs": 3575
    },
    "The bicycle taking a holiday is carrying a picture.": {
        "file": "006d994e5729f43e3a2c.mp3",
        "bank": "en-oo1",
        "durationMs": 3650
    },
    "The bicycle taking a holiday is pulling a ticket.": {
        "file": "e98cb1155f49f09b51de.mp3",
        "bank": "en-oo1",
        "durationMs": 3525
    },
    "The bicycle taking a holiday is pulling a picture.": {
        "file": "3d2f2599273ce5a78bbe.mp3",
        "bank": "en-oo1",
        "durationMs": 3600
    },
    "The bicycle taking a holiday is carrying a computer.": {
        "file": "c915cefe5b54b9fe1ddb.mp3",
        "bank": "en-oo1",
        "durationMs": 3925
    },
    "The bicycle taking a holiday is carrying a hat.": {
        "file": "6262b44019688ecf8dbb.mp3",
        "bank": "en-oo1",
        "durationMs": 3425
    },
    "The bicycle taking a holiday is pulling a computer.": {
        "file": "8bf9852f0bbbe0a41e75.mp3",
        "bank": "en-oo1",
        "durationMs": 3875
    },
    "The bicycle taking a holiday is pulling a hat.": {
        "file": "59a90e97418acdfe89a7.mp3",
        "bank": "en-oo1",
        "durationMs": 3375
    },
    "The bicycle taking a holiday is carrying a clock.": {
        "file": "8cdf728241fe1bb81fbd.mp3",
        "bank": "en-oo1",
        "durationMs": 3525
    },
    "The bicycle taking a holiday is carrying a flower.": {
        "file": "b549993c6557c3e52c2a.mp3",
        "bank": "en-oo1",
        "durationMs": 3600
    },
    "The bicycle taking a holiday is pulling a clock.": {
        "file": "f8748679fc289c6891d1.mp3",
        "bank": "en-oo1",
        "durationMs": 3500
    },
    "The bicycle taking a holiday is pulling a flower.": {
        "file": "0b4f543f4f40a9910a6f.mp3",
        "bank": "en-oo1",
        "durationMs": 3650
    },
    "The lost map asks for help with a glass on its head.": {
        "file": "6ece109d782d9a502a18.mp3",
        "bank": "en-oo1",
        "durationMs": 3626
    },
    "The lost map asks for help with a glass under its arm.": {
        "file": "3dca2ccf3c70f5e85952.mp3",
        "bank": "en-oo1",
        "durationMs": 3750
    },
    "The lost map asks for help with a key on its head.": {
        "file": "33cd06c05b504270a07d.mp3",
        "bank": "en-oo1",
        "durationMs": 3500
    },
    "The lost map asks for help with a key under its arm.": {
        "file": "482d16b6e234e9cd79a7.mp3",
        "bank": "en-oo1",
        "durationMs": 3725
    },
    "The lost map asks for help with a fish on its head.": {
        "file": "3ef1765916870dad00be.mp3",
        "bank": "en-oo1",
        "durationMs": 2923
    },
    "The lost map asks for help with a fish under its arm.": {
        "file": "19b85723bc4ea4df1ceb.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The lost map asks for help with a cat on its head.": {
        "file": "ea65e5052d8b88ba91a7.mp3",
        "bank": "en-oo1",
        "durationMs": 2923
    },
    "The lost map asks for help with a cat under its arm.": {
        "file": "7bf5676eeec03f1d848c.mp3",
        "bank": "en-oo1",
        "durationMs": 3072
    },
    "The lost map asks for help with a book on its head.": {
        "file": "c8c95b92d98766fa1692.mp3",
        "bank": "en-oo1",
        "durationMs": 2837
    },
    "The lost map asks for help with a book under its arm.": {
        "file": "eade55896f7f6a2a57ff.mp3",
        "bank": "en-oo1",
        "durationMs": 3029
    },
    "The lost map asks for help with a box on its head.": {
        "file": "3e451e96130732e8c1c3.mp3",
        "bank": "en-oo1",
        "durationMs": 2965
    },
    "The lost map asks for help with a box under its arm.": {
        "file": "928ce1c951ec3739a543.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The lost map asks for help with a robot on its head.": {
        "file": "74115bfbc52cf8e516a7.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The lost map asks for help with a robot under its arm.": {
        "file": "70b6f990df29f3f3a507.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The lost map asks for help with a ticket on its head.": {
        "file": "99ebb969672b5ba13db3.mp3",
        "bank": "en-oo1",
        "durationMs": 3029
    },
    "The lost map asks for help with a ticket under its arm.": {
        "file": "831d3e1622b6e5ae8841.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The lost map asks for help with a computer on its head.": {
        "file": "007bd5fb7aab64e51977.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The lost map asks for help with a computer under its arm.": {
        "file": "0d7438134a5dfc622732.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The lost map asks for help with a gift on its head.": {
        "file": "23ea6c02d544ebc0b9b2.mp3",
        "bank": "en-oo1",
        "durationMs": 2880
    },
    "The lost map asks for help with a gift under its arm.": {
        "file": "57c3ac21836b1f30d605.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "The train's seats for umbrellas have two books beneath them.": {
        "file": "98bbebf3532e1315dc5a.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The train's seats for umbrellas have two dogs beneath them.": {
        "file": "113499dd7fad2f1ebab3.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The train's seats for umbrellas have three books beneath them.": {
        "file": "ed020da2930a4af442a9.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The train's seats for umbrellas have three dogs beneath them.": {
        "file": "cc6c9d39d681a313eb7c.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The train's seats for umbrellas have two glasses beneath them.": {
        "file": "e980bd65832cd8b4be5a.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The train's seats for umbrellas have two fish beneath them.": {
        "file": "3a599a0f7c8a8f59ff85.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The train's seats for umbrellas have four glasses beneath them.": {
        "file": "149e9e9d4d79f3617a8f.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The train's seats for umbrellas have four fish beneath them.": {
        "file": "06526914ba8fe6894178.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The train's seats for umbrellas have two cats beneath them.": {
        "file": "dbd4102459daf81723a8.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The train's seats for umbrellas have two boxes beneath them.": {
        "file": "2a8412a56cf215b3bb0b.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The train's seats for umbrellas have three cats beneath them.": {
        "file": "73091ae1543d23d4e2a5.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The train's seats for umbrellas have three boxes beneath them.": {
        "file": "2261cb13faef4cf80768.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The train's seats for umbrellas have two gifts beneath them.": {
        "file": "7c677a6b535c39b20f7d.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The train's seats for umbrellas have two pictures beneath them.": {
        "file": "b054469234de64fcea5d.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The train's seats for umbrellas have four gifts beneath them.": {
        "file": "bd8ae731e3dbc03d1b0b.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The train's seats for umbrellas have four pictures beneath them.": {
        "file": "803f2204cde37f013a51.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The train's seats for umbrellas have two keys beneath them.": {
        "file": "6e4315c4bf5ca850b104.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The train's seats for umbrellas have two coins beneath them.": {
        "file": "e9375911f71e2972b6a5.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The train's seats for umbrellas have three keys beneath them.": {
        "file": "099449f7b05858b0ccef.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The train's seats for umbrellas have three coins beneath them.": {
        "file": "2b868ab29b6aa71ee0c2.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The shoes carrying their owner stop beside a large computer.": {
        "file": "2410d4403d4e1253737b.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The shoes carrying their owner stop beside a large box.": {
        "file": "2c0f0b384218405e75ef.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The shoes carrying their owner stop beside a small computer.": {
        "file": "72796e01218d64f76236.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The shoes carrying their owner stop beside a small box.": {
        "file": "7d32c8bc7e05ed905aa7.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The shoes carrying their owner stop beside a large fish.": {
        "file": "5cbdbb89ceaadd462ef7.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The shoes carrying their owner stop beside a large shoe.": {
        "file": "3bbbb9f0157a7928bf32.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The shoes carrying their owner stop beside a small fish.": {
        "file": "9f0f5e1c29decb92f033.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The shoes carrying their owner stop beside a small shoe.": {
        "file": "21e147e7883a3036957c.mp3",
        "bank": "en-oo1",
        "durationMs": 2965
    },
    "The shoes carrying their owner stop beside a large clock.": {
        "file": "05e5a5df6a28965282d4.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The shoes carrying their owner stop beside a large glass.": {
        "file": "965562ecab34b2c12ac4.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The shoes carrying their owner stop beside a small clock.": {
        "file": "a3351f42b60b23ea8178.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The shoes carrying their owner stop beside a small glass.": {
        "file": "b41c7b1ed99df2e56259.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The shoes carrying their owner stop beside a large ticket.": {
        "file": "0b1be69317d0e744c74a.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The shoes carrying their owner stop beside a large book.": {
        "file": "9eace3f4c542a8e6b509.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The shoes carrying their owner stop beside a small ticket.": {
        "file": "6a4655e5cef37b25fc58.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The shoes carrying their owner stop beside a small book.": {
        "file": "36e7b339e1dec1a985bb.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "The shoes carrying their owner stop beside a large cup.": {
        "file": "a86e7b8a068c2f6d9afc.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The shoes carrying their owner stop beside a large key.": {
        "file": "a319b3925a5d9271346e.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The shoes carrying their owner stop beside a small cup.": {
        "file": "ab5cf4a3d880db75f4df.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The shoes carrying their owner stop beside a small key.": {
        "file": "7067f196792864e03642.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The fish taking our lunch order is wearing a large hat and holding a bottle.": {
        "file": "350497924a80bd278349.mp3",
        "bank": "en-oo1",
        "durationMs": 4352
    },
    "The fish taking our lunch order is wearing a large hat and holding a ticket.": {
        "file": "8bc41b6bf25b6eaee765.mp3",
        "bank": "en-oo1",
        "durationMs": 4416
    },
    "The fish taking our lunch order is wearing a small hat and holding a bottle.": {
        "file": "c4ed9d37b0100821e83a.mp3",
        "bank": "en-oo1",
        "durationMs": 4309
    },
    "The fish taking our lunch order is wearing a small hat and holding a ticket.": {
        "file": "95a31332fcb8ecd59858.mp3",
        "bank": "en-oo1",
        "durationMs": 4373
    },
    "The fish taking our lunch order is wearing a long scarf and holding a bag.": {
        "file": "5484aa69987ccca9e25d.mp3",
        "bank": "en-oo1",
        "durationMs": 4352
    },
    "The fish taking our lunch order is wearing a long scarf and holding a fish.": {
        "file": "1bc54a98647086be846b.mp3",
        "bank": "en-oo1",
        "durationMs": 4373
    },
    "The fish taking our lunch order is wearing a short scarf and holding a bag.": {
        "file": "0c7551d4c2280e04937e.mp3",
        "bank": "en-oo1",
        "durationMs": 4352
    },
    "The fish taking our lunch order is wearing a short scarf and holding a fish.": {
        "file": "ecc3af654fee108bb435.mp3",
        "bank": "en-oo1",
        "durationMs": 4395
    },
    "The fish taking our lunch order is wearing round glasses and holding a glass.": {
        "file": "d4db340c8b10b2c213d2.mp3",
        "bank": "en-oo1",
        "durationMs": 4459
    },
    "The fish taking our lunch order is wearing round glasses and holding a computer.": {
        "file": "4225c1a905ac0731541f.mp3",
        "bank": "en-oo1",
        "durationMs": 4608
    },
    "The fish taking our lunch order is wearing square glasses and holding a glass.": {
        "file": "1ea5ca83d1b2221d4e44.mp3",
        "bank": "en-oo1",
        "durationMs": 4501
    },
    "The fish taking our lunch order is wearing square glasses and holding a computer.": {
        "file": "fe95d87318c2465db162.mp3",
        "bank": "en-oo1",
        "durationMs": 4608
    },
    "The fish taking our lunch order is wearing a jacket with two pockets and holding a book.": {
        "file": "71b9480209ec314e48b7.mp3",
        "bank": "en-oo1",
        "durationMs": 5035
    },
    "The fish taking our lunch order is wearing a jacket with two pockets and holding a dog.": {
        "file": "e65dfa1ba709ee80d2ba.mp3",
        "bank": "en-oo1",
        "durationMs": 5056
    },
    "The fish taking our lunch order is wearing a jacket with four pockets and holding a book.": {
        "file": "3752598057b1c07c4ff1.mp3",
        "bank": "en-oo1",
        "durationMs": 5077
    },
    "The fish taking our lunch order is wearing a jacket with four pockets and holding a dog.": {
        "file": "7a319c5d20026fe915a4.mp3",
        "bank": "en-oo1",
        "durationMs": 5184
    },
    "The fish taking our lunch order is wearing a shirt with long sleeves and holding an apple.": {
        "file": "1063c8542d6f03f9da72.mp3",
        "bank": "en-oo1",
        "durationMs": 4992
    },
    "The fish taking our lunch order is wearing a shirt with long sleeves and holding a cat.": {
        "file": "fc8b67d7ae7a0b909d3a.mp3",
        "bank": "en-oo1",
        "durationMs": 4971
    },
    "The fish taking our lunch order is wearing a shirt with short sleeves and holding an apple.": {
        "file": "2bb1074b851a8e09f9df.mp3",
        "bank": "en-oo1",
        "durationMs": 4885
    },
    "The fish taking our lunch order is wearing a shirt with short sleeves and holding a cat.": {
        "file": "4e6957aa1f64c200be73.mp3",
        "bank": "en-oo1",
        "durationMs": 4928
    },
    "The menu having lunch keeps a gift on the table.": {
        "file": "c664db5a7dd7818a1315.mp3",
        "bank": "en-oo1",
        "durationMs": 2709
    },
    "The menu having lunch keeps a gift under the table.": {
        "file": "06e53513f63c0541b7a3.mp3",
        "bank": "en-oo1",
        "durationMs": 2773
    },
    "The menu having lunch keeps a bag on the table.": {
        "file": "a0d9a534fc30080c1666.mp3",
        "bank": "en-oo1",
        "durationMs": 2645
    },
    "The menu having lunch keeps a bag under the table.": {
        "file": "9620fee28f004fc9e9c6.mp3",
        "bank": "en-oo1",
        "durationMs": 2795
    },
    "The menu having lunch keeps a robot on the table.": {
        "file": "3f00fb4c1bfec6976d95.mp3",
        "bank": "en-oo1",
        "durationMs": 2880
    },
    "The menu having lunch keeps a robot under the table.": {
        "file": "ea785adee762f1ade353.mp3",
        "bank": "en-oo1",
        "durationMs": 3029
    },
    "The menu having lunch keeps a computer on the table.": {
        "file": "f80a71d966257cd8bcdb.mp3",
        "bank": "en-oo1",
        "durationMs": 2965
    },
    "The menu having lunch keeps a computer under the table.": {
        "file": "6e04136342f189a79133.mp3",
        "bank": "en-oo1",
        "durationMs": 2987
    },
    "The menu having lunch keeps a glass on the table.": {
        "file": "27bc47e2c7f0b5bde69b.mp3",
        "bank": "en-oo1",
        "durationMs": 2709
    },
    "The menu having lunch keeps a glass under the table.": {
        "file": "8f54519c307fe0399646.mp3",
        "bank": "en-oo1",
        "durationMs": 2837
    },
    "The menu having lunch keeps a fish on the table.": {
        "file": "4a43ecf1407e906e0b08.mp3",
        "bank": "en-oo1",
        "durationMs": 2645
    },
    "The menu having lunch keeps a fish under the table.": {
        "file": "5e28832e13d355bd995f.mp3",
        "bank": "en-oo1",
        "durationMs": 2795
    },
    "The menu having lunch keeps a bottle on the table.": {
        "file": "80356545a15675e645e2.mp3",
        "bank": "en-oo1",
        "durationMs": 2795
    },
    "The menu having lunch keeps a bottle under the table.": {
        "file": "e58d655fb6796e5fff80.mp3",
        "bank": "en-oo1",
        "durationMs": 2859
    },
    "The menu having lunch keeps a ticket on the table.": {
        "file": "9f4df533b056f67fa2dd.mp3",
        "bank": "en-oo1",
        "durationMs": 2795
    },
    "The menu having lunch keeps a ticket under the table.": {
        "file": "c389266fbfade0c54735.mp3",
        "bank": "en-oo1",
        "durationMs": 2859
    },
    "The menu having lunch keeps a cat on the table.": {
        "file": "1b313a5ba9016755cefb.mp3",
        "bank": "en-oo1",
        "durationMs": 2667
    },
    "The menu having lunch keeps a cat under the table.": {
        "file": "6eb22a2dcb6518affeaf.mp3",
        "bank": "en-oo1",
        "durationMs": 2816
    },
    "The menu having lunch keeps a dog on the table.": {
        "file": "84d4488623b01e6e7a4f.mp3",
        "bank": "en-oo1",
        "durationMs": 2816
    },
    "The menu having lunch keeps a dog under the table.": {
        "file": "1f8eb3167487e7cd2aa5.mp3",
        "bank": "en-oo1",
        "durationMs": 2859
    },
    "At the bread's birthday party, there are two gifts around it.": {
        "file": "3e02530e3ad0e34dedb9.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "At the bread's birthday party, there are two bottles around it.": {
        "file": "a83cc4d124d6b9276dac.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "At the bread's birthday party, there are three gifts around it.": {
        "file": "2ab9ba79f74252247502.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "At the bread's birthday party, there are three bottles around it.": {
        "file": "1e74010c04c59724709d.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "At the bread's birthday party, there are two phones around it.": {
        "file": "6372c6dc2b240f3ece2b.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "At the bread's birthday party, there are two hats around it.": {
        "file": "9cb2f62b4f8a0cc0aaed.mp3",
        "bank": "en-oo1",
        "durationMs": 3072
    },
    "At the bread's birthday party, there are four phones around it.": {
        "file": "628d9e65f9d2e1488b74.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "At the bread's birthday party, there are four hats around it.": {
        "file": "00d3566a0a468d22708f.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "At the bread's birthday party, there are two glasses around it.": {
        "file": "66f96cdb58c49f63b6f6.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "At the bread's birthday party, there are two computers around it.": {
        "file": "1c401af342dc2dc6ded1.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "At the bread's birthday party, there are three glasses around it.": {
        "file": "3256f45bbffa7549588c.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "At the bread's birthday party, there are three computers around it.": {
        "file": "62728031c48ade80a969.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "At the bread's birthday party, there are two shoes around it.": {
        "file": "c04b6732f8c7fd6545f5.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "At the bread's birthday party, there are two tickets around it.": {
        "file": "2743f9b334444ddbd5fa.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "At the bread's birthday party, there are four shoes around it.": {
        "file": "0a89ae2ef348e282272a.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "At the bread's birthday party, there are four tickets around it.": {
        "file": "11b2d2e6adcfb1c8931c.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "At the bread's birthday party, there are two flowers around it.": {
        "file": "d68562b0350659407bf5.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "At the bread's birthday party, there are two cups around it.": {
        "file": "d944d69ed25290257084.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "At the bread's birthday party, there are three flowers around it.": {
        "file": "01df8e09b78314765485.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "At the bread's birthday party, there are three cups around it.": {
        "file": "7c2ff04cb04daf2e7a94.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The glass asking for more water is holding a box.": {
        "file": "bf597dc5e8853f77d6d0.mp3",
        "bank": "en-oo1",
        "durationMs": 2965
    },
    "The glass asking for more water is holding a computer.": {
        "file": "752c78b5bb023316dc6f.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The glass asking for more water is washing a box.": {
        "file": "9dd553d04b650be3c485.mp3",
        "bank": "en-oo1",
        "durationMs": 2923
    },
    "The glass asking for more water is washing a computer.": {
        "file": "4431d9cd7a58b22e872b.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The glass asking for more water is holding a glass.": {
        "file": "a428239c23562f5ea0d6.mp3",
        "bank": "en-oo1",
        "durationMs": 3008
    },
    "The glass asking for more water is holding a book.": {
        "file": "180baa51b1edc0fa8481.mp3",
        "bank": "en-oo1",
        "durationMs": 2816
    },
    "The glass asking for more water is washing a glass.": {
        "file": "b3bba89730d20f01c363.mp3",
        "bank": "en-oo1",
        "durationMs": 2923
    },
    "The glass asking for more water is washing a book.": {
        "file": "a5959e7aea54c19b08ea.mp3",
        "bank": "en-oo1",
        "durationMs": 2816
    },
    "The glass asking for more water is holding a fish.": {
        "file": "d8e95ebde3420a438753.mp3",
        "bank": "en-oo1",
        "durationMs": 2923
    },
    "The glass asking for more water is holding a ticket.": {
        "file": "14a43fd0043066316858.mp3",
        "bank": "en-oo1",
        "durationMs": 2965
    },
    "The glass asking for more water is washing a fish.": {
        "file": "265513e8203cb15bfa7f.mp3",
        "bank": "en-oo1",
        "durationMs": 2859
    },
    "The glass asking for more water is washing a ticket.": {
        "file": "c75ed2106a48658f638b.mp3",
        "bank": "en-oo1",
        "durationMs": 2880
    },
    "The glass asking for more water is holding a bag.": {
        "file": "9e13d712af5e11a455bd.mp3",
        "bank": "en-oo1",
        "durationMs": 2837
    },
    "The glass asking for more water is holding a cup.": {
        "file": "c4fcac6f623329f05b78.mp3",
        "bank": "en-oo1",
        "durationMs": 2859
    },
    "The glass asking for more water is washing a bag.": {
        "file": "851e2f807b3cd16f1797.mp3",
        "bank": "en-oo1",
        "durationMs": 2859
    },
    "The glass asking for more water is washing a cup.": {
        "file": "c276a9278ae3c3e3e92d.mp3",
        "bank": "en-oo1",
        "durationMs": 2859
    },
    "The glass asking for more water is holding a gift.": {
        "file": "525050667d58ec78b7f7.mp3",
        "bank": "en-oo1",
        "durationMs": 2944
    },
    "The glass asking for more water is holding a cat.": {
        "file": "fd366b9b107dc59b1f9a.mp3",
        "bank": "en-oo1",
        "durationMs": 2923
    },
    "The glass asking for more water is washing a gift.": {
        "file": "1f7cd2dad9c305af824c.mp3",
        "bank": "en-oo1",
        "durationMs": 2901
    },
    "The glass asking for more water is washing a cat.": {
        "file": "96ea0502f22bb0dfcc8f.mp3",
        "bank": "en-oo1",
        "durationMs": 2816
    },
    "The table that ate our dinner is hiding a large bottle.": {
        "file": "590d46b68c9cd1694bf0.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The table that ate our dinner is hiding a large shoe.": {
        "file": "2732b350ca340a80b116.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "The table that ate our dinner is hiding a small bottle.": {
        "file": "4ffb37edd792c5711feb.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The table that ate our dinner is hiding a small shoe.": {
        "file": "4ae50b7ca4444edabe79.mp3",
        "bank": "en-oo1",
        "durationMs": 3051
    },
    "The table that ate our dinner is hiding a large glass.": {
        "file": "8eb36e486f937f756ffd.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The table that ate our dinner is hiding a large gift.": {
        "file": "263c4252dddedd390930.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The table that ate our dinner is hiding a small glass.": {
        "file": "0be8bb0a51321b8e111f.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The table that ate our dinner is hiding a small gift.": {
        "file": "9f5d6d07cc5ee873eec3.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The table that ate our dinner is hiding a large box.": {
        "file": "813f924089691843190f.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The table that ate our dinner is hiding a large fish.": {
        "file": "81700b1381dd838c5cc7.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The table that ate our dinner is hiding a small box.": {
        "file": "08fd9020e35f0b0cdbca.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The table that ate our dinner is hiding a small fish.": {
        "file": "e54f5cc0bffa7055a4e6.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "The table that ate our dinner is hiding a large ticket.": {
        "file": "4b32dd2e1d593f511498.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The table that ate our dinner is hiding a large dog.": {
        "file": "db4e5572ae1317e8465e.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The table that ate our dinner is hiding a small ticket.": {
        "file": "f65d6468b3685ceb5dce.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The table that ate our dinner is hiding a small dog.": {
        "file": "da1670d2944a6f5b7fdc.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The table that ate our dinner is hiding a large hat.": {
        "file": "ead2db61c2e24489c9c4.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The table that ate our dinner is hiding a large key.": {
        "file": "d2c9fb3024a3e4c28b48.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The table that ate our dinner is hiding a small hat.": {
        "file": "c9fce9a1fe80eec38a09.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The table that ate our dinner is hiding a small key.": {
        "file": "2243d19c55174f0dfd7f.mp3",
        "bank": "en-oo1",
        "durationMs": 3072
    },
    "The man on holiday in his soup keeps a bottle beside the bowl.": {
        "file": "9097f3c3654b7451f487.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The man on holiday in his soup keeps a bottle inside the bowl.": {
        "file": "d23902d6058043fcd1a4.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The man on holiday in his soup keeps a fish beside the bowl.": {
        "file": "092333ecb0f31a4cbfa9.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The man on holiday in his soup keeps a fish inside the bowl.": {
        "file": "962319853433ba58ef23.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The man on holiday in his soup keeps a glass beside the bowl.": {
        "file": "4bf691c2b8ef0545a633.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The man on holiday in his soup keeps a glass inside the bowl.": {
        "file": "ca3b65c4d8f01236493c.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The man on holiday in his soup keeps a ticket beside the bowl.": {
        "file": "b562653084d10c41c5d5.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The man on holiday in his soup keeps a ticket inside the bowl.": {
        "file": "f8116fbfe493d3744638.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The man on holiday in his soup keeps a cat beside the bowl.": {
        "file": "dadc7b3b8dc425c3e909.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The man on holiday in his soup keeps a cat inside the bowl.": {
        "file": "4b5533055522078a5a46.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The man on holiday in his soup keeps a shoe beside the bowl.": {
        "file": "0fb13d853ea292345566.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The man on holiday in his soup keeps a shoe inside the bowl.": {
        "file": "e241e9907742e18b2426.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The man on holiday in his soup keeps a dog beside the bowl.": {
        "file": "d8906e678296297be30d.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The man on holiday in his soup keeps a dog inside the bowl.": {
        "file": "1fee3912620c7559f04a.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The man on holiday in his soup keeps a box beside the bowl.": {
        "file": "f008ca725c064fe87491.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The man on holiday in his soup keeps a box inside the bowl.": {
        "file": "18b2d865cc817bb6c829.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The man on holiday in his soup keeps a gift beside the bowl.": {
        "file": "0c1e0deb846e7db491de.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The man on holiday in his soup keeps a gift inside the bowl.": {
        "file": "9e87a10015e1950b48ed.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The man on holiday in his soup keeps a bag beside the bowl.": {
        "file": "3d031a9415a5b35b22c2.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The man on holiday in his soup keeps a bag inside the bowl.": {
        "file": "8d15a6c902059db387b5.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The cake blowing out its own candles has two books beside it.": {
        "file": "4f0daef2d196722f8b41.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The cake blowing out its own candles has two cats beside it.": {
        "file": "b381c9f490c1446110d8.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The cake blowing out its own candles has three books beside it.": {
        "file": "b4d752cc505ed7b9be88.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The cake blowing out its own candles has three cats beside it.": {
        "file": "355a715ef97783d309a1.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The cake blowing out its own candles has two hats beside it.": {
        "file": "d5a510bd5f0a67103d60.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The cake blowing out its own candles has two dogs beside it.": {
        "file": "61ba5a321e322c3941f9.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The cake blowing out its own candles has four hats beside it.": {
        "file": "34dba9d128646176e3ad.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The cake blowing out its own candles has four dogs beside it.": {
        "file": "36db6fefdfdad91a0cfb.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "The cake blowing out its own candles has two fish beside it.": {
        "file": "1c15325692b3d219887e.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The cake blowing out its own candles has two gifts beside it.": {
        "file": "2dd35a8adb950db083a6.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The cake blowing out its own candles has three fish beside it.": {
        "file": "fd717b508db230f8bad7.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The cake blowing out its own candles has three gifts beside it.": {
        "file": "72e7caceca69dc551506.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The cake blowing out its own candles has two bottles beside it.": {
        "file": "4b2eee931dfc411c3ba7.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "The cake blowing out its own candles has two glasses beside it.": {
        "file": "7f0abf439122dfd6ff33.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The cake blowing out its own candles has four bottles beside it.": {
        "file": "632c44e5441d089a0077.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The cake blowing out its own candles has four glasses beside it.": {
        "file": "a7d2b463ca754669fd41.mp3",
        "bank": "en-oo1",
        "durationMs": 3819
    },
    "The cake blowing out its own candles has two pictures beside it.": {
        "file": "6b619a2b755f68997fac.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The cake blowing out its own candles has two bags beside it.": {
        "file": "da4018614bc57d5d9a1f.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The cake blowing out its own candles has three pictures beside it.": {
        "file": "daee0f8e50a3f8785470.mp3",
        "bank": "en-oo1",
        "durationMs": 3840
    },
    "The cake blowing out its own candles has three bags beside it.": {
        "file": "dfa3fa42f27b69bca506.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The spoon applying for a job brings a glass on its head.": {
        "file": "80cd99adc094de912be8.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The spoon applying for a job brings a glass under its arm.": {
        "file": "03c275a0b98e79d32edd.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The spoon applying for a job brings a key on its head.": {
        "file": "fcfa50d987410d5363c4.mp3",
        "bank": "en-oo1",
        "durationMs": 3072
    },
    "The spoon applying for a job brings a key under its arm.": {
        "file": "a67ed190a95f27673092.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The spoon applying for a job brings a book on its head.": {
        "file": "4c173775af688dde3112.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The spoon applying for a job brings a book under its arm.": {
        "file": "77452d5a3276ac07f6f6.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The spoon applying for a job brings a bottle on its head.": {
        "file": "2b01f92becaea2152b02.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The spoon applying for a job brings a bottle under its arm.": {
        "file": "b6f7866a41b2d3f0362e.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The spoon applying for a job brings a bag on its head.": {
        "file": "df8c4f22d71c4f520a58.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The spoon applying for a job brings a bag under its arm.": {
        "file": "ad52b4b2f724a7017356.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The spoon applying for a job brings a fish on its head.": {
        "file": "c9d5184a435dea785e89.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The spoon applying for a job brings a fish under its arm.": {
        "file": "5ee8317082805d22b76b.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The spoon applying for a job brings a gift on its head.": {
        "file": "e49a63af57ecc980fee1.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The spoon applying for a job brings a gift under its arm.": {
        "file": "dc667df7fe0aa8d8ab42.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The spoon applying for a job brings a cat on its head.": {
        "file": "366b1834e2817cc2b7fb.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The spoon applying for a job brings a cat under its arm.": {
        "file": "637738ed22bd8c7f8067.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The spoon applying for a job brings a cup on its head.": {
        "file": "c888dc4d46edcbf10d9b.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The spoon applying for a job brings a cup under its arm.": {
        "file": "8a7f8078956a41d21233.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The spoon applying for a job brings a picture on its head.": {
        "file": "4a3edfbe5ddd924471f0.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The spoon applying for a job brings a picture under its arm.": {
        "file": "df922eef9baa81b63902.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The man enjoying an empty plate is wearing a large hat and holding a glass.": {
        "file": "cddb60bff67701a8ee3b.mp3",
        "bank": "en-oo1",
        "durationMs": 4693
    },
    "The man enjoying an empty plate is wearing a large hat and holding a picture.": {
        "file": "20fab055a32662f490d1.mp3",
        "bank": "en-oo1",
        "durationMs": 4715
    },
    "The man enjoying an empty plate is wearing a small hat and holding a glass.": {
        "file": "ea0c7d3d48748865f095.mp3",
        "bank": "en-oo1",
        "durationMs": 4565
    },
    "The man enjoying an empty plate is wearing a small hat and holding a picture.": {
        "file": "187c6c7aafa1aa3cca02.mp3",
        "bank": "en-oo1",
        "durationMs": 4629
    },
    "The man enjoying an empty plate is wearing a long scarf and holding a ticket.": {
        "file": "4a829379685dba632f02.mp3",
        "bank": "en-oo1",
        "durationMs": 4608
    },
    "The man enjoying an empty plate is wearing a long scarf and holding a flower.": {
        "file": "2e07365eff87701743e5.mp3",
        "bank": "en-oo1",
        "durationMs": 4651
    },
    "The man enjoying an empty plate is wearing a short scarf and holding a ticket.": {
        "file": "690dd65b4c7922051534.mp3",
        "bank": "en-oo1",
        "durationMs": 4651
    },
    "The man enjoying an empty plate is wearing a short scarf and holding a flower.": {
        "file": "a048459c332471126a04.mp3",
        "bank": "en-oo1",
        "durationMs": 4736
    },
    "The man enjoying an empty plate is wearing round glasses and holding a book.": {
        "file": "632f8aea7236aa061a15.mp3",
        "bank": "en-oo1",
        "durationMs": 4480
    },
    "The man enjoying an empty plate is wearing round glasses and holding a fish.": {
        "file": "197460c296bc4275c6ad.mp3",
        "bank": "en-oo1",
        "durationMs": 4587
    },
    "The man enjoying an empty plate is wearing square glasses and holding a book.": {
        "file": "b8826dec365f38354350.mp3",
        "bank": "en-oo1",
        "durationMs": 4501
    },
    "The man enjoying an empty plate is wearing square glasses and holding a fish.": {
        "file": "5b3a8297fb22bcd0bc99.mp3",
        "bank": "en-oo1",
        "durationMs": 4629
    },
    "The man enjoying an empty plate is wearing a jacket with two pockets and holding a hat.": {
        "file": "d1d8266b6e9147585352.mp3",
        "bank": "en-oo1",
        "durationMs": 5099
    },
    "The man enjoying an empty plate is wearing a jacket with two pockets and holding a pencil.": {
        "file": "1c91130bd74dee0ba1a6.mp3",
        "bank": "en-oo1",
        "durationMs": 5440
    },
    "The man enjoying an empty plate is wearing a jacket with four pockets and holding a hat.": {
        "file": "c292cfd64c91aa642383.mp3",
        "bank": "en-oo1",
        "durationMs": 5333
    },
    "The man enjoying an empty plate is wearing a jacket with four pockets and holding a pencil.": {
        "file": "0ae1afedc483f860814e.mp3",
        "bank": "en-oo1",
        "durationMs": 5525
    },
    "The man enjoying an empty plate is wearing a shirt with long sleeves and holding a gift.": {
        "file": "1409f9e4532704fa70c4.mp3",
        "bank": "en-oo1",
        "durationMs": 5248
    },
    "The man enjoying an empty plate is wearing a shirt with long sleeves and holding a cat.": {
        "file": "7e95eae5ef29093e6410.mp3",
        "bank": "en-oo1",
        "durationMs": 5184
    },
    "The man enjoying an empty plate is wearing a shirt with short sleeves and holding a gift.": {
        "file": "290465fd433c6aae2990.mp3",
        "bank": "en-oo1",
        "durationMs": 5184
    },
    "The man enjoying an empty plate is wearing a shirt with short sleeves and holding a cat.": {
        "file": "4cb78688250cbd9b171f.mp3",
        "bank": "en-oo1",
        "durationMs": 5099
    },
    "The food judging its customer gives the man two gifts.": {
        "file": "e22a01b68b33646bdef9.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The food judging its customer gives the man two tickets.": {
        "file": "aaedadeb812603a31bb1.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The food judging its customer gives the man three gifts.": {
        "file": "9a4caf394be1b74ba2cc.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The food judging its customer gives the man three tickets.": {
        "file": "06cdb33d3adfc202ab1d.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The food judging its customer gives the man two glasses.": {
        "file": "0cb339a06567f9dc98ec.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The food judging its customer gives the man two bottles.": {
        "file": "7ce1da281acf627ef104.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The food judging its customer gives the man four glasses.": {
        "file": "395ac7a678a93460c4b0.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The food judging its customer gives the man four bottles.": {
        "file": "33e0c00747d595735172.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The food judging its customer gives the man two boxes.": {
        "file": "2fb7facf3ccd51a53cfe.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The food judging its customer gives the man two computers.": {
        "file": "1ea9bcc7d75d20adc2ef.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The food judging its customer gives the man three boxes.": {
        "file": "b9318c39605adccc0fd4.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The food judging its customer gives the man three computers.": {
        "file": "5105112883df584bd99b.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The food judging its customer gives the man two magazines.": {
        "file": "83dd569ea4b5957dd7f3.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The food judging its customer gives the man two fish.": {
        "file": "058c80a009a6b2fc9602.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The food judging its customer gives the man four magazines.": {
        "file": "9f3f8ae48b609b2b7063.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The food judging its customer gives the man four fish.": {
        "file": "e401315694686073d9e2.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The food judging its customer gives the man two bags.": {
        "file": "0c039ea3eaeb678d30b9.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The food judging its customer gives the man two eggs.": {
        "file": "40f92548cb5aa7839049.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The food judging its customer gives the man three bags.": {
        "file": "dd507725eb3ab495957f.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The food judging its customer gives the man three eggs.": {
        "file": "53a00e1e86de03608b1c.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "When our computer cloud starts raining, a dog is beside the computer.": {
        "file": "82d53a1ff7900827b6f2.mp3",
        "bank": "en-oo1",
        "durationMs": 4032
    },
    "When our computer cloud starts raining, a dog is behind the computer.": {
        "file": "dd116cbd2d77d8544218.mp3",
        "bank": "en-oo1",
        "durationMs": 4075
    },
    "When our computer cloud starts raining, a cat is beside the computer.": {
        "file": "fdc79db5d15a445deca2.mp3",
        "bank": "en-oo1",
        "durationMs": 3968
    },
    "When our computer cloud starts raining, a cat is behind the computer.": {
        "file": "7059a75e623ac5c0cea7.mp3",
        "bank": "en-oo1",
        "durationMs": 4011
    },
    "When our computer cloud starts raining, a fish is beside the computer.": {
        "file": "82b5168530ba7bb3deec.mp3",
        "bank": "en-oo1",
        "durationMs": 4011
    },
    "When our computer cloud starts raining, a fish is behind the computer.": {
        "file": "c163ac4e8ff4b629d671.mp3",
        "bank": "en-oo1",
        "durationMs": 4053
    },
    "When our computer cloud starts raining, a gift is beside the computer.": {
        "file": "7e28aba7e9baf376ef88.mp3",
        "bank": "en-oo1",
        "durationMs": 4011
    },
    "When our computer cloud starts raining, a gift is behind the computer.": {
        "file": "be96b3956a1adcccf3b0.mp3",
        "bank": "en-oo1",
        "durationMs": 4075
    },
    "When our computer cloud starts raining, a cup is beside the computer.": {
        "file": "8ed23511f5415aac2ab9.mp3",
        "bank": "en-oo1",
        "durationMs": 3947
    },
    "When our computer cloud starts raining, a cup is behind the computer.": {
        "file": "acd5e08b4b1a148e4868.mp3",
        "bank": "en-oo1",
        "durationMs": 3968
    },
    "When our computer cloud starts raining, an egg is beside the computer.": {
        "file": "c730ca6305092f999d9e.mp3",
        "bank": "en-oo1",
        "durationMs": 3968
    },
    "When our computer cloud starts raining, an egg is behind the computer.": {
        "file": "87b8830799a48532ca1c.mp3",
        "bank": "en-oo1",
        "durationMs": 4011
    },
    "When our computer cloud starts raining, a glass is beside the computer.": {
        "file": "e57ded4de785e7299b73.mp3",
        "bank": "en-oo1",
        "durationMs": 4011
    },
    "When our computer cloud starts raining, a glass is behind the computer.": {
        "file": "179845e16f2360522f6b.mp3",
        "bank": "en-oo1",
        "durationMs": 4075
    },
    "When our computer cloud starts raining, a computer is beside the computer.": {
        "file": "6d8507cc0e90c9fe138e.mp3",
        "bank": "en-oo1",
        "durationMs": 4075
    },
    "When our computer cloud starts raining, a computer is behind the computer.": {
        "file": "248d144a5eb4d37d3641.mp3",
        "bank": "en-oo1",
        "durationMs": 4139
    },
    "When our computer cloud starts raining, a coin is beside the computer.": {
        "file": "0cf813fb673f2c510252.mp3",
        "bank": "en-oo1",
        "durationMs": 4032
    },
    "When our computer cloud starts raining, a coin is behind the computer.": {
        "file": "915b85b35dc2fce66380.mp3",
        "bank": "en-oo1",
        "durationMs": 4096
    },
    "When our computer cloud starts raining, a book is beside the computer.": {
        "file": "bb90ea7405738ce21cce.mp3",
        "bank": "en-oo1",
        "durationMs": 3925
    },
    "When our computer cloud starts raining, a book is behind the computer.": {
        "file": "50f2351850e3a79cbeec.mp3",
        "bank": "en-oo1",
        "durationMs": 3989
    },
    "The computer refusing cookies has two glasses outside its door.": {
        "file": "28ce8bb8cf681f4ad925.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The computer refusing cookies has two bags outside its door.": {
        "file": "a69c966fd1c170128b20.mp3",
        "bank": "en-oo1",
        "durationMs": 3776
    },
    "The computer refusing cookies has three glasses outside its door.": {
        "file": "eab1d4e4fae63e72ef3d.mp3",
        "bank": "en-oo1",
        "durationMs": 3968
    },
    "The computer refusing cookies has three bags outside its door.": {
        "file": "0895666f4ce9839c3ebd.mp3",
        "bank": "en-oo1",
        "durationMs": 3861
    },
    "The computer refusing cookies has two boxes outside its door.": {
        "file": "f7dee90882b90b26e448.mp3",
        "bank": "en-oo1",
        "durationMs": 3883
    },
    "The computer refusing cookies has two dogs outside its door.": {
        "file": "65b6d36e824de1abb5ef.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "The computer refusing cookies has four boxes outside its door.": {
        "file": "4be6bf1804ede9ddef00.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "The computer refusing cookies has four dogs outside its door.": {
        "file": "e8ce8411151913f2fcf1.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The computer refusing cookies has two gifts outside its door.": {
        "file": "99b6c1a9520dc2de10b6.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The computer refusing cookies has two bottles outside its door.": {
        "file": "01c8147a8a7027212059.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The computer refusing cookies has three gifts outside its door.": {
        "file": "ca004cdd8a7e61bbe556.mp3",
        "bank": "en-oo1",
        "durationMs": 3819
    },
    "The computer refusing cookies has three bottles outside its door.": {
        "file": "abcddf207be6faff6e43.mp3",
        "bank": "en-oo1",
        "durationMs": 3861
    },
    "The computer refusing cookies has two fish outside its door.": {
        "file": "40cd73dd74d4a3cfc963.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The computer refusing cookies has two computers outside its door.": {
        "file": "6a3b5cd6c0d976c5c1ae.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "The computer refusing cookies has four fish outside its door.": {
        "file": "303241f7a22b1bd90429.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The computer refusing cookies has four computers outside its door.": {
        "file": "73af84cf3ad5e9ee7793.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "The computer refusing cookies has two shoes outside its door.": {
        "file": "130342748f8f69aa0814.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The computer refusing cookies has two clocks outside its door.": {
        "file": "30810a5be9f70474930d.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The computer refusing cookies has three shoes outside its door.": {
        "file": "b6deeaa00142402dbdfd.mp3",
        "bank": "en-oo1",
        "durationMs": 3776
    },
    "The computer refusing cookies has three clocks outside its door.": {
        "file": "5a0a80f280ec9ad28577.mp3",
        "bank": "en-oo1",
        "durationMs": 3819
    },
    "The man followed by his own phone is wearing a large hat and carrying a cat.": {
        "file": "f2f6a0941308820eefbe.mp3",
        "bank": "en-oo1",
        "durationMs": 4757
    },
    "The man followed by his own phone is wearing a large hat and carrying a key.": {
        "file": "227ab07273e8e74e3e8b.mp3",
        "bank": "en-oo1",
        "durationMs": 4736
    },
    "The man followed by his own phone is wearing a small hat and carrying a cat.": {
        "file": "f78f5c2d8d2b5e7e4763.mp3",
        "bank": "en-oo1",
        "durationMs": 4608
    },
    "The man followed by his own phone is wearing a small hat and carrying a key.": {
        "file": "e77f79628c3888fb1b1b.mp3",
        "bank": "en-oo1",
        "durationMs": 4587
    },
    "The man followed by his own phone is wearing a long scarf and carrying a glass.": {
        "file": "affb0342594026bc40a2.mp3",
        "bank": "en-oo1",
        "durationMs": 4821
    },
    "The man followed by his own phone is wearing a long scarf and carrying a box.": {
        "file": "54d58eabf560d1e76d36.mp3",
        "bank": "en-oo1",
        "durationMs": 4843
    },
    "The man followed by his own phone is wearing a short scarf and carrying a glass.": {
        "file": "9d7a934944566d90f559.mp3",
        "bank": "en-oo1",
        "durationMs": 4800
    },
    "The man followed by his own phone is wearing a short scarf and carrying a box.": {
        "file": "0a6ab167d71fa2e02cf2.mp3",
        "bank": "en-oo1",
        "durationMs": 4821
    },
    "The man followed by his own phone is wearing round glasses and carrying a gift.": {
        "file": "e40ff1556b554b362736.mp3",
        "bank": "en-oo1",
        "durationMs": 4800
    },
    "The man followed by his own phone is wearing round glasses and carrying a ticket.": {
        "file": "c58957f942217014a36e.mp3",
        "bank": "en-oo1",
        "durationMs": 4843
    },
    "The man followed by his own phone is wearing square glasses and carrying a gift.": {
        "file": "ab8ad336b416ff901c0f.mp3",
        "bank": "en-oo1",
        "durationMs": 4800
    },
    "The man followed by his own phone is wearing square glasses and carrying a ticket.": {
        "file": "b23c26bc7c9a7e8e5de0.mp3",
        "bank": "en-oo1",
        "durationMs": 4843
    },
    "The man followed by his own phone is wearing a jacket with two pockets and carrying a fish.": {
        "file": "ad7dd86f24c1bf770492.mp3",
        "bank": "en-oo1",
        "durationMs": 5525
    },
    "The man followed by his own phone is wearing a jacket with two pockets and carrying a computer.": {
        "file": "f2ec006feadac3781e82.mp3",
        "bank": "en-oo1",
        "durationMs": 5717
    },
    "The man followed by his own phone is wearing a jacket with four pockets and carrying a fish.": {
        "file": "80599b30299697428a8b.mp3",
        "bank": "en-oo1",
        "durationMs": 5675
    },
    "The man followed by his own phone is wearing a jacket with four pockets and carrying a computer.": {
        "file": "064449d79c934ea7e2dc.mp3",
        "bank": "en-oo1",
        "durationMs": 5803
    },
    "The man followed by his own phone is wearing a shirt with long sleeves and carrying a hat.": {
        "file": "c3a01c09db6c01f7b031.mp3",
        "bank": "en-oo1",
        "durationMs": 5355
    },
    "The man followed by his own phone is wearing a shirt with long sleeves and carrying a bottle.": {
        "file": "081da2f592e9492b3e80.mp3",
        "bank": "en-oo1",
        "durationMs": 5440
    },
    "The man followed by his own phone is wearing a shirt with short sleeves and carrying a hat.": {
        "file": "546b4774339f68230520.mp3",
        "bank": "en-oo1",
        "durationMs": 5205
    },
    "The man followed by his own phone is wearing a shirt with short sleeves and carrying a bottle.": {
        "file": "755b735cb6babc9785a4.mp3",
        "bank": "en-oo1",
        "durationMs": 5376
    },
    "During the online meeting by a real window, a gift is above the window.": {
        "file": "7dbb507e01f2d5a54331.mp3",
        "bank": "en-oo1",
        "durationMs": 4288
    },
    "During the online meeting by a real window, a gift is below the window.": {
        "file": "d22d12701ef7c988d325.mp3",
        "bank": "en-oo1",
        "durationMs": 4203
    },
    "During the online meeting by a real window, a ball is above the window.": {
        "file": "6d7af07c26d2c6c17399.mp3",
        "bank": "en-oo1",
        "durationMs": 4245
    },
    "During the online meeting by a real window, a ball is below the window.": {
        "file": "a1906762101ce810d7cf.mp3",
        "bank": "en-oo1",
        "durationMs": 4203
    },
    "During the online meeting by a real window, a glass is above the window.": {
        "file": "8cac9d5fd8a14be9bbdc.mp3",
        "bank": "en-oo1",
        "durationMs": 4352
    },
    "During the online meeting by a real window, a glass is below the window.": {
        "file": "af3760b8630e8b31600f.mp3",
        "bank": "en-oo1",
        "durationMs": 4267
    },
    "During the online meeting by a real window, a dog is above the window.": {
        "file": "b45325dcc6c83dfa9626.mp3",
        "bank": "en-oo1",
        "durationMs": 4331
    },
    "During the online meeting by a real window, a dog is below the window.": {
        "file": "22afb2a0dd49598f9b10.mp3",
        "bank": "en-oo1",
        "durationMs": 4245
    },
    "During the online meeting by a real window, a box is above the window.": {
        "file": "0dc1576accc1f93f5b7a.mp3",
        "bank": "en-oo1",
        "durationMs": 4224
    },
    "During the online meeting by a real window, a box is below the window.": {
        "file": "a7116dde05e58abf7e43.mp3",
        "bank": "en-oo1",
        "durationMs": 4160
    },
    "During the online meeting by a real window, a pencil is above the window.": {
        "file": "265bbf157e43f1479ac4.mp3",
        "bank": "en-oo1",
        "durationMs": 4373
    },
    "During the online meeting by a real window, a pencil is below the window.": {
        "file": "98efb91891b221e305a3.mp3",
        "bank": "en-oo1",
        "durationMs": 4331
    },
    "During the online meeting by a real window, a ticket is above the window.": {
        "file": "9f0af7bb523e2c66639a.mp3",
        "bank": "en-oo1",
        "durationMs": 4352
    },
    "During the online meeting by a real window, a ticket is below the window.": {
        "file": "c7420fda49199ccaf550.mp3",
        "bank": "en-oo1",
        "durationMs": 4331
    },
    "During the online meeting by a real window, a fish is above the window.": {
        "file": "d25d473a8ad26ab8b034.mp3",
        "bank": "en-oo1",
        "durationMs": 4331
    },
    "During the online meeting by a real window, a fish is below the window.": {
        "file": "b59a1ae6c6bf4b65e00e.mp3",
        "bank": "en-oo1",
        "durationMs": 4245
    },
    "During the online meeting by a real window, a phone is above the window.": {
        "file": "5d538f085b5569fe4a7f.mp3",
        "bank": "en-oo1",
        "durationMs": 4267
    },
    "During the online meeting by a real window, a phone is below the window.": {
        "file": "3e351a717ec871fe576d.mp3",
        "bank": "en-oo1",
        "durationMs": 4203
    },
    "During the online meeting by a real window, a bottle is above the window.": {
        "file": "be9f1e09cddbe99b2951.mp3",
        "bank": "en-oo1",
        "durationMs": 4309
    },
    "During the online meeting by a real window, a bottle is below the window.": {
        "file": "7a9023e8f85260bc5213.mp3",
        "bank": "en-oo1",
        "durationMs": 4224
    },
    "The mouse asking for a break is holding a glass.": {
        "file": "3e17026d0577a28e6135.mp3",
        "bank": "en-oo1",
        "durationMs": 2752
    },
    "The mouse asking for a break is holding a box.": {
        "file": "2dfcb79a24d70a26ac9b.mp3",
        "bank": "en-oo1",
        "durationMs": 2731
    },
    "The mouse asking for a break is pushing a glass.": {
        "file": "3764608d1cd24b14518e.mp3",
        "bank": "en-oo1",
        "durationMs": 2645
    },
    "The mouse asking for a break is pushing a box.": {
        "file": "9541f119e88d928e2eee.mp3",
        "bank": "en-oo1",
        "durationMs": 2624
    },
    "The mouse asking for a break is holding a fish.": {
        "file": "7b9fc18b823195e72be7.mp3",
        "bank": "en-oo1",
        "durationMs": 2645
    },
    "The mouse asking for a break is holding a robot.": {
        "file": "1f5dee00ea3a5b3bb18d.mp3",
        "bank": "en-oo1",
        "durationMs": 2923
    },
    "The mouse asking for a break is pushing a fish.": {
        "file": "e6264fe4d6ca7977c480.mp3",
        "bank": "en-oo1",
        "durationMs": 2581
    },
    "The mouse asking for a break is pushing a robot.": {
        "file": "055d56106dd8180a45df.mp3",
        "bank": "en-oo1",
        "durationMs": 2837
    },
    "The mouse asking for a break is holding a gift.": {
        "file": "bf69ddf0b498694383e7.mp3",
        "bank": "en-oo1",
        "durationMs": 2688
    },
    "The mouse asking for a break is holding a bag.": {
        "file": "f937b1e284e0358ded1a.mp3",
        "bank": "en-oo1",
        "durationMs": 2688
    },
    "The mouse asking for a break is pushing a gift.": {
        "file": "bd27cd6720dee0202c69.mp3",
        "bank": "en-oo1",
        "durationMs": 2603
    },
    "The mouse asking for a break is pushing a bag.": {
        "file": "80b69f020a0c2a92b1ad.mp3",
        "bank": "en-oo1",
        "durationMs": 2539
    },
    "The mouse asking for a break is holding a ticket.": {
        "file": "c81d4a2c455e3beaddcd.mp3",
        "bank": "en-oo1",
        "durationMs": 2752
    },
    "The mouse asking for a break is holding an egg.": {
        "file": "dfb6160c9d79c2edb7dc.mp3",
        "bank": "en-oo1",
        "durationMs": 2688
    },
    "The mouse asking for a break is pushing a ticket.": {
        "file": "1453970e517a97ac59fb.mp3",
        "bank": "en-oo1",
        "durationMs": 2645
    },
    "The mouse asking for a break is pushing an egg.": {
        "file": "306e65982a11545f2603.mp3",
        "bank": "en-oo1",
        "durationMs": 2560
    },
    "The mouse asking for a break is holding a ball.": {
        "file": "bd9d49b56e69b40af57e.mp3",
        "bank": "en-oo1",
        "durationMs": 2688
    },
    "The mouse asking for a break is holding a picture.": {
        "file": "fae3f79e176f8d2ad964.mp3",
        "bank": "en-oo1",
        "durationMs": 2837
    },
    "The mouse asking for a break is pushing a ball.": {
        "file": "6422c7e1a4f3dd717db0.mp3",
        "bank": "en-oo1",
        "durationMs": 2560
    },
    "The mouse asking for a break is pushing a picture.": {
        "file": "bbaa66ec790ee6635d4b.mp3",
        "bank": "en-oo1",
        "durationMs": 2731
    },
    "The computer's running trash can drops two dogs.": {
        "file": "52794ca9697afe70b8d2.mp3",
        "bank": "en-oo1",
        "durationMs": 2752
    },
    "The computer's running trash can drops two fish.": {
        "file": "6beac9ecfced3ea04143.mp3",
        "bank": "en-oo1",
        "durationMs": 2645
    },
    "The computer's running trash can drops three dogs.": {
        "file": "5cee153b58b955051925.mp3",
        "bank": "en-oo1",
        "durationMs": 2795
    },
    "The computer's running trash can drops three fish.": {
        "file": "96ca938a9f0d5a8ad6f1.mp3",
        "bank": "en-oo1",
        "durationMs": 2752
    },
    "The computer's running trash can drops two books.": {
        "file": "5ac89a50acec83472d43.mp3",
        "bank": "en-oo1",
        "durationMs": 2645
    },
    "The computer's running trash can drops two gifts.": {
        "file": "5f1b69b8917dd9c080ae.mp3",
        "bank": "en-oo1",
        "durationMs": 2773
    },
    "The computer's running trash can drops four books.": {
        "file": "f10ce59b23adc24f61b0.mp3",
        "bank": "en-oo1",
        "durationMs": 2773
    },
    "The computer's running trash can drops four gifts.": {
        "file": "dbaf056c9a9a7a7eb3ea.mp3",
        "bank": "en-oo1",
        "durationMs": 2837
    },
    "The computer's running trash can drops two cups.": {
        "file": "b22c0f5708dfaa9dc063.mp3",
        "bank": "en-oo1",
        "durationMs": 2645
    },
    "The computer's running trash can drops two boxes.": {
        "file": "14639856f81128436e2c.mp3",
        "bank": "en-oo1",
        "durationMs": 2901
    },
    "The computer's running trash can drops three cups.": {
        "file": "1cbd9d15ed164d6682e8.mp3",
        "bank": "en-oo1",
        "durationMs": 2709
    },
    "The computer's running trash can drops three boxes.": {
        "file": "e12ffc7a6aab0431ace0.mp3",
        "bank": "en-oo1",
        "durationMs": 2965
    },
    "The computer's running trash can drops two tickets.": {
        "file": "c6bfe5729837e9e380c7.mp3",
        "bank": "en-oo1",
        "durationMs": 2752
    },
    "The computer's running trash can drops two glasses.": {
        "file": "6c880dfc9c00a08f67c6.mp3",
        "bank": "en-oo1",
        "durationMs": 2944
    },
    "The computer's running trash can drops four tickets.": {
        "file": "dc64548f8104db3e3529.mp3",
        "bank": "en-oo1",
        "durationMs": 2859
    },
    "The computer's running trash can drops four glasses.": {
        "file": "fc72bca2f10353cac8e0.mp3",
        "bank": "en-oo1",
        "durationMs": 3008
    },
    "The computer's running trash can drops two bottles.": {
        "file": "5dee5eee39559a7e6238.mp3",
        "bank": "en-oo1",
        "durationMs": 2795
    },
    "The computer's running trash can drops two computers.": {
        "file": "fc0152c0bdb47f38b056.mp3",
        "bank": "en-oo1",
        "durationMs": 2965
    },
    "The computer's running trash can drops three bottles.": {
        "file": "51c2481706250335256e.mp3",
        "bank": "en-oo1",
        "durationMs": 2923
    },
    "The computer's running trash can drops three computers.": {
        "file": "6b0468e67de96d27e2f6.mp3",
        "bank": "en-oo1",
        "durationMs": 3072
    },
    "The man waiting for his dinner to load puts a bag on the table.": {
        "file": "c27ae534d7b2df3e1f04.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The man waiting for his dinner to load puts a bag under the table.": {
        "file": "e1f6f9e8085560b597ef.mp3",
        "bank": "en-oo1",
        "durationMs": 3776
    },
    "The man waiting for his dinner to load puts a shoe on the table.": {
        "file": "6e9042c505bf5d0a20ac.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The man waiting for his dinner to load puts a shoe under the table.": {
        "file": "fa6de4468e43d27adb67.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The man waiting for his dinner to load puts a bottle on the table.": {
        "file": "8c60ab5e80878d2ddc8c.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "The man waiting for his dinner to load puts a bottle under the table.": {
        "file": "2e136e1c3350e15924e1.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "The man waiting for his dinner to load puts a computer on the table.": {
        "file": "173c9f16df9ad241a165.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The man waiting for his dinner to load puts a computer under the table.": {
        "file": "c926f8d962ba2ee88c8d.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "The man waiting for his dinner to load puts a glass on the table.": {
        "file": "71291fef51382686a0ce.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The man waiting for his dinner to load puts a glass under the table.": {
        "file": "f33f79113894c4819aa6.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "The man waiting for his dinner to load puts a box on the table.": {
        "file": "97829cb9efefcbaf34a8.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The man waiting for his dinner to load puts a box under the table.": {
        "file": "68db360b8c0992021462.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The man waiting for his dinner to load puts a ticket on the table.": {
        "file": "b72613857a17da0dcdb7.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The man waiting for his dinner to load puts a ticket under the table.": {
        "file": "cd2e3de9355117d1dbdd.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The man waiting for his dinner to load puts an egg on the table.": {
        "file": "e0aef3b70ef0dc14b414.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The man waiting for his dinner to load puts an egg under the table.": {
        "file": "51add751fd765e281822.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The man waiting for his dinner to load puts a clock on the table.": {
        "file": "68dbf458944c71ecce0b.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The man waiting for his dinner to load puts a clock under the table.": {
        "file": "04ef800d0f045526903d.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The man waiting for his dinner to load puts a book on the table.": {
        "file": "230a59ef18e57da8aa34.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The man waiting for his dinner to load puts a book under the table.": {
        "file": "8d03bbb32f9763ecf5f0.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "To make an online friend, the woman offers a large glass.": {
        "file": "65c2b2b9a0242cb012a2.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "To make an online friend, the woman offers a large box.": {
        "file": "819cfa3b94e1a24b9143.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "To make an online friend, the woman offers a small glass.": {
        "file": "66270c122999e68d58ce.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "To make an online friend, the woman offers a small box.": {
        "file": "504514cadedfd3c43eb4.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "To make an online friend, the woman offers a large fish.": {
        "file": "170908eca6df136485e3.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "To make an online friend, the woman offers a large picture.": {
        "file": "5f9ac4aa317d9ceb67cf.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "To make an online friend, the woman offers a small fish.": {
        "file": "b5672b6234b3d4ea28dc.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "To make an online friend, the woman offers a small picture.": {
        "file": "c5558ee90c888171bec2.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "To make an online friend, the woman offers a large computer.": {
        "file": "6067288b376a3c9a728e.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "To make an online friend, the woman offers a large phone.": {
        "file": "8598d56530399caae7e5.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "To make an online friend, the woman offers a small computer.": {
        "file": "ed05da36b81046862e5e.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "To make an online friend, the woman offers a small phone.": {
        "file": "a2b3a5d2888e3a872c08.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "To make an online friend, the woman offers a large bottle.": {
        "file": "b288959cc21b6ba48cd2.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "To make an online friend, the woman offers a large gift.": {
        "file": "2d1c232a7e6d1c3e71d7.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "To make an online friend, the woman offers a small bottle.": {
        "file": "b2743e40ae4ac4a56e9e.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "To make an online friend, the woman offers a small gift.": {
        "file": "b2aa19b4e08509d91a34.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "To make an online friend, the woman offers a large dog.": {
        "file": "2c7c4ec48d0d9c0ed4cb.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "To make an online friend, the woman offers a large robot.": {
        "file": "f1d1d9ca0b67ed81e2b0.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "To make an online friend, the woman offers a small dog.": {
        "file": "faed8453e7aa3f88c4a7.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "To make an online friend, the woman offers a small robot.": {
        "file": "b088626387ffb5371437.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The computer locked out of its room holds a glass above its head.": {
        "file": "05fb59ed262da99f3941.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "The computer locked out of its room holds a glass behind its back.": {
        "file": "63a1c4381c5cc164bd86.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The computer locked out of its room holds a cup above its head.": {
        "file": "e810622c781dec8a4ee2.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The computer locked out of its room holds a cup behind its back.": {
        "file": "01eb79621b8ef2ddb2a1.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The computer locked out of its room holds a fish above its head.": {
        "file": "5c97ca28fc50517e0921.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The computer locked out of its room holds a fish behind its back.": {
        "file": "98f5e2702eb78c760387.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The computer locked out of its room holds a computer above its head.": {
        "file": "de9f6494d7861b5d42a2.mp3",
        "bank": "en-oo1",
        "durationMs": 3819
    },
    "The computer locked out of its room holds a computer behind its back.": {
        "file": "d9e00e49293ce22cdad0.mp3",
        "bank": "en-oo1",
        "durationMs": 3883
    },
    "The computer locked out of its room holds a dog above its head.": {
        "file": "1a3e5cfec141b622b918.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The computer locked out of its room holds a dog behind its back.": {
        "file": "bfa470d649a4aa04c849.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The computer locked out of its room holds a bottle above its head.": {
        "file": "a1f691683f8a0d9539f0.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The computer locked out of its room holds a bottle behind its back.": {
        "file": "d6289ae0f36d268881c7.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The computer locked out of its room holds a box above its head.": {
        "file": "54d48bd3f851aa905e38.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The computer locked out of its room holds a box behind its back.": {
        "file": "d9fea28d7b90ce2adaa4.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The computer locked out of its room holds a cat above its head.": {
        "file": "25d0933fbab23a7c468b.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The computer locked out of its room holds a cat behind its back.": {
        "file": "9463689873b2c0c6fa7d.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The computer locked out of its room holds a gift above its head.": {
        "file": "1391113bc2e570fbab39.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The computer locked out of its room holds a gift behind its back.": {
        "file": "a61184664fd533d267e5.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The computer locked out of its room holds a hat above its head.": {
        "file": "a4d34c1b8961cf925672.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The computer locked out of its room holds a hat behind its back.": {
        "file": "fda6efe3200f13ff2705.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The phone buying free time chooses two bags at the shop.": {
        "file": "5a15c1ed03d3482107d6.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The phone buying free time chooses two glasses at the shop.": {
        "file": "7dd45a796f0affdf97de.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The phone buying free time chooses three bags at the shop.": {
        "file": "2bf8ff9bfad95d988b90.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The phone buying free time chooses three glasses at the shop.": {
        "file": "2af6b2eca1ad1099d956.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "The phone buying free time chooses two boxes at the shop.": {
        "file": "20981376114c92c16213.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The phone buying free time chooses two books at the shop.": {
        "file": "505600b1c3280a640719.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The phone buying free time chooses four boxes at the shop.": {
        "file": "48bc2f5f4b5461370567.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "The phone buying free time chooses four books at the shop.": {
        "file": "3675e12391a31a593d58.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The phone buying free time chooses two shoes at the shop.": {
        "file": "5f8e92b1cf4110450007.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The phone buying free time chooses two hats at the shop.": {
        "file": "b37e59b29b8feb55f500.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The phone buying free time chooses three shoes at the shop.": {
        "file": "59c442517fca2cf6530c.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The phone buying free time chooses three hats at the shop.": {
        "file": "b7efc4c7b7abdda49c6f.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The phone buying free time chooses two cats at the shop.": {
        "file": "ca6d5f2ec8c3d1160229.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The phone buying free time chooses two eggs at the shop.": {
        "file": "403cc3b5dd67ff34983a.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The phone buying free time chooses four cats at the shop.": {
        "file": "f93d5a78a3e91d0ee3d8.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The phone buying free time chooses four eggs at the shop.": {
        "file": "020566cd6a450cc70515.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The phone buying free time chooses two pictures at the shop.": {
        "file": "05991226447ab553959b.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The phone buying free time chooses two phones at the shop.": {
        "file": "0d0c2697fc770843eb3e.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The phone buying free time chooses three pictures at the shop.": {
        "file": "695e835ee52bf31c7b26.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The phone buying free time chooses three phones at the shop.": {
        "file": "3a9739cfc1678dfeb4ba.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The vacuum cleaner taking a break leaves two bottles on the floor.": {
        "file": "5e81f346b66eaee8917a.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The vacuum cleaner taking a break leaves two gifts on the floor.": {
        "file": "538384cadd5d206df7df.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The vacuum cleaner taking a break leaves three bottles on the floor.": {
        "file": "290213271c87ddcc28e2.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The vacuum cleaner taking a break leaves three gifts on the floor.": {
        "file": "ed3cc0b9e32a095cbd4d.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The vacuum cleaner taking a break leaves two glasses on the floor.": {
        "file": "55b41130db9a47cf437b.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The vacuum cleaner taking a break leaves two fish on the floor.": {
        "file": "b1083eaddbe9ec1bb4c4.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The vacuum cleaner taking a break leaves four glasses on the floor.": {
        "file": "130d640dfd8dbbfe5d1b.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The vacuum cleaner taking a break leaves four fish on the floor.": {
        "file": "a7de2f1b564429f57beb.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The vacuum cleaner taking a break leaves two cats on the floor.": {
        "file": "0d821db23c2846d2bc86.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The vacuum cleaner taking a break leaves two robots on the floor.": {
        "file": "9e62526f8598c346f4d0.mp3",
        "bank": "en-oo1",
        "durationMs": 3776
    },
    "The vacuum cleaner taking a break leaves three cats on the floor.": {
        "file": "461ca86baa958e565935.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The vacuum cleaner taking a break leaves three robots on the floor.": {
        "file": "6f4ad3f1decab6f71228.mp3",
        "bank": "en-oo1",
        "durationMs": 3861
    },
    "The vacuum cleaner taking a break leaves two dogs on the floor.": {
        "file": "ca76774eac9652dcd232.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The vacuum cleaner taking a break leaves two tickets on the floor.": {
        "file": "582494e83ae24cc363dc.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The vacuum cleaner taking a break leaves four dogs on the floor.": {
        "file": "e4c6815b9303b516058c.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The vacuum cleaner taking a break leaves four tickets on the floor.": {
        "file": "fe47a68e54ed66a6a5bc.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The vacuum cleaner taking a break leaves two shoes on the floor.": {
        "file": "78c9c2a2ced50e80ef0d.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The vacuum cleaner taking a break leaves two boxes on the floor.": {
        "file": "d3856d13a256eb575777.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The vacuum cleaner taking a break leaves three shoes on the floor.": {
        "file": "a0e4af78e2770098e956.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The vacuum cleaner taking a break leaves three boxes on the floor.": {
        "file": "5156a2472a70fb05fd82.mp3",
        "bank": "en-oo1",
        "durationMs": 3776
    },
    "Our refrigerator going out for dinner is wearing a large hat and carrying a glass.": {
        "file": "7a5cb9335033a7efd1b9.mp3",
        "bank": "en-oo1",
        "durationMs": 5035
    },
    "Our refrigerator going out for dinner is wearing a large hat and carrying a book.": {
        "file": "b0d17fd2319f7661f00d.mp3",
        "bank": "en-oo1",
        "durationMs": 4949
    },
    "Our refrigerator going out for dinner is wearing a small hat and carrying a glass.": {
        "file": "f253571e523e24ca031d.mp3",
        "bank": "en-oo1",
        "durationMs": 4885
    },
    "Our refrigerator going out for dinner is wearing a small hat and carrying a book.": {
        "file": "cae3c2b310767a8ccf98.mp3",
        "bank": "en-oo1",
        "durationMs": 4821
    },
    "Our refrigerator going out for dinner is wearing a long scarf and carrying a box.": {
        "file": "01fd29d1e0f7d7be345d.mp3",
        "bank": "en-oo1",
        "durationMs": 5141
    },
    "Our refrigerator going out for dinner is wearing a long scarf and carrying a fish.": {
        "file": "a109ea2b8080bf9b22b2.mp3",
        "bank": "en-oo1",
        "durationMs": 5035
    },
    "Our refrigerator going out for dinner is wearing a short scarf and carrying a box.": {
        "file": "86326caf8838bc3027c8.mp3",
        "bank": "en-oo1",
        "durationMs": 5163
    },
    "Our refrigerator going out for dinner is wearing a short scarf and carrying a fish.": {
        "file": "985f38119eeebeae1c2b.mp3",
        "bank": "en-oo1",
        "durationMs": 5077
    },
    "Our refrigerator going out for dinner is wearing round glasses and carrying a hat.": {
        "file": "f64142fe1d8f597a9a5d.mp3",
        "bank": "en-oo1",
        "durationMs": 4992
    },
    "Our refrigerator going out for dinner is wearing round glasses and carrying a ticket.": {
        "file": "c9218a8b96284828da65.mp3",
        "bank": "en-oo1",
        "durationMs": 5163
    },
    "Our refrigerator going out for dinner is wearing square glasses and carrying a hat.": {
        "file": "996ce78f30cfc926fb42.mp3",
        "bank": "en-oo1",
        "durationMs": 5056
    },
    "Our refrigerator going out for dinner is wearing square glasses and carrying a ticket.": {
        "file": "70c96d5352c65b2c545b.mp3",
        "bank": "en-oo1",
        "durationMs": 5141
    },
    "Our refrigerator going out for dinner is wearing a jacket with two pockets and carrying a pencil.": {
        "file": "ee99717ab69bae896f81.mp3",
        "bank": "en-oo1",
        "durationMs": 5931
    },
    "Our refrigerator going out for dinner is wearing a jacket with two pockets and carrying a gift.": {
        "file": "6e53f2dde2fd3be1568d.mp3",
        "bank": "en-oo1",
        "durationMs": 5845
    },
    "Our refrigerator going out for dinner is wearing a jacket with four pockets and carrying a pencil.": {
        "file": "262493c4ca28d9b37edf.mp3",
        "bank": "en-oo1",
        "durationMs": 5952
    },
    "Our refrigerator going out for dinner is wearing a jacket with four pockets and carrying a gift.": {
        "file": "aa953eb8cf684c64b690.mp3",
        "bank": "en-oo1",
        "durationMs": 5931
    },
    "Our refrigerator going out for dinner is wearing a shirt with long sleeves and carrying a computer.": {
        "file": "449ab8d82c58bbc43a77.mp3",
        "bank": "en-oo1",
        "durationMs": 5867
    },
    "Our refrigerator going out for dinner is wearing a shirt with long sleeves and carrying a coin.": {
        "file": "94d5a83ae5b431a43c3d.mp3",
        "bank": "en-oo1",
        "durationMs": 5739
    },
    "Our refrigerator going out for dinner is wearing a shirt with short sleeves and carrying a computer.": {
        "file": "f2091ec9215b1370c922.mp3",
        "bank": "en-oo1",
        "durationMs": 5803
    },
    "Our refrigerator going out for dinner is wearing a shirt with short sleeves and carrying a coin.": {
        "file": "78438c663be24bb13300.mp3",
        "bank": "en-oo1",
        "durationMs": 5696
    },
    "The clothes doing the washing keep a gift beside the basket.": {
        "file": "f01dbcb531da32e706fe.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The clothes doing the washing keep a gift inside the basket.": {
        "file": "f5a833c7195c8df226e8.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The clothes doing the washing keep a bottle beside the basket.": {
        "file": "33b6cdd046322b2efb1d.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The clothes doing the washing keep a bottle inside the basket.": {
        "file": "5972dc5d9e7d68a45111.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The clothes doing the washing keep a glass beside the basket.": {
        "file": "d512ec3b0720c3a9a596.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The clothes doing the washing keep a glass inside the basket.": {
        "file": "6480df5d35ef6bd1fa7f.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The clothes doing the washing keep a ticket beside the basket.": {
        "file": "8e50990c3b4f131c92c5.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The clothes doing the washing keep a ticket inside the basket.": {
        "file": "afdb9d8077f3d0478be9.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The clothes doing the washing keep a ball beside the basket.": {
        "file": "50a1756542d4bfdb25fd.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The clothes doing the washing keep a ball inside the basket.": {
        "file": "a4aa7155c9b012980948.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The clothes doing the washing keep a hat beside the basket.": {
        "file": "d1fd26f68c1c3cacd217.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The clothes doing the washing keep a hat inside the basket.": {
        "file": "8300caca117e56cec2af.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The clothes doing the washing keep a picture beside the basket.": {
        "file": "b70ff662f4edcb906a6b.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The clothes doing the washing keep a picture inside the basket.": {
        "file": "d32baf1f0d8d9d2b7ab1.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The clothes doing the washing keep a bag beside the basket.": {
        "file": "810b92bb7ebb0b3be832.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The clothes doing the washing keep a bag inside the basket.": {
        "file": "b2e6ead1f7c417eb7ff1.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The clothes doing the washing keep a fish beside the basket.": {
        "file": "e5a57e77a758f175d45d.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The clothes doing the washing keep a fish inside the basket.": {
        "file": "28a85a3243b5de698cc5.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The clothes doing the washing keep a box beside the basket.": {
        "file": "d1f9369933a061001b23.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The clothes doing the washing keep a box inside the basket.": {
        "file": "60f84cd3b19dd44cc4ed.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The bed refusing to get up is holding a hat.": {
        "file": "39a3306620cf31da45d8.mp3",
        "bank": "en-oo1",
        "durationMs": 2624
    },
    "The bed refusing to get up is holding a cup.": {
        "file": "60d2a363dbc67584db0c.mp3",
        "bank": "en-oo1",
        "durationMs": 2624
    },
    "The bed refusing to get up is pushing a hat.": {
        "file": "a2eacaecdcc926b01240.mp3",
        "bank": "en-oo1",
        "durationMs": 2496
    },
    "The bed refusing to get up is pushing a cup.": {
        "file": "63a1328c3e354ff15403.mp3",
        "bank": "en-oo1",
        "durationMs": 2560
    },
    "The bed refusing to get up is holding a fish.": {
        "file": "5a6494e078bc1ce62719.mp3",
        "bank": "en-oo1",
        "durationMs": 2667
    },
    "The bed refusing to get up is holding a ticket.": {
        "file": "1c64fc0461eef4350127.mp3",
        "bank": "en-oo1",
        "durationMs": 2752
    },
    "The bed refusing to get up is pushing a fish.": {
        "file": "8942636c9ed7d826cc18.mp3",
        "bank": "en-oo1",
        "durationMs": 2496
    },
    "The bed refusing to get up is pushing a ticket.": {
        "file": "5a2c31c9d2fb522d35e5.mp3",
        "bank": "en-oo1",
        "durationMs": 2645
    },
    "The bed refusing to get up is holding a glass.": {
        "file": "d66791b38e64814bf590.mp3",
        "bank": "en-oo1",
        "durationMs": 2731
    },
    "The bed refusing to get up is holding a computer.": {
        "file": "99591a96f7c57373370f.mp3",
        "bank": "en-oo1",
        "durationMs": 3051
    },
    "The bed refusing to get up is pushing a glass.": {
        "file": "9251edce042964e777e1.mp3",
        "bank": "en-oo1",
        "durationMs": 2624
    },
    "The bed refusing to get up is pushing a computer.": {
        "file": "a638c23d54e5786b65d9.mp3",
        "bank": "en-oo1",
        "durationMs": 2901
    },
    "The bed refusing to get up is holding a shoe.": {
        "file": "3a48368580800cbe6164.mp3",
        "bank": "en-oo1",
        "durationMs": 2624
    },
    "The bed refusing to get up is holding a flower.": {
        "file": "f0d6c8ad61a3b35f4aeb.mp3",
        "bank": "en-oo1",
        "durationMs": 2752
    },
    "The bed refusing to get up is pushing a shoe.": {
        "file": "c3890d7eb2f26a4d19cd.mp3",
        "bank": "en-oo1",
        "durationMs": 2517
    },
    "The bed refusing to get up is pushing a flower.": {
        "file": "ab7b73ebad2832af7512.mp3",
        "bank": "en-oo1",
        "durationMs": 2752
    },
    "The bed refusing to get up is holding a gift.": {
        "file": "d38ea309e61fca321084.mp3",
        "bank": "en-oo1",
        "durationMs": 2731
    },
    "The bed refusing to get up is holding a bottle.": {
        "file": "5d34ff8c3351a2e4e8c0.mp3",
        "bank": "en-oo1",
        "durationMs": 2688
    },
    "The bed refusing to get up is pushing a gift.": {
        "file": "c8ad315d32d08b59095c.mp3",
        "bank": "en-oo1",
        "durationMs": 2581
    },
    "The bed refusing to get up is pushing a bottle.": {
        "file": "c409d5c0b5605238636e.mp3",
        "bank": "en-oo1",
        "durationMs": 2667
    },
    "The door leaving home takes a large fish.": {
        "file": "e49ce45d0b6fb60758c5.mp3",
        "bank": "en-oo1",
        "durationMs": 2325
    },
    "The door leaving home takes a large glass.": {
        "file": "f530294794a9e916e46b.mp3",
        "bank": "en-oo1",
        "durationMs": 2432
    },
    "The door leaving home takes a small fish.": {
        "file": "bdf7de4ef401e6401c95.mp3",
        "bank": "en-oo1",
        "durationMs": 2261
    },
    "The door leaving home takes a small glass.": {
        "file": "d3d26370647cdf72af36.mp3",
        "bank": "en-oo1",
        "durationMs": 2325
    },
    "The door leaving home takes a large egg.": {
        "file": "c0a16dff874c6c239186.mp3",
        "bank": "en-oo1",
        "durationMs": 2304
    },
    "The door leaving home takes a large robot.": {
        "file": "97d3fbe4b7cbcecb7b9b.mp3",
        "bank": "en-oo1",
        "durationMs": 2837
    },
    "The door leaving home takes a small egg.": {
        "file": "fbd1bda900332eb91cb2.mp3",
        "bank": "en-oo1",
        "durationMs": 2176
    },
    "The door leaving home takes a small robot.": {
        "file": "3e9cd22be08e02094bf1.mp3",
        "bank": "en-oo1",
        "durationMs": 2752
    },
    "The door leaving home takes a large cat.": {
        "file": "748ef440f13dcc35b9a1.mp3",
        "bank": "en-oo1",
        "durationMs": 2347
    },
    "The door leaving home takes a large box.": {
        "file": "8976bd6c203273cb3594.mp3",
        "bank": "en-oo1",
        "durationMs": 2517
    },
    "The door leaving home takes a small cat.": {
        "file": "fbb659b07167497f7d6b.mp3",
        "bank": "en-oo1",
        "durationMs": 2368
    },
    "The door leaving home takes a small box.": {
        "file": "4bc72628d12633adc4dd.mp3",
        "bank": "en-oo1",
        "durationMs": 2304
    },
    "The door leaving home takes a large computer.": {
        "file": "309b3f34111092364dbf.mp3",
        "bank": "en-oo1",
        "durationMs": 2773
    },
    "The door leaving home takes a large ticket.": {
        "file": "3834a79235ca71b9f2f7.mp3",
        "bank": "en-oo1",
        "durationMs": 2581
    },
    "The door leaving home takes a small computer.": {
        "file": "b73b582e53416cbc1691.mp3",
        "bank": "en-oo1",
        "durationMs": 2624
    },
    "The door leaving home takes a small ticket.": {
        "file": "babc0347651257d0edd8.mp3",
        "bank": "en-oo1",
        "durationMs": 2453
    },
    "The door leaving home takes a large bag.": {
        "file": "ef3bc798affba4cd5812.mp3",
        "bank": "en-oo1",
        "durationMs": 2389
    },
    "The door leaving home takes a large shoe.": {
        "file": "d5d9fff2af6008f929ac.mp3",
        "bank": "en-oo1",
        "durationMs": 2261
    },
    "The door leaving home takes a small bag.": {
        "file": "3430ac139bdc7a47fe5d.mp3",
        "bank": "en-oo1",
        "durationMs": 2240
    },
    "The door leaving home takes a small shoe.": {
        "file": "e11d4e316f7ba600aa90.mp3",
        "bank": "en-oo1",
        "durationMs": 2155
    },
    "The sleeping alarm clock keeps a bag beside the bed.": {
        "file": "c73cef6cc66d4d78b2d9.mp3",
        "bank": "en-oo1",
        "durationMs": 3051
    },
    "The sleeping alarm clock keeps a bag under the bed.": {
        "file": "5adab4deecde0ef9e4cb.mp3",
        "bank": "en-oo1",
        "durationMs": 2837
    },
    "The sleeping alarm clock keeps a box beside the bed.": {
        "file": "9ad7070c684b9a3ece90.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The sleeping alarm clock keeps a box under the bed.": {
        "file": "ba6746746466813fd1cc.mp3",
        "bank": "en-oo1",
        "durationMs": 2901
    },
    "The sleeping alarm clock keeps a bottle beside the bed.": {
        "file": "f2d7c52547332ef75ede.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The sleeping alarm clock keeps a bottle under the bed.": {
        "file": "a8ac22ae07c74f151dc4.mp3",
        "bank": "en-oo1",
        "durationMs": 2965
    },
    "The sleeping alarm clock keeps a magazine beside the bed.": {
        "file": "ca250efd50d707c4db1e.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The sleeping alarm clock keeps a magazine under the bed.": {
        "file": "3f480e82bed23b20430b.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The sleeping alarm clock keeps a gift beside the bed.": {
        "file": "62b06ccf93a7c45b90d3.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The sleeping alarm clock keeps a gift under the bed.": {
        "file": "ef331e8bc08d91bbf4a2.mp3",
        "bank": "en-oo1",
        "durationMs": 2965
    },
    "The sleeping alarm clock keeps a book beside the bed.": {
        "file": "89b656f1410ea8c12cf1.mp3",
        "bank": "en-oo1",
        "durationMs": 2944
    },
    "The sleeping alarm clock keeps a book under the bed.": {
        "file": "7f975fbc5253405591cd.mp3",
        "bank": "en-oo1",
        "durationMs": 2773
    },
    "The sleeping alarm clock keeps a pencil beside the bed.": {
        "file": "1f21ee58223285b41523.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The sleeping alarm clock keeps a pencil under the bed.": {
        "file": "acc3dd3c2767ed91bb24.mp3",
        "bank": "en-oo1",
        "durationMs": 3072
    },
    "The sleeping alarm clock keeps a robot beside the bed.": {
        "file": "a5d3c27dbb9dd318e00c.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The sleeping alarm clock keeps a robot under the bed.": {
        "file": "2d167342207e54893100.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The sleeping alarm clock keeps a dog beside the bed.": {
        "file": "dd39240057bece5b1551.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "The sleeping alarm clock keeps a dog under the bed.": {
        "file": "6d8105e9f70d787b8dcd.mp3",
        "bank": "en-oo1",
        "durationMs": 2923
    },
    "The sleeping alarm clock keeps a glass beside the bed.": {
        "file": "acf62f1ad78fd406133c.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "The sleeping alarm clock keeps a glass under the bed.": {
        "file": "ca796be65b2f89296981.mp3",
        "bank": "en-oo1",
        "durationMs": 2965
    },
    "The cup moving into a new cupboard brings two gifts.": {
        "file": "2fb849a22dc32068312e.mp3",
        "bank": "en-oo1",
        "durationMs": 2795
    },
    "The cup moving into a new cupboard brings two bags.": {
        "file": "cf54e8fc80653256c6f0.mp3",
        "bank": "en-oo1",
        "durationMs": 2837
    },
    "The cup moving into a new cupboard brings three gifts.": {
        "file": "c8e65e03ede67464656e.mp3",
        "bank": "en-oo1",
        "durationMs": 2987
    },
    "The cup moving into a new cupboard brings three bags.": {
        "file": "7e7a13b73bfd9b8bc6a7.mp3",
        "bank": "en-oo1",
        "durationMs": 2944
    },
    "The cup moving into a new cupboard brings two phones.": {
        "file": "5f504b51ff1620458a19.mp3",
        "bank": "en-oo1",
        "durationMs": 2880
    },
    "The cup moving into a new cupboard brings two hats.": {
        "file": "b879a1c411ef0c05ca30.mp3",
        "bank": "en-oo1",
        "durationMs": 2731
    },
    "The cup moving into a new cupboard brings four phones.": {
        "file": "01b16205c0cf345cee4d.mp3",
        "bank": "en-oo1",
        "durationMs": 2965
    },
    "The cup moving into a new cupboard brings four hats.": {
        "file": "53969f7c0917330a7342.mp3",
        "bank": "en-oo1",
        "durationMs": 2859
    },
    "The cup moving into a new cupboard brings two boxes.": {
        "file": "d38fbb18798137b6637b.mp3",
        "bank": "en-oo1",
        "durationMs": 2987
    },
    "The cup moving into a new cupboard brings two pencils.": {
        "file": "43a7ee2e5cd80518a86d.mp3",
        "bank": "en-oo1",
        "durationMs": 2987
    },
    "The cup moving into a new cupboard brings three boxes.": {
        "file": "3e1682f6a357b02996d3.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The cup moving into a new cupboard brings three pencils.": {
        "file": "f358eaf9701e06955432.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "The cup moving into a new cupboard brings two fish.": {
        "file": "eed1a6c3045582532ebc.mp3",
        "bank": "en-oo1",
        "durationMs": 2667
    },
    "The cup moving into a new cupboard brings two robots.": {
        "file": "01ec7f024bee0c4a777c.mp3",
        "bank": "en-oo1",
        "durationMs": 2965
    },
    "The cup moving into a new cupboard brings four fish.": {
        "file": "f760b5d7898c7786f477.mp3",
        "bank": "en-oo1",
        "durationMs": 2837
    },
    "The cup moving into a new cupboard brings four robots.": {
        "file": "b4e005fc75ffc6018ac2.mp3",
        "bank": "en-oo1",
        "durationMs": 3072
    },
    "The cup moving into a new cupboard brings two glasses.": {
        "file": "23cf5eaca509372e3b51.mp3",
        "bank": "en-oo1",
        "durationMs": 2944
    },
    "The cup moving into a new cupboard brings two computers.": {
        "file": "3a7ffcd356d6d4fbe37d.mp3",
        "bank": "en-oo1",
        "durationMs": 3072
    },
    "The cup moving into a new cupboard brings three glasses.": {
        "file": "26436dc8fc46799bcac0.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The cup moving into a new cupboard brings three computers.": {
        "file": "a9cf0c7b46bf1a809d8d.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The remote looking for its owner finds a computer on the sofa.": {
        "file": "39cb8f0dedabc7d3b853.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "The remote looking for its owner finds a computer under the sofa.": {
        "file": "1192e3b5f5eb64bac815.mp3",
        "bank": "en-oo1",
        "durationMs": 3776
    },
    "The remote looking for its owner finds a bag on the sofa.": {
        "file": "7c004f00ebb23610384f.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The remote looking for its owner finds a bag under the sofa.": {
        "file": "632ded3b57ce8b1c2775.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The remote looking for its owner finds a glass on the sofa.": {
        "file": "e0b38ad7488e10f268f6.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The remote looking for its owner finds a glass under the sofa.": {
        "file": "c404978404b39c083875.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The remote looking for its owner finds a fish on the sofa.": {
        "file": "747b838b44404a7eb6f2.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The remote looking for its owner finds a fish under the sofa.": {
        "file": "227957fd0f1de1b8ccb7.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The remote looking for its owner finds an egg on the sofa.": {
        "file": "64028b41d4e5d5731c34.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The remote looking for its owner finds an egg under the sofa.": {
        "file": "22a2df3325780bd64896.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The remote looking for its owner finds a gift on the sofa.": {
        "file": "16013f3a0722799ec2aa.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The remote looking for its owner finds a gift under the sofa.": {
        "file": "02d7f8dd3ef891676050.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The remote looking for its owner finds a phone on the sofa.": {
        "file": "9b3d2978a987390ae527.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The remote looking for its owner finds a phone under the sofa.": {
        "file": "02b5efc32edd43b91aa5.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The remote looking for its owner finds a coin on the sofa.": {
        "file": "66cb5a5d6bf220c0b3c4.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The remote looking for its owner finds a coin under the sofa.": {
        "file": "81cc653246c464969fe0.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The remote looking for its owner finds a book on the sofa.": {
        "file": "f8e8f15a03d3d821be80.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The remote looking for its owner finds a book under the sofa.": {
        "file": "cf89ef6e256432d94078.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The remote looking for its owner finds a cup on the sofa.": {
        "file": "b2809c3331dcab18aaca.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The remote looking for its owner finds a cup under the sofa.": {
        "file": "d649e807a6c933a6fdaa.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The mirror taking a break is wearing a large hat and holding a fish.": {
        "file": "cfc42ea5cb2ee4a786df.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "The mirror taking a break is wearing a large hat and holding a glass.": {
        "file": "b28733960bbad0dbd912.mp3",
        "bank": "en-oo1",
        "durationMs": 3989
    },
    "The mirror taking a break is wearing a small hat and holding a fish.": {
        "file": "d7e40f562b5cffe383ec.mp3",
        "bank": "en-oo1",
        "durationMs": 3840
    },
    "The mirror taking a break is wearing a small hat and holding a glass.": {
        "file": "95523a860a820033be36.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "The mirror taking a break is wearing a long scarf and holding a ticket.": {
        "file": "efa723c025fc4896aba8.mp3",
        "bank": "en-oo1",
        "durationMs": 3947
    },
    "The mirror taking a break is wearing a long scarf and holding a hat.": {
        "file": "94d5887caf2b0df7e05e.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "The mirror taking a break is wearing a short scarf and holding a ticket.": {
        "file": "813077cb874945a95cc5.mp3",
        "bank": "en-oo1",
        "durationMs": 3968
    },
    "The mirror taking a break is wearing a short scarf and holding a hat.": {
        "file": "ed6e443c7e93befce56b.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "The mirror taking a break is wearing round glasses and holding a book.": {
        "file": "8772e95113a24540a739.mp3",
        "bank": "en-oo1",
        "durationMs": 3883
    },
    "The mirror taking a break is wearing round glasses and holding a bottle.": {
        "file": "f12ee1df39175a176194.mp3",
        "bank": "en-oo1",
        "durationMs": 3989
    },
    "The mirror taking a break is wearing square glasses and holding a book.": {
        "file": "ff3481677d5da5938a26.mp3",
        "bank": "en-oo1",
        "durationMs": 3968
    },
    "The mirror taking a break is wearing square glasses and holding a bottle.": {
        "file": "bed2bd7dc69ebb84388b.mp3",
        "bank": "en-oo1",
        "durationMs": 4053
    },
    "The mirror taking a break is wearing a jacket with two pockets and holding a gift.": {
        "file": "2e61c2bd6b410f6d0eca.mp3",
        "bank": "en-oo1",
        "durationMs": 4587
    },
    "The mirror taking a break is wearing a jacket with two pockets and holding a cup.": {
        "file": "d7f8bbb815935837dfbf.mp3",
        "bank": "en-oo1",
        "durationMs": 4437
    },
    "The mirror taking a break is wearing a jacket with four pockets and holding a gift.": {
        "file": "ead7bf9d8f76c6912bcd.mp3",
        "bank": "en-oo1",
        "durationMs": 4693
    },
    "The mirror taking a break is wearing a jacket with four pockets and holding a cup.": {
        "file": "835af3f2fbd38efadb7d.mp3",
        "bank": "en-oo1",
        "durationMs": 4565
    },
    "The mirror taking a break is wearing a shirt with long sleeves and holding a computer.": {
        "file": "3dcd0e708a6f56654372.mp3",
        "bank": "en-oo1",
        "durationMs": 4651
    },
    "The mirror taking a break is wearing a shirt with long sleeves and holding a box.": {
        "file": "5ee43708571e8f20126d.mp3",
        "bank": "en-oo1",
        "durationMs": 4608
    },
    "The mirror taking a break is wearing a shirt with short sleeves and holding a computer.": {
        "file": "b3425f4eeb9fc6aae220.mp3",
        "bank": "en-oo1",
        "durationMs": 4608
    },
    "The mirror taking a break is wearing a shirt with short sleeves and holding a box.": {
        "file": "86f52e5900de42d95cd5.mp3",
        "bank": "en-oo1",
        "durationMs": 4544
    },
    "Our tired carpet is sleeping with two glasses beside it.": {
        "file": "39ce4392b2bd54ff35fc.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "Our tired carpet is sleeping with two bottles beside it.": {
        "file": "872005575a5a939590c8.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "Our tired carpet is sleeping with three glasses beside it.": {
        "file": "1771188c162b6a182456.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "Our tired carpet is sleeping with three bottles beside it.": {
        "file": "2363026930f7521c09e9.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "Our tired carpet is sleeping with two clocks beside it.": {
        "file": "64d66574d146d70ef66a.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "Our tired carpet is sleeping with two fish beside it.": {
        "file": "322d7b080a993c7a56e7.mp3",
        "bank": "en-oo1",
        "durationMs": 3008
    },
    "Our tired carpet is sleeping with four clocks beside it.": {
        "file": "0b65f3fe78d2fb3221e5.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "Our tired carpet is sleeping with four fish beside it.": {
        "file": "6d0025d34012c3d659c2.mp3",
        "bank": "en-oo1",
        "durationMs": 3072
    },
    "Our tired carpet is sleeping with two dogs beside it.": {
        "file": "391df1b8469b43b4d5b6.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "Our tired carpet is sleeping with two boxes beside it.": {
        "file": "7f0fa34c5fa374d896a8.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "Our tired carpet is sleeping with three dogs beside it.": {
        "file": "0b2d136b1d3df773ed4d.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "Our tired carpet is sleeping with three boxes beside it.": {
        "file": "587e585b1fe97a6f62b1.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "Our tired carpet is sleeping with two pictures beside it.": {
        "file": "a93ee8cefcc780cd99e8.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "Our tired carpet is sleeping with two cups beside it.": {
        "file": "5a49954967c7295d1aa4.mp3",
        "bank": "en-oo1",
        "durationMs": 2987
    },
    "Our tired carpet is sleeping with four pictures beside it.": {
        "file": "cb819ae86d3662cd62f5.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "Our tired carpet is sleeping with four cups beside it.": {
        "file": "eb25e5b2958c85b0ff6d.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "Our tired carpet is sleeping with two umbrellas beside it.": {
        "file": "1f715359990d81f629e9.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "Our tired carpet is sleeping with two hats beside it.": {
        "file": "eb72a16f3858f52dba30.mp3",
        "bank": "en-oo1",
        "durationMs": 3029
    },
    "Our tired carpet is sleeping with three umbrellas beside it.": {
        "file": "b4deb252b4b28c357485.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "Our tired carpet is sleeping with three hats beside it.": {
        "file": "fdb985296f57cf7757f7.mp3",
        "bank": "en-oo1",
        "durationMs": 3072
    },
    "The dog running the quiet library keeps a gift on the desk.": {
        "file": "cde5f7294caf776caf8a.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The dog running the quiet library keeps a gift under the desk.": {
        "file": "d893dec6761fe8d8a7f8.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The dog running the quiet library keeps a computer on the desk.": {
        "file": "39778b668807f398c47c.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The dog running the quiet library keeps a computer under the desk.": {
        "file": "08462e951ed7b112e141.mp3",
        "bank": "en-oo1",
        "durationMs": 3861
    },
    "The dog running the quiet library keeps a box on the desk.": {
        "file": "9637087637410cceab4a.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The dog running the quiet library keeps a box under the desk.": {
        "file": "88d6e17f6eb2f9717808.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The dog running the quiet library keeps a hat on the desk.": {
        "file": "fe81d40d1dc1870994c1.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The dog running the quiet library keeps a hat under the desk.": {
        "file": "4907fe86582f2abbc403.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The dog running the quiet library keeps a bag on the desk.": {
        "file": "97698e707d37a1f2b3be.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The dog running the quiet library keeps a bag under the desk.": {
        "file": "c480be0d9c3d45b070e9.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The dog running the quiet library keeps a fish on the desk.": {
        "file": "9a7e25cfca51127b34c6.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The dog running the quiet library keeps a fish under the desk.": {
        "file": "d68e0263cb953286b7f6.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The dog running the quiet library keeps a dog on the desk.": {
        "file": "02ec4d951349cda96d6f.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The dog running the quiet library keeps a dog under the desk.": {
        "file": "430178c2bab7c60b0b35.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The dog running the quiet library keeps a glass on the desk.": {
        "file": "174176e6e359f4f0db43.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The dog running the quiet library keeps a glass under the desk.": {
        "file": "bdbe4d363d3662ab51a9.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The dog running the quiet library keeps a ticket on the desk.": {
        "file": "70c30768927a3ca8cc9c.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The dog running the quiet library keeps a ticket under the desk.": {
        "file": "d54d191a4938bcec8b01.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The dog running the quiet library keeps a cup on the desk.": {
        "file": "e5d0ecd64cf2786060f3.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The dog running the quiet library keeps a cup under the desk.": {
        "file": "00dc2bcad189029afe3e.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The cat checking us into the hotel is wearing a large hat and holding a bottle.": {
        "file": "d2e6cb502191763cc200.mp3",
        "bank": "en-oo1",
        "durationMs": 4693
    },
    "The cat checking us into the hotel is wearing a large hat and holding a hat.": {
        "file": "7952ea915fdc5b095e7b.mp3",
        "bank": "en-oo1",
        "durationMs": 4629
    },
    "The cat checking us into the hotel is wearing a small hat and holding a bottle.": {
        "file": "3b5dd57ecd81d00fb790.mp3",
        "bank": "en-oo1",
        "durationMs": 4629
    },
    "The cat checking us into the hotel is wearing a small hat and holding a hat.": {
        "file": "1370ac4a6b9f24d522d3.mp3",
        "bank": "en-oo1",
        "durationMs": 4501
    },
    "The cat checking us into the hotel is wearing a long scarf and holding a picture.": {
        "file": "b5bc68f81e29a7f7e60a.mp3",
        "bank": "en-oo1",
        "durationMs": 4843
    },
    "The cat checking us into the hotel is wearing a long scarf and holding a computer.": {
        "file": "b99a663c988f8d788d77.mp3",
        "bank": "en-oo1",
        "durationMs": 4949
    },
    "The cat checking us into the hotel is wearing a short scarf and holding a picture.": {
        "file": "77c9bd7b9ef00601ea20.mp3",
        "bank": "en-oo1",
        "durationMs": 4928
    },
    "The cat checking us into the hotel is wearing a short scarf and holding a computer.": {
        "file": "11f486a8c2abe72e0c04.mp3",
        "bank": "en-oo1",
        "durationMs": 4928
    },
    "The cat checking us into the hotel is wearing round glasses and holding a cat.": {
        "file": "63c24eb891fcf2be8ad7.mp3",
        "bank": "en-oo1",
        "durationMs": 4651
    },
    "The cat checking us into the hotel is wearing round glasses and holding a book.": {
        "file": "a781482e68cfb784e57a.mp3",
        "bank": "en-oo1",
        "durationMs": 4608
    },
    "The cat checking us into the hotel is wearing square glasses and holding a cat.": {
        "file": "b7e7c27d39fdb22780fc.mp3",
        "bank": "en-oo1",
        "durationMs": 4672
    },
    "The cat checking us into the hotel is wearing square glasses and holding a book.": {
        "file": "f8e0c8841237140cafdb.mp3",
        "bank": "en-oo1",
        "durationMs": 4608
    },
    "The cat checking us into the hotel is wearing a jacket with two pockets and holding a glass.": {
        "file": "aa0eaafbb76ae9b144ea.mp3",
        "bank": "en-oo1",
        "durationMs": 5483
    },
    "The cat checking us into the hotel is wearing a jacket with two pockets and holding a gift.": {
        "file": "ec9010c336401c47b25f.mp3",
        "bank": "en-oo1",
        "durationMs": 5397
    },
    "The cat checking us into the hotel is wearing a jacket with four pockets and holding a glass.": {
        "file": "9d95fe3afa383b539ec6.mp3",
        "bank": "en-oo1",
        "durationMs": 5568
    },
    "The cat checking us into the hotel is wearing a jacket with four pockets and holding a gift.": {
        "file": "9ffaeaba519e1dae5b20.mp3",
        "bank": "en-oo1",
        "durationMs": 5547
    },
    "The cat checking us into the hotel is wearing a shirt with long sleeves and holding a dog.": {
        "file": "4017f188f39fcf0b2687.mp3",
        "bank": "en-oo1",
        "durationMs": 5333
    },
    "The cat checking us into the hotel is wearing a shirt with long sleeves and holding a fish.": {
        "file": "c58fbbf1a21db946ae20.mp3",
        "bank": "en-oo1",
        "durationMs": 5312
    },
    "The cat checking us into the hotel is wearing a shirt with short sleeves and holding a dog.": {
        "file": "ed1f804d5f11308b5924.mp3",
        "bank": "en-oo1",
        "durationMs": 5248
    },
    "The cat checking us into the hotel is wearing a shirt with short sleeves and holding a fish.": {
        "file": "e14915d7a2ae071df3b6.mp3",
        "bank": "en-oo1",
        "durationMs": 5227
    },
    "The fish having a picnic brings two boxes onto the grass.": {
        "file": "2af53511166cc62d67f1.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The fish having a picnic brings two computers onto the grass.": {
        "file": "5508853089b1aeffc1d5.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The fish having a picnic brings three boxes onto the grass.": {
        "file": "94de1d1ca7e011a742a3.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The fish having a picnic brings three computers onto the grass.": {
        "file": "1cbdbf62c6b90d6acad7.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The fish having a picnic brings two books onto the grass.": {
        "file": "a6c2b39e61798a30220a.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The fish having a picnic brings two tickets onto the grass.": {
        "file": "5568f06f76026668a7a5.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The fish having a picnic brings four books onto the grass.": {
        "file": "315a0fa73f33b598af65.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The fish having a picnic brings four tickets onto the grass.": {
        "file": "4ffe6629a8336c5664c6.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The fish having a picnic brings two glasses onto the grass.": {
        "file": "03ecc110b47ae3f4da4e.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The fish having a picnic brings two fish onto the grass.": {
        "file": "aac35fcff88f313e7889.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The fish having a picnic brings three glasses onto the grass.": {
        "file": "27999007688a2d0bca33.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The fish having a picnic brings three fish onto the grass.": {
        "file": "b2bba7f5b2f948c38d3d.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The fish having a picnic brings two cups onto the grass.": {
        "file": "348b70358f9ee984861a.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The fish having a picnic brings two gifts onto the grass.": {
        "file": "7b6506cee690938bcc4f.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The fish having a picnic brings four cups onto the grass.": {
        "file": "87f71315c229e325a537.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The fish having a picnic brings four gifts onto the grass.": {
        "file": "22a45485566832d9f476.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The fish having a picnic brings two flowers onto the grass.": {
        "file": "82494836bf9b132056cb.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The fish having a picnic brings two pictures onto the grass.": {
        "file": "1eae0b2dacb0e6ad9d86.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The fish having a picnic brings three flowers onto the grass.": {
        "file": "91a18d316be65e40f2c6.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The fish having a picnic brings three pictures onto the grass.": {
        "file": "01a81510de414a5026e3.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The bird teaching people to sing is carrying a fish.": {
        "file": "7ce1483bfd0267c435a1.mp3",
        "bank": "en-oo1",
        "durationMs": 3051
    },
    "The bird teaching people to sing is carrying a gift.": {
        "file": "d6902bd91dadc9ef3343.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The bird teaching people to sing is drawing a fish.": {
        "file": "6bc194043b2ad40a981f.mp3",
        "bank": "en-oo1",
        "durationMs": 3029
    },
    "The bird teaching people to sing is drawing a gift.": {
        "file": "0fddf0d982e920acbdb9.mp3",
        "bank": "en-oo1",
        "durationMs": 3072
    },
    "The bird teaching people to sing is carrying a bottle.": {
        "file": "0409cf9447c31f06a182.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The bird teaching people to sing is carrying a camera.": {
        "file": "9994adf7eab425a2c9b2.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The bird teaching people to sing is drawing a bottle.": {
        "file": "4018817a52123a510190.mp3",
        "bank": "en-oo1",
        "durationMs": 3072
    },
    "The bird teaching people to sing is drawing a camera.": {
        "file": "d212e6260c1bce6be7c0.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The bird teaching people to sing is carrying a glass.": {
        "file": "4b0f7a755cd315f5a171.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The bird teaching people to sing is carrying a cup.": {
        "file": "fc0f2fa295814d9141ad.mp3",
        "bank": "en-oo1",
        "durationMs": 3029
    },
    "The bird teaching people to sing is drawing a glass.": {
        "file": "ff6beb1ece3e9cdb08ca.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The bird teaching people to sing is drawing a cup.": {
        "file": "14c84dc1b83fe56fd8e3.mp3",
        "bank": "en-oo1",
        "durationMs": 2987
    },
    "The bird teaching people to sing is carrying a cat.": {
        "file": "05d86e36f1ef8731b3b1.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The bird teaching people to sing is carrying a computer.": {
        "file": "1a126c02404b45a3e088.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The bird teaching people to sing is drawing a cat.": {
        "file": "77401ac59ade274caa4f.mp3",
        "bank": "en-oo1",
        "durationMs": 3051
    },
    "The bird teaching people to sing is drawing a computer.": {
        "file": "2ac23e590b36710769d5.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The bird teaching people to sing is carrying a magazine.": {
        "file": "2de249fef56003a3133f.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The bird teaching people to sing is carrying a book.": {
        "file": "6878aa93d1a58b3e7351.mp3",
        "bank": "en-oo1",
        "durationMs": 2987
    },
    "The bird teaching people to sing is drawing a magazine.": {
        "file": "15c604e8d3d233305401.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The bird teaching people to sing is drawing a book.": {
        "file": "6554c2e45243f17436ff.mp3",
        "bank": "en-oo1",
        "durationMs": 2944
    },
    "The elephant looking for its seat carries a large bottle.": {
        "file": "ba21eee198c19c32a184.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The elephant looking for its seat carries a large glass.": {
        "file": "03d1f52869b4753adeaa.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The elephant looking for its seat carries a small bottle.": {
        "file": "43c0eab8c48b7c27e8bf.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The elephant looking for its seat carries a small glass.": {
        "file": "c004e0bf6db1fe061762.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The elephant looking for its seat carries a large computer.": {
        "file": "330987b58c9ee17b520b.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The elephant looking for its seat carries a large book.": {
        "file": "46dbb58e1b90e1a46331.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The elephant looking for its seat carries a small computer.": {
        "file": "a021a662e064d3e2ffab.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The elephant looking for its seat carries a small book.": {
        "file": "902b92aa62878e9ad66c.mp3",
        "bank": "en-oo1",
        "durationMs": 3051
    },
    "The elephant looking for its seat carries a large fish.": {
        "file": "5933e0ae340b6b5084e4.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The elephant looking for its seat carries a large shoe.": {
        "file": "0a164c38aae35c4b3d8a.mp3",
        "bank": "en-oo1",
        "durationMs": 3072
    },
    "The elephant looking for its seat carries a small fish.": {
        "file": "9df2357004e034332838.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The elephant looking for its seat carries a small shoe.": {
        "file": "90e52fa4de95107b42c6.mp3",
        "bank": "en-oo1",
        "durationMs": 3051
    },
    "The elephant looking for its seat carries a large picture.": {
        "file": "395705c93c3515ed7b20.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The elephant looking for its seat carries a large box.": {
        "file": "5d72bdc171f3c31655a6.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The elephant looking for its seat carries a small picture.": {
        "file": "5a89301f8c56dbed4c7f.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The elephant looking for its seat carries a small box.": {
        "file": "eda1e0f87917dae615dd.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "The elephant looking for its seat carries a large gift.": {
        "file": "38b60e31018867a30ecf.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The elephant looking for its seat carries a large cup.": {
        "file": "bfe6babbb9096594fbc1.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The elephant looking for its seat carries a small gift.": {
        "file": "77e108d3eef9df37f966.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "The elephant looking for its seat carries a small cup.": {
        "file": "67b812748ebd3aabc306.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "At the cat's meeting about humans, a picture is on the table.": {
        "file": "18cdbb9b08ce477d91a3.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "At the cat's meeting about humans, a picture is under the table.": {
        "file": "5e4dba29e15ca518b999.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "At the cat's meeting about humans, a glass is on the table.": {
        "file": "1b6bf64a0bb913dc6da9.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "At the cat's meeting about humans, a glass is under the table.": {
        "file": "f5ba848bc86fdf570225.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "At the cat's meeting about humans, a box is on the table.": {
        "file": "4c6c3bce8f3ac515e76a.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "At the cat's meeting about humans, a box is under the table.": {
        "file": "1a8f4433a0733f9a647d.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "At the cat's meeting about humans, a robot is on the table.": {
        "file": "ed2c84b4afd9ec9eda05.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "At the cat's meeting about humans, a robot is under the table.": {
        "file": "fdc329cb460681937c99.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "At the cat's meeting about humans, a cat is on the table.": {
        "file": "6fdb5b9c56d133875624.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "At the cat's meeting about humans, a cat is under the table.": {
        "file": "e30558b3f9f09eedc552.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "At the cat's meeting about humans, a fish is on the table.": {
        "file": "6259b993f5f66bac82fe.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "At the cat's meeting about humans, a fish is under the table.": {
        "file": "93fd359b2776f8645fd6.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "At the cat's meeting about humans, a bag is on the table.": {
        "file": "2870f2cb1e2ad0f734d9.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "At the cat's meeting about humans, a bag is under the table.": {
        "file": "fda3f4b31d01ecb00582.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "At the cat's meeting about humans, a gift is on the table.": {
        "file": "20300d21e1d977360598.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "At the cat's meeting about humans, a gift is under the table.": {
        "file": "1199dda5dba089ab5b80.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "At the cat's meeting about humans, a bottle is on the table.": {
        "file": "c77da772766abba9ea24.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "At the cat's meeting about humans, a bottle is under the table.": {
        "file": "18b0c9bc9d62890a773c.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "At the cat's meeting about humans, a book is on the table.": {
        "file": "a5a117b59f5f10e1b7c6.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "At the cat's meeting about humans, a book is under the table.": {
        "file": "ef907c335daeb19b8945.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The dog teaching people to sit has two dogs beside it.": {
        "file": "8adbbba8ae905e50b7cc.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The dog teaching people to sit has two glasses beside it.": {
        "file": "2f7d40cb5ef77ac2a3c2.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The dog teaching people to sit has three dogs beside it.": {
        "file": "fb3e6f7adf628198f63b.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The dog teaching people to sit has three glasses beside it.": {
        "file": "cf391cd702d17314b15a.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The dog teaching people to sit has two fish beside it.": {
        "file": "1fc7fd4506ea3226e650.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The dog teaching people to sit has two bottles beside it.": {
        "file": "738f52444f134a3a781a.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The dog teaching people to sit has four fish beside it.": {
        "file": "99233843e1762bb258b6.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The dog teaching people to sit has four bottles beside it.": {
        "file": "eca2aec703c16e5c2e88.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The dog teaching people to sit has two gifts beside it.": {
        "file": "5c00b0aa048a3411d06e.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The dog teaching people to sit has two tickets beside it.": {
        "file": "2bcdeb3027083f5b907d.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The dog teaching people to sit has three gifts beside it.": {
        "file": "192d9b60a3b2a1c0b683.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The dog teaching people to sit has three tickets beside it.": {
        "file": "25df8283096c15c32b62.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The dog teaching people to sit has two apples beside it.": {
        "file": "6e0f7b5c5e3e31ebb1b8.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The dog teaching people to sit has two cats beside it.": {
        "file": "92fe616f3b6d4bdc4cdc.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The dog teaching people to sit has four apples beside it.": {
        "file": "742b18fd7bc354b18cd2.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The dog teaching people to sit has four cats beside it.": {
        "file": "3dfaffaded91dc587233.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The dog teaching people to sit has two phones beside it.": {
        "file": "f2f12e4d80a210d9f9bd.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The dog teaching people to sit has two computers beside it.": {
        "file": "c6ca7f823fb0552a6d6a.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The dog teaching people to sit has three phones beside it.": {
        "file": "8371a4b2cbe22cfdba71.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The dog teaching people to sit has three computers beside it.": {
        "file": "1d5edc560c459732e000.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The fish selling things for rainy days keeps a picture beside the door.": {
        "file": "26fb872fb58f901ed986.mp3",
        "bank": "en-oo1",
        "durationMs": 3925
    },
    "The fish selling things for rainy days keeps a picture above the door.": {
        "file": "3e99d2cebe076c2d8590.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "The fish selling things for rainy days keeps an egg beside the door.": {
        "file": "99c1696500b054bb43ae.mp3",
        "bank": "en-oo1",
        "durationMs": 3883
    },
    "The fish selling things for rainy days keeps an egg above the door.": {
        "file": "60bd5e8d0fb758774066.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "The fish selling things for rainy days keeps a shoe beside the door.": {
        "file": "437492b6dd7b3b796c79.mp3",
        "bank": "en-oo1",
        "durationMs": 3840
    },
    "The fish selling things for rainy days keeps a shoe above the door.": {
        "file": "3198fe545c556eaf812b.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The fish selling things for rainy days keeps a cat beside the door.": {
        "file": "6299c07d097381217429.mp3",
        "bank": "en-oo1",
        "durationMs": 3840
    },
    "The fish selling things for rainy days keeps a cat above the door.": {
        "file": "294f670932f39bf5ea2e.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The fish selling things for rainy days keeps a gift beside the door.": {
        "file": "a2353bd383093984604d.mp3",
        "bank": "en-oo1",
        "durationMs": 3883
    },
    "The fish selling things for rainy days keeps a gift above the door.": {
        "file": "881698f4bf62cb438b4d.mp3",
        "bank": "en-oo1",
        "durationMs": 3819
    },
    "The fish selling things for rainy days keeps a hat beside the door.": {
        "file": "11b664d8a37371353c6f.mp3",
        "bank": "en-oo1",
        "durationMs": 3840
    },
    "The fish selling things for rainy days keeps a hat above the door.": {
        "file": "f894e7e7747f40e35be4.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The fish selling things for rainy days keeps a cup beside the door.": {
        "file": "926475c587325e1d015e.mp3",
        "bank": "en-oo1",
        "durationMs": 3776
    },
    "The fish selling things for rainy days keeps a cup above the door.": {
        "file": "4fd870b45977a2cab3df.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "The fish selling things for rainy days keeps a ticket beside the door.": {
        "file": "d1b9ee151984f00f7a77.mp3",
        "bank": "en-oo1",
        "durationMs": 3947
    },
    "The fish selling things for rainy days keeps a ticket above the door.": {
        "file": "e6948640c92461ba95d6.mp3",
        "bank": "en-oo1",
        "durationMs": 3861
    },
    "The fish selling things for rainy days keeps a box beside the door.": {
        "file": "fb135a719e0bfdb24b21.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "The fish selling things for rainy days keeps a box above the door.": {
        "file": "64b12707134c1210bcf5.mp3",
        "bank": "en-oo1",
        "durationMs": 3776
    },
    "The fish selling things for rainy days keeps a fish beside the door.": {
        "file": "c4b006fcf871b6e0b190.mp3",
        "bank": "en-oo1",
        "durationMs": 3925
    },
    "The fish selling things for rainy days keeps a fish above the door.": {
        "file": "e09a00d879ec3869fbf1.mp3",
        "bank": "en-oo1",
        "durationMs": 3776
    },
    "The shark waiting for a toothbrush is wearing a large hat and holding an apple.": {
        "file": "7f8dce01fd082977eb63.mp3",
        "bank": "en-oo1",
        "durationMs": 4587
    },
    "The shark waiting for a toothbrush is wearing a large hat and holding a box.": {
        "file": "077e889dd7261e64e417.mp3",
        "bank": "en-oo1",
        "durationMs": 4565
    },
    "The shark waiting for a toothbrush is wearing a small hat and holding an apple.": {
        "file": "c6eee7406777aace3c64.mp3",
        "bank": "en-oo1",
        "durationMs": 4437
    },
    "The shark waiting for a toothbrush is wearing a small hat and holding a box.": {
        "file": "10c115d3abaf1029ef9c.mp3",
        "bank": "en-oo1",
        "durationMs": 4437
    },
    "The shark waiting for a toothbrush is wearing a long scarf and holding a gift.": {
        "file": "d8bf688c50a6b270c566.mp3",
        "bank": "en-oo1",
        "durationMs": 4501
    },
    "The shark waiting for a toothbrush is wearing a long scarf and holding a book.": {
        "file": "7a06aab23677b888a246.mp3",
        "bank": "en-oo1",
        "durationMs": 4416
    },
    "The shark waiting for a toothbrush is wearing a short scarf and holding a gift.": {
        "file": "4807dc940bdb16de414d.mp3",
        "bank": "en-oo1",
        "durationMs": 4544
    },
    "The shark waiting for a toothbrush is wearing a short scarf and holding a book.": {
        "file": "15c84746f1d941191363.mp3",
        "bank": "en-oo1",
        "durationMs": 4459
    },
    "The shark waiting for a toothbrush is wearing round glasses and holding a computer.": {
        "file": "feac21838f05e1d8c13c.mp3",
        "bank": "en-oo1",
        "durationMs": 4779
    },
    "The shark waiting for a toothbrush is wearing round glasses and holding a coin.": {
        "file": "94b8ddad5c2761cad58d.mp3",
        "bank": "en-oo1",
        "durationMs": 4501
    },
    "The shark waiting for a toothbrush is wearing square glasses and holding a computer.": {
        "file": "f30b99526091c584fae3.mp3",
        "bank": "en-oo1",
        "durationMs": 4800
    },
    "The shark waiting for a toothbrush is wearing square glasses and holding a coin.": {
        "file": "78a4fbded72538cdc713.mp3",
        "bank": "en-oo1",
        "durationMs": 4629
    },
    "The shark waiting for a toothbrush is wearing a jacket with two pockets and holding a fish.": {
        "file": "194546d3992d01017ec8.mp3",
        "bank": "en-oo1",
        "durationMs": 5184
    },
    "The shark waiting for a toothbrush is wearing a jacket with two pockets and holding a hat.": {
        "file": "de1163708e191bc15017.mp3",
        "bank": "en-oo1",
        "durationMs": 5141
    },
    "The shark waiting for a toothbrush is wearing a jacket with four pockets and holding a fish.": {
        "file": "6fe0cb7049116e4cc31a.mp3",
        "bank": "en-oo1",
        "durationMs": 5312
    },
    "The shark waiting for a toothbrush is wearing a jacket with four pockets and holding a hat.": {
        "file": "8848dbf03e8ea72d30b6.mp3",
        "bank": "en-oo1",
        "durationMs": 5227
    },
    "The shark waiting for a toothbrush is wearing a shirt with long sleeves and holding a cat.": {
        "file": "a9d7f16b94c9b68ca4b8.mp3",
        "bank": "en-oo1",
        "durationMs": 5099
    },
    "The shark waiting for a toothbrush is wearing a shirt with long sleeves and holding a dog.": {
        "file": "bd137ad409a8f16a38d2.mp3",
        "bank": "en-oo1",
        "durationMs": 5099
    },
    "The shark waiting for a toothbrush is wearing a shirt with short sleeves and holding a cat.": {
        "file": "f64ba9d57892e33657f2.mp3",
        "bank": "en-oo1",
        "durationMs": 5077
    },
    "The shark waiting for a toothbrush is wearing a shirt with short sleeves and holding a dog.": {
        "file": "f944cf6f5f5bdf94cffd.mp3",
        "bank": "en-oo1",
        "durationMs": 5099
    },
    "The dog delivering news to itself carries two bottles.": {
        "file": "da9a0f1894ad00b7f991.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The dog delivering news to itself carries two gifts.": {
        "file": "4cfea62952b1baa56450.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The dog delivering news to itself carries three bottles.": {
        "file": "1cd6ca366bed91ed61b3.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The dog delivering news to itself carries three gifts.": {
        "file": "ade8501a17cb70fb5644.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The dog delivering news to itself carries two glasses.": {
        "file": "290c517ecc75a2fc7ceb.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The dog delivering news to itself carries two flowers.": {
        "file": "a2b399ef4a1079cbd040.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The dog delivering news to itself carries four glasses.": {
        "file": "fa5d425e8e733b76695c.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The dog delivering news to itself carries four flowers.": {
        "file": "fc2471d6e2163c2f1a3b.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The dog delivering news to itself carries two tickets.": {
        "file": "ca29a4047be754ec3662.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The dog delivering news to itself carries two boxes.": {
        "file": "bb3f6d8bc2df41199ac7.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The dog delivering news to itself carries three tickets.": {
        "file": "e302b4b091573beefeba.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The dog delivering news to itself carries three boxes.": {
        "file": "df6ace998b753aba5c3e.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The dog delivering news to itself carries two coins.": {
        "file": "3ab441762275d9e16238.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The dog delivering news to itself carries two fish.": {
        "file": "b1b70bbde9ddbcde56fb.mp3",
        "bank": "en-oo1",
        "durationMs": 3008
    },
    "The dog delivering news to itself carries four coins.": {
        "file": "d734c72f814465e971fe.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The dog delivering news to itself carries four fish.": {
        "file": "5ef5cea711da958380f9.mp3",
        "bank": "en-oo1",
        "durationMs": 3051
    },
    "The dog delivering news to itself carries two bags.": {
        "file": "e49a3f5a55ef960b738d.mp3",
        "bank": "en-oo1",
        "durationMs": 3051
    },
    "The dog delivering news to itself carries two books.": {
        "file": "fb10290d8d73d9fc4828.mp3",
        "bank": "en-oo1",
        "durationMs": 2965
    },
    "The dog delivering news to itself carries three bags.": {
        "file": "373d29eb3e67f9aa6c49.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The dog delivering news to itself carries three books.": {
        "file": "85e9a3b99bc45e912e5a.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The man handling an ant's paperwork uses a large gift.": {
        "file": "bd45a3383eb4e645fc1a.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The man handling an ant's paperwork uses a large glass.": {
        "file": "1984619c29d1767d2a8a.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The man handling an ant's paperwork uses a small gift.": {
        "file": "fcad779662e4cbfa06b1.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The man handling an ant's paperwork uses a small glass.": {
        "file": "60e0e42827c7b6a7397e.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The man handling an ant's paperwork uses a large computer.": {
        "file": "cc39bca93d7d245f01e8.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The man handling an ant's paperwork uses a large book.": {
        "file": "536b2d47a6df997f714b.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The man handling an ant's paperwork uses a small computer.": {
        "file": "651113b0f19027e43d21.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The man handling an ant's paperwork uses a small book.": {
        "file": "3e34243b79aa94c3f8d1.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The man handling an ant's paperwork uses a large box.": {
        "file": "c87fa1dd5827cdc30bb4.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The man handling an ant's paperwork uses a large fish.": {
        "file": "3613cfa33b88944f0b2a.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The man handling an ant's paperwork uses a small box.": {
        "file": "020fc25b7dceed0a3548.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The man handling an ant's paperwork uses a small fish.": {
        "file": "8e5ea0128ae67dd9a307.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The man handling an ant's paperwork uses a large ticket.": {
        "file": "aa0aa26183678605c7ab.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The man handling an ant's paperwork uses a large camera.": {
        "file": "58c59a8d29957db27365.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The man handling an ant's paperwork uses a small ticket.": {
        "file": "d273eeaa1eb28164e583.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The man handling an ant's paperwork uses a small camera.": {
        "file": "16077e4d1a10bf8d2bcd.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The man handling an ant's paperwork uses a large phone.": {
        "file": "abeab12c70a03a5b4578.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The man handling an ant's paperwork uses a large hat.": {
        "file": "0e2580937e7a219d79c3.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The man handling an ant's paperwork uses a small phone.": {
        "file": "0083c2822b72a60be528.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The man handling an ant's paperwork uses a small hat.": {
        "file": "d01307591e3132c77e1f.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The woman giving a puddle an address puts a coin beside the water.": {
        "file": "b0d1c5eb7562bc2034ee.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "The woman giving a puddle an address puts a coin above the water.": {
        "file": "27bea9ec62a668e33bad.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The woman giving a puddle an address puts a gift beside the water.": {
        "file": "cac8e9f3e57674a95326.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The woman giving a puddle an address puts a gift above the water.": {
        "file": "29c31266dcf1bb1a1d0e.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The woman giving a puddle an address puts a robot beside the water.": {
        "file": "21934c8b16eac8f3d69a.mp3",
        "bank": "en-oo1",
        "durationMs": 3861
    },
    "The woman giving a puddle an address puts a robot above the water.": {
        "file": "863f61790574d6e33c3b.mp3",
        "bank": "en-oo1",
        "durationMs": 3883
    },
    "The woman giving a puddle an address puts a glass beside the water.": {
        "file": "af6e40466bc907f66b1b.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The woman giving a puddle an address puts a glass above the water.": {
        "file": "c52a5d58023fe41e7cc7.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The woman giving a puddle an address puts a box beside the water.": {
        "file": "88d6d4a28050ba650ee2.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The woman giving a puddle an address puts a box above the water.": {
        "file": "b91774c10274aeb7ec32.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The woman giving a puddle an address puts a computer beside the water.": {
        "file": "8ec3877d527d1b5e5fbc.mp3",
        "bank": "en-oo1",
        "durationMs": 3925
    },
    "The woman giving a puddle an address puts a computer above the water.": {
        "file": "a3a9d6f36bb85156c4e4.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "The woman giving a puddle an address puts a bag beside the water.": {
        "file": "69c175e19c69f0e99573.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The woman giving a puddle an address puts a bag above the water.": {
        "file": "c038503c407b482336d9.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The woman giving a puddle an address puts a fish beside the water.": {
        "file": "9bc4c9d33047c9ff2dd6.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The woman giving a puddle an address puts a fish above the water.": {
        "file": "5deba963232ef4ce6504.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The woman giving a puddle an address puts a book beside the water.": {
        "file": "a8caf68369232b51e19f.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The woman giving a puddle an address puts a book above the water.": {
        "file": "ef9731c7d4402ae5b7ab.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The woman giving a puddle an address puts a ticket beside the water.": {
        "file": "27ecd3fdfadc4df96c88.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "The woman giving a puddle an address puts a ticket above the water.": {
        "file": "bf4cc4af09841a7e8b5c.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The leaf leaving its job brings two gifts to the desk.": {
        "file": "cc061acbc424cd86a7a2.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The leaf leaving its job brings two cups to the desk.": {
        "file": "5bd49090e62a1fdf8368.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The leaf leaving its job brings three gifts to the desk.": {
        "file": "77d13865043a404b2a47.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The leaf leaving its job brings three cups to the desk.": {
        "file": "64f1283449b209c1c39a.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The leaf leaving its job brings two tickets to the desk.": {
        "file": "1f83d0bc921683de2f5d.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The leaf leaving its job brings two glasses to the desk.": {
        "file": "fb2548f9418a50928416.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The leaf leaving its job brings four tickets to the desk.": {
        "file": "69edbf86ce2347b5de74.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The leaf leaving its job brings four glasses to the desk.": {
        "file": "672a76d03357d1bcc258.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The leaf leaving its job brings two bottles to the desk.": {
        "file": "1b612a2d6fc26af67f1f.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The leaf leaving its job brings two fish to the desk.": {
        "file": "77319bfe6b3ea68100dd.mp3",
        "bank": "en-oo1",
        "durationMs": 2987
    },
    "The leaf leaving its job brings three bottles to the desk.": {
        "file": "92d8190ff9d9781dafd5.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The leaf leaving its job brings three fish to the desk.": {
        "file": "1f58d6d56e4de92a38af.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The leaf leaving its job brings two books to the desk.": {
        "file": "d56862cb81ac1b0aad07.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The leaf leaving its job brings two cats to the desk.": {
        "file": "32b8adb281ba4e42781f.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The leaf leaving its job brings four books to the desk.": {
        "file": "b138bd605a60256cbe39.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The leaf leaving its job brings four cats to the desk.": {
        "file": "c9c0d1cec151dcad5763.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The leaf leaving its job brings two computers to the desk.": {
        "file": "b09d84c55a19ade9d4e3.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The leaf leaving its job brings two bags to the desk.": {
        "file": "8093302e67d7e452306e.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The leaf leaving its job brings three computers to the desk.": {
        "file": "77704c7a10e400df5283.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The leaf leaving its job brings three bags to the desk.": {
        "file": "519b263db49329d494f2.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The ticket waiting for its number keeps a glass on the table.": {
        "file": "6a414bb13cc937096fe7.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The ticket waiting for its number keeps a glass under the table.": {
        "file": "76f0edd1fd829f23ef5c.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The ticket waiting for its number keeps a robot on the table.": {
        "file": "3b6606026161c2a20c22.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The ticket waiting for its number keeps a robot under the table.": {
        "file": "d6c5f3616884329c6589.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The ticket waiting for its number keeps a shoe on the table.": {
        "file": "4868bf4633403c6fd63e.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The ticket waiting for its number keeps a shoe under the table.": {
        "file": "9bb6b86ad5f0b320402d.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The ticket waiting for its number keeps a computer on the table.": {
        "file": "98adcbea7d16e7689c64.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The ticket waiting for its number keeps a computer under the table.": {
        "file": "5af5f410b59c533ada3a.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The ticket waiting for its number keeps a key on the table.": {
        "file": "6dd4f4101112578c2d7a.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The ticket waiting for its number keeps a key under the table.": {
        "file": "a631772c91ba21949b6b.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The ticket waiting for its number keeps a gift on the table.": {
        "file": "f6448f316b8dce28cdf8.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The ticket waiting for its number keeps a gift under the table.": {
        "file": "4cce881002eb42dcf9a5.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The ticket waiting for its number keeps a book on the table.": {
        "file": "ebab22dcd1542f60672b.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The ticket waiting for its number keeps a book under the table.": {
        "file": "9f05295be0364732edf9.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The ticket waiting for its number keeps a cup on the table.": {
        "file": "34eb2586e882a123b3c2.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The ticket waiting for its number keeps a cup under the table.": {
        "file": "eb2b1e63156e4917a21f.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The ticket waiting for its number keeps a coin on the table.": {
        "file": "65635d79da71370b7704.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The ticket waiting for its number keeps a coin under the table.": {
        "file": "8d921e84948b4fac681b.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The ticket waiting for its number keeps a box on the table.": {
        "file": "1e2c2aca8c21e5bad8c4.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The ticket waiting for its number keeps a box under the table.": {
        "file": "22fac4da9e3391b5e7b7.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The man taking a picture of his shadow is wearing a large hat and holding a computer.": {
        "file": "6738cfc16090e79f73bf.mp3",
        "bank": "en-oo1",
        "durationMs": 5035
    },
    "The man taking a picture of his shadow is wearing a large hat and holding a dog.": {
        "file": "b9453cfd4dfc8a41e6f0.mp3",
        "bank": "en-oo1",
        "durationMs": 4779
    },
    "The man taking a picture of his shadow is wearing a small hat and holding a computer.": {
        "file": "1ef6d304c01e034a6890.mp3",
        "bank": "en-oo1",
        "durationMs": 5013
    },
    "The man taking a picture of his shadow is wearing a small hat and holding a dog.": {
        "file": "ab983e6222a7461b4b6a.mp3",
        "bank": "en-oo1",
        "durationMs": 4800
    },
    "The man taking a picture of his shadow is wearing a long scarf and holding a fish.": {
        "file": "416b79c1a284a7ec858a.mp3",
        "bank": "en-oo1",
        "durationMs": 4800
    },
    "The man taking a picture of his shadow is wearing a long scarf and holding a glass.": {
        "file": "858e2a343f29ed027ae3.mp3",
        "bank": "en-oo1",
        "durationMs": 4949
    },
    "The man taking a picture of his shadow is wearing a short scarf and holding a fish.": {
        "file": "f7846ea4516b8699e232.mp3",
        "bank": "en-oo1",
        "durationMs": 4864
    },
    "The man taking a picture of his shadow is wearing a short scarf and holding a glass.": {
        "file": "0f4ed3a81e0448e93f74.mp3",
        "bank": "en-oo1",
        "durationMs": 4971
    },
    "The man taking a picture of his shadow is wearing round glasses and holding a bottle.": {
        "file": "1a1d2cefc208000420e5.mp3",
        "bank": "en-oo1",
        "durationMs": 4928
    },
    "The man taking a picture of his shadow is wearing round glasses and holding a bag.": {
        "file": "371c3f38ac302a23aa1f.mp3",
        "bank": "en-oo1",
        "durationMs": 4779
    },
    "The man taking a picture of his shadow is wearing square glasses and holding a bottle.": {
        "file": "10f853d10d2f81405a32.mp3",
        "bank": "en-oo1",
        "durationMs": 4971
    },
    "The man taking a picture of his shadow is wearing square glasses and holding a bag.": {
        "file": "7bbf14b27acdb88dee2a.mp3",
        "bank": "en-oo1",
        "durationMs": 4885
    },
    "The man taking a picture of his shadow is wearing a jacket with two pockets and holding a box.": {
        "file": "693a8d4e4f9d83a3e466.mp3",
        "bank": "en-oo1",
        "durationMs": 5717
    },
    "The man taking a picture of his shadow is wearing a jacket with two pockets and holding a picture.": {
        "file": "29d2a9750eb2cc199ad6.mp3",
        "bank": "en-oo1",
        "durationMs": 5781
    },
    "The man taking a picture of his shadow is wearing a jacket with four pockets and holding a box.": {
        "file": "f75c281e8b46283043e8.mp3",
        "bank": "en-oo1",
        "durationMs": 5824
    },
    "The man taking a picture of his shadow is wearing a jacket with four pockets and holding a picture.": {
        "file": "4da2941803f94887d582.mp3",
        "bank": "en-oo1",
        "durationMs": 5867
    },
    "The man taking a picture of his shadow is wearing a shirt with long sleeves and holding a cat.": {
        "file": "05802a645dde90ee7445.mp3",
        "bank": "en-oo1",
        "durationMs": 5589
    },
    "The man taking a picture of his shadow is wearing a shirt with long sleeves and holding a flower.": {
        "file": "6f1ddd34cac11890ee8b.mp3",
        "bank": "en-oo1",
        "durationMs": 5632
    },
    "The man taking a picture of his shadow is wearing a shirt with short sleeves and holding a cat.": {
        "file": "123fd690dbd59b0ea382.mp3",
        "bank": "en-oo1",
        "durationMs": 5525
    },
    "The man taking a picture of his shadow is wearing a shirt with short sleeves and holding a flower.": {
        "file": "d312cb15b820c866654d.mp3",
        "bank": "en-oo1",
        "durationMs": 5589
    },
    "The woman asking for a quiet day is holding a dog.": {
        "file": "0abb40a574d1c2691415.mp3",
        "bank": "en-oo1",
        "durationMs": 2987
    },
    "The woman asking for a quiet day is holding a glass.": {
        "file": "72ed6e45283336e823fb.mp3",
        "bank": "en-oo1",
        "durationMs": 3072
    },
    "The woman asking for a quiet day is washing a dog.": {
        "file": "119e5c3519316d4007ca.mp3",
        "bank": "en-oo1",
        "durationMs": 2965
    },
    "The woman asking for a quiet day is washing a glass.": {
        "file": "2ade1b4e8e2f82380722.mp3",
        "bank": "en-oo1",
        "durationMs": 3029
    },
    "The woman asking for a quiet day is holding a box.": {
        "file": "2e7dbd307ca909f6a081.mp3",
        "bank": "en-oo1",
        "durationMs": 3072
    },
    "The woman asking for a quiet day is holding a computer.": {
        "file": "a6a645b1258cf4ccc207.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The woman asking for a quiet day is washing a box.": {
        "file": "7a2082ba7ea3bcd47e0e.mp3",
        "bank": "en-oo1",
        "durationMs": 3008
    },
    "The woman asking for a quiet day is washing a computer.": {
        "file": "023d47cfe31983d92259.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The woman asking for a quiet day is holding a gift.": {
        "file": "f827ee78d5c5630f99da.mp3",
        "bank": "en-oo1",
        "durationMs": 3051
    },
    "The woman asking for a quiet day is holding a coin.": {
        "file": "8f7302b6b54ce6882b8e.mp3",
        "bank": "en-oo1",
        "durationMs": 2965
    },
    "The woman asking for a quiet day is washing a gift.": {
        "file": "9483de19711605e48dde.mp3",
        "bank": "en-oo1",
        "durationMs": 3029
    },
    "The woman asking for a quiet day is washing a coin.": {
        "file": "6fbf1355534045f57f4f.mp3",
        "bank": "en-oo1",
        "durationMs": 2965
    },
    "The woman asking for a quiet day is holding a phone.": {
        "file": "1ef4a256f5eabe29e64e.mp3",
        "bank": "en-oo1",
        "durationMs": 3008
    },
    "The woman asking for a quiet day is holding a hat.": {
        "file": "2aa51e1d828b8b19190e.mp3",
        "bank": "en-oo1",
        "durationMs": 2944
    },
    "The woman asking for a quiet day is washing a phone.": {
        "file": "92e5a70ccb9f2ecb862b.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The woman asking for a quiet day is washing a hat.": {
        "file": "21ead3771d2a58892c4b.mp3",
        "bank": "en-oo1",
        "durationMs": 2901
    },
    "The woman asking for a quiet day is holding a fish.": {
        "file": "7a3317516fe9ea866f11.mp3",
        "bank": "en-oo1",
        "durationMs": 2987
    },
    "The woman asking for a quiet day is holding a book.": {
        "file": "97c91fedbb2c4ea85552.mp3",
        "bank": "en-oo1",
        "durationMs": 2944
    },
    "The woman asking for a quiet day is washing a fish.": {
        "file": "b8e65881869db65d4f02.mp3",
        "bank": "en-oo1",
        "durationMs": 2880
    },
    "The woman asking for a quiet day is washing a book.": {
        "file": "632383b9378d9964741c.mp3",
        "bank": "en-oo1",
        "durationMs": 2859
    },
    "The key moving to another lock leaves a dog beside the box.": {
        "file": "0fa8e8c44c0e258bc398.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The key moving to another lock leaves a dog inside the box.": {
        "file": "2bb38bd67eb1e562e008.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The key moving to another lock leaves a cup beside the box.": {
        "file": "fef2544aa1ce5c8436ef.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The key moving to another lock leaves a cup inside the box.": {
        "file": "7cf1bbe09afb271361c3.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The key moving to another lock leaves a gift beside the box.": {
        "file": "56085694d84725535eac.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The key moving to another lock leaves a gift inside the box.": {
        "file": "ff70f3282e934b45bcdd.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The key moving to another lock leaves a book beside the box.": {
        "file": "b4480bf4210da8872ef9.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The key moving to another lock leaves a book inside the box.": {
        "file": "01aa55779db79d1f3668.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The key moving to another lock leaves a fish beside the box.": {
        "file": "cb1092dab7e46a02aa7f.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The key moving to another lock leaves a fish inside the box.": {
        "file": "a664ad9057a0f5cabf1b.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The key moving to another lock leaves a ticket beside the box.": {
        "file": "e325f39200d8b9fd7006.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The key moving to another lock leaves a ticket inside the box.": {
        "file": "a4bbdea94ff1b6cd7071.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The key moving to another lock leaves a glass beside the box.": {
        "file": "30ef55ff873521605c60.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The key moving to another lock leaves a glass inside the box.": {
        "file": "c1b2db4fb073ad71f3d1.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The key moving to another lock leaves a robot beside the box.": {
        "file": "a6b92abe59942837f102.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "The key moving to another lock leaves a robot inside the box.": {
        "file": "deffc6ac14148e325b44.mp3",
        "bank": "en-oo1",
        "durationMs": 3840
    },
    "The key moving to another lock leaves a computer beside the box.": {
        "file": "105cc9068944bb0d1542.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The key moving to another lock leaves a computer inside the box.": {
        "file": "eced84fadda7a89b27ed.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "The key moving to another lock leaves a box beside the box.": {
        "file": "482dfce85d14c8489eef.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The key moving to another lock leaves a box inside the box.": {
        "file": "ea6909976c4a63070e7c.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The cloud paying to park drops two glasses beside the machine.": {
        "file": "2352fc45c25e9b67b5c8.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The cloud paying to park drops two robots beside the machine.": {
        "file": "b370ad376bedb2cd1afa.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "The cloud paying to park drops three glasses beside the machine.": {
        "file": "018c7a3f8e41f7cb240a.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "The cloud paying to park drops three robots beside the machine.": {
        "file": "39a795994c75385feb09.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The cloud paying to park drops two fish beside the machine.": {
        "file": "579753250d35d35270e2.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The cloud paying to park drops two cups beside the machine.": {
        "file": "dadcacbc18d73cc08e9c.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The cloud paying to park drops four fish beside the machine.": {
        "file": "bbf2611b3adb7c252cad.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The cloud paying to park drops four cups beside the machine.": {
        "file": "343e25178f5284a1d4db.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The cloud paying to park drops two tickets beside the machine.": {
        "file": "e1f1d67d6fa8d46a4ff2.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The cloud paying to park drops two boxes beside the machine.": {
        "file": "179fabf47ed47885f9cd.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The cloud paying to park drops three tickets beside the machine.": {
        "file": "b1b57fc46504b6e0bbc9.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The cloud paying to park drops three boxes beside the machine.": {
        "file": "a12f4272fcd99e07ad30.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "The cloud paying to park drops two books beside the machine.": {
        "file": "128d9d5fad74a9f35f45.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The cloud paying to park drops two bottles beside the machine.": {
        "file": "7980f64310c76dfe067b.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The cloud paying to park drops four books beside the machine.": {
        "file": "687795e86808b853f9fe.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The cloud paying to park drops four bottles beside the machine.": {
        "file": "37a63fe06ffce8eb215f.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The cloud paying to park drops two hats beside the machine.": {
        "file": "45c45e5211da0dc45743.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The cloud paying to park drops two computers beside the machine.": {
        "file": "97e9a2cf6ed7b9eda3ad.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The cloud paying to park drops three hats beside the machine.": {
        "file": "13105021fae103e02d04.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The cloud paying to park drops three computers beside the machine.": {
        "file": "b353e3787fa7e6ca7bdc.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The man applying for a nap brings a large box.": {
        "file": "e96dee61173962fe073f.mp3",
        "bank": "en-oo1",
        "durationMs": 2944
    },
    "The man applying for a nap brings a large ticket.": {
        "file": "8af8d72a29eac9ab0107.mp3",
        "bank": "en-oo1",
        "durationMs": 2880
    },
    "The man applying for a nap brings a small box.": {
        "file": "ac32a29cfebe8d36f780.mp3",
        "bank": "en-oo1",
        "durationMs": 2731
    },
    "The man applying for a nap brings a small ticket.": {
        "file": "22175abdc22f00568c1d.mp3",
        "bank": "en-oo1",
        "durationMs": 2816
    },
    "The man applying for a nap brings a large glass.": {
        "file": "643b1d0e8008aa5e93b9.mp3",
        "bank": "en-oo1",
        "durationMs": 2923
    },
    "The man applying for a nap brings a large cat.": {
        "file": "260cc19565f816577361.mp3",
        "bank": "en-oo1",
        "durationMs": 2773
    },
    "The man applying for a nap brings a small glass.": {
        "file": "0e0ce9bd2917588c1ce3.mp3",
        "bank": "en-oo1",
        "durationMs": 2837
    },
    "The man applying for a nap brings a small cat.": {
        "file": "23f77612f78ab45b82e3.mp3",
        "bank": "en-oo1",
        "durationMs": 2752
    },
    "The man applying for a nap brings a large computer.": {
        "file": "5227f09e075abf0da425.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The man applying for a nap brings a large hat.": {
        "file": "5b8cc462b171fba7928a.mp3",
        "bank": "en-oo1",
        "durationMs": 2773
    },
    "The man applying for a nap brings a small computer.": {
        "file": "5c1def953ce65c1ddaf6.mp3",
        "bank": "en-oo1",
        "durationMs": 3008
    },
    "The man applying for a nap brings a small hat.": {
        "file": "0fcd6ad71c6bd6a5c2a9.mp3",
        "bank": "en-oo1",
        "durationMs": 2752
    },
    "The man applying for a nap brings a large gift.": {
        "file": "a028d23da9eec15a608d.mp3",
        "bank": "en-oo1",
        "durationMs": 2859
    },
    "The man applying for a nap brings a large picture.": {
        "file": "fdd127786cfb51b9a2c7.mp3",
        "bank": "en-oo1",
        "durationMs": 3051
    },
    "The man applying for a nap brings a small gift.": {
        "file": "871d3e6b230bb14b268f.mp3",
        "bank": "en-oo1",
        "durationMs": 2773
    },
    "The man applying for a nap brings a small picture.": {
        "file": "a30b0eb249671935a661.mp3",
        "bank": "en-oo1",
        "durationMs": 2880
    },
    "The man applying for a nap brings a large ball.": {
        "file": "6f3ea8edb90b2af857fd.mp3",
        "bank": "en-oo1",
        "durationMs": 2816
    },
    "The man applying for a nap brings a large key.": {
        "file": "3882524395d44c53104c.mp3",
        "bank": "en-oo1",
        "durationMs": 2709
    },
    "The man applying for a nap brings a small ball.": {
        "file": "03d7531c55ddbbd82f0b.mp3",
        "bank": "en-oo1",
        "durationMs": 2709
    },
    "The man applying for a nap brings a small key.": {
        "file": "ce1224e59037be0a6464.mp3",
        "bank": "en-oo1",
        "durationMs": 2667
    },
    "The stamp approving another stamp keeps a glass on the desk.": {
        "file": "2804ff0e6886c4faf52a.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The stamp approving another stamp keeps a glass under the desk.": {
        "file": "15ccb1b532d67c2392a8.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The stamp approving another stamp keeps a fish on the desk.": {
        "file": "0249bfbf42ef709b011d.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The stamp approving another stamp keeps a fish under the desk.": {
        "file": "5bf53a9b9330845d5ad7.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The stamp approving another stamp keeps a box on the desk.": {
        "file": "86316a89ac3cb0d52f13.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The stamp approving another stamp keeps a box under the desk.": {
        "file": "f876240f7d376a4c6250.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The stamp approving another stamp keeps a clock on the desk.": {
        "file": "dcb03db6a1d3dcef9890.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The stamp approving another stamp keeps a clock under the desk.": {
        "file": "a74cd6ebc1ad82284136.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The stamp approving another stamp keeps a dog on the desk.": {
        "file": "4198348f1cce2d45c680.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The stamp approving another stamp keeps a dog under the desk.": {
        "file": "914e056875b6e89e4b1e.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The stamp approving another stamp keeps a bottle on the desk.": {
        "file": "58e28d591b4434d20f68.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The stamp approving another stamp keeps a bottle under the desk.": {
        "file": "e76be0fc2943660b0d89.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The stamp approving another stamp keeps a gift on the desk.": {
        "file": "239c60e17302ec505b5c.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The stamp approving another stamp keeps a gift under the desk.": {
        "file": "2e544e089dbd361545c8.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The stamp approving another stamp keeps a picture on the desk.": {
        "file": "addb572dfaee361df1b0.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The stamp approving another stamp keeps a picture under the desk.": {
        "file": "af378a36271f427356c3.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The stamp approving another stamp keeps a book on the desk.": {
        "file": "13e75400e8d8a86b8945.mp3",
        "bank": "en-oo1",
        "durationMs": 3029
    },
    "The stamp approving another stamp keeps a book under the desk.": {
        "file": "00957baeee68e4d904e8.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The stamp approving another stamp keeps a robot on the desk.": {
        "file": "57d81ff56fda1851e102.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The stamp approving another stamp keeps a robot under the desk.": {
        "file": "509c83f51d8f14636b2a.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "At the shop selling empty boxes, there are two dogs by the door.": {
        "file": "a627db7a10bb345bbe73.mp3",
        "bank": "en-oo1",
        "durationMs": 3861
    },
    "At the shop selling empty boxes, there are two gifts by the door.": {
        "file": "888216b5509ffa3bba5f.mp3",
        "bank": "en-oo1",
        "durationMs": 3776
    },
    "At the shop selling empty boxes, there are three dogs by the door.": {
        "file": "ab1220661cbc98dc25db.mp3",
        "bank": "en-oo1",
        "durationMs": 4032
    },
    "At the shop selling empty boxes, there are three gifts by the door.": {
        "file": "980f2296bbd03ec2f120.mp3",
        "bank": "en-oo1",
        "durationMs": 3925
    },
    "At the shop selling empty boxes, there are two bottles by the door.": {
        "file": "0f28f21109e661d16c89.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "At the shop selling empty boxes, there are two shoes by the door.": {
        "file": "8ee07f2b1f9118ae0cca.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "At the shop selling empty boxes, there are four bottles by the door.": {
        "file": "0b236cbd9732e8d887b7.mp3",
        "bank": "en-oo1",
        "durationMs": 4032
    },
    "At the shop selling empty boxes, there are four shoes by the door.": {
        "file": "ebc9ff949af0e9cc4342.mp3",
        "bank": "en-oo1",
        "durationMs": 3947
    },
    "At the shop selling empty boxes, there are two computers by the door.": {
        "file": "db21e9dec546ea9491b1.mp3",
        "bank": "en-oo1",
        "durationMs": 3947
    },
    "At the shop selling empty boxes, there are two keys by the door.": {
        "file": "18b93e850b49e46efe01.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "At the shop selling empty boxes, there are three computers by the door.": {
        "file": "020b63db1f70c7a88740.mp3",
        "bank": "en-oo1",
        "durationMs": 4096
    },
    "At the shop selling empty boxes, there are three keys by the door.": {
        "file": "48aebea56087eaa8b422.mp3",
        "bank": "en-oo1",
        "durationMs": 3968
    },
    "At the shop selling empty boxes, there are two glasses by the door.": {
        "file": "dd5d999460d594b061c4.mp3",
        "bank": "en-oo1",
        "durationMs": 3947
    },
    "At the shop selling empty boxes, there are two cups by the door.": {
        "file": "1183e3c4115f49cc5ee5.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "At the shop selling empty boxes, there are four glasses by the door.": {
        "file": "bef9197ffa102f406b30.mp3",
        "bank": "en-oo1",
        "durationMs": 4096
    },
    "At the shop selling empty boxes, there are four cups by the door.": {
        "file": "1656e0da4a5f27094557.mp3",
        "bank": "en-oo1",
        "durationMs": 3840
    },
    "At the shop selling empty boxes, there are two fish by the door.": {
        "file": "054bd282cad06ac720d2.mp3",
        "bank": "en-oo1",
        "durationMs": 3776
    },
    "At the shop selling empty boxes, there are two hats by the door.": {
        "file": "c6f131c5c0d1c51e3598.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "At the shop selling empty boxes, there are three fish by the door.": {
        "file": "ee2aea1b2e67b73c9fff.mp3",
        "bank": "en-oo1",
        "durationMs": 3861
    },
    "At the shop selling empty boxes, there are three hats by the door.": {
        "file": "e19a636b129717695476.mp3",
        "bank": "en-oo1",
        "durationMs": 3883
    },
    "The shop selling one piece of dust displays a large cat.": {
        "file": "d8a49ab14c1f0aa2d80c.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The shop selling one piece of dust displays a large box.": {
        "file": "c051511a84e68a884e6d.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "The shop selling one piece of dust displays a small cat.": {
        "file": "d6085d9643f1674690b9.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The shop selling one piece of dust displays a small box.": {
        "file": "1249dbf2464651e849bb.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The shop selling one piece of dust displays a large ticket.": {
        "file": "4ce6127684e805fe8bf2.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The shop selling one piece of dust displays a large gift.": {
        "file": "9940b118f05c17bd5634.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The shop selling one piece of dust displays a small ticket.": {
        "file": "f534e9027d1ddd4b0ef1.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The shop selling one piece of dust displays a small gift.": {
        "file": "9ad0d7e1df716f6c5e0f.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The shop selling one piece of dust displays a large fish.": {
        "file": "3563aff90568e03f3736.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The shop selling one piece of dust displays a large hat.": {
        "file": "fe3eb29ebcbf1b637979.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The shop selling one piece of dust displays a small fish.": {
        "file": "d948884c3650363ca23e.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The shop selling one piece of dust displays a small hat.": {
        "file": "5a25d76fb3e38db4608d.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The shop selling one piece of dust displays a large computer.": {
        "file": "1e981e00dd4364e839cb.mp3",
        "bank": "en-oo1",
        "durationMs": 3819
    },
    "The shop selling one piece of dust displays a large glass.": {
        "file": "673820cb6e1969737fa6.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The shop selling one piece of dust displays a small computer.": {
        "file": "e0c00bb614521e61c6a8.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "The shop selling one piece of dust displays a small glass.": {
        "file": "1dfefd42075c0f6e0a9d.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The shop selling one piece of dust displays a large key.": {
        "file": "8e6ff7449b074fbd81ec.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The shop selling one piece of dust displays a large shoe.": {
        "file": "b212f3207912b42622a2.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The shop selling one piece of dust displays a small key.": {
        "file": "74725f6a18464d7a1de2.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The shop selling one piece of dust displays a small shoe.": {
        "file": "8832ac04319a01f456bc.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The bag shopping for another bag carries a clock on its head.": {
        "file": "87186b6bfb20336d79f9.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The bag shopping for another bag carries a clock under its arm.": {
        "file": "db5778f3a0254dfd76aa.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The bag shopping for another bag carries a book on its head.": {
        "file": "2729ce518f85b781c8da.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The bag shopping for another bag carries a book under its arm.": {
        "file": "d42258a1ace66f7ba2c8.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The bag shopping for another bag carries a magazine on its head.": {
        "file": "c4cb157552c77b866a0a.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The bag shopping for another bag carries a magazine under its arm.": {
        "file": "439b2fe1ff544a7f4c66.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "The bag shopping for another bag carries a phone on its head.": {
        "file": "e537c1ff98ada1f9ec76.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The bag shopping for another bag carries a phone under its arm.": {
        "file": "6bc6f5698d91632e482e.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The bag shopping for another bag carries a gift on its head.": {
        "file": "d19d4d74c592fe1589eb.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The bag shopping for another bag carries a gift under its arm.": {
        "file": "1bc24b501978aef5ace9.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The bag shopping for another bag carries a glass on its head.": {
        "file": "b6bb2a791a2b94831e12.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The bag shopping for another bag carries a glass under its arm.": {
        "file": "0117ab62f99330f93a49.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The bag shopping for another bag carries a picture on its head.": {
        "file": "627016ed0803e2c62b29.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The bag shopping for another bag carries a picture under its arm.": {
        "file": "be03ecb095abdb370bc4.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The bag shopping for another bag carries a bottle on its head.": {
        "file": "aa3b336bec958ef86603.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The bag shopping for another bag carries a bottle under its arm.": {
        "file": "fb36c863ef4fe1cf74cd.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The bag shopping for another bag carries a newspaper on its head.": {
        "file": "fab5f565d42a2af8337d.mp3",
        "bank": "en-oo1",
        "durationMs": 3861
    },
    "The bag shopping for another bag carries a newspaper under its arm.": {
        "file": "2c854baf4c771795e5c5.mp3",
        "bank": "en-oo1",
        "durationMs": 3968
    },
    "The bag shopping for another bag carries a cup on its head.": {
        "file": "ab391907ef257b5e9853.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The bag shopping for another bag carries a cup under its arm.": {
        "file": "f51d29913a362ff1b174.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The woman selling price labels is carrying a glass.": {
        "file": "2ec72a6ab359d92f6b10.mp3",
        "bank": "en-oo1",
        "durationMs": 3051
    },
    "The woman selling price labels is carrying a fish.": {
        "file": "3f842e1ab9064ef6aa9b.mp3",
        "bank": "en-oo1",
        "durationMs": 2987
    },
    "The woman selling price labels is drawing a glass.": {
        "file": "661c93df9009286de286.mp3",
        "bank": "en-oo1",
        "durationMs": 3008
    },
    "The woman selling price labels is drawing a fish.": {
        "file": "8045ac2b2abce7dd08a3.mp3",
        "bank": "en-oo1",
        "durationMs": 2944
    },
    "The woman selling price labels is carrying a hat.": {
        "file": "6ca142ec681b852d920d.mp3",
        "bank": "en-oo1",
        "durationMs": 2923
    },
    "The woman selling price labels is carrying a gift.": {
        "file": "0b8abad6354816ee4e0e.mp3",
        "bank": "en-oo1",
        "durationMs": 3051
    },
    "The woman selling price labels is drawing a hat.": {
        "file": "c2d08c4df175e2194d82.mp3",
        "bank": "en-oo1",
        "durationMs": 2880
    },
    "The woman selling price labels is drawing a gift.": {
        "file": "9921152c6c75c2de47fd.mp3",
        "bank": "en-oo1",
        "durationMs": 2965
    },
    "The woman selling price labels is carrying a ticket.": {
        "file": "2b108569825efa28718a.mp3",
        "bank": "en-oo1",
        "durationMs": 3051
    },
    "The woman selling price labels is carrying a computer.": {
        "file": "631cf1419f1380e16ecd.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The woman selling price labels is drawing a ticket.": {
        "file": "53190dc809fd55697713.mp3",
        "bank": "en-oo1",
        "durationMs": 3008
    },
    "The woman selling price labels is drawing a computer.": {
        "file": "12c18e796126fcca855a.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The woman selling price labels is carrying a book.": {
        "file": "62925486eabb341d859a.mp3",
        "bank": "en-oo1",
        "durationMs": 2944
    },
    "The woman selling price labels is carrying an egg.": {
        "file": "3f7ddc6a7b93892dc300.mp3",
        "bank": "en-oo1",
        "durationMs": 2944
    },
    "The woman selling price labels is drawing a book.": {
        "file": "9912e799039ba826b1d8.mp3",
        "bank": "en-oo1",
        "durationMs": 2901
    },
    "The woman selling price labels is drawing an egg.": {
        "file": "6c2b992b086430889367.mp3",
        "bank": "en-oo1",
        "durationMs": 2944
    },
    "The woman selling price labels is carrying a cup.": {
        "file": "cb21dba127e6eabc6be6.mp3",
        "bank": "en-oo1",
        "durationMs": 2987
    },
    "The woman selling price labels is carrying a picture.": {
        "file": "c004721b84d64d9d42eb.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The woman selling price labels is drawing a cup.": {
        "file": "85e8fcc8212f2bf475a7.mp3",
        "bank": "en-oo1",
        "durationMs": 2859
    },
    "The woman selling price labels is drawing a picture.": {
        "file": "65727ea43f00c6ffd4c5.mp3",
        "bank": "en-oo1",
        "durationMs": 3072
    },
    "The man collecting very long receipts buys two boxes.": {
        "file": "3f597cea2ecc48af05c7.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The man collecting very long receipts buys two fish.": {
        "file": "454fdf6f0dc39021804d.mp3",
        "bank": "en-oo1",
        "durationMs": 2965
    },
    "The man collecting very long receipts buys three boxes.": {
        "file": "405e94eac0278356aad5.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The man collecting very long receipts buys three fish.": {
        "file": "e7227473fed26c840f3d.mp3",
        "bank": "en-oo1",
        "durationMs": 3008
    },
    "The man collecting very long receipts buys two bottles.": {
        "file": "b192240f2b990c51391b.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "The man collecting very long receipts buys two glasses.": {
        "file": "ac5f45e24f9c5accdb01.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The man collecting very long receipts buys four bottles.": {
        "file": "5e09301e2c31497f719e.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "The man collecting very long receipts buys four glasses.": {
        "file": "80b295608fd090ae9ee6.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The man collecting very long receipts buys two hats.": {
        "file": "f466a167fc4939b23c53.mp3",
        "bank": "en-oo1",
        "durationMs": 2965
    },
    "The man collecting very long receipts buys two cups.": {
        "file": "25c31c5c89726db8fc63.mp3",
        "bank": "en-oo1",
        "durationMs": 2965
    },
    "The man collecting very long receipts buys three hats.": {
        "file": "e5301d5a307fbeb72f65.mp3",
        "bank": "en-oo1",
        "durationMs": 3029
    },
    "The man collecting very long receipts buys three cups.": {
        "file": "63d71e842be2026b0c32.mp3",
        "bank": "en-oo1",
        "durationMs": 2944
    },
    "The man collecting very long receipts buys two coins.": {
        "file": "e5867bd4b8bfc3ad2554.mp3",
        "bank": "en-oo1",
        "durationMs": 3029
    },
    "The man collecting very long receipts buys two magazines.": {
        "file": "a1c9711be9a271000c1f.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The man collecting very long receipts buys four coins.": {
        "file": "5ae37d1346e7eb7b00f8.mp3",
        "bank": "en-oo1",
        "durationMs": 3029
    },
    "The man collecting very long receipts buys four magazines.": {
        "file": "b3aaea3b995a59616e37.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The man collecting very long receipts buys two cats.": {
        "file": "b1432fa37074f0ec172e.mp3",
        "bank": "en-oo1",
        "durationMs": 2987
    },
    "The man collecting very long receipts buys two tickets.": {
        "file": "094fb4fc5ff63a46e677.mp3",
        "bank": "en-oo1",
        "durationMs": 3072
    },
    "The man collecting very long receipts buys three cats.": {
        "file": "133d2be297ea13ddf9a9.mp3",
        "bank": "en-oo1",
        "durationMs": 3051
    },
    "The man collecting very long receipts buys three tickets.": {
        "file": "ec29eadc3543deb5ac79.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The woman buying the shop window leaves a fish above the window.": {
        "file": "b456b1204f44696d88da.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The woman buying the shop window leaves a fish below the window.": {
        "file": "b81eb84e10d4cdf4fc79.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The woman buying the shop window leaves a ticket above the window.": {
        "file": "af9ac47ccd32dca5d225.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The woman buying the shop window leaves a ticket below the window.": {
        "file": "1d2937ee57bd3f9c707d.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The woman buying the shop window leaves a box above the window.": {
        "file": "2750fcd9e915c035e9f9.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The woman buying the shop window leaves a box below the window.": {
        "file": "36ccf4456404dedbc15d.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The woman buying the shop window leaves a cup above the window.": {
        "file": "68c2b7e04768210a86ea.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The woman buying the shop window leaves a cup below the window.": {
        "file": "1788ff59f4a65eec9b4f.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The woman buying the shop window leaves a computer above the window.": {
        "file": "b62b9d4d9f29d1727d9a.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "The woman buying the shop window leaves a computer below the window.": {
        "file": "63b0a8eee450c7555f8d.mp3",
        "bank": "en-oo1",
        "durationMs": 3840
    },
    "The woman buying the shop window leaves an egg above the window.": {
        "file": "e35576349a237301efb5.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "The woman buying the shop window leaves an egg below the window.": {
        "file": "7281085807bc21476955.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The woman buying the shop window leaves a shoe above the window.": {
        "file": "d34a98e6cd5c07c3b313.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The woman buying the shop window leaves a shoe below the window.": {
        "file": "7f578e671bab17df276e.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The woman buying the shop window leaves a book above the window.": {
        "file": "9a2076f176400963adaa.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The woman buying the shop window leaves a book below the window.": {
        "file": "8f045b4bc6c64e770409.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The woman buying the shop window leaves a glass above the window.": {
        "file": "947f698a86f4e2885a0a.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The woman buying the shop window leaves a glass below the window.": {
        "file": "2d45d0ace1a3481ee9c4.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The woman buying the shop window leaves a cat above the window.": {
        "file": "fe0091ea9d974964a765.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The woman buying the shop window leaves a cat below the window.": {
        "file": "0dd5ef81a5ea87bbe154.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The coin looking for something cheap is wearing a large hat and holding a glass.": {
        "file": "5cfb925a729e21a64033.mp3",
        "bank": "en-oo1",
        "durationMs": 4672
    },
    "The coin looking for something cheap is wearing a large hat and holding a book.": {
        "file": "ec6a1bbb5448a7292b37.mp3",
        "bank": "en-oo1",
        "durationMs": 4544
    },
    "The coin looking for something cheap is wearing a small hat and holding a glass.": {
        "file": "4aa6e8741d3050f22803.mp3",
        "bank": "en-oo1",
        "durationMs": 4587
    },
    "The coin looking for something cheap is wearing a small hat and holding a book.": {
        "file": "f129083bb54b434bc177.mp3",
        "bank": "en-oo1",
        "durationMs": 4437
    },
    "The coin looking for something cheap is wearing a long scarf and holding a ticket.": {
        "file": "b909ec1ef851c5fdab37.mp3",
        "bank": "en-oo1",
        "durationMs": 4629
    },
    "The coin looking for something cheap is wearing a long scarf and holding a gift.": {
        "file": "79b8d1bfe2ab9d5e1078.mp3",
        "bank": "en-oo1",
        "durationMs": 4608
    },
    "The coin looking for something cheap is wearing a short scarf and holding a ticket.": {
        "file": "c2328761e84ef2bda18b.mp3",
        "bank": "en-oo1",
        "durationMs": 4672
    },
    "The coin looking for something cheap is wearing a short scarf and holding a gift.": {
        "file": "3feffcc327833903a438.mp3",
        "bank": "en-oo1",
        "durationMs": 4629
    },
    "The coin looking for something cheap is wearing round glasses and holding a phone.": {
        "file": "8d38b6c5bf66d6fd9fc2.mp3",
        "bank": "en-oo1",
        "durationMs": 4565
    },
    "The coin looking for something cheap is wearing round glasses and holding a fish.": {
        "file": "02d845088b93a5da6289.mp3",
        "bank": "en-oo1",
        "durationMs": 4544
    },
    "The coin looking for something cheap is wearing square glasses and holding a phone.": {
        "file": "9c232f5e21b811d0853b.mp3",
        "bank": "en-oo1",
        "durationMs": 4608
    },
    "The coin looking for something cheap is wearing square glasses and holding a fish.": {
        "file": "2beca1aba828acc4b1c8.mp3",
        "bank": "en-oo1",
        "durationMs": 4608
    },
    "The coin looking for something cheap is wearing a jacket with two pockets and holding a computer.": {
        "file": "19911adca24a1d48bdee.mp3",
        "bank": "en-oo1",
        "durationMs": 5547
    },
    "The coin looking for something cheap is wearing a jacket with two pockets and holding a bag.": {
        "file": "4de23f8bd4d70bc54eaf.mp3",
        "bank": "en-oo1",
        "durationMs": 5333
    },
    "The coin looking for something cheap is wearing a jacket with four pockets and holding a computer.": {
        "file": "52974e41ada9674deb79.mp3",
        "bank": "en-oo1",
        "durationMs": 5675
    },
    "The coin looking for something cheap is wearing a jacket with four pockets and holding a bag.": {
        "file": "2118d1d5f6d903345568.mp3",
        "bank": "en-oo1",
        "durationMs": 5483
    },
    "The coin looking for something cheap is wearing a shirt with long sleeves and holding a bottle.": {
        "file": "b190be6f6da7026fa2d6.mp3",
        "bank": "en-oo1",
        "durationMs": 5333
    },
    "The coin looking for something cheap is wearing a shirt with long sleeves and holding a dog.": {
        "file": "156de08b5232a256fc27.mp3",
        "bank": "en-oo1",
        "durationMs": 5248
    },
    "The coin looking for something cheap is wearing a shirt with short sleeves and holding a bottle.": {
        "file": "e20ddb653f9ce3c19906.mp3",
        "bank": "en-oo1",
        "durationMs": 5269
    },
    "The coin looking for something cheap is wearing a shirt with short sleeves and holding a dog.": {
        "file": "b3555c5f978481d02211.mp3",
        "bank": "en-oo1",
        "durationMs": 5205
    },
    "The objects escaping from the sale carry two glasses.": {
        "file": "b1c27b1241b08a9046a8.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The objects escaping from the sale carry two gifts.": {
        "file": "4a6acd11673862f15c24.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The objects escaping from the sale carry three glasses.": {
        "file": "5ed8a32677490c9bcba2.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The objects escaping from the sale carry three gifts.": {
        "file": "dc3079b0f13761b5589a.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The objects escaping from the sale carry two fish.": {
        "file": "cbc0ee0808dc302aafca.mp3",
        "bank": "en-oo1",
        "durationMs": 3072
    },
    "The objects escaping from the sale carry two bottles.": {
        "file": "4c66186460a755debf29.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The objects escaping from the sale carry four fish.": {
        "file": "01dab250d88b7d8c1739.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The objects escaping from the sale carry four bottles.": {
        "file": "246a648e9dbdace45c7b.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The objects escaping from the sale carry two books.": {
        "file": "a89a481671ca3fccdd73.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The objects escaping from the sale carry two computers.": {
        "file": "f1a6f8e3d3864983d806.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The objects escaping from the sale carry three books.": {
        "file": "a5168ff519bb9e88ce32.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The objects escaping from the sale carry three computers.": {
        "file": "aa277843225d47e9bdfc.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The objects escaping from the sale carry two pictures.": {
        "file": "47b08fc29d22ade88892.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The objects escaping from the sale carry two cups.": {
        "file": "f25f30bb8e4ea3637f4d.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The objects escaping from the sale carry four pictures.": {
        "file": "84cdeaf4a0b8b83333e0.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The objects escaping from the sale carry four cups.": {
        "file": "fcda315198938cdc678a.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The objects escaping from the sale carry two pencils.": {
        "file": "1b79ee55daadd1ed01c3.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The objects escaping from the sale carry two tickets.": {
        "file": "6c2547b5456c8403f6da.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The objects escaping from the sale carry three pencils.": {
        "file": "53ca2298ef4c3bc7632d.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The objects escaping from the sale carry three tickets.": {
        "file": "a32f6cf002b87b849881.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "At the shop that sells closed signs, a ticket is beside the door.": {
        "file": "eb10aef49c97f748661f.mp3",
        "bank": "en-oo1",
        "durationMs": 3861
    },
    "At the shop that sells closed signs, a ticket is above the door.": {
        "file": "f801d8ae6f428d4231ec.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "At the shop that sells closed signs, a glass is beside the door.": {
        "file": "9d4777911e4d0c39e069.mp3",
        "bank": "en-oo1",
        "durationMs": 3883
    },
    "At the shop that sells closed signs, a glass is above the door.": {
        "file": "b100a9a8db099d02223b.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "At the shop that sells closed signs, a dog is beside the door.": {
        "file": "98f82d1eb2629eae5735.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "At the shop that sells closed signs, a dog is above the door.": {
        "file": "d87b3012550d91778141.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "At the shop that sells closed signs, a box is beside the door.": {
        "file": "b56ccb898d4ce68e0405.mp3",
        "bank": "en-oo1",
        "durationMs": 3861
    },
    "At the shop that sells closed signs, a box is above the door.": {
        "file": "13fbbeabc1afc24e61b5.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "At the shop that sells closed signs, a fish is beside the door.": {
        "file": "414a1b0a9655f392d32d.mp3",
        "bank": "en-oo1",
        "durationMs": 3819
    },
    "At the shop that sells closed signs, a fish is above the door.": {
        "file": "7bfbd5ffa49a39350dd7.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "At the shop that sells closed signs, a gift is beside the door.": {
        "file": "f29a1e573a17dc21e773.mp3",
        "bank": "en-oo1",
        "durationMs": 3840
    },
    "At the shop that sells closed signs, a gift is above the door.": {
        "file": "1faa2649b08bac08d79e.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "At the shop that sells closed signs, a picture is beside the door.": {
        "file": "efd9775a7701a93ff3c9.mp3",
        "bank": "en-oo1",
        "durationMs": 3883
    },
    "At the shop that sells closed signs, a picture is above the door.": {
        "file": "7d00c7880bc10215b037.mp3",
        "bank": "en-oo1",
        "durationMs": 3819
    },
    "At the shop that sells closed signs, a bag is beside the door.": {
        "file": "0da54e7d9045b0049153.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "At the shop that sells closed signs, a bag is above the door.": {
        "file": "050023e9f2201bbea21c.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "At the shop that sells closed signs, a computer is beside the door.": {
        "file": "ee4119ce68846298e2d2.mp3",
        "bank": "en-oo1",
        "durationMs": 3968
    },
    "At the shop that sells closed signs, a computer is above the door.": {
        "file": "3ffe3c2977617d6aa2dd.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "At the shop that sells closed signs, a cup is beside the door.": {
        "file": "89ad9cce0a26206a304e.mp3",
        "bank": "en-oo1",
        "durationMs": 3819
    },
    "At the shop that sells closed signs, a cup is above the door.": {
        "file": "718e40c67e722afebba1.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The gift returning its customer brings a large glass.": {
        "file": "d4db0df5fcc58747eac0.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The gift returning its customer brings a large dog.": {
        "file": "087481c32c5bbe802f5f.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The gift returning its customer brings a small glass.": {
        "file": "186c5cea0b7380a2e1db.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The gift returning its customer brings a small dog.": {
        "file": "ce63ee160f841a72fb19.mp3",
        "bank": "en-oo1",
        "durationMs": 3051
    },
    "The gift returning its customer brings a large robot.": {
        "file": "a11e1b5cd96457f9fe62.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The gift returning its customer brings a large clock.": {
        "file": "002bf230833104441367.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The gift returning its customer brings a small robot.": {
        "file": "bf7bf82948eaf29805eb.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The gift returning its customer brings a small clock.": {
        "file": "37ef05175ca7bb0b9711.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The gift returning its customer brings a large gift.": {
        "file": "530e4cb6f9b2157ea7ce.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The gift returning its customer brings a large flower.": {
        "file": "9d01c2965499becbe5e1.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The gift returning its customer brings a small gift.": {
        "file": "7037743b562013bff3e7.mp3",
        "bank": "en-oo1",
        "durationMs": 3051
    },
    "The gift returning its customer brings a small flower.": {
        "file": "8be54d03aa8fc6141aba.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The gift returning its customer brings a large cat.": {
        "file": "042274d53121c61b33bc.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "The gift returning its customer brings a large box.": {
        "file": "1344fa15487f93ec1cc7.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The gift returning its customer brings a small cat.": {
        "file": "b68ec55af68fa9397f20.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The gift returning its customer brings a small box.": {
        "file": "518e5b3113571e33cde0.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The gift returning its customer brings a large ticket.": {
        "file": "ae223c6f858da6818921.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The gift returning its customer brings a large bottle.": {
        "file": "7173e6388bd498408153.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The gift returning its customer brings a small ticket.": {
        "file": "62821423d18d8f3a52d0.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The gift returning its customer brings a small bottle.": {
        "file": "e0244ca61dd86b8b07bb.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The family washing clothes in space uses two clocks.": {
        "file": "4fa58a462fb10f3ffb2e.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The family washing clothes in space uses two bags.": {
        "file": "2149b951c83d7cea4657.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The family washing clothes in space uses three clocks.": {
        "file": "63c3f88fff7e861b7b08.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The family washing clothes in space uses three bags.": {
        "file": "01af92c62d1219e3ab8d.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The family washing clothes in space uses two keys.": {
        "file": "162251e1bad58d5b02de.mp3",
        "bank": "en-oo1",
        "durationMs": 3072
    },
    "The family washing clothes in space uses two books.": {
        "file": "faa9155d6a6150e12d7d.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The family washing clothes in space uses four keys.": {
        "file": "b8ce794029e349192157.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The family washing clothes in space uses four books.": {
        "file": "560be2a19d62c3bdcd5f.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The family washing clothes in space uses two computers.": {
        "file": "af0d7dd52c128c4b1e1f.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The family washing clothes in space uses two glasses.": {
        "file": "ecad55e944919111bd53.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The family washing clothes in space uses three computers.": {
        "file": "ee4b8811b46b1f22c1f6.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The family washing clothes in space uses three glasses.": {
        "file": "358178d7510b5ec58cae.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The family washing clothes in space uses two eggs.": {
        "file": "d8f8a070e2adcf71bbb0.mp3",
        "bank": "en-oo1",
        "durationMs": 3051
    },
    "The family washing clothes in space uses two fish.": {
        "file": "0872f9ed128a9a30a3a8.mp3",
        "bank": "en-oo1",
        "durationMs": 3051
    },
    "The family washing clothes in space uses four eggs.": {
        "file": "9a1ecfba9a708b14d35f.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "The family washing clothes in space uses four fish.": {
        "file": "5edb2578f237831ed493.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The family washing clothes in space uses two gifts.": {
        "file": "c3b7ec8f36a2eda23643.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The family washing clothes in space uses two hats.": {
        "file": "e17c91a2826d432bdf93.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The family washing clothes in space uses three gifts.": {
        "file": "824ac156f54260699e2a.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The family washing clothes in space uses three hats.": {
        "file": "21a78b0d62d806de4ff3.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The man locked out of his spaceship keeps a glass above his head.": {
        "file": "f7943373a86ec81a486b.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The man locked out of his spaceship keeps a glass behind his back.": {
        "file": "4bb7319dd21e4b3919e4.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The man locked out of his spaceship keeps a book above his head.": {
        "file": "b598c84f2d72edf4f36f.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The man locked out of his spaceship keeps a book behind his back.": {
        "file": "0a54fb11b6c698be34ad.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The man locked out of his spaceship keeps a ticket above his head.": {
        "file": "10a03dc3354e0d03b132.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The man locked out of his spaceship keeps a ticket behind his back.": {
        "file": "cf891b0a82114dd389a4.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "The man locked out of his spaceship keeps a gift above his head.": {
        "file": "1b59106a189c3af2bbb7.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The man locked out of his spaceship keeps a gift behind his back.": {
        "file": "abe39ee0b81d841751fd.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The man locked out of his spaceship keeps a box above his head.": {
        "file": "f6c697794db60780106e.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The man locked out of his spaceship keeps a box behind his back.": {
        "file": "cf964cd80ca494ab8530.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The man locked out of his spaceship keeps a fish above his head.": {
        "file": "304ff07b0fdc2f3b1bf4.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The man locked out of his spaceship keeps a fish behind his back.": {
        "file": "7b6ce16b808082fe1e79.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The man locked out of his spaceship keeps a key above his head.": {
        "file": "a221fcb40b6c3b97d2d5.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The man locked out of his spaceship keeps a key behind his back.": {
        "file": "cc9153cda6ff2d7bc671.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The man locked out of his spaceship keeps a phone above his head.": {
        "file": "b45b91ed4118eebbcfa3.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The man locked out of his spaceship keeps a phone behind his back.": {
        "file": "eddf6d0048e8ad9417d8.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The man locked out of his spaceship keeps a computer above his head.": {
        "file": "f7d5b577d483a3bc3424.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The man locked out of his spaceship keeps a computer behind his back.": {
        "file": "3eb38eaff2c5b6d33788.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The man locked out of his spaceship keeps a bag above his head.": {
        "file": "4884b5f55b86ca6bc258.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The man locked out of his spaceship keeps a bag behind his back.": {
        "file": "5175cd50ceb7ec4c0f39.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The woman saving a picnic spot on the moon brings a large book.": {
        "file": "82d1656034b45faaba9e.mp3",
        "bank": "en-oo1",
        "durationMs": 3819
    },
    "The woman saving a picnic spot on the moon brings a large fish.": {
        "file": "05346ad47371af3bf3fc.mp3",
        "bank": "en-oo1",
        "durationMs": 3819
    },
    "The woman saving a picnic spot on the moon brings a small book.": {
        "file": "f77a897ef741c7cf66b4.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "The woman saving a picnic spot on the moon brings a small fish.": {
        "file": "edff50d1dd3b338cf86b.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The woman saving a picnic spot on the moon brings a large bag.": {
        "file": "268a8542a94487f31832.mp3",
        "bank": "en-oo1",
        "durationMs": 3840
    },
    "The woman saving a picnic spot on the moon brings a large egg.": {
        "file": "cab30524fd8d5ff767f6.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The woman saving a picnic spot on the moon brings a small bag.": {
        "file": "ea3d2772a0f4d9b574ac.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The woman saving a picnic spot on the moon brings a small egg.": {
        "file": "dab5406dcf0340868639.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The woman saving a picnic spot on the moon brings a large dog.": {
        "file": "cc22815228a8ed40886e.mp3",
        "bank": "en-oo1",
        "durationMs": 3861
    },
    "The woman saving a picnic spot on the moon brings a large ticket.": {
        "file": "d89fa411e3ad60070b2a.mp3",
        "bank": "en-oo1",
        "durationMs": 3861
    },
    "The woman saving a picnic spot on the moon brings a small dog.": {
        "file": "4ee6ddefb830a7a04373.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "The woman saving a picnic spot on the moon brings a small ticket.": {
        "file": "c9eac2083335afc034e4.mp3",
        "bank": "en-oo1",
        "durationMs": 3861
    },
    "The woman saving a picnic spot on the moon brings a large computer.": {
        "file": "f050590be086f34ace2b.mp3",
        "bank": "en-oo1",
        "durationMs": 4075
    },
    "The woman saving a picnic spot on the moon brings a large glass.": {
        "file": "7939bcebcf7036a24d39.mp3",
        "bank": "en-oo1",
        "durationMs": 3925
    },
    "The woman saving a picnic spot on the moon brings a small computer.": {
        "file": "70b2ebb356c055462805.mp3",
        "bank": "en-oo1",
        "durationMs": 3968
    },
    "The woman saving a picnic spot on the moon brings a small glass.": {
        "file": "6145d6934d2a23a818c3.mp3",
        "bank": "en-oo1",
        "durationMs": 3819
    },
    "The woman saving a picnic spot on the moon brings a large cup.": {
        "file": "f7a51943d7543fae7458.mp3",
        "bank": "en-oo1",
        "durationMs": 3776
    },
    "The woman saving a picnic spot on the moon brings a large gift.": {
        "file": "a379e12b6dd451dd3417.mp3",
        "bank": "en-oo1",
        "durationMs": 3883
    },
    "The woman saving a picnic spot on the moon brings a small cup.": {
        "file": "247981a4c88d45490887.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The woman saving a picnic spot on the moon brings a small gift.": {
        "file": "d97b74041d9c8e0816ad.mp3",
        "bank": "en-oo1",
        "durationMs": 3776
    },
    "The visitor from space joining our morning meeting is wearing a large hat and holding a gift.": {
        "file": "9ef7fa5348ff1bf36bfd.mp3",
        "bank": "en-oo1",
        "durationMs": 5568
    },
    "The visitor from space joining our morning meeting is wearing a large hat and holding a glass.": {
        "file": "e5d6c4378da07c29f5bc.mp3",
        "bank": "en-oo1",
        "durationMs": 5611
    },
    "The visitor from space joining our morning meeting is wearing a small hat and holding a gift.": {
        "file": "a19f6924f2a95bed928f.mp3",
        "bank": "en-oo1",
        "durationMs": 5568
    },
    "The visitor from space joining our morning meeting is wearing a small hat and holding a glass.": {
        "file": "22c29610be8d87608095.mp3",
        "bank": "en-oo1",
        "durationMs": 5568
    },
    "The visitor from space joining our morning meeting is wearing a long scarf and holding a robot.": {
        "file": "f540a57147e5caf87d81.mp3",
        "bank": "en-oo1",
        "durationMs": 5867
    },
    "The visitor from space joining our morning meeting is wearing a long scarf and holding a picture.": {
        "file": "9e743cbcacb64ef90fa7.mp3",
        "bank": "en-oo1",
        "durationMs": 5803
    },
    "The visitor from space joining our morning meeting is wearing a short scarf and holding a robot.": {
        "file": "e4e7dfda67eaf0e6d5ee.mp3",
        "bank": "en-oo1",
        "durationMs": 5845
    },
    "The visitor from space joining our morning meeting is wearing a short scarf and holding a picture.": {
        "file": "9660a42be486ce6a7ae4.mp3",
        "bank": "en-oo1",
        "durationMs": 5760
    },
    "The visitor from space joining our morning meeting is wearing round glasses and holding a bottle.": {
        "file": "8001f1e4767e0054abc4.mp3",
        "bank": "en-oo1",
        "durationMs": 5632
    },
    "The visitor from space joining our morning meeting is wearing round glasses and holding a fish.": {
        "file": "8cd41b0f69d6febb8964.mp3",
        "bank": "en-oo1",
        "durationMs": 5504
    },
    "The visitor from space joining our morning meeting is wearing square glasses and holding a bottle.": {
        "file": "cd6c367af0d60ab33904.mp3",
        "bank": "en-oo1",
        "durationMs": 5717
    },
    "The visitor from space joining our morning meeting is wearing square glasses and holding a fish.": {
        "file": "b78a64478f1c4bdfcb6d.mp3",
        "bank": "en-oo1",
        "durationMs": 5717
    },
    "The visitor from space joining our morning meeting is wearing a jacket with two pockets and holding a dog.": {
        "file": "aa194bf65627cbe7621b.mp3",
        "bank": "en-oo1",
        "durationMs": 6507
    },
    "The visitor from space joining our morning meeting is wearing a jacket with two pockets and holding a shoe.": {
        "file": "9e47252e3fe3fb982e8f.mp3",
        "bank": "en-oo1",
        "durationMs": 6485
    },
    "The visitor from space joining our morning meeting is wearing a jacket with four pockets and holding a dog.": {
        "file": "2d335113ee1cc266ab6b.mp3",
        "bank": "en-oo1",
        "durationMs": 6613
    },
    "The visitor from space joining our morning meeting is wearing a jacket with four pockets and holding a shoe.": {
        "file": "6ca8a2c2cc47919ceb77.mp3",
        "bank": "en-oo1",
        "durationMs": 6507
    },
    "The visitor from space joining our morning meeting is wearing a shirt with long sleeves and holding a clock.": {
        "file": "6b3a214c64d6393f7f35.mp3",
        "bank": "en-oo1",
        "durationMs": 6357
    },
    "The visitor from space joining our morning meeting is wearing a shirt with long sleeves and holding a box.": {
        "file": "89a6247ad38e9131bb88.mp3",
        "bank": "en-oo1",
        "durationMs": 6357
    },
    "The visitor from space joining our morning meeting is wearing a shirt with short sleeves and holding a clock.": {
        "file": "ebac08b997062ce45273.mp3",
        "bank": "en-oo1",
        "durationMs": 6336
    },
    "The visitor from space joining our morning meeting is wearing a shirt with short sleeves and holding a box.": {
        "file": "b18bcd0ef8b121fcf59a.mp3",
        "bank": "en-oo1",
        "durationMs": 6357
    },
    "The man sleeping above his space bed has a bag beside the bed.": {
        "file": "13c3a0b0410e3b861cea.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The man sleeping above his space bed has a bag under the bed.": {
        "file": "64c1c0400f0812a2cc40.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The man sleeping above his space bed has a ticket beside the bed.": {
        "file": "092e824528cb86c1e643.mp3",
        "bank": "en-oo1",
        "durationMs": 3776
    },
    "The man sleeping above his space bed has a ticket under the bed.": {
        "file": "3a7d48dd6d052b5afd9c.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The man sleeping above his space bed has a box beside the bed.": {
        "file": "6f9cb51d6178f90c6151.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The man sleeping above his space bed has a box under the bed.": {
        "file": "46527966a43d8eefe415.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The man sleeping above his space bed has a fish beside the bed.": {
        "file": "628d71fcce4da8b925b1.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The man sleeping above his space bed has a fish under the bed.": {
        "file": "36d4757f2648093cb658.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The man sleeping above his space bed has a gift beside the bed.": {
        "file": "02543b3a89efb6e52bc2.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The man sleeping above his space bed has a gift under the bed.": {
        "file": "91e6b468f09f17ff4871.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The man sleeping above his space bed has a key beside the bed.": {
        "file": "e523962c08ce3451c046.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The man sleeping above his space bed has a key under the bed.": {
        "file": "85b935f31b399ec5ac43.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The man sleeping above his space bed has a hat beside the bed.": {
        "file": "796d72653f5234847544.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The man sleeping above his space bed has a hat under the bed.": {
        "file": "200ea63af0272923c52c.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The man sleeping above his space bed has a cup beside the bed.": {
        "file": "e75a8dea9feec09e819f.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The man sleeping above his space bed has a cup under the bed.": {
        "file": "b80f44afce9bed1620a5.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The man sleeping above his space bed has a glass beside the bed.": {
        "file": "a87807fb81d278919ac1.mp3",
        "bank": "en-oo1",
        "durationMs": 3776
    },
    "The man sleeping above his space bed has a glass under the bed.": {
        "file": "3fad2c918ba524683002.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The man sleeping above his space bed has a computer beside the bed.": {
        "file": "d70e0fb1000e539626d2.mp3",
        "bank": "en-oo1",
        "durationMs": 3840
    },
    "The man sleeping above his space bed has a computer under the bed.": {
        "file": "c9f99c98319feebfe4af.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "The woman delivering lunch to the moon carries two eggs.": {
        "file": "b8d21d212b50efe35818.mp3",
        "bank": "en-oo1",
        "durationMs": 2987
    },
    "The woman delivering lunch to the moon carries two bags.": {
        "file": "0f1da49f064818644443.mp3",
        "bank": "en-oo1",
        "durationMs": 3029
    },
    "The woman delivering lunch to the moon carries three eggs.": {
        "file": "7fd55aaafc0beef08c15.mp3",
        "bank": "en-oo1",
        "durationMs": 3072
    },
    "The woman delivering lunch to the moon carries three bags.": {
        "file": "e671d694c367cf759d8c.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "The woman delivering lunch to the moon carries two glasses.": {
        "file": "16bd6019e951c251603a.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The woman delivering lunch to the moon carries two tickets.": {
        "file": "3b79b1e4a4f3c7d72fa9.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The woman delivering lunch to the moon carries four glasses.": {
        "file": "1d294f66600399ae2fb1.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The woman delivering lunch to the moon carries four tickets.": {
        "file": "ec0795d3c9d9167b24c3.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The woman delivering lunch to the moon carries two computers.": {
        "file": "0870a6a5e1f119ea78a5.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The woman delivering lunch to the moon carries two fish.": {
        "file": "a3bdae59615034eda276.mp3",
        "bank": "en-oo1",
        "durationMs": 2987
    },
    "The woman delivering lunch to the moon carries three computers.": {
        "file": "14433983a93c89ba3aab.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The woman delivering lunch to the moon carries three fish.": {
        "file": "bc4925fa335910fb578d.mp3",
        "bank": "en-oo1",
        "durationMs": 3051
    },
    "The woman delivering lunch to the moon carries two shoes.": {
        "file": "c69f17088b9a1f226aff.mp3",
        "bank": "en-oo1",
        "durationMs": 3051
    },
    "The woman delivering lunch to the moon carries two boxes.": {
        "file": "2c6b6afc00f51311494f.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The woman delivering lunch to the moon carries four shoes.": {
        "file": "8ac4c58dd3162a8228e9.mp3",
        "bank": "en-oo1",
        "durationMs": 3072
    },
    "The woman delivering lunch to the moon carries four boxes.": {
        "file": "aa951699e7d74fc1df73.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The woman delivering lunch to the moon carries two cats.": {
        "file": "f19eba987ee93e900197.mp3",
        "bank": "en-oo1",
        "durationMs": 3029
    },
    "The woman delivering lunch to the moon carries two gifts.": {
        "file": "16bf512a114b2e9debe4.mp3",
        "bank": "en-oo1",
        "durationMs": 3072
    },
    "The woman delivering lunch to the moon carries three cats.": {
        "file": "ca33450bef31c20e3fb9.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The woman delivering lunch to the moon carries three gifts.": {
        "file": "de041aa1a34f1f00217d.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The man parking his rocket at home is holding a ticket.": {
        "file": "5a65e735b58ac5946798.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The man parking his rocket at home is holding an egg.": {
        "file": "f8af8801321e0e8a2b68.mp3",
        "bank": "en-oo1",
        "durationMs": 3051
    },
    "The man parking his rocket at home is pulling a ticket.": {
        "file": "3f1e1170013ecf699480.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The man parking his rocket at home is pulling an egg.": {
        "file": "f993ed54836a8c46492d.mp3",
        "bank": "en-oo1",
        "durationMs": 3008
    },
    "The man parking his rocket at home is holding a cup.": {
        "file": "963add50484133a993c4.mp3",
        "bank": "en-oo1",
        "durationMs": 3029
    },
    "The man parking his rocket at home is holding a fish.": {
        "file": "d3b8689bb339a5e989f2.mp3",
        "bank": "en-oo1",
        "durationMs": 3072
    },
    "The man parking his rocket at home is pulling a cup.": {
        "file": "7da1e0da219d235a5cc2.mp3",
        "bank": "en-oo1",
        "durationMs": 3008
    },
    "The man parking his rocket at home is pulling a fish.": {
        "file": "43f0399be16cb2f4b6cd.mp3",
        "bank": "en-oo1",
        "durationMs": 3029
    },
    "The man parking his rocket at home is holding a bag.": {
        "file": "45d2e22c319773616b26.mp3",
        "bank": "en-oo1",
        "durationMs": 3072
    },
    "The man parking his rocket at home is holding a bottle.": {
        "file": "486abcb29537a92bb2d4.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "The man parking his rocket at home is pulling a bag.": {
        "file": "d6657208e646823664bf.mp3",
        "bank": "en-oo1",
        "durationMs": 3029
    },
    "The man parking his rocket at home is pulling a bottle.": {
        "file": "d132ba592ddf5f3872be.mp3",
        "bank": "en-oo1",
        "durationMs": 3072
    },
    "The man parking his rocket at home is holding a glass.": {
        "file": "7649c403293c4b3fcfdd.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The man parking his rocket at home is holding a box.": {
        "file": "8469c5dcad712aa6edcf.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The man parking his rocket at home is pulling a glass.": {
        "file": "88d1d13060a8d5d39d80.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The man parking his rocket at home is pulling a box.": {
        "file": "0c516426dda04da54fea.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The man parking his rocket at home is holding a book.": {
        "file": "dd87f38622205a080c58.mp3",
        "bank": "en-oo1",
        "durationMs": 2987
    },
    "The man parking his rocket at home is holding a robot.": {
        "file": "303e38107c13a795744b.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The man parking his rocket at home is pulling a book.": {
        "file": "92896f60c2fdfdb4df87.mp3",
        "bank": "en-oo1",
        "durationMs": 2944
    },
    "The man parking his rocket at home is pulling a robot.": {
        "file": "1b8b529c68b1c470d8dd.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "After visiting space, the student proudly brings home a large clock.": {
        "file": "0afcefaa2506b1a9fda5.mp3",
        "bank": "en-oo1",
        "durationMs": 4053
    },
    "After visiting space, the student proudly brings home a large gift.": {
        "file": "6c632821df77fb6cc739.mp3",
        "bank": "en-oo1",
        "durationMs": 4053
    },
    "After visiting space, the student proudly brings home a small clock.": {
        "file": "276dd3cce863c59fd5b8.mp3",
        "bank": "en-oo1",
        "durationMs": 3968
    },
    "After visiting space, the student proudly brings home a small gift.": {
        "file": "fe12d8d99b94b1d99d22.mp3",
        "bank": "en-oo1",
        "durationMs": 4011
    },
    "After visiting space, the student proudly brings home a large egg.": {
        "file": "72ac5a19b2f9ae67f3f4.mp3",
        "bank": "en-oo1",
        "durationMs": 3968
    },
    "After visiting space, the student proudly brings home a large fish.": {
        "file": "a6feb6b04e4af08ce5fd.mp3",
        "bank": "en-oo1",
        "durationMs": 3989
    },
    "After visiting space, the student proudly brings home a small egg.": {
        "file": "a2aad3133f79a1c9cff1.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "After visiting space, the student proudly brings home a small fish.": {
        "file": "169c0d38dee4b6c66034.mp3",
        "bank": "en-oo1",
        "durationMs": 3947
    },
    "After visiting space, the student proudly brings home a large ticket.": {
        "file": "e8ee56e03fa5cbafaae6.mp3",
        "bank": "en-oo1",
        "durationMs": 4075
    },
    "After visiting space, the student proudly brings home a large picture.": {
        "file": "c1a16b207192f80d3d55.mp3",
        "bank": "en-oo1",
        "durationMs": 4181
    },
    "After visiting space, the student proudly brings home a small ticket.": {
        "file": "285ae3751f3cf09b4fb7.mp3",
        "bank": "en-oo1",
        "durationMs": 4032
    },
    "After visiting space, the student proudly brings home a small picture.": {
        "file": "f84c8d2658681e83ab12.mp3",
        "bank": "en-oo1",
        "durationMs": 4075
    },
    "After visiting space, the student proudly brings home a large bag.": {
        "file": "b0d7780b7b3678a2c1fe.mp3",
        "bank": "en-oo1",
        "durationMs": 4011
    },
    "After visiting space, the student proudly brings home a large key.": {
        "file": "2bed387e0f9be6b32c3f.mp3",
        "bank": "en-oo1",
        "durationMs": 3925
    },
    "After visiting space, the student proudly brings home a small bag.": {
        "file": "6e47e02dc6e186c58748.mp3",
        "bank": "en-oo1",
        "durationMs": 3883
    },
    "After visiting space, the student proudly brings home a small key.": {
        "file": "ff585045b6ddba0dbb64.mp3",
        "bank": "en-oo1",
        "durationMs": 3947
    },
    "After visiting space, the student proudly brings home a large bottle.": {
        "file": "b3f87be1cceab4dbba7c.mp3",
        "bank": "en-oo1",
        "durationMs": 4139
    },
    "After visiting space, the student proudly brings home a large glass.": {
        "file": "628e8a76d576c4852e19.mp3",
        "bank": "en-oo1",
        "durationMs": 4139
    },
    "After visiting space, the student proudly brings home a small bottle.": {
        "file": "19647ffc61b32b81f89a.mp3",
        "bank": "en-oo1",
        "durationMs": 4032
    },
    "After visiting space, the student proudly brings home a small glass.": {
        "file": "4d7317347d7ede520e59.mp3",
        "bank": "en-oo1",
        "durationMs": 4075
    },
    "The woman visiting the next planet carries a ticket above her head.": {
        "file": "ce7bf677d239737239a6.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The woman visiting the next planet carries a ticket behind her back.": {
        "file": "292a5cd1cffcd712dd8a.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The woman visiting the next planet carries a gift above her head.": {
        "file": "91050f856f863e1bc571.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The woman visiting the next planet carries a gift behind her back.": {
        "file": "a7f8f13ca89926e5741b.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The woman visiting the next planet carries a cat above her head.": {
        "file": "0032e60e54c96bb30dde.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The woman visiting the next planet carries a cat behind her back.": {
        "file": "9f166f3f53cb26ec49fe.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "The woman visiting the next planet carries a glass above her head.": {
        "file": "21bf0dd8139f435796e3.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The woman visiting the next planet carries a glass behind her back.": {
        "file": "97fb4d8e9baabd552d98.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The woman visiting the next planet carries a computer above her head.": {
        "file": "f66d246cef9f2d6c3b28.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "The woman visiting the next planet carries a computer behind her back.": {
        "file": "680aa093bce95bd5130c.mp3",
        "bank": "en-oo1",
        "durationMs": 3883
    },
    "The woman visiting the next planet carries a phone above her head.": {
        "file": "70cf9fa3c8484ec5a0fd.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The woman visiting the next planet carries a phone behind her back.": {
        "file": "84bdb2447f126c293369.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The woman visiting the next planet carries a box above her head.": {
        "file": "3535b23a0eaaf6c0f872.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The woman visiting the next planet carries a box behind her back.": {
        "file": "3704209ff721f0afac8c.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The woman visiting the next planet carries an umbrella above her head.": {
        "file": "b7d948efd0f8df54d5bf.mp3",
        "bank": "en-oo1",
        "durationMs": 3883
    },
    "The woman visiting the next planet carries an umbrella behind her back.": {
        "file": "dc3eb65cc26eadabff56.mp3",
        "bank": "en-oo1",
        "durationMs": 3947
    },
    "The woman visiting the next planet carries a robot above her head.": {
        "file": "37a78f85d5378fbf8a9b.mp3",
        "bank": "en-oo1",
        "durationMs": 3840
    },
    "The woman visiting the next planet carries a robot behind her back.": {
        "file": "b1c6e79485544445a696.mp3",
        "bank": "en-oo1",
        "durationMs": 3925
    },
    "The woman visiting the next planet carries a hat above her head.": {
        "file": "d12f6bbdcc9d6117b5e3.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The woman visiting the next planet carries a hat behind her back.": {
        "file": "9302484907c63d8c47e9.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The man watering his space garden has two computers beside him.": {
        "file": "ba2c0854771d51b3ffe4.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "The man watering his space garden has two fish beside him.": {
        "file": "deff3fb1f221af3e41d0.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The man watering his space garden has three computers beside him.": {
        "file": "68797beb77d60685a19b.mp3",
        "bank": "en-oo1",
        "durationMs": 3776
    },
    "The man watering his space garden has three fish beside him.": {
        "file": "bb5fc73bb9d354f04419.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The man watering his space garden has two phones beside him.": {
        "file": "455eced6fd41fca7e7bb.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The man watering his space garden has two gifts beside him.": {
        "file": "178b88e70d7eef762df2.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The man watering his space garden has four phones beside him.": {
        "file": "bddcd87fededaa6a85fd.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The man watering his space garden has four gifts beside him.": {
        "file": "1300dc9ac2b2d963fb98.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The man watering his space garden has two bags beside him.": {
        "file": "1d1621a19b1ab31f2cbf.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The man watering his space garden has two bottles beside him.": {
        "file": "53431d2c9e90451d5341.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The man watering his space garden has three bags beside him.": {
        "file": "61c9145f300c2e62867b.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The man watering his space garden has three bottles beside him.": {
        "file": "10611c04c3247cf6a455.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The man watering his space garden has two glasses beside him.": {
        "file": "d11408e0e0362624bce4.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The man watering his space garden has two boxes beside him.": {
        "file": "eba29c2c64f706ab3e5a.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The man watering his space garden has four glasses beside him.": {
        "file": "2eb9df71c5e3123f7f71.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The man watering his space garden has four boxes beside him.": {
        "file": "a2dd39807e79fbaea89a.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The man watering his space garden has two magazines beside him.": {
        "file": "f758e75cf5bc70c5782b.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The man watering his space garden has two books beside him.": {
        "file": "ef24ac77716ff90ddbb8.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The man watering his space garden has three magazines beside him.": {
        "file": "6c085889cbda77dcbcd0.mp3",
        "bank": "en-oo1",
        "durationMs": 3861
    },
    "The man watering his space garden has three books beside him.": {
        "file": "a5cd2e6688806b73edad.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The winner of our slow walking race is wearing a large hat and holding a flower.": {
        "file": "2b717744e73cb27c9035.mp3",
        "bank": "en-oo1",
        "durationMs": 4672
    },
    "The winner of our slow walking race is wearing a large hat and holding a fish.": {
        "file": "92124ca80343096d1cbf.mp3",
        "bank": "en-oo1",
        "durationMs": 4565
    },
    "The winner of our slow walking race is wearing a small hat and holding a flower.": {
        "file": "cd8a5d378b37a0bc532c.mp3",
        "bank": "en-oo1",
        "durationMs": 4629
    },
    "The winner of our slow walking race is wearing a small hat and holding a fish.": {
        "file": "d2816e57702cead5ec40.mp3",
        "bank": "en-oo1",
        "durationMs": 4459
    },
    "The winner of our slow walking race is wearing a long scarf and holding a book.": {
        "file": "0eb1797a7684b0b80081.mp3",
        "bank": "en-oo1",
        "durationMs": 4565
    },
    "The winner of our slow walking race is wearing a long scarf and holding a phone.": {
        "file": "4354aae674c906834153.mp3",
        "bank": "en-oo1",
        "durationMs": 4629
    },
    "The winner of our slow walking race is wearing a short scarf and holding a book.": {
        "file": "fc328210f2c6cfb3bb2b.mp3",
        "bank": "en-oo1",
        "durationMs": 4544
    },
    "The winner of our slow walking race is wearing a short scarf and holding a phone.": {
        "file": "ab9d28b6af3a1efbdbfd.mp3",
        "bank": "en-oo1",
        "durationMs": 4608
    },
    "The winner of our slow walking race is wearing round glasses and holding a ticket.": {
        "file": "1105ae6496186041259f.mp3",
        "bank": "en-oo1",
        "durationMs": 4651
    },
    "The winner of our slow walking race is wearing round glasses and holding a gift.": {
        "file": "a61cecaeb91fe6824111.mp3",
        "bank": "en-oo1",
        "durationMs": 4565
    },
    "The winner of our slow walking race is wearing square glasses and holding a ticket.": {
        "file": "100e201b1b3b519c2bc4.mp3",
        "bank": "en-oo1",
        "durationMs": 4672
    },
    "The winner of our slow walking race is wearing square glasses and holding a gift.": {
        "file": "357a5bd63ae53f8360cd.mp3",
        "bank": "en-oo1",
        "durationMs": 4608
    },
    "The winner of our slow walking race is wearing a jacket with two pockets and holding a cat.": {
        "file": "e658450c3762b6d9305f.mp3",
        "bank": "en-oo1",
        "durationMs": 5397
    },
    "The winner of our slow walking race is wearing a jacket with two pockets and holding a robot.": {
        "file": "aee9d77a214a4a848f45.mp3",
        "bank": "en-oo1",
        "durationMs": 5568
    },
    "The winner of our slow walking race is wearing a jacket with four pockets and holding a cat.": {
        "file": "92ba1409ee6a069ece57.mp3",
        "bank": "en-oo1",
        "durationMs": 5461
    },
    "The winner of our slow walking race is wearing a jacket with four pockets and holding a robot.": {
        "file": "0df3cf3f3e836cb14df0.mp3",
        "bank": "en-oo1",
        "durationMs": 5675
    },
    "The winner of our slow walking race is wearing a shirt with long sleeves and holding a glass.": {
        "file": "aa3964c982abe8fdd5e3.mp3",
        "bank": "en-oo1",
        "durationMs": 5355
    },
    "The winner of our slow walking race is wearing a shirt with long sleeves and holding a box.": {
        "file": "fcb85be311f8bd950733.mp3",
        "bank": "en-oo1",
        "durationMs": 5355
    },
    "The winner of our slow walking race is wearing a shirt with short sleeves and holding a glass.": {
        "file": "2006aae1a44ae7171a2d.mp3",
        "bank": "en-oo1",
        "durationMs": 5269
    },
    "The winner of our slow walking race is wearing a shirt with short sleeves and holding a box.": {
        "file": "b6d72359d1af6de42caa.mp3",
        "bank": "en-oo1",
        "durationMs": 5312
    },
    "At the sleeping competition, there are two fish beside the winner.": {
        "file": "b1997a1fe755d95ab624.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "At the sleeping competition, there are two cats beside the winner.": {
        "file": "0904a1a254f3ef263590.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "At the sleeping competition, there are three fish beside the winner.": {
        "file": "3da2acf89efbb6914382.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "At the sleeping competition, there are three cats beside the winner.": {
        "file": "599cd845e8141a2f8242.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "At the sleeping competition, there are two glasses beside the winner.": {
        "file": "4e3424acb413261c202d.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "At the sleeping competition, there are two bags beside the winner.": {
        "file": "b36509b49a908000b696.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "At the sleeping competition, there are four glasses beside the winner.": {
        "file": "39fc5b9bd39e55787463.mp3",
        "bank": "en-oo1",
        "durationMs": 3883
    },
    "At the sleeping competition, there are four bags beside the winner.": {
        "file": "be665417f89077ddc780.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "At the sleeping competition, there are two tickets beside the winner.": {
        "file": "245bb18b2cad7c288694.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "At the sleeping competition, there are two pictures beside the winner.": {
        "file": "df3fca86e106bd7a179c.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "At the sleeping competition, there are three tickets beside the winner.": {
        "file": "118fae0fe0dc84fea8a7.mp3",
        "bank": "en-oo1",
        "durationMs": 3776
    },
    "At the sleeping competition, there are three pictures beside the winner.": {
        "file": "d80388540df9ceaedf2a.mp3",
        "bank": "en-oo1",
        "durationMs": 3861
    },
    "At the sleeping competition, there are two dogs beside the winner.": {
        "file": "920125e7de2d6596850c.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "At the sleeping competition, there are two gifts beside the winner.": {
        "file": "cab5a9fefea3901f0404.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "At the sleeping competition, there are four dogs beside the winner.": {
        "file": "0ddd81e5a2cb390285de.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "At the sleeping competition, there are four gifts beside the winner.": {
        "file": "0c5b334afd7550270881.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "At the sleeping competition, there are two books beside the winner.": {
        "file": "68522ecb7f69b8197ce1.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "At the sleeping competition, there are two boxes beside the winner.": {
        "file": "c21fafa1bed755689a0b.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "At the sleeping competition, there are three books beside the winner.": {
        "file": "1ec62f59887d6499dc42.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "At the sleeping competition, there are three boxes beside the winner.": {
        "file": "8cda4a9722b95de973ec.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The shoes racing without their owner pass a chair beside the tree.": {
        "file": "4539a2bb47ee70ed2fd7.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "The shoes racing without their owner pass a chair under the tree.": {
        "file": "6c4b79d45c3986a981d0.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The shoes racing without their owner pass a glass beside the tree.": {
        "file": "be8fe85ff621ba7d5e6a.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "The shoes racing without their owner pass a glass under the tree.": {
        "file": "b4612533f23eaec766c3.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The shoes racing without their owner pass a computer beside the tree.": {
        "file": "1da0514baeac74464183.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "The shoes racing without their owner pass a computer under the tree.": {
        "file": "928656626e5d89dcaf0a.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The shoes racing without their owner pass a robot beside the tree.": {
        "file": "201a25106a6a8e09811b.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The shoes racing without their owner pass a robot under the tree.": {
        "file": "15c31b1b0452dcc74c86.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The shoes racing without their owner pass a cat beside the tree.": {
        "file": "eeb48ec27028aa62b366.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The shoes racing without their owner pass a cat under the tree.": {
        "file": "487679267fe1cde0aad3.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The shoes racing without their owner pass a gift beside the tree.": {
        "file": "a659e46592c2e22e5d23.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The shoes racing without their owner pass a gift under the tree.": {
        "file": "e80d5de45c28903fa136.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The shoes racing without their owner pass a box beside the tree.": {
        "file": "62c9afcc4fb955e295fa.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The shoes racing without their owner pass a box under the tree.": {
        "file": "6994adc19dc01f344972.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The shoes racing without their owner pass a cup beside the tree.": {
        "file": "983e6d1ce918142d3be3.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The shoes racing without their owner pass a cup under the tree.": {
        "file": "3615a7a36e04a7949996.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The shoes racing without their owner pass an egg beside the tree.": {
        "file": "e1d63c1c525afcb42c0d.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The shoes racing without their owner pass an egg under the tree.": {
        "file": "616e54112d43d713b792.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The shoes racing without their owner pass a fish beside the tree.": {
        "file": "50caf4a1d5d9df124bfe.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The shoes racing without their owner pass a fish under the tree.": {
        "file": "d7cec753ec62b648b5f0.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The man racing on an office chair carries a large box.": {
        "file": "4f221bda9c129d29e989.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The man racing on an office chair carries a large bag.": {
        "file": "6385205115e90c93b4ba.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The man racing on an office chair carries a small box.": {
        "file": "2231282dd16e86096f52.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The man racing on an office chair carries a small bag.": {
        "file": "af037a2a47209140a63a.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The man racing on an office chair carries a large glass.": {
        "file": "19d1987df1f9ead8ea1f.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The man racing on an office chair carries a large gift.": {
        "file": "ef58c8ad6bce7e01eb43.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The man racing on an office chair carries a small glass.": {
        "file": "51bc60f04403b8b636f3.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The man racing on an office chair carries a small gift.": {
        "file": "eea3a094a9c4b9754319.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The man racing on an office chair carries a large ticket.": {
        "file": "9d694e6383555540e9b7.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The man racing on an office chair carries a large book.": {
        "file": "510bedb62bf862d4e7f0.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The man racing on an office chair carries a small ticket.": {
        "file": "eb572ede008da7455dda.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The man racing on an office chair carries a small book.": {
        "file": "ed3fef12c83d498b632f.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The man racing on an office chair carries a large hat.": {
        "file": "f18e0a1c00a07713f986.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The man racing on an office chair carries a large egg.": {
        "file": "6ff6b819233b6046dffa.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The man racing on an office chair carries a small hat.": {
        "file": "623b885ba209823d5894.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The man racing on an office chair carries a small egg.": {
        "file": "0e7d5013020bc1f34f98.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The man racing on an office chair carries a large cat.": {
        "file": "608e89e3e13ec1ee1b93.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The man racing on an office chair carries a large fish.": {
        "file": "49b7145bcb308df33fc7.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The man racing on an office chair carries a small cat.": {
        "file": "36368cc10e79bb67ab05.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The man racing on an office chair carries a small fish.": {
        "file": "458dcfcfc3e0e7dcba68.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The fish waiting for its race is holding a box.": {
        "file": "ebe0e1de514a749f665d.mp3",
        "bank": "en-oo1",
        "durationMs": 2859
    },
    "The fish waiting for its race is holding a book.": {
        "file": "e44edb72f2f03014ba2c.mp3",
        "bank": "en-oo1",
        "durationMs": 2709
    },
    "The fish waiting for its race is pushing a box.": {
        "file": "464804140aeb1c32e202.mp3",
        "bank": "en-oo1",
        "durationMs": 2816
    },
    "The fish waiting for its race is pushing a book.": {
        "file": "7501296cbfcf8c7538c3.mp3",
        "bank": "en-oo1",
        "durationMs": 2667
    },
    "The fish waiting for its race is holding a gift.": {
        "file": "191c47044dca3e3fd704.mp3",
        "bank": "en-oo1",
        "durationMs": 2816
    },
    "The fish waiting for its race is holding a bag.": {
        "file": "6d4e7b0fdf565dcab1c2.mp3",
        "bank": "en-oo1",
        "durationMs": 2752
    },
    "The fish waiting for its race is pushing a gift.": {
        "file": "b1fd818ea2297a8918a5.mp3",
        "bank": "en-oo1",
        "durationMs": 2773
    },
    "The fish waiting for its race is pushing a bag.": {
        "file": "4485ef2c5f032bb9466b.mp3",
        "bank": "en-oo1",
        "durationMs": 2667
    },
    "The fish waiting for its race is holding an egg.": {
        "file": "8e9114f6637a39c8e7ee.mp3",
        "bank": "en-oo1",
        "durationMs": 2795
    },
    "The fish waiting for its race is holding a fish.": {
        "file": "52a2ed5c697eb528bfc1.mp3",
        "bank": "en-oo1",
        "durationMs": 2795
    },
    "The fish waiting for its race is pushing an egg.": {
        "file": "c1914570f67322068e5a.mp3",
        "bank": "en-oo1",
        "durationMs": 2688
    },
    "The fish waiting for its race is pushing a fish.": {
        "file": "0767077d7d726d92c2c6.mp3",
        "bank": "en-oo1",
        "durationMs": 2752
    },
    "The fish waiting for its race is holding a key.": {
        "file": "aa61b4d9b4ecd9b46aba.mp3",
        "bank": "en-oo1",
        "durationMs": 2752
    },
    "The fish waiting for its race is holding a dog.": {
        "file": "8fbb777a81420717d0ad.mp3",
        "bank": "en-oo1",
        "durationMs": 2773
    },
    "The fish waiting for its race is pushing a key.": {
        "file": "5d27952cf275aaa9485b.mp3",
        "bank": "en-oo1",
        "durationMs": 2645
    },
    "The fish waiting for its race is pushing a dog.": {
        "file": "0ef1bd5d8c2a00a4b281.mp3",
        "bank": "en-oo1",
        "durationMs": 2731
    },
    "The fish waiting for its race is holding an apple.": {
        "file": "8bcf9d7bff64f2e05bf6.mp3",
        "bank": "en-oo1",
        "durationMs": 2880
    },
    "The fish waiting for its race is holding a robot.": {
        "file": "5cbc936f6410c5fad4b1.mp3",
        "bank": "en-oo1",
        "durationMs": 2965
    },
    "The fish waiting for its race is pushing an apple.": {
        "file": "70786cfb3b9c54718dfb.mp3",
        "bank": "en-oo1",
        "durationMs": 2859
    },
    "The fish waiting for its race is pushing a robot.": {
        "file": "66fb7c72ccdaf415e084.mp3",
        "bank": "en-oo1",
        "durationMs": 2944
    },
    "The people cheering for the cheering team have two glasses.": {
        "file": "221beac1773362f3caaa.mp3",
        "bank": "en-oo1",
        "durationMs": 2965
    },
    "The people cheering for the cheering team have two boxes.": {
        "file": "47d55dc5b3bcf417ecaf.mp3",
        "bank": "en-oo1",
        "durationMs": 2965
    },
    "The people cheering for the cheering team have three glasses.": {
        "file": "58c78e8b3605b6282174.mp3",
        "bank": "en-oo1",
        "durationMs": 3008
    },
    "The people cheering for the cheering team have three boxes.": {
        "file": "b72f1b9aebd6c8c95ee5.mp3",
        "bank": "en-oo1",
        "durationMs": 3008
    },
    "The people cheering for the cheering team have two pencils.": {
        "file": "62dffa31a4e2ca9804a8.mp3",
        "bank": "en-oo1",
        "durationMs": 2965
    },
    "The people cheering for the cheering team have two bags.": {
        "file": "6e691866a895716b859e.mp3",
        "bank": "en-oo1",
        "durationMs": 2795
    },
    "The people cheering for the cheering team have four pencils.": {
        "file": "42971bb0fa724e39c37c.mp3",
        "bank": "en-oo1",
        "durationMs": 3072
    },
    "The people cheering for the cheering team have four bags.": {
        "file": "3fb4c981fd5708cb2d68.mp3",
        "bank": "en-oo1",
        "durationMs": 2923
    },
    "The people cheering for the cheering team have two tickets.": {
        "file": "6703a37f60cfca80d0e7.mp3",
        "bank": "en-oo1",
        "durationMs": 2859
    },
    "The people cheering for the cheering team have two eggs.": {
        "file": "f6105304a62ef56a1ba8.mp3",
        "bank": "en-oo1",
        "durationMs": 2709
    },
    "The people cheering for the cheering team have three tickets.": {
        "file": "d2c4f0932f271cf18c50.mp3",
        "bank": "en-oo1",
        "durationMs": 2923
    },
    "The people cheering for the cheering team have three eggs.": {
        "file": "10c124df68824c95f2cd.mp3",
        "bank": "en-oo1",
        "durationMs": 2773
    },
    "The people cheering for the cheering team have two fish.": {
        "file": "d5910929a447dcf1dcc0.mp3",
        "bank": "en-oo1",
        "durationMs": 2731
    },
    "The people cheering for the cheering team have two gifts.": {
        "file": "1221d781aa86eafa194d.mp3",
        "bank": "en-oo1",
        "durationMs": 2837
    },
    "The people cheering for the cheering team have four fish.": {
        "file": "984be9e29104a5a2d418.mp3",
        "bank": "en-oo1",
        "durationMs": 2816
    },
    "The people cheering for the cheering team have four gifts.": {
        "file": "e1ace665e4b72619c94a.mp3",
        "bank": "en-oo1",
        "durationMs": 2901
    },
    "The people cheering for the cheering team have two computers.": {
        "file": "0dcbfb855aa33f4638a1.mp3",
        "bank": "en-oo1",
        "durationMs": 2987
    },
    "The people cheering for the cheering team have two cats.": {
        "file": "c617e1def3d7cb770734.mp3",
        "bank": "en-oo1",
        "durationMs": 2795
    },
    "The people cheering for the cheering team have three computers.": {
        "file": "2eb0a4a41e5e581946fc.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "The people cheering for the cheering team have three cats.": {
        "file": "99a231a40f37cc20833d.mp3",
        "bank": "en-oo1",
        "durationMs": 2816
    },
    "The ball looking for the players finds a phone beside the box.": {
        "file": "6aa15ee8d3c1e0689f0f.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The ball looking for the players finds a phone inside the box.": {
        "file": "47db8efe58fde91c4083.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The ball looking for the players finds a robot beside the box.": {
        "file": "059c0e862efa20923c46.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The ball looking for the players finds a robot inside the box.": {
        "file": "1dad6a2e767e5ec6ef55.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The ball looking for the players finds a cat beside the box.": {
        "file": "eb816ca2fa864894288f.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The ball looking for the players finds a cat inside the box.": {
        "file": "71b55e9659c2e4586a67.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The ball looking for the players finds a glass beside the box.": {
        "file": "e6cc9167a39b182e0946.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The ball looking for the players finds a glass inside the box.": {
        "file": "3b7fd491312084bbba0c.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "The ball looking for the players finds a gift beside the box.": {
        "file": "6c83067b11d9c9dcd6cb.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The ball looking for the players finds a gift inside the box.": {
        "file": "ee9b74772199ff36a344.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The ball looking for the players finds a fish beside the box.": {
        "file": "1da4378e7bf332c6b9ee.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The ball looking for the players finds a fish inside the box.": {
        "file": "d59f34899ee76d608061.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The ball looking for the players finds a box beside the box.": {
        "file": "4f48b33a5f66b738025b.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The ball looking for the players finds a box inside the box.": {
        "file": "aa27530289e1295123b8.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The ball looking for the players finds a ticket beside the box.": {
        "file": "257219e5b66808f186b4.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The ball looking for the players finds a ticket inside the box.": {
        "file": "f328d503e37ecbbf5726.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "The ball looking for the players finds a book beside the box.": {
        "file": "4f18d808d0fe14af75da.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The ball looking for the players finds a book inside the box.": {
        "file": "522efd34c7db1d7b5415.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The ball looking for the players finds a bottle beside the box.": {
        "file": "f568fbb4cc23bcf867b0.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The ball looking for the players finds a bottle inside the box.": {
        "file": "2be07f8482c697869824.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The trophy winning another trophy is wearing a large hat and holding a gift.": {
        "file": "ea46fea8cc49378f4b47.mp3",
        "bank": "en-oo1",
        "durationMs": 4501
    },
    "The trophy winning another trophy is wearing a large hat and holding a ticket.": {
        "file": "2137d13a4555d95ed29d.mp3",
        "bank": "en-oo1",
        "durationMs": 4565
    },
    "The trophy winning another trophy is wearing a small hat and holding a gift.": {
        "file": "e37df906f881e2cfe108.mp3",
        "bank": "en-oo1",
        "durationMs": 4395
    },
    "The trophy winning another trophy is wearing a small hat and holding a ticket.": {
        "file": "e8602dc0002c266f7689.mp3",
        "bank": "en-oo1",
        "durationMs": 4544
    },
    "The trophy winning another trophy is wearing a long scarf and holding a fish.": {
        "file": "d8d6dad1489ff267556a.mp3",
        "bank": "en-oo1",
        "durationMs": 4480
    },
    "The trophy winning another trophy is wearing a long scarf and holding a glass.": {
        "file": "fb8b56b200426992eab2.mp3",
        "bank": "en-oo1",
        "durationMs": 4544
    },
    "The trophy winning another trophy is wearing a short scarf and holding a fish.": {
        "file": "e5ba8aad8ee4470bf93a.mp3",
        "bank": "en-oo1",
        "durationMs": 4565
    },
    "The trophy winning another trophy is wearing a short scarf and holding a glass.": {
        "file": "adf3f457213bcc18d195.mp3",
        "bank": "en-oo1",
        "durationMs": 4565
    },
    "The trophy winning another trophy is wearing round glasses and holding an egg.": {
        "file": "47ff16988e294e67c403.mp3",
        "bank": "en-oo1",
        "durationMs": 4459
    },
    "The trophy winning another trophy is wearing round glasses and holding a computer.": {
        "file": "ecdeda87d70054c4b887.mp3",
        "bank": "en-oo1",
        "durationMs": 4757
    },
    "The trophy winning another trophy is wearing square glasses and holding an egg.": {
        "file": "6e4cf7231ce85513bd42.mp3",
        "bank": "en-oo1",
        "durationMs": 4480
    },
    "The trophy winning another trophy is wearing square glasses and holding a computer.": {
        "file": "e6233ebe124f8ca25c7e.mp3",
        "bank": "en-oo1",
        "durationMs": 4821
    },
    "The trophy winning another trophy is wearing a jacket with two pockets and holding a bag.": {
        "file": "30fc367f5d46b01a635c.mp3",
        "bank": "en-oo1",
        "durationMs": 5184
    },
    "The trophy winning another trophy is wearing a jacket with two pockets and holding a box.": {
        "file": "5d117e526a8d6609d95f.mp3",
        "bank": "en-oo1",
        "durationMs": 5312
    },
    "The trophy winning another trophy is wearing a jacket with four pockets and holding a bag.": {
        "file": "9b59b32ed76ef2a034a6.mp3",
        "bank": "en-oo1",
        "durationMs": 5291
    },
    "The trophy winning another trophy is wearing a jacket with four pockets and holding a box.": {
        "file": "efb5e9e60a9f6a983841.mp3",
        "bank": "en-oo1",
        "durationMs": 5440
    },
    "The trophy winning another trophy is wearing a shirt with long sleeves and holding a hat.": {
        "file": "824fa47b19aa48287504.mp3",
        "bank": "en-oo1",
        "durationMs": 5013
    },
    "The trophy winning another trophy is wearing a shirt with long sleeves and holding a phone.": {
        "file": "d657ab9fc9bbdaf5c1c9.mp3",
        "bank": "en-oo1",
        "durationMs": 5163
    },
    "The trophy winning another trophy is wearing a shirt with short sleeves and holding a hat.": {
        "file": "3e4bc29251b8eccf5464.mp3",
        "bank": "en-oo1",
        "durationMs": 4992
    },
    "The trophy winning another trophy is wearing a shirt with short sleeves and holding a phone.": {
        "file": "d83e9f291b7f73750b14.mp3",
        "bank": "en-oo1",
        "durationMs": 5120
    },
    "The finish line walking toward the runners carries two fish.": {
        "file": "1616750b34fe1406fb22.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The finish line walking toward the runners carries two phones.": {
        "file": "aaf99e8592aa3f80a67d.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The finish line walking toward the runners carries three fish.": {
        "file": "be944aea923bca7ca5f2.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The finish line walking toward the runners carries three phones.": {
        "file": "2215fb966d5dd246657f.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The finish line walking toward the runners carries two glasses.": {
        "file": "b7c7acc7f2699caf330c.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The finish line walking toward the runners carries two cameras.": {
        "file": "a05d679ec084ff3d2528.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The finish line walking toward the runners carries four glasses.": {
        "file": "59bee151df1cccf13482.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The finish line walking toward the runners carries four cameras.": {
        "file": "38d63a5dae20f7d3e15b.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The finish line walking toward the runners carries two gifts.": {
        "file": "55b8e5ddeb1079848567.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The finish line walking toward the runners carries two robots.": {
        "file": "2c045d4f4c1e955454cf.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The finish line walking toward the runners carries three gifts.": {
        "file": "79d803f77f8d57733951.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The finish line walking toward the runners carries three robots.": {
        "file": "2d2ac05f8f2d1f0d425f.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The finish line walking toward the runners carries two bottles.": {
        "file": "6a2f146e2f83e9d552db.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The finish line walking toward the runners carries two computers.": {
        "file": "b6c9aaa6c263c2af1eb8.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The finish line walking toward the runners carries four bottles.": {
        "file": "c706ae0d72a98445b16f.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The finish line walking toward the runners carries four computers.": {
        "file": "ccd5c7eada3802bb08ea.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The finish line walking toward the runners carries two bags.": {
        "file": "972160e40d2f05398e32.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The finish line walking toward the runners carries two books.": {
        "file": "e48a1a602d4b52486fa4.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The finish line walking toward the runners carries three bags.": {
        "file": "5ee8cbe619c3978aeafe.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The finish line walking toward the runners carries three books.": {
        "file": "66d69d11772374b55e91.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The student taking a break during a race sits beside a large fish.": {
        "file": "1d50696dc7f9a795dd82.mp3",
        "bank": "en-oo1",
        "durationMs": 3989
    },
    "The student taking a break during a race sits beside a large cat.": {
        "file": "c38eb8015e5310173727.mp3",
        "bank": "en-oo1",
        "durationMs": 3947
    },
    "The student taking a break during a race sits beside a small fish.": {
        "file": "d9e93b0ef8fd743c9d4b.mp3",
        "bank": "en-oo1",
        "durationMs": 3925
    },
    "The student taking a break during a race sits beside a small cat.": {
        "file": "69d44c802e116dc3934f.mp3",
        "bank": "en-oo1",
        "durationMs": 3883
    },
    "The student taking a break during a race sits beside a large bag.": {
        "file": "fc2b053fd8d453a9fbe1.mp3",
        "bank": "en-oo1",
        "durationMs": 4011
    },
    "The student taking a break during a race sits beside a large shoe.": {
        "file": "ece63ba3af1e3f5ad824.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "The student taking a break during a race sits beside a small bag.": {
        "file": "5e6726283d5525a50154.mp3",
        "bank": "en-oo1",
        "durationMs": 3883
    },
    "The student taking a break during a race sits beside a small shoe.": {
        "file": "571e02e335100891d269.mp3",
        "bank": "en-oo1",
        "durationMs": 3861
    },
    "The student taking a break during a race sits beside a large ticket.": {
        "file": "214ffd12e2eaebc2c046.mp3",
        "bank": "en-oo1",
        "durationMs": 4096
    },
    "The student taking a break during a race sits beside a large glass.": {
        "file": "b177a9e2894b0d8ab038.mp3",
        "bank": "en-oo1",
        "durationMs": 4096
    },
    "The student taking a break during a race sits beside a small ticket.": {
        "file": "66d759e57356fc0fec6d.mp3",
        "bank": "en-oo1",
        "durationMs": 4011
    },
    "The student taking a break during a race sits beside a small glass.": {
        "file": "d8d24e4ea2c7d7274cb2.mp3",
        "bank": "en-oo1",
        "durationMs": 3925
    },
    "The student taking a break during a race sits beside a large bottle.": {
        "file": "840797b725717f4cab83.mp3",
        "bank": "en-oo1",
        "durationMs": 4117
    },
    "The student taking a break during a race sits beside a large box.": {
        "file": "244adfe2ee0e8c03c36f.mp3",
        "bank": "en-oo1",
        "durationMs": 4117
    },
    "The student taking a break during a race sits beside a small bottle.": {
        "file": "715352ab5b233e1fc6ee.mp3",
        "bank": "en-oo1",
        "durationMs": 3968
    },
    "The student taking a break during a race sits beside a small box.": {
        "file": "dd1967a5cb08731793dc.mp3",
        "bank": "en-oo1",
        "durationMs": 3968
    },
    "The student taking a break during a race sits beside a large book.": {
        "file": "fc068f69425c35b07526.mp3",
        "bank": "en-oo1",
        "durationMs": 3968
    },
    "The student taking a break during a race sits beside a large egg.": {
        "file": "ff432f4169f6a3e2c4a9.mp3",
        "bank": "en-oo1",
        "durationMs": 3947
    },
    "The student taking a break during a race sits beside a small book.": {
        "file": "58a90deca409c1fd1dca.mp3",
        "bank": "en-oo1",
        "durationMs": 3883
    },
    "The student taking a break during a race sits beside a small egg.": {
        "file": "56a4cdbae53aba74eb2a.mp3",
        "bank": "en-oo1",
        "durationMs": 3883
    },
    "The bed checking into the hotel is wearing a large hat and carrying a fish.": {
        "file": "b28f327c022650678af8.mp3",
        "bank": "en-oo1",
        "durationMs": 4587
    },
    "The bed checking into the hotel is wearing a large hat and carrying a gift.": {
        "file": "0d92eb9b2c1d3c47d003.mp3",
        "bank": "en-oo1",
        "durationMs": 4587
    },
    "The bed checking into the hotel is wearing a small hat and carrying a fish.": {
        "file": "6a4a63c11439ce9e5cbd.mp3",
        "bank": "en-oo1",
        "durationMs": 4395
    },
    "The bed checking into the hotel is wearing a small hat and carrying a gift.": {
        "file": "e37567e7ecda49c72aa0.mp3",
        "bank": "en-oo1",
        "durationMs": 4373
    },
    "The bed checking into the hotel is wearing a long scarf and carrying a glass.": {
        "file": "465c7730218c5dd455e7.mp3",
        "bank": "en-oo1",
        "durationMs": 4523
    },
    "The bed checking into the hotel is wearing a long scarf and carrying a cat.": {
        "file": "8fdaa7e26d918cbe459f.mp3",
        "bank": "en-oo1",
        "durationMs": 4501
    },
    "The bed checking into the hotel is wearing a short scarf and carrying a glass.": {
        "file": "a22ed57d67122d99c5aa.mp3",
        "bank": "en-oo1",
        "durationMs": 4587
    },
    "The bed checking into the hotel is wearing a short scarf and carrying a cat.": {
        "file": "8ac0308a274c40fb3df2.mp3",
        "bank": "en-oo1",
        "durationMs": 4501
    },
    "The bed checking into the hotel is wearing round glasses and carrying a phone.": {
        "file": "b2f043e7471f99b8bcbe.mp3",
        "bank": "en-oo1",
        "durationMs": 4629
    },
    "The bed checking into the hotel is wearing round glasses and carrying a box.": {
        "file": "f750552b2b61a1af34dd.mp3",
        "bank": "en-oo1",
        "durationMs": 4715
    },
    "The bed checking into the hotel is wearing square glasses and carrying a phone.": {
        "file": "a5a2590ad2204f7dce7a.mp3",
        "bank": "en-oo1",
        "durationMs": 4736
    },
    "The bed checking into the hotel is wearing square glasses and carrying a box.": {
        "file": "a97294ad06189fa471c7.mp3",
        "bank": "en-oo1",
        "durationMs": 4779
    },
    "The bed checking into the hotel is wearing a jacket with two pockets and carrying a computer.": {
        "file": "66636faf8751fa871c33.mp3",
        "bank": "en-oo1",
        "durationMs": 5440
    },
    "The bed checking into the hotel is wearing a jacket with two pockets and carrying a book.": {
        "file": "0515458d51a78344f613.mp3",
        "bank": "en-oo1",
        "durationMs": 5163
    },
    "The bed checking into the hotel is wearing a jacket with four pockets and carrying a computer.": {
        "file": "15e4b3a5a97eb73c47a5.mp3",
        "bank": "en-oo1",
        "durationMs": 5504
    },
    "The bed checking into the hotel is wearing a jacket with four pockets and carrying a book.": {
        "file": "80abb8f053eb7263f344.mp3",
        "bank": "en-oo1",
        "durationMs": 5269
    },
    "The bed checking into the hotel is wearing a shirt with long sleeves and carrying a bottle.": {
        "file": "c6227dcc8ee125f078ab.mp3",
        "bank": "en-oo1",
        "durationMs": 5163
    },
    "The bed checking into the hotel is wearing a shirt with long sleeves and carrying a shoe.": {
        "file": "7858f192a825f1c17439.mp3",
        "bank": "en-oo1",
        "durationMs": 4971
    },
    "The bed checking into the hotel is wearing a shirt with short sleeves and carrying a bottle.": {
        "file": "365e7b0b7b73441412c2.mp3",
        "bank": "en-oo1",
        "durationMs": 5077
    },
    "The bed checking into the hotel is wearing a shirt with short sleeves and carrying a shoe.": {
        "file": "2f5ee62a2e14dd966e30.mp3",
        "bank": "en-oo1",
        "durationMs": 4971
    },
    "The suitcase traveling without its owner keeps a box on its head.": {
        "file": "7ca57a27d8f7d473898b.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The suitcase traveling without its owner keeps a box under its arm.": {
        "file": "812f98b5fef3010d6c9e.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The suitcase traveling without its owner keeps a glass on its head.": {
        "file": "1b856116cc4515fa6afe.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The suitcase traveling without its owner keeps a glass under its arm.": {
        "file": "562a90440d448af69a3e.mp3",
        "bank": "en-oo1",
        "durationMs": 3861
    },
    "The suitcase traveling without its owner keeps a gift on its head.": {
        "file": "232aa9d11e7441444c9c.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The suitcase traveling without its owner keeps a gift under its arm.": {
        "file": "779781c36a45f40baeba.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The suitcase traveling without its owner keeps a picture on its head.": {
        "file": "39070d3cbe46848858c4.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The suitcase traveling without its owner keeps a picture under its arm.": {
        "file": "b9aed7ee3b133e80ec5f.mp3",
        "bank": "en-oo1",
        "durationMs": 3947
    },
    "The suitcase traveling without its owner keeps a computer on its head.": {
        "file": "ae49c8db468c1592d274.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "The suitcase traveling without its owner keeps a computer under its arm.": {
        "file": "224935b49bad978ac464.mp3",
        "bank": "en-oo1",
        "durationMs": 4075
    },
    "The suitcase traveling without its owner keeps a dog on its head.": {
        "file": "674f37d49b55c036ca07.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The suitcase traveling without its owner keeps a dog under its arm.": {
        "file": "b3e1510bcb790c63f15f.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "The suitcase traveling without its owner keeps a coin on its head.": {
        "file": "be97d86c7fbe76d5552c.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The suitcase traveling without its owner keeps a coin under its arm.": {
        "file": "f306d147e8ab67dd4e02.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "The suitcase traveling without its owner keeps a flower on its head.": {
        "file": "0c2860cb64c53ecd8749.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The suitcase traveling without its owner keeps a flower under its arm.": {
        "file": "713e92eb3687fa82a582.mp3",
        "bank": "en-oo1",
        "durationMs": 3947
    },
    "The suitcase traveling without its owner keeps a bag on its head.": {
        "file": "35d93946e5cfea53ce44.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The suitcase traveling without its owner keeps a bag under its arm.": {
        "file": "f5865c80745cd9d18cd6.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The suitcase traveling without its owner keeps a shoe on its head.": {
        "file": "6b45ca3c14d1deb98f64.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The suitcase traveling without its owner keeps a shoe under its arm.": {
        "file": "364b8ca8a3fc5726f87f.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "Outside the hotel, the mountain is looking at two fish.": {
        "file": "309928649fd2f2eae545.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "Outside the hotel, the mountain is looking at two boxes.": {
        "file": "7a3ec47fb5b2c27ea233.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "Outside the hotel, the mountain is looking at three fish.": {
        "file": "d776975b56c31b57c6a6.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "Outside the hotel, the mountain is looking at three boxes.": {
        "file": "ff709501382ccf344319.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "Outside the hotel, the mountain is looking at two gifts.": {
        "file": "865e2f1d2fa89318451e.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "Outside the hotel, the mountain is looking at two computers.": {
        "file": "486d5555c98ea718fd68.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "Outside the hotel, the mountain is looking at four gifts.": {
        "file": "9cd52f96332a417e080b.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "Outside the hotel, the mountain is looking at four computers.": {
        "file": "fd22ba97d5e3ba2c2b4d.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "Outside the hotel, the mountain is looking at two tickets.": {
        "file": "aa4ebc4489cd2ed80669.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "Outside the hotel, the mountain is looking at two shoes.": {
        "file": "8bdfa335bf9d1ef8578f.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "Outside the hotel, the mountain is looking at three tickets.": {
        "file": "c4a43df1076f3d9dc4db.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "Outside the hotel, the mountain is looking at three shoes.": {
        "file": "4d4930574ef62921eb8f.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "Outside the hotel, the mountain is looking at two books.": {
        "file": "6d77d2c6be9c529e69c3.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "Outside the hotel, the mountain is looking at two glasses.": {
        "file": "fb2e92f28dbebecce639.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "Outside the hotel, the mountain is looking at four books.": {
        "file": "90dabf90f4f83ead4930.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "Outside the hotel, the mountain is looking at four glasses.": {
        "file": "e8f7344152a2ec9115f3.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "Outside the hotel, the mountain is looking at two dogs.": {
        "file": "e1027488b4f39d38c842.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "Outside the hotel, the mountain is looking at two hats.": {
        "file": "d8129612909e8c2eb269.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "Outside the hotel, the mountain is looking at three dogs.": {
        "file": "134c2dd1acf71b5787a7.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "Outside the hotel, the mountain is looking at three hats.": {
        "file": "41aecd441c566746caab.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The guest at our tiny hotel receives a large fish.": {
        "file": "d0e1534c78d44ed37664.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The guest at our tiny hotel receives a large glass.": {
        "file": "d72403f80ea470b4c2cc.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The guest at our tiny hotel receives a small fish.": {
        "file": "c54f61f7c0fd2f983c29.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "The guest at our tiny hotel receives a small glass.": {
        "file": "a3cbb38b5f67444a3180.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The guest at our tiny hotel receives a large box.": {
        "file": "22f93a0228c4d703741c.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The guest at our tiny hotel receives a large cat.": {
        "file": "3c1a7e8aafd5208cadd2.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The guest at our tiny hotel receives a small box.": {
        "file": "dd13f6108d135092a6a5.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "The guest at our tiny hotel receives a small cat.": {
        "file": "70f89f8271495187ba17.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The guest at our tiny hotel receives a large ticket.": {
        "file": "96ff60ef85ee030051dd.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The guest at our tiny hotel receives a large bag.": {
        "file": "83f0922b89451ce32ea8.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The guest at our tiny hotel receives a small ticket.": {
        "file": "cc82b8bbde98c732f0e2.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The guest at our tiny hotel receives a small bag.": {
        "file": "decd5aa28dc192b8f3ea.mp3",
        "bank": "en-oo1",
        "durationMs": 3008
    },
    "The guest at our tiny hotel receives a large robot.": {
        "file": "75176b0aac70944a233b.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The guest at our tiny hotel receives a large gift.": {
        "file": "11c4cc471ba05908e76a.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The guest at our tiny hotel receives a small robot.": {
        "file": "abf0434555018dd39c25.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The guest at our tiny hotel receives a small gift.": {
        "file": "2d19e71615db57e09030.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The guest at our tiny hotel receives a large picture.": {
        "file": "702f55a803a1c0391f10.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The guest at our tiny hotel receives a large flower.": {
        "file": "62f87093c917f172faa7.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The guest at our tiny hotel receives a small picture.": {
        "file": "1f9b634dd2907d4a2b94.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The guest at our tiny hotel receives a small flower.": {
        "file": "f990c116805271f929de.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The map enjoying its holiday is holding a fish.": {
        "file": "93a771effdaca09ad180.mp3",
        "bank": "en-oo1",
        "durationMs": 2923
    },
    "The map enjoying its holiday is holding a ticket.": {
        "file": "cbfc46b1fe7bfc0c4368.mp3",
        "bank": "en-oo1",
        "durationMs": 2987
    },
    "The map enjoying its holiday is drawing a fish.": {
        "file": "82922af2605f7fe73862.mp3",
        "bank": "en-oo1",
        "durationMs": 2859
    },
    "The map enjoying its holiday is drawing a ticket.": {
        "file": "f0cb4ad8e60924f5c424.mp3",
        "bank": "en-oo1",
        "durationMs": 2944
    },
    "The map enjoying its holiday is holding a gift.": {
        "file": "387ba3e7d1c6145dd51e.mp3",
        "bank": "en-oo1",
        "durationMs": 2901
    },
    "The map enjoying its holiday is holding a dog.": {
        "file": "e2044677f0f782ced5b7.mp3",
        "bank": "en-oo1",
        "durationMs": 2859
    },
    "The map enjoying its holiday is drawing a gift.": {
        "file": "d704202f53a40b50c4a2.mp3",
        "bank": "en-oo1",
        "durationMs": 2837
    },
    "The map enjoying its holiday is drawing a dog.": {
        "file": "601b78fff83d6dd231fd.mp3",
        "bank": "en-oo1",
        "durationMs": 2859
    },
    "The map enjoying its holiday is holding a glass.": {
        "file": "44c63e9865a5f7426236.mp3",
        "bank": "en-oo1",
        "durationMs": 2987
    },
    "The map enjoying its holiday is holding a bottle.": {
        "file": "bb7484ec6e0d103b2123.mp3",
        "bank": "en-oo1",
        "durationMs": 2965
    },
    "The map enjoying its holiday is drawing a glass.": {
        "file": "e3bef77addcacfa5d986.mp3",
        "bank": "en-oo1",
        "durationMs": 2944
    },
    "The map enjoying its holiday is drawing a bottle.": {
        "file": "a7bcbec2f0a4a71d0eb7.mp3",
        "bank": "en-oo1",
        "durationMs": 2923
    },
    "The map enjoying its holiday is holding a book.": {
        "file": "f44b6ba0507aeaad9174.mp3",
        "bank": "en-oo1",
        "durationMs": 2859
    },
    "The map enjoying its holiday is holding a computer.": {
        "file": "54a37eb3c3b3000c0677.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The map enjoying its holiday is drawing a book.": {
        "file": "cfcb9dd2fc8a5a525821.mp3",
        "bank": "en-oo1",
        "durationMs": 2816
    },
    "The map enjoying its holiday is drawing a computer.": {
        "file": "73e6e97446ef864ad6c5.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The map enjoying its holiday is holding a cat.": {
        "file": "b6f42b4a7fc65086fc22.mp3",
        "bank": "en-oo1",
        "durationMs": 2880
    },
    "The map enjoying its holiday is holding an egg.": {
        "file": "3551d5a67bee23fcc27d.mp3",
        "bank": "en-oo1",
        "durationMs": 2859
    },
    "The map enjoying its holiday is drawing a cat.": {
        "file": "31ff6ae5f4f71a9551d5.mp3",
        "bank": "en-oo1",
        "durationMs": 2859
    },
    "The map enjoying its holiday is drawing an egg.": {
        "file": "96f9abc284a828a51ea3.mp3",
        "bank": "en-oo1",
        "durationMs": 2816
    },
    "The man giving a tour of his bedroom puts a book beside the bed.": {
        "file": "269460a19b29487ce36f.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The man giving a tour of his bedroom puts a book under the bed.": {
        "file": "760109a9fe6ab1a60c8b.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The man giving a tour of his bedroom puts a cup beside the bed.": {
        "file": "ebb66fc951f8c08b51e2.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The man giving a tour of his bedroom puts a cup under the bed.": {
        "file": "0ee1dfa20c25dbebe40f.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The man giving a tour of his bedroom puts a glass beside the bed.": {
        "file": "1582f98b7b306a35f2ab.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The man giving a tour of his bedroom puts a glass under the bed.": {
        "file": "9b2c63ced1de611a00cf.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The man giving a tour of his bedroom puts a fish beside the bed.": {
        "file": "71d750372c2e321513eb.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The man giving a tour of his bedroom puts a fish under the bed.": {
        "file": "3d433db3b2df95e8cff8.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The man giving a tour of his bedroom puts a ticket beside the bed.": {
        "file": "614340774539d11ea035.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "The man giving a tour of his bedroom puts a ticket under the bed.": {
        "file": "3bfe99a3875cda285daf.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The man giving a tour of his bedroom puts a picture beside the bed.": {
        "file": "d55fae89dab42da05430.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The man giving a tour of his bedroom puts a picture under the bed.": {
        "file": "bd55770c1baf5b34fd50.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The man giving a tour of his bedroom puts a bottle beside the bed.": {
        "file": "1902dd060e9f243c7ca0.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The man giving a tour of his bedroom puts a bottle under the bed.": {
        "file": "0e4ce7ac52310e6f050b.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The man giving a tour of his bedroom puts a pencil beside the bed.": {
        "file": "fe418a960c4b855fe44d.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The man giving a tour of his bedroom puts a pencil under the bed.": {
        "file": "8d6cbd304824ed382c74.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "The man giving a tour of his bedroom puts a gift beside the bed.": {
        "file": "dbcd126acee41edd2817.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The man giving a tour of his bedroom puts a gift under the bed.": {
        "file": "aec27bf847dc838f9a46.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The man giving a tour of his bedroom puts a computer beside the bed.": {
        "file": "fc9a0c672659700f4076.mp3",
        "bank": "en-oo1",
        "durationMs": 3840
    },
    "The man giving a tour of his bedroom puts a computer under the bed.": {
        "file": "420ce60c0e6e3df25b94.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "The tourists visiting a famous queue carry two glasses.": {
        "file": "b16edde393a4919e43f0.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The tourists visiting a famous queue carry two phones.": {
        "file": "44d1384e9b893f764733.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The tourists visiting a famous queue carry three glasses.": {
        "file": "c552d6e767ff33f97502.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The tourists visiting a famous queue carry three phones.": {
        "file": "e1d6cd58cf53159a7a37.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The tourists visiting a famous queue carry two clocks.": {
        "file": "8a97362581b95fe54e26.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The tourists visiting a famous queue carry two books.": {
        "file": "3743f7a630820465d6d4.mp3",
        "bank": "en-oo1",
        "durationMs": 3072
    },
    "The tourists visiting a famous queue carry four clocks.": {
        "file": "3c8f9f950c4f508dbe5a.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The tourists visiting a famous queue carry four books.": {
        "file": "8ffe6c73083aa37dd077.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The tourists visiting a famous queue carry two robots.": {
        "file": "7540b8beed876bfed573.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The tourists visiting a famous queue carry two fish.": {
        "file": "3e314c96d544e8f76baa.mp3",
        "bank": "en-oo1",
        "durationMs": 3051
    },
    "The tourists visiting a famous queue carry three robots.": {
        "file": "88e085bbe7b9a34ee721.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The tourists visiting a famous queue carry three fish.": {
        "file": "ee674b20ec878c3d7d75.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "The tourists visiting a famous queue carry two pictures.": {
        "file": "c3d47f2c307a7c249eed.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The tourists visiting a famous queue carry two gifts.": {
        "file": "ca54124f406fd8cca699.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The tourists visiting a famous queue carry four pictures.": {
        "file": "99103ffbd2d923839df6.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The tourists visiting a famous queue carry four gifts.": {
        "file": "d91582393da13a5259b2.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The tourists visiting a famous queue carry two hats.": {
        "file": "bac485a509b6da08a0f7.mp3",
        "bank": "en-oo1",
        "durationMs": 3051
    },
    "The tourists visiting a famous queue carry two dogs.": {
        "file": "23d3f7baafc79b962661.mp3",
        "bank": "en-oo1",
        "durationMs": 3072
    },
    "The tourists visiting a famous queue carry three hats.": {
        "file": "eb9111235575aba772a7.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The tourists visiting a famous queue carry three dogs.": {
        "file": "9acba3b21094674fcb80.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The sand taking a swimming lesson leaves a box beside the water.": {
        "file": "1b39fb407d15055e05ae.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "The sand taking a swimming lesson leaves a box above the water.": {
        "file": "96dbde4d50ea059ec8eb.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The sand taking a swimming lesson leaves a glass beside the water.": {
        "file": "45bede88303045b08ba0.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The sand taking a swimming lesson leaves a glass above the water.": {
        "file": "32b15327569ca7182c0d.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "The sand taking a swimming lesson leaves a cup beside the water.": {
        "file": "78bdcc66d90cd70d6193.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "The sand taking a swimming lesson leaves a cup above the water.": {
        "file": "2db828c127444ba52beb.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "The sand taking a swimming lesson leaves a bottle beside the water.": {
        "file": "d133bbe2c5b864683ffb.mp3",
        "bank": "en-oo1",
        "durationMs": 3840
    },
    "The sand taking a swimming lesson leaves a bottle above the water.": {
        "file": "56d8e7b177fb56e843f3.mp3",
        "bank": "en-oo1",
        "durationMs": 3776
    },
    "The sand taking a swimming lesson leaves a key beside the water.": {
        "file": "b5b80b918e995d42ed0d.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The sand taking a swimming lesson leaves a key above the water.": {
        "file": "f53540d43a8122ddeb04.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The sand taking a swimming lesson leaves a camera beside the water.": {
        "file": "d544548798946836d40f.mp3",
        "bank": "en-oo1",
        "durationMs": 3840
    },
    "The sand taking a swimming lesson leaves a camera above the water.": {
        "file": "df9f2175ccefaa5af87e.mp3",
        "bank": "en-oo1",
        "durationMs": 3819
    },
    "The sand taking a swimming lesson leaves a magazine beside the water.": {
        "file": "ee8b866c0676c231cfaf.mp3",
        "bank": "en-oo1",
        "durationMs": 4011
    },
    "The sand taking a swimming lesson leaves a magazine above the water.": {
        "file": "e23cde8fe21c6cd1fdef.mp3",
        "bank": "en-oo1",
        "durationMs": 3989
    },
    "The sand taking a swimming lesson leaves a bag beside the water.": {
        "file": "5e31ae2dbd4b89a4aae4.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "The sand taking a swimming lesson leaves a bag above the water.": {
        "file": "1656dcf47eb9fa304c45.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "The sand taking a swimming lesson leaves a gift beside the water.": {
        "file": "dbdbbd2276620e5b90ae.mp3",
        "bank": "en-oo1",
        "durationMs": 3776
    },
    "The sand taking a swimming lesson leaves a gift above the water.": {
        "file": "f3cc4e0e9316603bdc0f.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The sand taking a swimming lesson leaves a book beside the water.": {
        "file": "8dc175d06d8de4cb4ae6.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The sand taking a swimming lesson leaves a book above the water.": {
        "file": "f9ed7dc39d1f92490d2f.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The gift taking holiday pictures is wearing a large hat and holding a glass.": {
        "file": "848e8f14419faac1d882.mp3",
        "bank": "en-oo1",
        "durationMs": 4885
    },
    "The gift taking holiday pictures is wearing a large hat and holding a ticket.": {
        "file": "f1d9a74b425a75f746e2.mp3",
        "bank": "en-oo1",
        "durationMs": 4907
    },
    "The gift taking holiday pictures is wearing a small hat and holding a glass.": {
        "file": "9bd6aa179867b57a8501.mp3",
        "bank": "en-oo1",
        "durationMs": 4779
    },
    "The gift taking holiday pictures is wearing a small hat and holding a ticket.": {
        "file": "9a604ab5b2dbd2214998.mp3",
        "bank": "en-oo1",
        "durationMs": 4715
    },
    "The gift taking holiday pictures is wearing a long scarf and holding a key.": {
        "file": "f23157ba55afe29c3120.mp3",
        "bank": "en-oo1",
        "durationMs": 4757
    },
    "The gift taking holiday pictures is wearing a long scarf and holding a gift.": {
        "file": "ce1685af02e4fa78b6d6.mp3",
        "bank": "en-oo1",
        "durationMs": 4779
    },
    "The gift taking holiday pictures is wearing a short scarf and holding a key.": {
        "file": "1ca76b3c94f562708916.mp3",
        "bank": "en-oo1",
        "durationMs": 4779
    },
    "The gift taking holiday pictures is wearing a short scarf and holding a gift.": {
        "file": "47926031ab2c889a12b7.mp3",
        "bank": "en-oo1",
        "durationMs": 4843
    },
    "The gift taking holiday pictures is wearing round glasses and holding a box.": {
        "file": "de3e33a1dc37441fafb3.mp3",
        "bank": "en-oo1",
        "durationMs": 4821
    },
    "The gift taking holiday pictures is wearing round glasses and holding a hat.": {
        "file": "f74b765199eaaf267f81.mp3",
        "bank": "en-oo1",
        "durationMs": 4672
    },
    "The gift taking holiday pictures is wearing square glasses and holding a box.": {
        "file": "08b92c633e214cbeb99e.mp3",
        "bank": "en-oo1",
        "durationMs": 4907
    },
    "The gift taking holiday pictures is wearing square glasses and holding a hat.": {
        "file": "c8d985cc300abe2748f7.mp3",
        "bank": "en-oo1",
        "durationMs": 4736
    },
    "The gift taking holiday pictures is wearing a jacket with two pockets and holding a bottle.": {
        "file": "21f455f17fd2fdc89226.mp3",
        "bank": "en-oo1",
        "durationMs": 5653
    },
    "The gift taking holiday pictures is wearing a jacket with two pockets and holding a shoe.": {
        "file": "e90575ae29983ae45a85.mp3",
        "bank": "en-oo1",
        "durationMs": 5461
    },
    "The gift taking holiday pictures is wearing a jacket with four pockets and holding a bottle.": {
        "file": "793df5280d9344e0235d.mp3",
        "bank": "en-oo1",
        "durationMs": 5717
    },
    "The gift taking holiday pictures is wearing a jacket with four pockets and holding a shoe.": {
        "file": "3fbc6adae7c19daba3c8.mp3",
        "bank": "en-oo1",
        "durationMs": 5568
    },
    "The gift taking holiday pictures is wearing a shirt with long sleeves and holding a computer.": {
        "file": "d92460fbde73b2ddeac8.mp3",
        "bank": "en-oo1",
        "durationMs": 5696
    },
    "The gift taking holiday pictures is wearing a shirt with long sleeves and holding a fish.": {
        "file": "fc50cce3417464fd4e9a.mp3",
        "bank": "en-oo1",
        "durationMs": 5483
    },
    "The gift taking holiday pictures is wearing a shirt with short sleeves and holding a computer.": {
        "file": "dfc19c996d6eb00fa883.mp3",
        "bank": "en-oo1",
        "durationMs": 5632
    },
    "The gift taking holiday pictures is wearing a shirt with short sleeves and holding a fish.": {
        "file": "b41cc6bfa0c95654e064.mp3",
        "bank": "en-oo1",
        "durationMs": 5440
    },
    "The hotel room following its guest has two boxes by its door.": {
        "file": "46e211265313c9c28195.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The hotel room following its guest has two computers by its door.": {
        "file": "6f81678c2dbd58e9a9f5.mp3",
        "bank": "en-oo1",
        "durationMs": 3861
    },
    "The hotel room following its guest has three boxes by its door.": {
        "file": "26431dcdfdc54d9b58f1.mp3",
        "bank": "en-oo1",
        "durationMs": 3840
    },
    "The hotel room following its guest has three computers by its door.": {
        "file": "cbd4f85ff82bcbed3ef2.mp3",
        "bank": "en-oo1",
        "durationMs": 3883
    },
    "The hotel room following its guest has two dogs by its door.": {
        "file": "87e3b2477139e2a12fbc.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The hotel room following its guest has two gifts by its door.": {
        "file": "6a40d258a31a976ab44f.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The hotel room following its guest has four dogs by its door.": {
        "file": "a5af42fd9f92609e1f20.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The hotel room following its guest has four gifts by its door.": {
        "file": "59f5854006a7049dd45f.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The hotel room following its guest has two shoes by its door.": {
        "file": "6024e7d2f5220dc79289.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The hotel room following its guest has two glasses by its door.": {
        "file": "519c94ddcbd0257ecf20.mp3",
        "bank": "en-oo1",
        "durationMs": 3776
    },
    "The hotel room following its guest has three shoes by its door.": {
        "file": "63fc4e9e7dca96932f1e.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The hotel room following its guest has three glasses by its door.": {
        "file": "b289c18200b060e451b4.mp3",
        "bank": "en-oo1",
        "durationMs": 3819
    },
    "The hotel room following its guest has two cups by its door.": {
        "file": "e21514354836ab4c3134.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The hotel room following its guest has two fish by its door.": {
        "file": "79e9f0a4658063abd47c.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The hotel room following its guest has four cups by its door.": {
        "file": "15887492ed968ec7541a.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The hotel room following its guest has four fish by its door.": {
        "file": "9bd3cb8467acd76acee1.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The hotel room following its guest has two phones by its door.": {
        "file": "7c3321e84e0df5286eb2.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The hotel room following its guest has two tickets by its door.": {
        "file": "a150a881b5d787d199c9.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "The hotel room following its guest has three phones by its door.": {
        "file": "bc1090c5701549d954f1.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "The hotel room following its guest has three tickets by its door.": {
        "file": "3ec55836c4ddec2ad10b.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The woman giving a receipt as a gift puts a fish beside the box.": {
        "file": "942739cd490bc40d8846.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "The woman giving a receipt as a gift puts a fish inside the box.": {
        "file": "b01d731e14cb096e489a.mp3",
        "bank": "en-oo1",
        "durationMs": 3925
    },
    "The woman giving a receipt as a gift puts a computer beside the box.": {
        "file": "d8aeb78ef00b46866d52.mp3",
        "bank": "en-oo1",
        "durationMs": 4032
    },
    "The woman giving a receipt as a gift puts a computer inside the box.": {
        "file": "64835c78d296e56ef237.mp3",
        "bank": "en-oo1",
        "durationMs": 4245
    },
    "The woman giving a receipt as a gift puts a gift beside the box.": {
        "file": "650481096ca38e4e4ccb.mp3",
        "bank": "en-oo1",
        "durationMs": 3947
    },
    "The woman giving a receipt as a gift puts a gift inside the box.": {
        "file": "f41c1599513ad8962c39.mp3",
        "bank": "en-oo1",
        "durationMs": 4032
    },
    "The woman giving a receipt as a gift puts a glass beside the box.": {
        "file": "88f3ff3dd86fc2400262.mp3",
        "bank": "en-oo1",
        "durationMs": 3947
    },
    "The woman giving a receipt as a gift puts a glass inside the box.": {
        "file": "f59472b2c22c138d8e5f.mp3",
        "bank": "en-oo1",
        "durationMs": 4053
    },
    "The woman giving a receipt as a gift puts a book beside the box.": {
        "file": "e64231bf1edbbcc09232.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The woman giving a receipt as a gift puts a book inside the box.": {
        "file": "5c23041e48fcaeed3852.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The woman giving a receipt as a gift puts a bag beside the box.": {
        "file": "9ad3a64edccf82ec41a7.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "The woman giving a receipt as a gift puts a bag inside the box.": {
        "file": "634c378d024fb7b20800.mp3",
        "bank": "en-oo1",
        "durationMs": 3925
    },
    "The woman giving a receipt as a gift puts a dog beside the box.": {
        "file": "009f5778338a8516b03c.mp3",
        "bank": "en-oo1",
        "durationMs": 3968
    },
    "The woman giving a receipt as a gift puts a dog inside the box.": {
        "file": "3d8317d131ca4d110146.mp3",
        "bank": "en-oo1",
        "durationMs": 3947
    },
    "The woman giving a receipt as a gift puts a coin beside the box.": {
        "file": "0cb786255c4dfd0d97fe.mp3",
        "bank": "en-oo1",
        "durationMs": 3883
    },
    "The woman giving a receipt as a gift puts a coin inside the box.": {
        "file": "8187bb601f2d911051f9.mp3",
        "bank": "en-oo1",
        "durationMs": 3989
    },
    "The woman giving a receipt as a gift puts a ticket beside the box.": {
        "file": "27a55951c0f483c856fa.mp3",
        "bank": "en-oo1",
        "durationMs": 3968
    },
    "The woman giving a receipt as a gift puts a ticket inside the box.": {
        "file": "11d031c3d37b76b978cf.mp3",
        "bank": "en-oo1",
        "durationMs": 4117
    },
    "The woman giving a receipt as a gift puts a shoe beside the box.": {
        "file": "acd291a006ce88df4acf.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The woman giving a receipt as a gift puts a shoe inside the box.": {
        "file": "e0950a8ccf7fe3256772.mp3",
        "bank": "en-oo1",
        "durationMs": 3861
    },
    "The gift box opening its own present finds two fish.": {
        "file": "4adc634a368f5003c0b7.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The gift box opening its own present finds two glasses.": {
        "file": "653e19289417f12463b9.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The gift box opening its own present finds three fish.": {
        "file": "3df4bff0e952698c4e3d.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The gift box opening its own present finds three glasses.": {
        "file": "6983c4f4e348c96a62a3.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The gift box opening its own present finds two gifts.": {
        "file": "2d086ee7fcd7b8def638.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The gift box opening its own present finds two eggs.": {
        "file": "18b82b7481c88dd2ebda.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The gift box opening its own present finds four gifts.": {
        "file": "f4a7454dc3a3d7bf5827.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The gift box opening its own present finds four eggs.": {
        "file": "e4e1c291b82e04b03b46.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The gift box opening its own present finds two tickets.": {
        "file": "df248c9b56d7bed76c42.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The gift box opening its own present finds two boxes.": {
        "file": "f4c1ad70b10525e0a02b.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The gift box opening its own present finds three tickets.": {
        "file": "e1a26140d715cbda5347.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The gift box opening its own present finds three boxes.": {
        "file": "a31c1d7b12b10e8d3483.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The gift box opening its own present finds two pictures.": {
        "file": "c59edf007c76f525fb34.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The gift box opening its own present finds two cats.": {
        "file": "6306528572c289402ab8.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The gift box opening its own present finds four pictures.": {
        "file": "0f7df9fe5add3ff6a72c.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The gift box opening its own present finds four cats.": {
        "file": "4562011dd6893e5425c5.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The gift box opening its own present finds two hats.": {
        "file": "72d15eec5a1985e6b7f7.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "The gift box opening its own present finds two books.": {
        "file": "a0401610e0c6aedf2d67.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The gift box opening its own present finds three hats.": {
        "file": "4546e2c2ae19f681ee0f.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The gift box opening its own present finds three books.": {
        "file": "bdf6408a6b2e3cd777eb.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The woman bringing a fish a present carries a large bottle.": {
        "file": "a564728a9db4000a6462.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The woman bringing a fish a present carries a large pencil.": {
        "file": "771b848ff4c5247a1de3.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The woman bringing a fish a present carries a small bottle.": {
        "file": "fabb068ed508c51251e0.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The woman bringing a fish a present carries a small pencil.": {
        "file": "47138cbbc241802c1a8b.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The woman bringing a fish a present carries a large picture.": {
        "file": "8dab412fb2b9f7b2a993.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The woman bringing a fish a present carries a large cup.": {
        "file": "05eb06f9ab9e87737ef3.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The woman bringing a fish a present carries a small picture.": {
        "file": "8d5cf54c58ed1934448a.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The woman bringing a fish a present carries a small cup.": {
        "file": "19bae05bb8e1333eec7e.mp3",
        "bank": "en-oo1",
        "durationMs": 3072
    },
    "The woman bringing a fish a present carries a large fish.": {
        "file": "0c791d89620cb95148f8.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The woman bringing a fish a present carries a large gift.": {
        "file": "a29ec1cdce72cdcba04a.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The woman bringing a fish a present carries a small fish.": {
        "file": "e6cf3f1361fab912e77e.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "The woman bringing a fish a present carries a small gift.": {
        "file": "e9d8d08d2be7c336e843.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The woman bringing a fish a present carries a large flower.": {
        "file": "6b9a685223f3d4fe06cd.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The woman bringing a fish a present carries a large glass.": {
        "file": "baeb843cae00c13986ff.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The woman bringing a fish a present carries a small flower.": {
        "file": "3cb6ea054214cbea0fc7.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The woman bringing a fish a present carries a small glass.": {
        "file": "ea78249f03a7e961fb21.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The woman bringing a fish a present carries a large egg.": {
        "file": "68add726b82d24ff1a0a.mp3",
        "bank": "en-oo1",
        "durationMs": 3051
    },
    "The woman bringing a fish a present carries a large dog.": {
        "file": "ee80a3f686f631396e7e.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The woman bringing a fish a present carries a small egg.": {
        "file": "59cff25997a19ba50f0d.mp3",
        "bank": "en-oo1",
        "durationMs": 3008
    },
    "The woman bringing a fish a present carries a small dog.": {
        "file": "85242b8e32ec19a00ea8.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "The clock receiving a birthday present is wearing a large hat and holding a hat.": {
        "file": "861181b85d2be7f2dcbf.mp3",
        "bank": "en-oo1",
        "durationMs": 4672
    },
    "The clock receiving a birthday present is wearing a large hat and holding a bottle.": {
        "file": "9d23cbfbced8c5076eae.mp3",
        "bank": "en-oo1",
        "durationMs": 4843
    },
    "The clock receiving a birthday present is wearing a small hat and holding a hat.": {
        "file": "b56c1666f80a8213623c.mp3",
        "bank": "en-oo1",
        "durationMs": 4629
    },
    "The clock receiving a birthday present is wearing a small hat and holding a bottle.": {
        "file": "6fd3874ab1b2cd977adb.mp3",
        "bank": "en-oo1",
        "durationMs": 4779
    },
    "The clock receiving a birthday present is wearing a long scarf and holding a box.": {
        "file": "839afd00455bd74e72b6.mp3",
        "bank": "en-oo1",
        "durationMs": 4821
    },
    "The clock receiving a birthday present is wearing a long scarf and holding a ticket.": {
        "file": "f63debf9462f076b4071.mp3",
        "bank": "en-oo1",
        "durationMs": 4800
    },
    "The clock receiving a birthday present is wearing a short scarf and holding a box.": {
        "file": "9df68c29cdf9e04c036c.mp3",
        "bank": "en-oo1",
        "durationMs": 4864
    },
    "The clock receiving a birthday present is wearing a short scarf and holding a ticket.": {
        "file": "8f8d57272168ce75dd94.mp3",
        "bank": "en-oo1",
        "durationMs": 4885
    },
    "The clock receiving a birthday present is wearing round glasses and holding a cup.": {
        "file": "0068c1be3ef540046089.mp3",
        "bank": "en-oo1",
        "durationMs": 4757
    },
    "The clock receiving a birthday present is wearing round glasses and holding a bag.": {
        "file": "3a50f15cbb6cf8187711.mp3",
        "bank": "en-oo1",
        "durationMs": 4800
    },
    "The clock receiving a birthday present is wearing square glasses and holding a cup.": {
        "file": "c538c3ca722d5958dae4.mp3",
        "bank": "en-oo1",
        "durationMs": 4715
    },
    "The clock receiving a birthday present is wearing square glasses and holding a bag.": {
        "file": "7f09c87aa3b503163187.mp3",
        "bank": "en-oo1",
        "durationMs": 4779
    },
    "The clock receiving a birthday present is wearing a jacket with two pockets and holding a gift.": {
        "file": "ff636b7456b887d436bb.mp3",
        "bank": "en-oo1",
        "durationMs": 5504
    },
    "The clock receiving a birthday present is wearing a jacket with two pockets and holding a glass.": {
        "file": "0f427338bd6c40a2a6d1.mp3",
        "bank": "en-oo1",
        "durationMs": 5525
    },
    "The clock receiving a birthday present is wearing a jacket with four pockets and holding a gift.": {
        "file": "19fa7d3b1a05844e6fc5.mp3",
        "bank": "en-oo1",
        "durationMs": 5632
    },
    "The clock receiving a birthday present is wearing a jacket with four pockets and holding a glass.": {
        "file": "82b72189990b0b030d4a.mp3",
        "bank": "en-oo1",
        "durationMs": 5675
    },
    "The clock receiving a birthday present is wearing a shirt with long sleeves and holding a chair.": {
        "file": "9955e3bf6edc98553988.mp3",
        "bank": "en-oo1",
        "durationMs": 5397
    },
    "The clock receiving a birthday present is wearing a shirt with long sleeves and holding a fish.": {
        "file": "225e0d3adebd05278d8c.mp3",
        "bank": "en-oo1",
        "durationMs": 5397
    },
    "The clock receiving a birthday present is wearing a shirt with short sleeves and holding a chair.": {
        "file": "96baa850fbfbee7adecf.mp3",
        "bank": "en-oo1",
        "durationMs": 5312
    },
    "The clock receiving a birthday present is wearing a shirt with short sleeves and holding a fish.": {
        "file": "9bcb62c8452482e38679.mp3",
        "bank": "en-oo1",
        "durationMs": 5312
    },
    "The man giving paper to a tree puts a key beside the tree.": {
        "file": "e6986105d8d6be92e13b.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The man giving paper to a tree puts a key under the tree.": {
        "file": "f1765118508946e55f71.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The man giving paper to a tree puts a glass beside the tree.": {
        "file": "96957ca08637fdfff006.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The man giving paper to a tree puts a glass under the tree.": {
        "file": "0bf298fe22a3c2898988.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The man giving paper to a tree puts a dog beside the tree.": {
        "file": "f67bcaed282834e5e9f6.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The man giving paper to a tree puts a dog under the tree.": {
        "file": "a49465e9e64da1c39248.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The man giving paper to a tree puts a cat beside the tree.": {
        "file": "c3ce3130a6f16ac48346.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The man giving paper to a tree puts a cat under the tree.": {
        "file": "f052d6fa8e4e20c8b646.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The man giving paper to a tree puts a gift beside the tree.": {
        "file": "e9d371c197b99f6a6f01.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The man giving paper to a tree puts a gift under the tree.": {
        "file": "b47c96eae5445857981b.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The man giving paper to a tree puts a bag beside the tree.": {
        "file": "f98726a4b051bf016667.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The man giving paper to a tree puts a bag under the tree.": {
        "file": "e599f877272dced5bf29.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The man giving paper to a tree puts a ticket beside the tree.": {
        "file": "8f1e074d5614e0b5a99f.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "The man giving paper to a tree puts a ticket under the tree.": {
        "file": "5606a7a25cb0b4c1d4e8.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The man giving paper to a tree puts a box beside the tree.": {
        "file": "3b266e8b3a8e5c9dd938.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The man giving paper to a tree puts a box under the tree.": {
        "file": "4f9610c7b45e9f18c3c9.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The man giving paper to a tree puts a bottle beside the tree.": {
        "file": "51129df649325cdad19c.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "The man giving paper to a tree puts a bottle under the tree.": {
        "file": "686a25a66b862b44f06b.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The man giving paper to a tree puts a book beside the tree.": {
        "file": "6ee02ceaf0c47f46fe52.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The man giving paper to a tree puts a book under the tree.": {
        "file": "6ae2d869b360ea64785f.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The snowman opening its present is holding a dog.": {
        "file": "b40efffa65aa49a26508.mp3",
        "bank": "en-oo1",
        "durationMs": 2965
    },
    "The snowman opening its present is holding a pencil.": {
        "file": "cd8ecec26e5d0ee96fe2.mp3",
        "bank": "en-oo1",
        "durationMs": 3072
    },
    "The snowman opening its present is drawing a dog.": {
        "file": "0b7dcf7706c10293b139.mp3",
        "bank": "en-oo1",
        "durationMs": 2901
    },
    "The snowman opening its present is drawing a pencil.": {
        "file": "6dcf1033884d1d5b9c26.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The snowman opening its present is holding a glass.": {
        "file": "e6e92eef5205ad85ec53.mp3",
        "bank": "en-oo1",
        "durationMs": 3008
    },
    "The snowman opening its present is holding a coin.": {
        "file": "456d0ca2f3a84c8c95da.mp3",
        "bank": "en-oo1",
        "durationMs": 2944
    },
    "The snowman opening its present is drawing a glass.": {
        "file": "30c60a75912ff9e3f1b7.mp3",
        "bank": "en-oo1",
        "durationMs": 2944
    },
    "The snowman opening its present is drawing a coin.": {
        "file": "9c4676b97e4eb6c1ba73.mp3",
        "bank": "en-oo1",
        "durationMs": 2859
    },
    "The snowman opening its present is holding a cup.": {
        "file": "7e1db1a19dd10cc93d72.mp3",
        "bank": "en-oo1",
        "durationMs": 2880
    },
    "The snowman opening its present is holding a fish.": {
        "file": "4ee31f06174948582f00.mp3",
        "bank": "en-oo1",
        "durationMs": 2923
    },
    "The snowman opening its present is drawing a cup.": {
        "file": "02c8c7481a29dceb16ed.mp3",
        "bank": "en-oo1",
        "durationMs": 2837
    },
    "The snowman opening its present is drawing a fish.": {
        "file": "9f2390699f19dce2f68d.mp3",
        "bank": "en-oo1",
        "durationMs": 2923
    },
    "The snowman opening its present is holding a computer.": {
        "file": "cbf3490a3b699a8be841.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The snowman opening its present is holding a bottle.": {
        "file": "ccd3407ba5693835ae55.mp3",
        "bank": "en-oo1",
        "durationMs": 3008
    },
    "The snowman opening its present is drawing a computer.": {
        "file": "c36ce81a92a92ce31e95.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The snowman opening its present is drawing a bottle.": {
        "file": "dbc23216b068046f93dc.mp3",
        "bank": "en-oo1",
        "durationMs": 3051
    },
    "The snowman opening its present is holding a clock.": {
        "file": "cef9d9d02ed60e3978e9.mp3",
        "bank": "en-oo1",
        "durationMs": 2944
    },
    "The snowman opening its present is holding a hat.": {
        "file": "9055b3730ae33fef7e4d.mp3",
        "bank": "en-oo1",
        "durationMs": 2859
    },
    "The snowman opening its present is drawing a clock.": {
        "file": "92b6c73ae35d9d16f635.mp3",
        "bank": "en-oo1",
        "durationMs": 2965
    },
    "The snowman opening its present is drawing a hat.": {
        "file": "13e083d94ae3bded6961.mp3",
        "bank": "en-oo1",
        "durationMs": 2859
    },
    "The door without a lock receives two fish for its birthday.": {
        "file": "2565aa61fd08a35ff6bb.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The door without a lock receives two glasses for its birthday.": {
        "file": "2335a6dfa4011e2da69b.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The door without a lock receives three fish for its birthday.": {
        "file": "d1fb718a39fb52f2c688.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The door without a lock receives three glasses for its birthday.": {
        "file": "2a143414ee7d8f04f6d1.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The door without a lock receives two computers for its birthday.": {
        "file": "1e8e1536123684156289.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The door without a lock receives two books for its birthday.": {
        "file": "b4db0b890b441b0d2759.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The door without a lock receives four computers for its birthday.": {
        "file": "659c4d5cf4bc5a1ecffb.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The door without a lock receives four books for its birthday.": {
        "file": "ea608c9f6dcb96d2996a.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The door without a lock receives two robots for its birthday.": {
        "file": "aa6879991ca5cdf2545d.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The door without a lock receives two gifts for its birthday.": {
        "file": "b4e6faa95d3a208f2055.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The door without a lock receives three robots for its birthday.": {
        "file": "80e1fddb28ddf31da746.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The door without a lock receives three gifts for its birthday.": {
        "file": "f1fb6b7ee6662ef433e5.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The door without a lock receives two clocks for its birthday.": {
        "file": "3dc3866e39fa2e5cae37.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The door without a lock receives two eggs for its birthday.": {
        "file": "bc5939a6de1799bbacb3.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The door without a lock receives four clocks for its birthday.": {
        "file": "b0c9f8b4a045830780ae.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The door without a lock receives four eggs for its birthday.": {
        "file": "00cc27e8c513f2a746b9.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The door without a lock receives two flowers for its birthday.": {
        "file": "325162ca29dfb47a3a23.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The door without a lock receives two hats for its birthday.": {
        "file": "750f617d266059aa4f90.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The door without a lock receives three flowers for its birthday.": {
        "file": "c29154241580cff450c2.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The door without a lock receives three hats for its birthday.": {
        "file": "f56620f39f33d0f9cb67.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The woman giving a mirror a photo keeps a box on the table.": {
        "file": "1384c8bb596f2554bf37.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The woman giving a mirror a photo keeps a box under the table.": {
        "file": "8161e921899e84cc6f78.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The woman giving a mirror a photo keeps a ticket on the table.": {
        "file": "8f1897291fcba01c5295.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The woman giving a mirror a photo keeps a ticket under the table.": {
        "file": "2f2692e562f6766ee1d9.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The woman giving a mirror a photo keeps a book on the table.": {
        "file": "b06de40ff38c475492e5.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The woman giving a mirror a photo keeps a book under the table.": {
        "file": "5952154fbc7c165c93c3.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The woman giving a mirror a photo keeps a cat on the table.": {
        "file": "6f2093bad315f6ecd4bc.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The woman giving a mirror a photo keeps a cat under the table.": {
        "file": "941f1bc003528c4473ec.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The woman giving a mirror a photo keeps a magazine on the table.": {
        "file": "9b00027f709093af547e.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The woman giving a mirror a photo keeps a magazine under the table.": {
        "file": "3c0b8df678f83e46db0f.mp3",
        "bank": "en-oo1",
        "durationMs": 3989
    },
    "The woman giving a mirror a photo keeps a fish on the table.": {
        "file": "74aee5f8c6b1513a195c.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The woman giving a mirror a photo keeps a fish under the table.": {
        "file": "bf170fc4316bc0712d11.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The woman giving a mirror a photo keeps a bag on the table.": {
        "file": "c91c5e78dae1d899cce3.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The woman giving a mirror a photo keeps a bag under the table.": {
        "file": "6d90c61a4db7ca4eac89.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The woman giving a mirror a photo keeps a bottle on the table.": {
        "file": "54675b1b9c232bd9ee43.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The woman giving a mirror a photo keeps a bottle under the table.": {
        "file": "6af677b43e96a545420b.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The woman giving a mirror a photo keeps a gift on the table.": {
        "file": "3170755dd93cc9d17bf6.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The woman giving a mirror a photo keeps a gift under the table.": {
        "file": "48038c40a75978d7f680.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The woman giving a mirror a photo keeps a clock on the table.": {
        "file": "b06db4fe01b9b9cc2cd8.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The woman giving a mirror a photo keeps a clock under the table.": {
        "file": "a8b6fe571a1a8b2a7045.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The man packing lunch for his lunch box includes a large glass.": {
        "file": "36d87a5175e194ee1f59.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The man packing lunch for his lunch box includes a large gift.": {
        "file": "d1c0b4763a454cdecf0f.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The man packing lunch for his lunch box includes a small glass.": {
        "file": "2a3b9b71aec834593904.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The man packing lunch for his lunch box includes a small gift.": {
        "file": "61b6e909f95f240b3107.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The man packing lunch for his lunch box includes a large ticket.": {
        "file": "f1156842ab344f631895.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The man packing lunch for his lunch box includes a large picture.": {
        "file": "b3e6ba8692e65a52b96a.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The man packing lunch for his lunch box includes a small ticket.": {
        "file": "9f8ddde24c34a6297e87.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The man packing lunch for his lunch box includes a small picture.": {
        "file": "79384b20ebf7aa1d0122.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The man packing lunch for his lunch box includes a large hat.": {
        "file": "29f58ac2e178a6356c95.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The man packing lunch for his lunch box includes a large pencil.": {
        "file": "61332b41277b9b18385c.mp3",
        "bank": "en-oo1",
        "durationMs": 3840
    },
    "The man packing lunch for his lunch box includes a small hat.": {
        "file": "360dc34e504316a67c67.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The man packing lunch for his lunch box includes a small pencil.": {
        "file": "e40a8a6b90df35a0da70.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The man packing lunch for his lunch box includes a large computer.": {
        "file": "5bcb183d42c055d0a8c4.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "The man packing lunch for his lunch box includes a large box.": {
        "file": "dc51ad90a44a9f4a0a2b.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The man packing lunch for his lunch box includes a small computer.": {
        "file": "7b9e06a7a916459fd16b.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "The man packing lunch for his lunch box includes a small box.": {
        "file": "a2d580c279df44719eba.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The man packing lunch for his lunch box includes a large chair.": {
        "file": "a37358f64d41065af10b.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "The man packing lunch for his lunch box includes a large shoe.": {
        "file": "cbae0590471cf1f009f6.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The man packing lunch for his lunch box includes a small chair.": {
        "file": "c3b86f13b87c357d7343.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The man packing lunch for his lunch box includes a small shoe.": {
        "file": "056826c4139a5afcd804.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The present coming back to its sender brings two phones.": {
        "file": "8973d72f32725d3f0268.mp3",
        "bank": "en-oo1",
        "durationMs": 2837
    },
    "The present coming back to its sender brings two glasses.": {
        "file": "bab698016f3ec5663562.mp3",
        "bank": "en-oo1",
        "durationMs": 2901
    },
    "The present coming back to its sender brings three phones.": {
        "file": "669631b0a0932deefea9.mp3",
        "bank": "en-oo1",
        "durationMs": 2923
    },
    "The present coming back to its sender brings three glasses.": {
        "file": "4a4cfda25f80510b48e7.mp3",
        "bank": "en-oo1",
        "durationMs": 3029
    },
    "The present coming back to its sender brings two fish.": {
        "file": "9d3a5c9e7b74cd81ad55.mp3",
        "bank": "en-oo1",
        "durationMs": 2688
    },
    "The present coming back to its sender brings two gifts.": {
        "file": "d589093008a1b02574f5.mp3",
        "bank": "en-oo1",
        "durationMs": 2773
    },
    "The present coming back to its sender brings four fish.": {
        "file": "ca64997dc34a60c7d057.mp3",
        "bank": "en-oo1",
        "durationMs": 2795
    },
    "The present coming back to its sender brings four gifts.": {
        "file": "47820986b43e36b7ae12.mp3",
        "bank": "en-oo1",
        "durationMs": 2880
    },
    "The present coming back to its sender brings two pictures.": {
        "file": "7bbb526d191c93b4d72d.mp3",
        "bank": "en-oo1",
        "durationMs": 2923
    },
    "The present coming back to its sender brings two cups.": {
        "file": "867f2e944b06a98396f9.mp3",
        "bank": "en-oo1",
        "durationMs": 2688
    },
    "The present coming back to its sender brings three pictures.": {
        "file": "9c4ccde903bc770e8f2b.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "The present coming back to its sender brings three cups.": {
        "file": "7dbd539db9c68ae00c28.mp3",
        "bank": "en-oo1",
        "durationMs": 2773
    },
    "The present coming back to its sender brings two boxes.": {
        "file": "bf965ef51fa532dfcd41.mp3",
        "bank": "en-oo1",
        "durationMs": 2901
    },
    "The present coming back to its sender brings two eggs.": {
        "file": "60928cdfea95f6776913.mp3",
        "bank": "en-oo1",
        "durationMs": 2709
    },
    "The present coming back to its sender brings four boxes.": {
        "file": "1e4fad9faa7aae129b92.mp3",
        "bank": "en-oo1",
        "durationMs": 3008
    },
    "The present coming back to its sender brings four eggs.": {
        "file": "fae3c702f6bc06097836.mp3",
        "bank": "en-oo1",
        "durationMs": 2731
    },
    "The present coming back to its sender brings two computers.": {
        "file": "8cc6e0c0ee15a6e96a34.mp3",
        "bank": "en-oo1",
        "durationMs": 3051
    },
    "The present coming back to its sender brings two robots.": {
        "file": "02e3993f730113850118.mp3",
        "bank": "en-oo1",
        "durationMs": 2901
    },
    "The present coming back to its sender brings three computers.": {
        "file": "97a9756d56639cef5968.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The present coming back to its sender brings three robots.": {
        "file": "d15bfe746abd4f063581.mp3",
        "bank": "en-oo1",
        "durationMs": 3051
    },
    "The ghost arriving for work keeps a bottle above its head.": {
        "file": "ae169e93ab3c1ac97ca1.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The ghost arriving for work keeps a bottle behind its back.": {
        "file": "2a2d1092e1f1f7649095.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The ghost arriving for work keeps a fish above its head.": {
        "file": "a6bc39eb5f7536e3e7c7.mp3",
        "bank": "en-oo1",
        "durationMs": 3008
    },
    "The ghost arriving for work keeps a fish behind its back.": {
        "file": "d3d7a5708c3d360461be.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The ghost arriving for work keeps a glass above its head.": {
        "file": "15eb03497039ba8aa2e1.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The ghost arriving for work keeps a glass behind its back.": {
        "file": "fc93ab3b2eab81a30a37.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The ghost arriving for work keeps a hat above its head.": {
        "file": "a3c96d483b465cafb0b2.mp3",
        "bank": "en-oo1",
        "durationMs": 2987
    },
    "The ghost arriving for work keeps a hat behind its back.": {
        "file": "94a756a046326383bfdb.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The ghost arriving for work keeps a ticket above its head.": {
        "file": "f090e8773b4157dbafd6.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The ghost arriving for work keeps a ticket behind its back.": {
        "file": "f2175ada52f8a989741c.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The ghost arriving for work keeps a box above its head.": {
        "file": "fa1f15ea0041fcd6e805.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The ghost arriving for work keeps a box behind its back.": {
        "file": "0ac686dd4842cea3f321.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The ghost arriving for work keeps a robot above its head.": {
        "file": "9bdb63d3288695ea9d73.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The ghost arriving for work keeps a robot behind its back.": {
        "file": "74848424f0f66141aca6.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The ghost arriving for work keeps a pencil above its head.": {
        "file": "70f152d37a500baa8ebd.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The ghost arriving for work keeps a pencil behind its back.": {
        "file": "00349906739f6acc7748.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The ghost arriving for work keeps a bag above its head.": {
        "file": "ef406e617c6d8f0cc22f.mp3",
        "bank": "en-oo1",
        "durationMs": 3029
    },
    "The ghost arriving for work keeps a bag behind its back.": {
        "file": "ec82d53b28665b03e5e2.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The ghost arriving for work keeps a cup above its head.": {
        "file": "63f466d4a0df70b93f41.mp3",
        "bank": "en-oo1",
        "durationMs": 2901
    },
    "The ghost arriving for work keeps a cup behind its back.": {
        "file": "e281a2d99c09521129d5.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "The dragon making a cold lunch is wearing a large hat and holding a phone.": {
        "file": "981a74e1426ffaa9afa5.mp3",
        "bank": "en-oo1",
        "durationMs": 4523
    },
    "The dragon making a cold lunch is wearing a large hat and holding a dog.": {
        "file": "6fa58fa23896f929a2ed.mp3",
        "bank": "en-oo1",
        "durationMs": 4480
    },
    "The dragon making a cold lunch is wearing a small hat and holding a phone.": {
        "file": "1e0f89ce596276296577.mp3",
        "bank": "en-oo1",
        "durationMs": 4459
    },
    "The dragon making a cold lunch is wearing a small hat and holding a dog.": {
        "file": "5ca523bd7579dde82188.mp3",
        "bank": "en-oo1",
        "durationMs": 4373
    },
    "The dragon making a cold lunch is wearing a long scarf and holding a gift.": {
        "file": "e1f932f382cb167560e9.mp3",
        "bank": "en-oo1",
        "durationMs": 4459
    },
    "The dragon making a cold lunch is wearing a long scarf and holding a bottle.": {
        "file": "9a8341a250635219101a.mp3",
        "bank": "en-oo1",
        "durationMs": 4587
    },
    "The dragon making a cold lunch is wearing a short scarf and holding a gift.": {
        "file": "00a30886c4f00d01f087.mp3",
        "bank": "en-oo1",
        "durationMs": 4501
    },
    "The dragon making a cold lunch is wearing a short scarf and holding a bottle.": {
        "file": "ab7f65761b22f2f45989.mp3",
        "bank": "en-oo1",
        "durationMs": 4608
    },
    "The dragon making a cold lunch is wearing round glasses and holding a bag.": {
        "file": "727e3e531908561fa83f.mp3",
        "bank": "en-oo1",
        "durationMs": 4459
    },
    "The dragon making a cold lunch is wearing round glasses and holding a hat.": {
        "file": "0032254124eaf0787a02.mp3",
        "bank": "en-oo1",
        "durationMs": 4416
    },
    "The dragon making a cold lunch is wearing square glasses and holding a bag.": {
        "file": "b40e3e29ad9ce493c99d.mp3",
        "bank": "en-oo1",
        "durationMs": 4523
    },
    "The dragon making a cold lunch is wearing square glasses and holding a hat.": {
        "file": "1e16445d6e5a51efc9dc.mp3",
        "bank": "en-oo1",
        "durationMs": 4501
    },
    "The dragon making a cold lunch is wearing a jacket with two pockets and holding a box.": {
        "file": "acf65e39fc8e9918b635.mp3",
        "bank": "en-oo1",
        "durationMs": 5248
    },
    "The dragon making a cold lunch is wearing a jacket with two pockets and holding a glass.": {
        "file": "069f48ba682b1d8ff55d.mp3",
        "bank": "en-oo1",
        "durationMs": 5269
    },
    "The dragon making a cold lunch is wearing a jacket with four pockets and holding a box.": {
        "file": "254a48d04f58a70d4785.mp3",
        "bank": "en-oo1",
        "durationMs": 5440
    },
    "The dragon making a cold lunch is wearing a jacket with four pockets and holding a glass.": {
        "file": "99489406c1731cf6513b.mp3",
        "bank": "en-oo1",
        "durationMs": 5440
    },
    "The dragon making a cold lunch is wearing a shirt with long sleeves and holding a computer.": {
        "file": "343009681aa7bac0656d.mp3",
        "bank": "en-oo1",
        "durationMs": 5333
    },
    "The dragon making a cold lunch is wearing a shirt with long sleeves and holding a flower.": {
        "file": "1d005224906741be0f8e.mp3",
        "bank": "en-oo1",
        "durationMs": 5291
    },
    "The dragon making a cold lunch is wearing a shirt with short sleeves and holding a computer.": {
        "file": "3d4622e1eccfbc46cffe.mp3",
        "bank": "en-oo1",
        "durationMs": 5269
    },
    "The dragon making a cold lunch is wearing a shirt with short sleeves and holding a flower.": {
        "file": "f8aafa827820441476e6.mp3",
        "bank": "en-oo1",
        "durationMs": 5205
    },
    "The vampire shopping for shade buys two tickets.": {
        "file": "424db15854a9fe67ec36.mp3",
        "bank": "en-oo1",
        "durationMs": 2773
    },
    "The vampire shopping for shade buys two fish.": {
        "file": "640290cc11565d9a3a65.mp3",
        "bank": "en-oo1",
        "durationMs": 2688
    },
    "The vampire shopping for shade buys three tickets.": {
        "file": "53ea4404c3bfce471d02.mp3",
        "bank": "en-oo1",
        "durationMs": 2816
    },
    "The vampire shopping for shade buys three fish.": {
        "file": "e85b3b73c33b6446b340.mp3",
        "bank": "en-oo1",
        "durationMs": 2837
    },
    "The vampire shopping for shade buys two computers.": {
        "file": "9c80cd3ab42a79bc9cb6.mp3",
        "bank": "en-oo1",
        "durationMs": 2965
    },
    "The vampire shopping for shade buys two clocks.": {
        "file": "a6ff45dcef7918f0dac3.mp3",
        "bank": "en-oo1",
        "durationMs": 2773
    },
    "The vampire shopping for shade buys four computers.": {
        "file": "8ca7605af2cf8defcf63.mp3",
        "bank": "en-oo1",
        "durationMs": 2965
    },
    "The vampire shopping for shade buys four clocks.": {
        "file": "757bc20671d9584087a8.mp3",
        "bank": "en-oo1",
        "durationMs": 2795
    },
    "The vampire shopping for shade buys two glasses.": {
        "file": "d5c6f3612c2e70aa2a5c.mp3",
        "bank": "en-oo1",
        "durationMs": 2880
    },
    "The vampire shopping for shade buys two bottles.": {
        "file": "cacae35bbc039a78167e.mp3",
        "bank": "en-oo1",
        "durationMs": 2816
    },
    "The vampire shopping for shade buys three glasses.": {
        "file": "1dbdd683887bc7a8abb2.mp3",
        "bank": "en-oo1",
        "durationMs": 2944
    },
    "The vampire shopping for shade buys three bottles.": {
        "file": "b9587dfa4c2459225e4d.mp3",
        "bank": "en-oo1",
        "durationMs": 2923
    },
    "The vampire shopping for shade buys two eggs.": {
        "file": "0791bdfb4f57dc91209d.mp3",
        "bank": "en-oo1",
        "durationMs": 2667
    },
    "The vampire shopping for shade buys two bags.": {
        "file": "7d1ff46699cc17058f74.mp3",
        "bank": "en-oo1",
        "durationMs": 2688
    },
    "The vampire shopping for shade buys four eggs.": {
        "file": "725e08d4acf7f42c881b.mp3",
        "bank": "en-oo1",
        "durationMs": 2773
    },
    "The vampire shopping for shade buys four bags.": {
        "file": "65845d621880a5fea8c0.mp3",
        "bank": "en-oo1",
        "durationMs": 2773
    },
    "The vampire shopping for shade buys two robots.": {
        "file": "ccfdb8fae4caac6049cc.mp3",
        "bank": "en-oo1",
        "durationMs": 2901
    },
    "The vampire shopping for shade buys two phones.": {
        "file": "fb3511ae054746b51bae.mp3",
        "bank": "en-oo1",
        "durationMs": 2752
    },
    "The vampire shopping for shade buys three robots.": {
        "file": "5cfa4a3257dcf5ee2441.mp3",
        "bank": "en-oo1",
        "durationMs": 3051
    },
    "The vampire shopping for shade buys three phones.": {
        "file": "0f5634978e03aeebc8e5.mp3",
        "bank": "en-oo1",
        "durationMs": 2901
    },
    "The sleepy monster getting ready for work is holding a fish.": {
        "file": "8b2c388ee3ededbad902.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The sleepy monster getting ready for work is holding a phone.": {
        "file": "43f68f00542ec5928cd7.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The sleepy monster getting ready for work is washing a fish.": {
        "file": "1dff14519f6981cac9f5.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The sleepy monster getting ready for work is washing a phone.": {
        "file": "c75e316c2433ea58b576.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The sleepy monster getting ready for work is holding an egg.": {
        "file": "6f5bfb3683d0ca43c372.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The sleepy monster getting ready for work is holding a dog.": {
        "file": "80a80971bcb7cc21752f.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The sleepy monster getting ready for work is washing an egg.": {
        "file": "98426722ae8dc5df617f.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The sleepy monster getting ready for work is washing a dog.": {
        "file": "91e1f65b4829594e893a.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The sleepy monster getting ready for work is holding a robot.": {
        "file": "75dc7da13a8bf835278d.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The sleepy monster getting ready for work is holding a bag.": {
        "file": "9a436423796354d2bf54.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The sleepy monster getting ready for work is washing a robot.": {
        "file": "4cdd55cbbb0defae48f3.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The sleepy monster getting ready for work is washing a bag.": {
        "file": "a9d6e7601b44d7bebe7b.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The sleepy monster getting ready for work is holding a box.": {
        "file": "6bf97c6024e03db5e4a8.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The sleepy monster getting ready for work is holding a glass.": {
        "file": "f3c729622d52b8cfae9f.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The sleepy monster getting ready for work is washing a box.": {
        "file": "985cc354275d1943c4af.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The sleepy monster getting ready for work is washing a glass.": {
        "file": "9d2cfc4cfc07e5062360.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The sleepy monster getting ready for work is holding a ticket.": {
        "file": "038f86b750d857df94ab.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The sleepy monster getting ready for work is holding a bottle.": {
        "file": "20db1a18cc1ea07a7e4e.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The sleepy monster getting ready for work is washing a ticket.": {
        "file": "100c89c14a6bcbc059a9.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The sleepy monster getting ready for work is washing a bottle.": {
        "file": "96b15d121943b7601bd3.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The giant trying to fit into the lift carries a large box.": {
        "file": "ef99de719993979182ef.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The giant trying to fit into the lift carries a large egg.": {
        "file": "14db3ea44490d78c7076.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The giant trying to fit into the lift carries a small box.": {
        "file": "21669ea50f50619a871d.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The giant trying to fit into the lift carries a small egg.": {
        "file": "25b89d6588ca0ad02ce0.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "The giant trying to fit into the lift carries a large bag.": {
        "file": "a49ccb5c8fdca6c52190.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The giant trying to fit into the lift carries a large glass.": {
        "file": "ff86675fab07d995d04e.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The giant trying to fit into the lift carries a small bag.": {
        "file": "3147b52a2a5cdeacbb8d.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The giant trying to fit into the lift carries a small glass.": {
        "file": "6070b0592f937bee10ef.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The giant trying to fit into the lift carries a large cat.": {
        "file": "3bfa576736bfc832570e.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The giant trying to fit into the lift carries a large shoe.": {
        "file": "323d73e4bbe8cf66e3c9.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The giant trying to fit into the lift carries a small cat.": {
        "file": "9f59da53365fddbad160.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The giant trying to fit into the lift carries a small shoe.": {
        "file": "ee67fe96fc743b4e5b32.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "The giant trying to fit into the lift carries a large book.": {
        "file": "affcb3835065db628a4e.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The giant trying to fit into the lift carries a large ticket.": {
        "file": "45e13735893a9311b55a.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The giant trying to fit into the lift carries a small book.": {
        "file": "e7c38fe2415f5ad79a84.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The giant trying to fit into the lift carries a small ticket.": {
        "file": "55ce679a63dfa3d27112.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The giant trying to fit into the lift carries a large fish.": {
        "file": "7610a82f12009e219054.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The giant trying to fit into the lift carries a large gift.": {
        "file": "499c0bdd61e535b0afa1.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The giant trying to fit into the lift carries a small fish.": {
        "file": "31a8336f78b984d1610b.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The giant trying to fit into the lift carries a small gift.": {
        "file": "40b32bffc6aa3b1b0f13.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The witch cleaning her flying broom leaves a dog beside the door.": {
        "file": "6c639fe90748d64d1c88.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The witch cleaning her flying broom leaves a dog above the door.": {
        "file": "6f43abfa3854058e842d.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The witch cleaning her flying broom leaves a flower beside the door.": {
        "file": "6b38bf19cad07b8ece97.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The witch cleaning her flying broom leaves a flower above the door.": {
        "file": "dd6254e3fb96e98211f5.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "The witch cleaning her flying broom leaves a computer beside the door.": {
        "file": "1360ef388f1982031e91.mp3",
        "bank": "en-oo1",
        "durationMs": 3861
    },
    "The witch cleaning her flying broom leaves a computer above the door.": {
        "file": "eb3af9fed06569345b88.mp3",
        "bank": "en-oo1",
        "durationMs": 3776
    },
    "The witch cleaning her flying broom leaves a gift beside the door.": {
        "file": "d669327e19db33ea03b8.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The witch cleaning her flying broom leaves a gift above the door.": {
        "file": "6f2c77c6e6c08324edb9.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The witch cleaning her flying broom leaves a book beside the door.": {
        "file": "650e94e8d0c45bb69382.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The witch cleaning her flying broom leaves a book above the door.": {
        "file": "67f4a590d38d8feb8439.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The witch cleaning her flying broom leaves a bottle beside the door.": {
        "file": "3308b1b081b5b92068a1.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The witch cleaning her flying broom leaves a bottle above the door.": {
        "file": "7726b81313557f68b6d6.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The witch cleaning her flying broom leaves a ticket beside the door.": {
        "file": "da555a0793e43743227b.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The witch cleaning her flying broom leaves a ticket above the door.": {
        "file": "cfe171adbd9475d88d7f.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The witch cleaning her flying broom leaves an egg beside the door.": {
        "file": "884d30d0562a60e2ce6a.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The witch cleaning her flying broom leaves an egg above the door.": {
        "file": "cd608d6b469797a13945.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The witch cleaning her flying broom leaves a cup beside the door.": {
        "file": "770643966ce528391b29.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The witch cleaning her flying broom leaves a cup above the door.": {
        "file": "ae5dd000b3b04c931ac4.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The witch cleaning her flying broom leaves a box beside the door.": {
        "file": "175d286b112e5b2277a8.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "The witch cleaning her flying broom leaves a box above the door.": {
        "file": "ff037ec4537828c73046.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The shadow taking a holiday packs two boxes.": {
        "file": "99923c3cd443587b86f2.mp3",
        "bank": "en-oo1",
        "durationMs": 2795
    },
    "The shadow taking a holiday packs two cats.": {
        "file": "638a3ce61711953d8522.mp3",
        "bank": "en-oo1",
        "durationMs": 2517
    },
    "The shadow taking a holiday packs three boxes.": {
        "file": "04ea002f6aa48d0d4a2d.mp3",
        "bank": "en-oo1",
        "durationMs": 2837
    },
    "The shadow taking a holiday packs three cats.": {
        "file": "a387ada76e54ff59c73a.mp3",
        "bank": "en-oo1",
        "durationMs": 2667
    },
    "The shadow taking a holiday packs two cups.": {
        "file": "d6f2a91d3e1598c0c8b6.mp3",
        "bank": "en-oo1",
        "durationMs": 2453
    },
    "The shadow taking a holiday packs two computers.": {
        "file": "92e067b95e13a9eb49b9.mp3",
        "bank": "en-oo1",
        "durationMs": 2901
    },
    "The shadow taking a holiday packs four cups.": {
        "file": "de21cfbc9881ca578c42.mp3",
        "bank": "en-oo1",
        "durationMs": 2645
    },
    "The shadow taking a holiday packs four computers.": {
        "file": "2a0e788f4408887f7564.mp3",
        "bank": "en-oo1",
        "durationMs": 2901
    },
    "The shadow taking a holiday packs two gifts.": {
        "file": "3d6a37b890d2c293f290.mp3",
        "bank": "en-oo1",
        "durationMs": 2603
    },
    "The shadow taking a holiday packs two glasses.": {
        "file": "3dda5b2000181bee605a.mp3",
        "bank": "en-oo1",
        "durationMs": 2795
    },
    "The shadow taking a holiday packs three gifts.": {
        "file": "29bf1ad8f0ff831b14ad.mp3",
        "bank": "en-oo1",
        "durationMs": 2709
    },
    "The shadow taking a holiday packs three glasses.": {
        "file": "15ce23822de792364bea.mp3",
        "bank": "en-oo1",
        "durationMs": 2859
    },
    "The shadow taking a holiday packs two phones.": {
        "file": "280e198f571cd9338690.mp3",
        "bank": "en-oo1",
        "durationMs": 2603
    },
    "The shadow taking a holiday packs two shoes.": {
        "file": "a16b7e7e06fa0dc7b0e6.mp3",
        "bank": "en-oo1",
        "durationMs": 2496
    },
    "The shadow taking a holiday packs four phones.": {
        "file": "723862959196a9dc20b3.mp3",
        "bank": "en-oo1",
        "durationMs": 2752
    },
    "The shadow taking a holiday packs four shoes.": {
        "file": "2c0cce8424699b8788fb.mp3",
        "bank": "en-oo1",
        "durationMs": 2560
    },
    "The shadow taking a holiday packs two tickets.": {
        "file": "83f45ae9be70b3161bda.mp3",
        "bank": "en-oo1",
        "durationMs": 2645
    },
    "The shadow taking a holiday packs two dogs.": {
        "file": "7f97fb3d902a9dee2116.mp3",
        "bank": "en-oo1",
        "durationMs": 2560
    },
    "The shadow taking a holiday packs three tickets.": {
        "file": "6797a15bfa5c576b8afa.mp3",
        "bank": "en-oo1",
        "durationMs": 2731
    },
    "The shadow taking a holiday packs three dogs.": {
        "file": "63a7e06a297cad81aa4b.mp3",
        "bank": "en-oo1",
        "durationMs": 2667
    },
    "The monster delivering mail to the castle holds a hat above its head.": {
        "file": "2e025dfd97948ad001cb.mp3",
        "bank": "en-oo1",
        "durationMs": 3989
    },
    "The monster delivering mail to the castle holds a hat behind its back.": {
        "file": "5b045446176dfe2de7bd.mp3",
        "bank": "en-oo1",
        "durationMs": 4096
    },
    "The monster delivering mail to the castle holds a glass above its head.": {
        "file": "505f8eaaf73ae8e77977.mp3",
        "bank": "en-oo1",
        "durationMs": 4075
    },
    "The monster delivering mail to the castle holds a glass behind its back.": {
        "file": "bde24d3b154b162c8ea4.mp3",
        "bank": "en-oo1",
        "durationMs": 4181
    },
    "The monster delivering mail to the castle holds a newspaper above its head.": {
        "file": "a1891dd31f2eca3f8a64.mp3",
        "bank": "en-oo1",
        "durationMs": 4373
    },
    "The monster delivering mail to the castle holds a newspaper behind its back.": {
        "file": "4a9b48eac7dba1ad5467.mp3",
        "bank": "en-oo1",
        "durationMs": 4480
    },
    "The monster delivering mail to the castle holds a dog above its head.": {
        "file": "46602aff017d5010b5e2.mp3",
        "bank": "en-oo1",
        "durationMs": 4053
    },
    "The monster delivering mail to the castle holds a dog behind its back.": {
        "file": "1c221287e049fda24c54.mp3",
        "bank": "en-oo1",
        "durationMs": 4224
    },
    "The monster delivering mail to the castle holds a fish above its head.": {
        "file": "6804421adeb8b1175150.mp3",
        "bank": "en-oo1",
        "durationMs": 4053
    },
    "The monster delivering mail to the castle holds a fish behind its back.": {
        "file": "74a29210f77704bbb53d.mp3",
        "bank": "en-oo1",
        "durationMs": 4160
    },
    "The monster delivering mail to the castle holds a bag above its head.": {
        "file": "00a5fb3ac5e7d81eb709.mp3",
        "bank": "en-oo1",
        "durationMs": 4011
    },
    "The monster delivering mail to the castle holds a bag behind its back.": {
        "file": "bdf17a56cc3c6c2f419f.mp3",
        "bank": "en-oo1",
        "durationMs": 4181
    },
    "The monster delivering mail to the castle holds an apple above its head.": {
        "file": "36ddb1e789b8083a5701.mp3",
        "bank": "en-oo1",
        "durationMs": 4139
    },
    "The monster delivering mail to the castle holds an apple behind its back.": {
        "file": "a522a0131231a6ee2864.mp3",
        "bank": "en-oo1",
        "durationMs": 4245
    },
    "The monster delivering mail to the castle holds a book above its head.": {
        "file": "579ec457edbffe1999f4.mp3",
        "bank": "en-oo1",
        "durationMs": 3989
    },
    "The monster delivering mail to the castle holds a book behind its back.": {
        "file": "814b430f91636daa414e.mp3",
        "bank": "en-oo1",
        "durationMs": 4117
    },
    "The monster delivering mail to the castle holds a ticket above its head.": {
        "file": "3472752ba9419b123aee.mp3",
        "bank": "en-oo1",
        "durationMs": 4075
    },
    "The monster delivering mail to the castle holds a ticket behind its back.": {
        "file": "ed741559dd35b21f87dd.mp3",
        "bank": "en-oo1",
        "durationMs": 4267
    },
    "The monster delivering mail to the castle holds a box above its head.": {
        "file": "f66a84b3b334cd34e3f4.mp3",
        "bank": "en-oo1",
        "durationMs": 4053
    },
    "The monster delivering mail to the castle holds a box behind its back.": {
        "file": "df36e677c4e201823901.mp3",
        "bank": "en-oo1",
        "durationMs": 4139
    },
    "The mummy waiting for its laundry is wearing a large hat and holding a dog.": {
        "file": "b61a4fb0533ba9bfc43d.mp3",
        "bank": "en-oo1",
        "durationMs": 4480
    },
    "The mummy waiting for its laundry is wearing a large hat and holding a box.": {
        "file": "eaea8398d4e80fcd0c7a.mp3",
        "bank": "en-oo1",
        "durationMs": 4544
    },
    "The mummy waiting for its laundry is wearing a small hat and holding a dog.": {
        "file": "0d35634004b46081f6ac.mp3",
        "bank": "en-oo1",
        "durationMs": 4352
    },
    "The mummy waiting for its laundry is wearing a small hat and holding a box.": {
        "file": "3c0ee56a0469f12863aa.mp3",
        "bank": "en-oo1",
        "durationMs": 4459
    },
    "The mummy waiting for its laundry is wearing a long scarf and holding a glass.": {
        "file": "ba4c960148c487bd4946.mp3",
        "bank": "en-oo1",
        "durationMs": 4608
    },
    "The mummy waiting for its laundry is wearing a long scarf and holding a bag.": {
        "file": "2c3f2b88939171e8986f.mp3",
        "bank": "en-oo1",
        "durationMs": 4501
    },
    "The mummy waiting for its laundry is wearing a short scarf and holding a glass.": {
        "file": "ccb7aee984fbf0e7fb6c.mp3",
        "bank": "en-oo1",
        "durationMs": 4608
    },
    "The mummy waiting for its laundry is wearing a short scarf and holding a bag.": {
        "file": "3d082287d54fc8d59db9.mp3",
        "bank": "en-oo1",
        "durationMs": 4501
    },
    "The mummy waiting for its laundry is wearing round glasses and holding a gift.": {
        "file": "3d6394332f51d00eb848.mp3",
        "bank": "en-oo1",
        "durationMs": 4480
    },
    "The mummy waiting for its laundry is wearing round glasses and holding a ticket.": {
        "file": "bd440012a695b32c9488.mp3",
        "bank": "en-oo1",
        "durationMs": 4565
    },
    "The mummy waiting for its laundry is wearing square glasses and holding a gift.": {
        "file": "1bb24242ee95f5f0bdfb.mp3",
        "bank": "en-oo1",
        "durationMs": 4523
    },
    "The mummy waiting for its laundry is wearing square glasses and holding a ticket.": {
        "file": "957cc947062b50cc21b7.mp3",
        "bank": "en-oo1",
        "durationMs": 4565
    },
    "The mummy waiting for its laundry is wearing a jacket with two pockets and holding a bottle.": {
        "file": "a3b6cc5f9c1d3e4f7ee0.mp3",
        "bank": "en-oo1",
        "durationMs": 5333
    },
    "The mummy waiting for its laundry is wearing a jacket with two pockets and holding a fish.": {
        "file": "a9325d5031546005cb60.mp3",
        "bank": "en-oo1",
        "durationMs": 5291
    },
    "The mummy waiting for its laundry is wearing a jacket with four pockets and holding a bottle.": {
        "file": "40d7a355b194799c1de2.mp3",
        "bank": "en-oo1",
        "durationMs": 5397
    },
    "The mummy waiting for its laundry is wearing a jacket with four pockets and holding a fish.": {
        "file": "a8e563a93cfd20f850c5.mp3",
        "bank": "en-oo1",
        "durationMs": 5376
    },
    "The mummy waiting for its laundry is wearing a shirt with long sleeves and holding a computer.": {
        "file": "3c597e0b7b2ef1d74b58.mp3",
        "bank": "en-oo1",
        "durationMs": 5376
    },
    "The mummy waiting for its laundry is wearing a shirt with long sleeves and holding a newspaper.": {
        "file": "7d7133c9c17a8d3605e4.mp3",
        "bank": "en-oo1",
        "durationMs": 5525
    },
    "The mummy waiting for its laundry is wearing a shirt with short sleeves and holding a computer.": {
        "file": "c82eb93f1a29e9a4c21d.mp3",
        "bank": "en-oo1",
        "durationMs": 5291
    },
    "The mummy waiting for its laundry is wearing a shirt with short sleeves and holding a newspaper.": {
        "file": "edbb1c3268e9d4e67d68.mp3",
        "bank": "en-oo1",
        "durationMs": 5461
    },
    "The bat's job interview has two gifts hanging above the desk.": {
        "file": "64d1dec457613e32f04e.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The bat's job interview has two fish hanging above the desk.": {
        "file": "3cb01aaa3dfbd8f4d9f9.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The bat's job interview has three gifts hanging above the desk.": {
        "file": "607ed9f4d6c98d3a3131.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The bat's job interview has three fish hanging above the desk.": {
        "file": "a2e3242e34bed3e2840f.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The bat's job interview has two boxes hanging above the desk.": {
        "file": "afe000371b50880ad13e.mp3",
        "bank": "en-oo1",
        "durationMs": 3776
    },
    "The bat's job interview has two bottles hanging above the desk.": {
        "file": "0aab536707abf31c3cb2.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The bat's job interview has four boxes hanging above the desk.": {
        "file": "52b9115f56aa390492fb.mp3",
        "bank": "en-oo1",
        "durationMs": 3819
    },
    "The bat's job interview has four bottles hanging above the desk.": {
        "file": "bdc6b0ad24a6e7780997.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "The bat's job interview has two computers hanging above the desk.": {
        "file": "bee27b07a86f40062f45.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "The bat's job interview has two cups hanging above the desk.": {
        "file": "db9b1435dbdf42df0023.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The bat's job interview has three computers hanging above the desk.": {
        "file": "2094cdf0ae6309ca2825.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The bat's job interview has three cups hanging above the desk.": {
        "file": "4e255799be861f1b880c.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The bat's job interview has two chairs hanging above the desk.": {
        "file": "80dcf9172565d22ae0ec.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The bat's job interview has two phones hanging above the desk.": {
        "file": "f0a9fa58639c9edec043.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The bat's job interview has four chairs hanging above the desk.": {
        "file": "57012afccbea112e3acf.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "The bat's job interview has four phones hanging above the desk.": {
        "file": "221f28129002eee40e24.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "The bat's job interview has two glasses hanging above the desk.": {
        "file": "462dad4f625b9e5afa62.mp3",
        "bank": "en-oo1",
        "durationMs": 3819
    },
    "The bat's job interview has two tickets hanging above the desk.": {
        "file": "522fbe79527ec3872f6a.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The bat's job interview has three glasses hanging above the desk.": {
        "file": "4697459a0d8f0264061f.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "The bat's job interview has three tickets hanging above the desk.": {
        "file": "88270419bcaf2296c5d8.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "The rain cloud shopping for shade is wearing a large hat and holding a glass.": {
        "file": "3ed9e3f1d3c693452805.mp3",
        "bank": "en-oo1",
        "durationMs": 4736
    },
    "The rain cloud shopping for shade is wearing a large hat and holding a computer.": {
        "file": "bab8e430fcd6b1ebbd95.mp3",
        "bank": "en-oo1",
        "durationMs": 4843
    },
    "The rain cloud shopping for shade is wearing a small hat and holding a glass.": {
        "file": "d4874851ed06e7b28344.mp3",
        "bank": "en-oo1",
        "durationMs": 4651
    },
    "The rain cloud shopping for shade is wearing a small hat and holding a computer.": {
        "file": "2782c4414cd6f1d44851.mp3",
        "bank": "en-oo1",
        "durationMs": 4736
    },
    "The rain cloud shopping for shade is wearing a long scarf and holding a bag.": {
        "file": "16926874f4d7a2c56010.mp3",
        "bank": "en-oo1",
        "durationMs": 4651
    },
    "The rain cloud shopping for shade is wearing a long scarf and holding a pencil.": {
        "file": "6177651dc50ae4de5057.mp3",
        "bank": "en-oo1",
        "durationMs": 4821
    },
    "The rain cloud shopping for shade is wearing a short scarf and holding a bag.": {
        "file": "86e7c55efd3b94739b58.mp3",
        "bank": "en-oo1",
        "durationMs": 4672
    },
    "The rain cloud shopping for shade is wearing a short scarf and holding a pencil.": {
        "file": "48a7760396827a109d12.mp3",
        "bank": "en-oo1",
        "durationMs": 4821
    },
    "The rain cloud shopping for shade is wearing round glasses and holding a fish.": {
        "file": "07ac1f8abd24242d8559.mp3",
        "bank": "en-oo1",
        "durationMs": 4651
    },
    "The rain cloud shopping for shade is wearing round glasses and holding a phone.": {
        "file": "c88b8163bd109822a7df.mp3",
        "bank": "en-oo1",
        "durationMs": 4651
    },
    "The rain cloud shopping for shade is wearing square glasses and holding a fish.": {
        "file": "9551932375b2ba7a7902.mp3",
        "bank": "en-oo1",
        "durationMs": 4715
    },
    "The rain cloud shopping for shade is wearing square glasses and holding a phone.": {
        "file": "d91cedaa4449af118bc6.mp3",
        "bank": "en-oo1",
        "durationMs": 4779
    },
    "The rain cloud shopping for shade is wearing a jacket with two pockets and holding a dog.": {
        "file": "89b1cb15ffa816bb5fdf.mp3",
        "bank": "en-oo1",
        "durationMs": 5461
    },
    "The rain cloud shopping for shade is wearing a jacket with two pockets and holding a key.": {
        "file": "b8b2dde1b6e3a7f9ae3b.mp3",
        "bank": "en-oo1",
        "durationMs": 5397
    },
    "The rain cloud shopping for shade is wearing a jacket with four pockets and holding a dog.": {
        "file": "b8418a84a73c602e465e.mp3",
        "bank": "en-oo1",
        "durationMs": 5611
    },
    "The rain cloud shopping for shade is wearing a jacket with four pockets and holding a key.": {
        "file": "8fff2d78b1c8a1b46d9f.mp3",
        "bank": "en-oo1",
        "durationMs": 5568
    },
    "The rain cloud shopping for shade is wearing a shirt with long sleeves and holding a gift.": {
        "file": "7c7f659a4ab7e7d8728d.mp3",
        "bank": "en-oo1",
        "durationMs": 5397
    },
    "The rain cloud shopping for shade is wearing a shirt with long sleeves and holding a ticket.": {
        "file": "3350e616cf4bc7c113b7.mp3",
        "bank": "en-oo1",
        "durationMs": 5419
    },
    "The rain cloud shopping for shade is wearing a shirt with short sleeves and holding a gift.": {
        "file": "4edfc64cc69fdb60beb9.mp3",
        "bank": "en-oo1",
        "durationMs": 5376
    },
    "The rain cloud shopping for shade is wearing a shirt with short sleeves and holding a ticket.": {
        "file": "2904c80d99682619fd0a.mp3",
        "bank": "en-oo1",
        "durationMs": 5376
    },
    "The woman protecting her umbrella from rain keeps a glass on her head.": {
        "file": "f4f206097207265fad8b.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "The woman protecting her umbrella from rain keeps a glass under her arm.": {
        "file": "4441678ec4180faf243c.mp3",
        "bank": "en-oo1",
        "durationMs": 4224
    },
    "The woman protecting her umbrella from rain keeps a picture on her head.": {
        "file": "0cdb313f6e9cb8fb5cd8.mp3",
        "bank": "en-oo1",
        "durationMs": 3883
    },
    "The woman protecting her umbrella from rain keeps a picture under her arm.": {
        "file": "020b118d291f432e386a.mp3",
        "bank": "en-oo1",
        "durationMs": 4117
    },
    "The woman protecting her umbrella from rain keeps a clock on her head.": {
        "file": "2f1e36e7847c4d7d63bf.mp3",
        "bank": "en-oo1",
        "durationMs": 3883
    },
    "The woman protecting her umbrella from rain keeps a clock under her arm.": {
        "file": "896be77673a55cc3659c.mp3",
        "bank": "en-oo1",
        "durationMs": 4117
    },
    "The woman protecting her umbrella from rain keeps a flower on her head.": {
        "file": "e7291a78a5f2d37300c9.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "The woman protecting her umbrella from rain keeps a flower under her arm.": {
        "file": "bb1ade77d67907737b37.mp3",
        "bank": "en-oo1",
        "durationMs": 4224
    },
    "The woman protecting her umbrella from rain keeps a fish on her head.": {
        "file": "4c83acd6d9014910908e.mp3",
        "bank": "en-oo1",
        "durationMs": 3840
    },
    "The woman protecting her umbrella from rain keeps a fish under her arm.": {
        "file": "3b434f327f4aa0e45a42.mp3",
        "bank": "en-oo1",
        "durationMs": 4075
    },
    "The woman protecting her umbrella from rain keeps a cat on her head.": {
        "file": "3cc8df539e0a92fd78d4.mp3",
        "bank": "en-oo1",
        "durationMs": 3776
    },
    "The woman protecting her umbrella from rain keeps a cat under her arm.": {
        "file": "2b8ea2c96df8214b1cbb.mp3",
        "bank": "en-oo1",
        "durationMs": 4053
    },
    "The woman protecting her umbrella from rain keeps a gift on her head.": {
        "file": "d6a288166e07b00bf9ac.mp3",
        "bank": "en-oo1",
        "durationMs": 3819
    },
    "The woman protecting her umbrella from rain keeps a gift under her arm.": {
        "file": "6f70cf27b3be8a0a87d2.mp3",
        "bank": "en-oo1",
        "durationMs": 4117
    },
    "The woman protecting her umbrella from rain keeps an apple on her head.": {
        "file": "e0dbe43df66ed3acd3a4.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "The woman protecting her umbrella from rain keeps an apple under her arm.": {
        "file": "a455606099cf5f1f090e.mp3",
        "bank": "en-oo1",
        "durationMs": 4160
    },
    "The woman protecting her umbrella from rain keeps a robot on her head.": {
        "file": "de4720b4bd0d8ed3a2af.mp3",
        "bank": "en-oo1",
        "durationMs": 4032
    },
    "The woman protecting her umbrella from rain keeps a robot under her arm.": {
        "file": "af663d3b8f645b85f7e9.mp3",
        "bank": "en-oo1",
        "durationMs": 4245
    },
    "The woman protecting her umbrella from rain keeps a dog on her head.": {
        "file": "67f1f2f589ebb40780ac.mp3",
        "bank": "en-oo1",
        "durationMs": 3819
    },
    "The woman protecting her umbrella from rain keeps a dog under her arm.": {
        "file": "5460b6f97cba3e5ab0c7.mp3",
        "bank": "en-oo1",
        "durationMs": 4096
    },
    "The snowman moving into our refrigerator brings two fish.": {
        "file": "9d1e95d9a6a05a5d8611.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The snowman moving into our refrigerator brings two books.": {
        "file": "902ca94d5e0cb5ef323f.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The snowman moving into our refrigerator brings three fish.": {
        "file": "f1b6aef73c4a7f03d177.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The snowman moving into our refrigerator brings three books.": {
        "file": "2f58be125ab768eba4d4.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The snowman moving into our refrigerator brings two hats.": {
        "file": "93406d214f5d6f2a7041.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The snowman moving into our refrigerator brings two clocks.": {
        "file": "154db0f48b76a4f10437.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The snowman moving into our refrigerator brings four hats.": {
        "file": "b50eb6e734ee34a2b607.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The snowman moving into our refrigerator brings four clocks.": {
        "file": "857910ab5f18c58fb669.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The snowman moving into our refrigerator brings two gifts.": {
        "file": "921d6e007ec0feb8e622.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The snowman moving into our refrigerator brings two tickets.": {
        "file": "900caaa97a07bf5bbc82.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The snowman moving into our refrigerator brings three gifts.": {
        "file": "3c1e46becffdbc772107.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The snowman moving into our refrigerator brings three tickets.": {
        "file": "229b21dfad6cd46ad584.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The snowman moving into our refrigerator brings two magazines.": {
        "file": "6bc0abd14bf2c8da9245.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "The snowman moving into our refrigerator brings two eggs.": {
        "file": "c19a23e65dc7684d4178.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The snowman moving into our refrigerator brings four magazines.": {
        "file": "47c02bd637c6537d6f21.mp3",
        "bank": "en-oo1",
        "durationMs": 3840
    },
    "The snowman moving into our refrigerator brings four eggs.": {
        "file": "391e6caa780bd2d4b2a7.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The snowman moving into our refrigerator brings two pictures.": {
        "file": "d05e412496ccedcb4a88.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The snowman moving into our refrigerator brings two glasses.": {
        "file": "6f6ee8220b2b4ff85184.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The snowman moving into our refrigerator brings three pictures.": {
        "file": "d5f473ddbe4376bda644.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The snowman moving into our refrigerator brings three glasses.": {
        "file": "7a678d899ac8fac25b83.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The man giving the wind directions is holding a hat.": {
        "file": "f7123e8934c61065d121.mp3",
        "bank": "en-oo1",
        "durationMs": 2880
    },
    "The man giving the wind directions is holding a glass.": {
        "file": "d9561795bee647808f08.mp3",
        "bank": "en-oo1",
        "durationMs": 2987
    },
    "The man giving the wind directions is drawing a hat.": {
        "file": "05e0978a0a7cf3661220.mp3",
        "bank": "en-oo1",
        "durationMs": 2944
    },
    "The man giving the wind directions is drawing a glass.": {
        "file": "2dbde6534c18e2e06932.mp3",
        "bank": "en-oo1",
        "durationMs": 3029
    },
    "The man giving the wind directions is holding a fish.": {
        "file": "52661ecdd3dcac12a6fd.mp3",
        "bank": "en-oo1",
        "durationMs": 2901
    },
    "The man giving the wind directions is holding a gift.": {
        "file": "4f41905d1fc3407c0a1f.mp3",
        "bank": "en-oo1",
        "durationMs": 3029
    },
    "The man giving the wind directions is drawing a fish.": {
        "file": "fca7f852231a0e00ffda.mp3",
        "bank": "en-oo1",
        "durationMs": 2923
    },
    "The man giving the wind directions is drawing a gift.": {
        "file": "cee14d227eed1f09c7d4.mp3",
        "bank": "en-oo1",
        "durationMs": 3008
    },
    "The man giving the wind directions is holding a dog.": {
        "file": "18f19b7beae4f9da0ef7.mp3",
        "bank": "en-oo1",
        "durationMs": 2965
    },
    "The man giving the wind directions is holding a picture.": {
        "file": "5a8c00b233bce0a8d5f0.mp3",
        "bank": "en-oo1",
        "durationMs": 3072
    },
    "The man giving the wind directions is drawing a dog.": {
        "file": "1f64694dcfa61a35f69f.mp3",
        "bank": "en-oo1",
        "durationMs": 2965
    },
    "The man giving the wind directions is drawing a picture.": {
        "file": "167fc244cfd595ce5147.mp3",
        "bank": "en-oo1",
        "durationMs": 3072
    },
    "The man giving the wind directions is holding a book.": {
        "file": "304cdacae4db198dc63c.mp3",
        "bank": "en-oo1",
        "durationMs": 2859
    },
    "The man giving the wind directions is holding a robot.": {
        "file": "86a706899e250dd447d2.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The man giving the wind directions is drawing a book.": {
        "file": "6bf7dbd0846bbeb8b91f.mp3",
        "bank": "en-oo1",
        "durationMs": 2880
    },
    "The man giving the wind directions is drawing a robot.": {
        "file": "c639b8e20adea2a72cb7.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The man giving the wind directions is holding a computer.": {
        "file": "97f339f9919a5c979587.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The man giving the wind directions is holding a bag.": {
        "file": "eaf5c278f635cb52600a.mp3",
        "bank": "en-oo1",
        "durationMs": 2880
    },
    "The man giving the wind directions is drawing a computer.": {
        "file": "8b9bb7c3960aeff4c770.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The man giving the wind directions is drawing a bag.": {
        "file": "684f9c92b1f1ffe48586.mp3",
        "bank": "en-oo1",
        "durationMs": 2880
    },
    "The sun visiting our shop chooses a large cat.": {
        "file": "e63b53ac8852aadd7902.mp3",
        "bank": "en-oo1",
        "durationMs": 2645
    },
    "The sun visiting our shop chooses a large glass.": {
        "file": "fca5122d7320b88d959b.mp3",
        "bank": "en-oo1",
        "durationMs": 2816
    },
    "The sun visiting our shop chooses a small cat.": {
        "file": "252367714326c7614653.mp3",
        "bank": "en-oo1",
        "durationMs": 2581
    },
    "The sun visiting our shop chooses a small glass.": {
        "file": "bb66df013d50d29bb38c.mp3",
        "bank": "en-oo1",
        "durationMs": 2603
    },
    "The sun visiting our shop chooses a large fish.": {
        "file": "ed93a91eac0cdf0cad6f.mp3",
        "bank": "en-oo1",
        "durationMs": 2731
    },
    "The sun visiting our shop chooses a large gift.": {
        "file": "653d17b3b0323c0e7853.mp3",
        "bank": "en-oo1",
        "durationMs": 2816
    },
    "The sun visiting our shop chooses a small fish.": {
        "file": "50e7613d7489113af1ad.mp3",
        "bank": "en-oo1",
        "durationMs": 2645
    },
    "The sun visiting our shop chooses a small gift.": {
        "file": "93362c692df1b5a924cf.mp3",
        "bank": "en-oo1",
        "durationMs": 2709
    },
    "The sun visiting our shop chooses a large magazine.": {
        "file": "3800d785a2efa9e1b0ab.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The sun visiting our shop chooses a large ticket.": {
        "file": "a9b6f0bfbae375dfd86c.mp3",
        "bank": "en-oo1",
        "durationMs": 2859
    },
    "The sun visiting our shop chooses a small magazine.": {
        "file": "e473f5689875b5458468.mp3",
        "bank": "en-oo1",
        "durationMs": 3029
    },
    "The sun visiting our shop chooses a small ticket.": {
        "file": "af6c9a2f6c88d74bb0d1.mp3",
        "bank": "en-oo1",
        "durationMs": 2731
    },
    "The sun visiting our shop chooses a large box.": {
        "file": "e2572c5b71b814e50b76.mp3",
        "bank": "en-oo1",
        "durationMs": 2944
    },
    "The sun visiting our shop chooses a large book.": {
        "file": "899e944d42191e8dce9e.mp3",
        "bank": "en-oo1",
        "durationMs": 2731
    },
    "The sun visiting our shop chooses a small box.": {
        "file": "53fea52ec6d1a008ab20.mp3",
        "bank": "en-oo1",
        "durationMs": 2731
    },
    "The sun visiting our shop chooses a small book.": {
        "file": "c41b3ef9c71599b98c6d.mp3",
        "bank": "en-oo1",
        "durationMs": 2560
    },
    "The sun visiting our shop chooses a large dog.": {
        "file": "c4820a5b3ac87c89c85f.mp3",
        "bank": "en-oo1",
        "durationMs": 2795
    },
    "The sun visiting our shop chooses a large coin.": {
        "file": "e8f2dde152195c8f1e9b.mp3",
        "bank": "en-oo1",
        "durationMs": 2731
    },
    "The sun visiting our shop chooses a small dog.": {
        "file": "cb4d06fddb2b0b8e8111.mp3",
        "bank": "en-oo1",
        "durationMs": 2624
    },
    "The sun visiting our shop chooses a small coin.": {
        "file": "eff4c38186fcf32e7816.mp3",
        "bank": "en-oo1",
        "durationMs": 2645
    },
    "The puddle visiting the beach leaves a glass beside the water.": {
        "file": "ef8a4bd8d0a4ec06e96f.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The puddle visiting the beach leaves a glass above the water.": {
        "file": "b874328d95f9b67c252f.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The puddle visiting the beach leaves a ticket beside the water.": {
        "file": "980b5ca76a7315daf389.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The puddle visiting the beach leaves a ticket above the water.": {
        "file": "a0e25e4b265216c10471.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The puddle visiting the beach leaves a gift beside the water.": {
        "file": "cc2fe0c18c60af5fff8b.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The puddle visiting the beach leaves a gift above the water.": {
        "file": "ec088f1135b6bcf3d22f.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The puddle visiting the beach leaves a fish beside the water.": {
        "file": "d5f0a27c6e826c06b45f.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The puddle visiting the beach leaves a fish above the water.": {
        "file": "995d734a275a38afaa00.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The puddle visiting the beach leaves a dog beside the water.": {
        "file": "21708eb9fe4d24b3cd21.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The puddle visiting the beach leaves a dog above the water.": {
        "file": "7d34944d2c3303c1bb83.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The puddle visiting the beach leaves a cat beside the water.": {
        "file": "18ec4990bd3443419e3c.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The puddle visiting the beach leaves a cat above the water.": {
        "file": "be151c69bff1e0548a5a.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The puddle visiting the beach leaves a book beside the water.": {
        "file": "1d637f9897c4a6fa1050.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The puddle visiting the beach leaves a book above the water.": {
        "file": "a08cc60e4b376c73251f.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The puddle visiting the beach leaves a robot beside the water.": {
        "file": "816274d5449563f0967e.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The puddle visiting the beach leaves a robot above the water.": {
        "file": "d5713c70cfb23740b291.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The puddle visiting the beach leaves a picture beside the water.": {
        "file": "308365324d5dc41a32d2.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The puddle visiting the beach leaves a picture above the water.": {
        "file": "c8c77ce058f3d423defd.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The puddle visiting the beach leaves a flower beside the water.": {
        "file": "265c10bab8911f4ffba9.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The puddle visiting the beach leaves a flower above the water.": {
        "file": "11ddb61da1a3e9e67484.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The weather map leaving the studio carries two eggs.": {
        "file": "c4769318a643d7735ead.mp3",
        "bank": "en-oo1",
        "durationMs": 2795
    },
    "The weather map leaving the studio carries two boxes.": {
        "file": "89057bc5c1514c88b5e5.mp3",
        "bank": "en-oo1",
        "durationMs": 2987
    },
    "The weather map leaving the studio carries three eggs.": {
        "file": "bdd89071e02e51b500c5.mp3",
        "bank": "en-oo1",
        "durationMs": 2837
    },
    "The weather map leaving the studio carries three boxes.": {
        "file": "c8c4ea218d8e1088487b.mp3",
        "bank": "en-oo1",
        "durationMs": 3029
    },
    "The weather map leaving the studio carries two glasses.": {
        "file": "326db59322261d5d99b7.mp3",
        "bank": "en-oo1",
        "durationMs": 3029
    },
    "The weather map leaving the studio carries two books.": {
        "file": "f3cc05ae4553275bb79c.mp3",
        "bank": "en-oo1",
        "durationMs": 2816
    },
    "The weather map leaving the studio carries four glasses.": {
        "file": "1e2bb212a857b5c2e011.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The weather map leaving the studio carries four books.": {
        "file": "8f0b7d9d7a43dd99f80f.mp3",
        "bank": "en-oo1",
        "durationMs": 2859
    },
    "The weather map leaving the studio carries two fish.": {
        "file": "a4b5b6e1204f6a128cd8.mp3",
        "bank": "en-oo1",
        "durationMs": 2816
    },
    "The weather map leaving the studio carries two gifts.": {
        "file": "b52307baa3fb5b6ace69.mp3",
        "bank": "en-oo1",
        "durationMs": 2880
    },
    "The weather map leaving the studio carries three fish.": {
        "file": "b368f396a71febbbd5d0.mp3",
        "bank": "en-oo1",
        "durationMs": 2859
    },
    "The weather map leaving the studio carries three gifts.": {
        "file": "cb5bc3b03fcbed1ce874.mp3",
        "bank": "en-oo1",
        "durationMs": 2923
    },
    "The weather map leaving the studio carries two tickets.": {
        "file": "84b5cb28941e064b82ac.mp3",
        "bank": "en-oo1",
        "durationMs": 2901
    },
    "The weather map leaving the studio carries two bottles.": {
        "file": "a93c50a18491f0b8357e.mp3",
        "bank": "en-oo1",
        "durationMs": 2923
    },
    "The weather map leaving the studio carries four tickets.": {
        "file": "5fa980204114003dffc5.mp3",
        "bank": "en-oo1",
        "durationMs": 3008
    },
    "The weather map leaving the studio carries four bottles.": {
        "file": "94292aa9789a6eacce41.mp3",
        "bank": "en-oo1",
        "durationMs": 3008
    },
    "The weather map leaving the studio carries two pictures.": {
        "file": "ca23a92f05e534bed609.mp3",
        "bank": "en-oo1",
        "durationMs": 2987
    },
    "The weather map leaving the studio carries two bags.": {
        "file": "91a00fbd794805eaed86.mp3",
        "bank": "en-oo1",
        "durationMs": 2901
    },
    "The weather map leaving the studio carries three pictures.": {
        "file": "6e518bf0d9184cf54d1d.mp3",
        "bank": "en-oo1",
        "durationMs": 2987
    },
    "The weather map leaving the studio carries three bags.": {
        "file": "e711c41086559af137ba.mp3",
        "bank": "en-oo1",
        "durationMs": 2944
    },
    "The raincoat taking a sunny holiday is wearing a large hat and holding a gift.": {
        "file": "a74c3af8b8e52a358bd3.mp3",
        "bank": "en-oo1",
        "durationMs": 4693
    },
    "The raincoat taking a sunny holiday is wearing a large hat and holding a dog.": {
        "file": "c508bf269e9b9d74913c.mp3",
        "bank": "en-oo1",
        "durationMs": 4651
    },
    "The raincoat taking a sunny holiday is wearing a small hat and holding a gift.": {
        "file": "498a6c125e575ef55248.mp3",
        "bank": "en-oo1",
        "durationMs": 4651
    },
    "The raincoat taking a sunny holiday is wearing a small hat and holding a dog.": {
        "file": "a592f25c254a1773bd9b.mp3",
        "bank": "en-oo1",
        "durationMs": 4629
    },
    "The raincoat taking a sunny holiday is wearing a long scarf and holding a fish.": {
        "file": "a3ccc40442aeb48ff50d.mp3",
        "bank": "en-oo1",
        "durationMs": 4736
    },
    "The raincoat taking a sunny holiday is wearing a long scarf and holding a box.": {
        "file": "5b6b1fbc9b4bd97715c4.mp3",
        "bank": "en-oo1",
        "durationMs": 4800
    },
    "The raincoat taking a sunny holiday is wearing a short scarf and holding a fish.": {
        "file": "04b9b4ff7b045d249d74.mp3",
        "bank": "en-oo1",
        "durationMs": 4779
    },
    "The raincoat taking a sunny holiday is wearing a short scarf and holding a box.": {
        "file": "80c1b1689cefcd8758d4.mp3",
        "bank": "en-oo1",
        "durationMs": 4843
    },
    "The raincoat taking a sunny holiday is wearing round glasses and holding a hat.": {
        "file": "c4b76fc4b3fd9c593760.mp3",
        "bank": "en-oo1",
        "durationMs": 4672
    },
    "The raincoat taking a sunny holiday is wearing round glasses and holding a glass.": {
        "file": "0331bd33782e825aaa93.mp3",
        "bank": "en-oo1",
        "durationMs": 4821
    },
    "The raincoat taking a sunny holiday is wearing square glasses and holding a hat.": {
        "file": "2351110678382482ab45.mp3",
        "bank": "en-oo1",
        "durationMs": 4715
    },
    "The raincoat taking a sunny holiday is wearing square glasses and holding a glass.": {
        "file": "d57d236b6992f120119e.mp3",
        "bank": "en-oo1",
        "durationMs": 4885
    },
    "The raincoat taking a sunny holiday is wearing a jacket with two pockets and holding a newspaper.": {
        "file": "3e88cf61df212a4f6dee.mp3",
        "bank": "en-oo1",
        "durationMs": 5824
    },
    "The raincoat taking a sunny holiday is wearing a jacket with two pockets and holding a computer.": {
        "file": "404e45363b95f5d0b936.mp3",
        "bank": "en-oo1",
        "durationMs": 5717
    },
    "The raincoat taking a sunny holiday is wearing a jacket with four pockets and holding a newspaper.": {
        "file": "ea6e06d51f48d3af461a.mp3",
        "bank": "en-oo1",
        "durationMs": 5909
    },
    "The raincoat taking a sunny holiday is wearing a jacket with four pockets and holding a computer.": {
        "file": "e97e9a2b7ddd710d27ce.mp3",
        "bank": "en-oo1",
        "durationMs": 5824
    },
    "The raincoat taking a sunny holiday is wearing a shirt with long sleeves and holding a robot.": {
        "file": "69a4a345270b6478053a.mp3",
        "bank": "en-oo1",
        "durationMs": 5611
    },
    "The raincoat taking a sunny holiday is wearing a shirt with long sleeves and holding a book.": {
        "file": "6943d21a22b642ebf490.mp3",
        "bank": "en-oo1",
        "durationMs": 5333
    },
    "The raincoat taking a sunny holiday is wearing a shirt with short sleeves and holding a robot.": {
        "file": "bcd9b9cda90eabe93446.mp3",
        "bank": "en-oo1",
        "durationMs": 5483
    },
    "The raincoat taking a sunny holiday is wearing a shirt with short sleeves and holding a book.": {
        "file": "5676ef753c65bc81a2ae.mp3",
        "bank": "en-oo1",
        "durationMs": 5248
    },
    "The ice attending a meeting about heat keeps a computer beside the glass.": {
        "file": "79b9aa5af777b8137f1b.mp3",
        "bank": "en-oo1",
        "durationMs": 4245
    },
    "The ice attending a meeting about heat keeps a computer inside the glass.": {
        "file": "2e0d74709d0eef8d679e.mp3",
        "bank": "en-oo1",
        "durationMs": 4352
    },
    "The ice attending a meeting about heat keeps a glass beside the glass.": {
        "file": "50a55bf0d78d4cd5dd72.mp3",
        "bank": "en-oo1",
        "durationMs": 4053
    },
    "The ice attending a meeting about heat keeps a glass inside the glass.": {
        "file": "29bc3dbea1a1a866dc3e.mp3",
        "bank": "en-oo1",
        "durationMs": 4011
    },
    "The ice attending a meeting about heat keeps a flower beside the glass.": {
        "file": "cc74d0b8499ce861e8db.mp3",
        "bank": "en-oo1",
        "durationMs": 4096
    },
    "The ice attending a meeting about heat keeps a flower inside the glass.": {
        "file": "d54d220d6d6cb5d79649.mp3",
        "bank": "en-oo1",
        "durationMs": 4117
    },
    "The ice attending a meeting about heat keeps a book beside the glass.": {
        "file": "cf12b48e15de358d5407.mp3",
        "bank": "en-oo1",
        "durationMs": 3819
    },
    "The ice attending a meeting about heat keeps a book inside the glass.": {
        "file": "68b2772fabad0560ba0a.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "The ice attending a meeting about heat keeps a picture beside the glass.": {
        "file": "36886a1242ea1ae08c4b.mp3",
        "bank": "en-oo1",
        "durationMs": 4139
    },
    "The ice attending a meeting about heat keeps a picture inside the glass.": {
        "file": "d99eb908bc3d039fb9e4.mp3",
        "bank": "en-oo1",
        "durationMs": 4160
    },
    "The ice attending a meeting about heat keeps a cup beside the glass.": {
        "file": "09dc669beb2c1ec40e3a.mp3",
        "bank": "en-oo1",
        "durationMs": 3861
    },
    "The ice attending a meeting about heat keeps a cup inside the glass.": {
        "file": "dec05a4ed6596c2c51a9.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "The ice attending a meeting about heat keeps a robot beside the glass.": {
        "file": "73ccf7413e858d9bf0c8.mp3",
        "bank": "en-oo1",
        "durationMs": 4245
    },
    "The ice attending a meeting about heat keeps a robot inside the glass.": {
        "file": "803faf4bbde0e53ffe43.mp3",
        "bank": "en-oo1",
        "durationMs": 4309
    },
    "The ice attending a meeting about heat keeps a fish beside the glass.": {
        "file": "e79515d489f26cb8020e.mp3",
        "bank": "en-oo1",
        "durationMs": 3989
    },
    "The ice attending a meeting about heat keeps a fish inside the glass.": {
        "file": "bfc7c0e8de1ed42bcb4e.mp3",
        "bank": "en-oo1",
        "durationMs": 4032
    },
    "The ice attending a meeting about heat keeps a cat beside the glass.": {
        "file": "a7c76d265420200d467d.mp3",
        "bank": "en-oo1",
        "durationMs": 3947
    },
    "The ice attending a meeting about heat keeps a cat inside the glass.": {
        "file": "2ca7818fdadd360dde7a.mp3",
        "bank": "en-oo1",
        "durationMs": 4053
    },
    "The ice attending a meeting about heat keeps a dog beside the glass.": {
        "file": "92a77e00b7b73fd481af.mp3",
        "bank": "en-oo1",
        "durationMs": 4053
    },
    "The ice attending a meeting about heat keeps a dog inside the glass.": {
        "file": "5198ce9a89f3ca41d608.mp3",
        "bank": "en-oo1",
        "durationMs": 4032
    },
    "The leaves refusing to fall hang two glasses from the tree.": {
        "file": "18863ea7a68998c45f17.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The leaves refusing to fall hang two computers from the tree.": {
        "file": "84969fd8edd02fc46199.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The leaves refusing to fall hang three glasses from the tree.": {
        "file": "81e7eb57583878da8110.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The leaves refusing to fall hang three computers from the tree.": {
        "file": "ed1ab7c681feb90127a7.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The leaves refusing to fall hang two boxes from the tree.": {
        "file": "0c27fc0883e20f4bf76e.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The leaves refusing to fall hang two fish from the tree.": {
        "file": "102d609a1fafef5a0947.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The leaves refusing to fall hang four boxes from the tree.": {
        "file": "e27ddacb04c2c2b3974e.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "The leaves refusing to fall hang four fish from the tree.": {
        "file": "015df600ea03d11b6109.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The leaves refusing to fall hang two robots from the tree.": {
        "file": "637fdc1acdabe1e5881e.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The leaves refusing to fall hang two books from the tree.": {
        "file": "5c1b39cb2b16d5568749.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The leaves refusing to fall hang three robots from the tree.": {
        "file": "90c3a1025ba35f7377f2.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The leaves refusing to fall hang three books from the tree.": {
        "file": "468b0c63216b7f3af946.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The leaves refusing to fall hang two phones from the tree.": {
        "file": "04641dbbf2566ded44e4.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The leaves refusing to fall hang two gifts from the tree.": {
        "file": "ff5a4c5066fca68b1dc0.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The leaves refusing to fall hang four phones from the tree.": {
        "file": "571da67c71e0c5fc006c.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The leaves refusing to fall hang four gifts from the tree.": {
        "file": "a7f1d3474311a28c3ffa.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The leaves refusing to fall hang two pencils from the tree.": {
        "file": "494f2cb54ab2e9eb21e4.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The leaves refusing to fall hang two dogs from the tree.": {
        "file": "c9691de0a32d69b7a834.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The leaves refusing to fall hang three pencils from the tree.": {
        "file": "ea1250eeb5695d08004b.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The leaves refusing to fall hang three dogs from the tree.": {
        "file": "ae976cfe22c77355d303.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The machine making rain indoors has a computer beside the box.": {
        "file": "b72d24099e831e3842b3.mp3",
        "bank": "en-oo1",
        "durationMs": 3819
    },
    "The machine making rain indoors has a computer inside the box.": {
        "file": "dbc6f698d22737a9c028.mp3",
        "bank": "en-oo1",
        "durationMs": 3925
    },
    "The machine making rain indoors has a ticket beside the box.": {
        "file": "309899540f2588416158.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The machine making rain indoors has a ticket inside the box.": {
        "file": "1565c33b5533b3412b90.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The machine making rain indoors has a flower beside the box.": {
        "file": "ce8b1f7c2096443eae1b.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The machine making rain indoors has a flower inside the box.": {
        "file": "3a63c25b1f30a1a12456.mp3",
        "bank": "en-oo1",
        "durationMs": 3819
    },
    "The machine making rain indoors has a glass beside the box.": {
        "file": "d0ed7996facd5ec6875b.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The machine making rain indoors has a glass inside the box.": {
        "file": "3d61bafd08664e51996e.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The machine making rain indoors has a phone beside the box.": {
        "file": "79d071c52293cd35c240.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The machine making rain indoors has a phone inside the box.": {
        "file": "fa17fecbe4442b3af1f8.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The machine making rain indoors has a dog beside the box.": {
        "file": "e896c26b7e07a8af658f.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The machine making rain indoors has a dog inside the box.": {
        "file": "370c9bebe586cfb328c7.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The machine making rain indoors has a hat beside the box.": {
        "file": "2515ce791a4d0e58afc9.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The machine making rain indoors has a hat inside the box.": {
        "file": "ab784a1c038032d2d88b.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The machine making rain indoors has a box beside the box.": {
        "file": "81014e09db00e658c597.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The machine making rain indoors has a box inside the box.": {
        "file": "91ad1c8955596121c6d4.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The machine making rain indoors has a fish beside the box.": {
        "file": "a0ad8b970f588a7ae62f.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The machine making rain indoors has a fish inside the box.": {
        "file": "710f5c3c90a05c63793e.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The machine making rain indoors has a shoe beside the box.": {
        "file": "6f92096028a87d2594c7.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The machine making rain indoors has a shoe inside the box.": {
        "file": "92b6fb38f3db7d29be85.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The machine turning toast back into bread has two dogs beside it.": {
        "file": "057ce904e14077d4a441.mp3",
        "bank": "en-oo1",
        "durationMs": 3861
    },
    "The machine turning toast back into bread has two gifts beside it.": {
        "file": "fc309a8c6f3f449eac59.mp3",
        "bank": "en-oo1",
        "durationMs": 3819
    },
    "The machine turning toast back into bread has three dogs beside it.": {
        "file": "afd11761a1bc3719114b.mp3",
        "bank": "en-oo1",
        "durationMs": 3925
    },
    "The machine turning toast back into bread has three gifts beside it.": {
        "file": "f1e47d143a89fe2b0cd3.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "The machine turning toast back into bread has two books beside it.": {
        "file": "5c0296d3b048a8a2e1b7.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "The machine turning toast back into bread has two fish beside it.": {
        "file": "95d2943099d60f5e230d.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The machine turning toast back into bread has four books beside it.": {
        "file": "981861efa0a306707ac2.mp3",
        "bank": "en-oo1",
        "durationMs": 3776
    },
    "The machine turning toast back into bread has four fish beside it.": {
        "file": "f2b1cb69f07f0cef306d.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The machine turning toast back into bread has two balls beside it.": {
        "file": "d1788c1fa486728a566b.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The machine turning toast back into bread has two flowers beside it.": {
        "file": "43afa311bd76366e7745.mp3",
        "bank": "en-oo1",
        "durationMs": 3883
    },
    "The machine turning toast back into bread has three balls beside it.": {
        "file": "cd9ab76ebf2a30223f58.mp3",
        "bank": "en-oo1",
        "durationMs": 3840
    },
    "The machine turning toast back into bread has three flowers beside it.": {
        "file": "08481623ae41b03d3212.mp3",
        "bank": "en-oo1",
        "durationMs": 3968
    },
    "The machine turning toast back into bread has two boxes beside it.": {
        "file": "00f11848bb8d70ec4916.mp3",
        "bank": "en-oo1",
        "durationMs": 3989
    },
    "The machine turning toast back into bread has two glasses beside it.": {
        "file": "d9dacfd1faf2c34bd09b.mp3",
        "bank": "en-oo1",
        "durationMs": 3968
    },
    "The machine turning toast back into bread has four boxes beside it.": {
        "file": "41beb2f5bcb5bf769233.mp3",
        "bank": "en-oo1",
        "durationMs": 4032
    },
    "The machine turning toast back into bread has four glasses beside it.": {
        "file": "3c06a0c552ff32d02018.mp3",
        "bank": "en-oo1",
        "durationMs": 4011
    },
    "The machine turning toast back into bread has two bottles beside it.": {
        "file": "be8abd5e46b94a412d8f.mp3",
        "bank": "en-oo1",
        "durationMs": 3925
    },
    "The machine turning toast back into bread has two robots beside it.": {
        "file": "dbdabfe7491b2e8f651c.mp3",
        "bank": "en-oo1",
        "durationMs": 4011
    },
    "The machine turning toast back into bread has three bottles beside it.": {
        "file": "fa0b2035c8a4044c8a6f.mp3",
        "bank": "en-oo1",
        "durationMs": 3947
    },
    "The machine turning toast back into bread has three robots beside it.": {
        "file": "0dd4ed732fc63d343105.mp3",
        "bank": "en-oo1",
        "durationMs": 4075
    },
    "The door that knocks on people is wearing a large hat and holding a fish.": {
        "file": "207f37b3fa5e5276354d.mp3",
        "bank": "en-oo1",
        "durationMs": 4373
    },
    "The door that knocks on people is wearing a large hat and holding a phone.": {
        "file": "381d0229ac91f3fbe595.mp3",
        "bank": "en-oo1",
        "durationMs": 4395
    },
    "The door that knocks on people is wearing a small hat and holding a fish.": {
        "file": "3620fcf1a36626a1eeda.mp3",
        "bank": "en-oo1",
        "durationMs": 4245
    },
    "The door that knocks on people is wearing a small hat and holding a phone.": {
        "file": "a140863e734b4a5c43df.mp3",
        "bank": "en-oo1",
        "durationMs": 4309
    },
    "The door that knocks on people is wearing a long scarf and holding a glass.": {
        "file": "962ba9c4bdc3f66f4aaa.mp3",
        "bank": "en-oo1",
        "durationMs": 4352
    },
    "The door that knocks on people is wearing a long scarf and holding a bottle.": {
        "file": "537bcaac3fa559763bb4.mp3",
        "bank": "en-oo1",
        "durationMs": 4416
    },
    "The door that knocks on people is wearing a short scarf and holding a glass.": {
        "file": "954894ae02518af34857.mp3",
        "bank": "en-oo1",
        "durationMs": 4416
    },
    "The door that knocks on people is wearing a short scarf and holding a bottle.": {
        "file": "38be51211e97c82b100d.mp3",
        "bank": "en-oo1",
        "durationMs": 4501
    },
    "The door that knocks on people is wearing round glasses and holding a computer.": {
        "file": "e32a7586b72295e930d4.mp3",
        "bank": "en-oo1",
        "durationMs": 4587
    },
    "The door that knocks on people is wearing round glasses and holding a box.": {
        "file": "5c3858c69ad4088acca3.mp3",
        "bank": "en-oo1",
        "durationMs": 4395
    },
    "The door that knocks on people is wearing square glasses and holding a computer.": {
        "file": "22fbcf7032731bdb056b.mp3",
        "bank": "en-oo1",
        "durationMs": 4587
    },
    "The door that knocks on people is wearing square glasses and holding a box.": {
        "file": "d9e01d46577087449404.mp3",
        "bank": "en-oo1",
        "durationMs": 4501
    },
    "The door that knocks on people is wearing a jacket with two pockets and holding a shoe.": {
        "file": "cf70137c410b4cfb8e90.mp3",
        "bank": "en-oo1",
        "durationMs": 5077
    },
    "The door that knocks on people is wearing a jacket with two pockets and holding a cup.": {
        "file": "29a42590ec6e2a640617.mp3",
        "bank": "en-oo1",
        "durationMs": 5035
    },
    "The door that knocks on people is wearing a jacket with four pockets and holding a shoe.": {
        "file": "168e15b9460b0cbdb3bb.mp3",
        "bank": "en-oo1",
        "durationMs": 5205
    },
    "The door that knocks on people is wearing a jacket with four pockets and holding a cup.": {
        "file": "e353c62b986a98ee781c.mp3",
        "bank": "en-oo1",
        "durationMs": 5184
    },
    "The door that knocks on people is wearing a shirt with long sleeves and holding a magazine.": {
        "file": "27bad18eb26939bc8cd1.mp3",
        "bank": "en-oo1",
        "durationMs": 5312
    },
    "The door that knocks on people is wearing a shirt with long sleeves and holding an egg.": {
        "file": "447d08ce0780831e992b.mp3",
        "bank": "en-oo1",
        "durationMs": 4864
    },
    "The door that knocks on people is wearing a shirt with short sleeves and holding a magazine.": {
        "file": "a6ce2c46898cd1a78b59.mp3",
        "bank": "en-oo1",
        "durationMs": 5333
    },
    "The door that knocks on people is wearing a shirt with short sleeves and holding an egg.": {
        "file": "575151fbbe4b8c81833a.mp3",
        "bank": "en-oo1",
        "durationMs": 4864
    },
    "The machine making single socks sits on a large glass.": {
        "file": "d73d768b8bff3e4885a2.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The machine making single socks sits on a large gift.": {
        "file": "f8b821d6289999bb3c45.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The machine making single socks sits on a small glass.": {
        "file": "a4b8b22a716f47c8be12.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The machine making single socks sits on a small gift.": {
        "file": "f917faa03731e3faa1b7.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The machine making single socks sits on a large key.": {
        "file": "9b1a63d3c7f01817f401.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The machine making single socks sits on a large egg.": {
        "file": "9a82a9935cc911274a48.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The machine making single socks sits on a small key.": {
        "file": "cd7c51b9ef3c6a5e684d.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The machine making single socks sits on a small egg.": {
        "file": "0d92c3c48efb98fdb698.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The machine making single socks sits on a large box.": {
        "file": "b10c178d220fd9c04296.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The machine making single socks sits on a large ticket.": {
        "file": "245f28672d0754b2d2d7.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The machine making single socks sits on a small box.": {
        "file": "b8506326e28fc3be271a.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The machine making single socks sits on a small ticket.": {
        "file": "614808356a7fed5b51bb.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The machine making single socks sits on a large book.": {
        "file": "bf5b0a0d3520ac1e3c26.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The machine making single socks sits on a large hat.": {
        "file": "95d22c3bfba9c1d3be8c.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The machine making single socks sits on a small book.": {
        "file": "d02feee151b26316dcf7.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The machine making single socks sits on a small hat.": {
        "file": "b8f93473576f89fa238b.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The machine making single socks sits on a large fish.": {
        "file": "a1b2f35d58dee0f246e1.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The machine making single socks sits on a large bottle.": {
        "file": "88a42e880a404b83fcae.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The machine making single socks sits on a small fish.": {
        "file": "910960ef8585ffc8f204.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The machine making single socks sits on a small bottle.": {
        "file": "0e709b1454364f17280f.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The robot asking us to do its work is holding a glass.": {
        "file": "36913cc218b1bf31b8fa.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The robot asking us to do its work is holding a fish.": {
        "file": "acff279ef94062e732db.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The robot asking us to do its work is drawing a glass.": {
        "file": "6ecc5933f875ba5ed594.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The robot asking us to do its work is drawing a fish.": {
        "file": "beff67be8f60786337b2.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The robot asking us to do its work is holding a bag.": {
        "file": "c1d7b1e71a79a1435f28.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The robot asking us to do its work is holding a robot.": {
        "file": "b21a94e3a3223ba6183b.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The robot asking us to do its work is drawing a bag.": {
        "file": "d35699e899fcfa867dc7.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The robot asking us to do its work is drawing a robot.": {
        "file": "88c8e2509a37697e859a.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The robot asking us to do its work is holding a box.": {
        "file": "af5b27c58d7dd033f24a.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The robot asking us to do its work is holding a coin.": {
        "file": "8f136547cca69eb05fd5.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The robot asking us to do its work is drawing a box.": {
        "file": "090b61a1628abd743e93.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The robot asking us to do its work is drawing a coin.": {
        "file": "85336e607097046127ef.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "The robot asking us to do its work is holding a gift.": {
        "file": "08e6d704d1b0868fd264.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The robot asking us to do its work is holding a hat.": {
        "file": "b6e51910741c320e3dae.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The robot asking us to do its work is drawing a gift.": {
        "file": "9d27d9981f7c46a1c337.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The robot asking us to do its work is drawing a hat.": {
        "file": "c0a4646ec3d3a8013064.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The robot asking us to do its work is holding a magazine.": {
        "file": "a1f73d537680f5f019a3.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The robot asking us to do its work is holding a cup.": {
        "file": "c8c70d86e71a9729e167.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The robot asking us to do its work is drawing a magazine.": {
        "file": "7c7b083cdbab2983699e.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The robot asking us to do its work is drawing a cup.": {
        "file": "8402d69732b4dcfa75af.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "The student trying to make water wetter puts a fish beside the glass.": {
        "file": "e3ab75bcbccb88ed5755.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The student trying to make water wetter puts a fish inside the glass.": {
        "file": "34118a6e40beee5e732f.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The student trying to make water wetter puts a ticket beside the glass.": {
        "file": "d358b82b983af829d7c6.mp3",
        "bank": "en-oo1",
        "durationMs": 3819
    },
    "The student trying to make water wetter puts a ticket inside the glass.": {
        "file": "680355370d5139dc495f.mp3",
        "bank": "en-oo1",
        "durationMs": 3947
    },
    "The student trying to make water wetter puts a bag beside the glass.": {
        "file": "a6a1dd1b1e5081eb6e86.mp3",
        "bank": "en-oo1",
        "durationMs": 3776
    },
    "The student trying to make water wetter puts a bag inside the glass.": {
        "file": "7e219d1c94b3437e4e57.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The student trying to make water wetter puts a box beside the glass.": {
        "file": "6ac5195c578f71ded76d.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The student trying to make water wetter puts a box inside the glass.": {
        "file": "347ebd32d7715a71fba0.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The student trying to make water wetter puts a bottle beside the glass.": {
        "file": "81367628a4a8459e0643.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The student trying to make water wetter puts a bottle inside the glass.": {
        "file": "d60f417f8fa0e2910ce1.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "The student trying to make water wetter puts a gift beside the glass.": {
        "file": "e9194f9dfb79b4fbf701.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The student trying to make water wetter puts a gift inside the glass.": {
        "file": "62f1d90d1190c1857241.mp3",
        "bank": "en-oo1",
        "durationMs": 3861
    },
    "The student trying to make water wetter puts a glass beside the glass.": {
        "file": "33e2a2341de8ee192c61.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The student trying to make water wetter puts a glass inside the glass.": {
        "file": "f2d1b63cc4290dba1437.mp3",
        "bank": "en-oo1",
        "durationMs": 3925
    },
    "The student trying to make water wetter puts a computer beside the glass.": {
        "file": "8a97b2005f6fc0e2f8d2.mp3",
        "bank": "en-oo1",
        "durationMs": 3861
    },
    "The student trying to make water wetter puts a computer inside the glass.": {
        "file": "2973af93c289a2b16759.mp3",
        "bank": "en-oo1",
        "durationMs": 4032
    },
    "The student trying to make water wetter puts a phone beside the glass.": {
        "file": "3c82569af217d1beaf47.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The student trying to make water wetter puts a phone inside the glass.": {
        "file": "aacfdd50b9333096ab83.mp3",
        "bank": "en-oo1",
        "durationMs": 3819
    },
    "The student trying to make water wetter puts a picture beside the glass.": {
        "file": "a866efaacaf69215ea7f.mp3",
        "bank": "en-oo1",
        "durationMs": 3819
    },
    "The student trying to make water wetter puts a picture inside the glass.": {
        "file": "8e5a89db16cef0665502.mp3",
        "bank": "en-oo1",
        "durationMs": 3989
    },
    "The chair that makes people stand has two gifts beneath it.": {
        "file": "bb264409805596478a2f.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The chair that makes people stand has two cats beneath it.": {
        "file": "b56f30bbde2b7f2a3627.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The chair that makes people stand has three gifts beneath it.": {
        "file": "2ad5cebff89e30ea684a.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The chair that makes people stand has three cats beneath it.": {
        "file": "e53172056c7511265699.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The chair that makes people stand has two phones beneath it.": {
        "file": "4d9d0f8f9d97b88022c9.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The chair that makes people stand has two glasses beneath it.": {
        "file": "f1b6e19bc6a78ad11dec.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The chair that makes people stand has four phones beneath it.": {
        "file": "3106570cfd98704fe80e.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The chair that makes people stand has four glasses beneath it.": {
        "file": "a61e1b78924a53c846ff.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The chair that makes people stand has two fish beneath it.": {
        "file": "2d620f1463a79910537b.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The chair that makes people stand has two coins beneath it.": {
        "file": "daba1dd7a5ffe7ba7800.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The chair that makes people stand has three fish beneath it.": {
        "file": "239f0e2724b94db879ac.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The chair that makes people stand has three coins beneath it.": {
        "file": "caa6dcf6b25c5228fd13.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The chair that makes people stand has two dogs beneath it.": {
        "file": "8186d7234ff6b09f3a34.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The chair that makes people stand has two books beneath it.": {
        "file": "7ca9a8bdca6c16ed4877.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The chair that makes people stand has four dogs beneath it.": {
        "file": "1136918ca4f5dd748890.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The chair that makes people stand has four books beneath it.": {
        "file": "c0e3fa0c7903b9e34a78.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The chair that makes people stand has two boxes beneath it.": {
        "file": "4fb3a671b86022dac1a3.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The chair that makes people stand has two pictures beneath it.": {
        "file": "94406c42c230fc4d7031.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The chair that makes people stand has three boxes beneath it.": {
        "file": "42b5c4fab2073acfcb85.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The chair that makes people stand has three pictures beneath it.": {
        "file": "166bbbe24518a3139511.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The alarm clock waking another clock keeps a dog beside the bed.": {
        "file": "1c5e26bd9d4a68ba4079.mp3",
        "bank": "en-oo1",
        "durationMs": 3819
    },
    "The alarm clock waking another clock keeps a dog under the bed.": {
        "file": "4c8b280950ad172a7114.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The alarm clock waking another clock keeps a fish beside the bed.": {
        "file": "b5800d715ac42b983571.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "The alarm clock waking another clock keeps a fish under the bed.": {
        "file": "e4c50cde50252a4c8472.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The alarm clock waking another clock keeps a computer beside the bed.": {
        "file": "098e0106bae14f2e9060.mp3",
        "bank": "en-oo1",
        "durationMs": 3968
    },
    "The alarm clock waking another clock keeps a computer under the bed.": {
        "file": "8c1c110d5212119f1752.mp3",
        "bank": "en-oo1",
        "durationMs": 3883
    },
    "The alarm clock waking another clock keeps a box beside the bed.": {
        "file": "7a260b519fdcc4dea492.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "The alarm clock waking another clock keeps a box under the bed.": {
        "file": "eaa99ce3a9e53ac88da6.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The alarm clock waking another clock keeps a glass beside the bed.": {
        "file": "c35d2c9c6003c619616c.mp3",
        "bank": "en-oo1",
        "durationMs": 3819
    },
    "The alarm clock waking another clock keeps a glass under the bed.": {
        "file": "759221f94ba19bd9fe01.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "The alarm clock waking another clock keeps a shoe beside the bed.": {
        "file": "48dddf3d977d815a0cc0.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The alarm clock waking another clock keeps a shoe under the bed.": {
        "file": "423e780fbd7b1cf68747.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The alarm clock waking another clock keeps a camera beside the bed.": {
        "file": "1dbc9b70b2da0413c5fb.mp3",
        "bank": "en-oo1",
        "durationMs": 3840
    },
    "The alarm clock waking another clock keeps a camera under the bed.": {
        "file": "4e727d09b0a517601fce.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The alarm clock waking another clock keeps a phone beside the bed.": {
        "file": "28212a34dc92777b54bc.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The alarm clock waking another clock keeps a phone under the bed.": {
        "file": "288f3caf55460a34ea9f.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The alarm clock waking another clock keeps a bottle beside the bed.": {
        "file": "fbb304b7930ff5605b6e.mp3",
        "bank": "en-oo1",
        "durationMs": 3840
    },
    "The alarm clock waking another clock keeps a bottle under the bed.": {
        "file": "966e655bd948a1556105.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The alarm clock waking another clock keeps a gift beside the bed.": {
        "file": "103b443269368cc4177d.mp3",
        "bank": "en-oo1",
        "durationMs": 3819
    },
    "The alarm clock waking another clock keeps a gift under the bed.": {
        "file": "0b19a5c4cc6ec12a3337.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "The machine making hats for hats produces a large book.": {
        "file": "4451fd95bd01623222f8.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The machine making hats for hats produces a large bottle.": {
        "file": "905847e00ae41a741852.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The machine making hats for hats produces a small book.": {
        "file": "02fa9b5c6fe6b3792255.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The machine making hats for hats produces a small bottle.": {
        "file": "e691e8a087fb27402f09.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The machine making hats for hats produces a large computer.": {
        "file": "8f6c5239c26eef5fb15f.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The machine making hats for hats produces a large shoe.": {
        "file": "e2f7b6976d0457cf5ce3.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The machine making hats for hats produces a small computer.": {
        "file": "a3821fd648ef740e1c97.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The machine making hats for hats produces a small shoe.": {
        "file": "8bd6ced196f3e840bdef.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The machine making hats for hats produces a large phone.": {
        "file": "d07e507c44a0847b7fe0.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The machine making hats for hats produces a large fish.": {
        "file": "4dec2c5011e5c01ebbdc.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The machine making hats for hats produces a small phone.": {
        "file": "eed2e392eb573cf8071f.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The machine making hats for hats produces a small fish.": {
        "file": "1825ffb65dfe8cb6a707.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The machine making hats for hats produces a large cup.": {
        "file": "16059483cefc35337367.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The machine making hats for hats produces a large ticket.": {
        "file": "9c6934c24598c78e7c6f.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The machine making hats for hats produces a small cup.": {
        "file": "731d0be4e221039c405c.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The machine making hats for hats produces a small ticket.": {
        "file": "202a2edff9b8cb47cf17.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The machine making hats for hats produces a large magazine.": {
        "file": "04680d27f238aeddb50d.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The machine making hats for hats produces a large gift.": {
        "file": "c06e284b2c7b8251b7ec.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The machine making hats for hats produces a small magazine.": {
        "file": "14e83b8e5208d8e19183.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The machine making hats for hats produces a small gift.": {
        "file": "8f6deecf77264d1503fc.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The machine creating extra waiting lines has two tickets beside it.": {
        "file": "8e683d756c2d3e2832fe.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "The machine creating extra waiting lines has two robots beside it.": {
        "file": "b6d52fc7fc08e6212f0a.mp3",
        "bank": "en-oo1",
        "durationMs": 4117
    },
    "The machine creating extra waiting lines has three tickets beside it.": {
        "file": "af91027cfbcb2ad45933.mp3",
        "bank": "en-oo1",
        "durationMs": 3947
    },
    "The machine creating extra waiting lines has three robots beside it.": {
        "file": "9ad0eba51498bc14ce4c.mp3",
        "bank": "en-oo1",
        "durationMs": 4181
    },
    "The machine creating extra waiting lines has two computers beside it.": {
        "file": "048c19c68008786f422b.mp3",
        "bank": "en-oo1",
        "durationMs": 4117
    },
    "The machine creating extra waiting lines has two gifts beside it.": {
        "file": "b872e51a25900e04b644.mp3",
        "bank": "en-oo1",
        "durationMs": 3861
    },
    "The machine creating extra waiting lines has four computers beside it.": {
        "file": "320aa9b9216666cb1203.mp3",
        "bank": "en-oo1",
        "durationMs": 4181
    },
    "The machine creating extra waiting lines has four gifts beside it.": {
        "file": "bb55b54d0e60a0ba335e.mp3",
        "bank": "en-oo1",
        "durationMs": 3925
    },
    "The machine creating extra waiting lines has two fish beside it.": {
        "file": "72e121918f87732209cc.mp3",
        "bank": "en-oo1",
        "durationMs": 3861
    },
    "The machine creating extra waiting lines has two hats beside it.": {
        "file": "362931bafc011d6b15b6.mp3",
        "bank": "en-oo1",
        "durationMs": 3819
    },
    "The machine creating extra waiting lines has three fish beside it.": {
        "file": "4e6e8d5d6ae2e0587080.mp3",
        "bank": "en-oo1",
        "durationMs": 3947
    },
    "The machine creating extra waiting lines has three hats beside it.": {
        "file": "9b3d237a27dc780c1ee8.mp3",
        "bank": "en-oo1",
        "durationMs": 3883
    },
    "The machine creating extra waiting lines has two glasses beside it.": {
        "file": "ae1cc5ec91306ac85da7.mp3",
        "bank": "en-oo1",
        "durationMs": 4075
    },
    "The machine creating extra waiting lines has two shoes beside it.": {
        "file": "b121ab4249bbae46e157.mp3",
        "bank": "en-oo1",
        "durationMs": 3840
    },
    "The machine creating extra waiting lines has four glasses beside it.": {
        "file": "9604edb269017c3846f4.mp3",
        "bank": "en-oo1",
        "durationMs": 4096
    },
    "The machine creating extra waiting lines has four shoes beside it.": {
        "file": "7c98a3c026b585693b6a.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "The machine creating extra waiting lines has two dogs beside it.": {
        "file": "3c4bd0a3c953f32e6846.mp3",
        "bank": "en-oo1",
        "durationMs": 3947
    },
    "The machine creating extra waiting lines has two boxes beside it.": {
        "file": "0c8391c8d624ba3fcb1c.mp3",
        "bank": "en-oo1",
        "durationMs": 4096
    },
    "The machine creating extra waiting lines has three dogs beside it.": {
        "file": "d1ac8b19f01de34cde0d.mp3",
        "bank": "en-oo1",
        "durationMs": 4011
    },
    "The machine creating extra waiting lines has three boxes beside it.": {
        "file": "180e2140b87cd595e2a3.mp3",
        "bank": "en-oo1",
        "durationMs": 4160
    },
    "The robot submitting its work on paper keeps a glass beside the computer.": {
        "file": "c77dd6b71d53c936d94d.mp3",
        "bank": "en-oo1",
        "durationMs": 4203
    },
    "The robot submitting its work on paper keeps a glass behind the computer.": {
        "file": "d2c3b228720ed5a23a98.mp3",
        "bank": "en-oo1",
        "durationMs": 4181
    },
    "The robot submitting its work on paper keeps a box beside the computer.": {
        "file": "41cf816e3e9efb47e4de.mp3",
        "bank": "en-oo1",
        "durationMs": 4203
    },
    "The robot submitting its work on paper keeps a box behind the computer.": {
        "file": "0b7d8e6d2529a2cb9277.mp3",
        "bank": "en-oo1",
        "durationMs": 4117
    },
    "The robot submitting its work on paper keeps a picture beside the computer.": {
        "file": "ec824c127f6eb1ed965e.mp3",
        "bank": "en-oo1",
        "durationMs": 4203
    },
    "The robot submitting its work on paper keeps a picture behind the computer.": {
        "file": "a6ae6349ef990a1f7e19.mp3",
        "bank": "en-oo1",
        "durationMs": 4245
    },
    "The robot submitting its work on paper keeps a ticket beside the computer.": {
        "file": "c525bfd00e57b662a631.mp3",
        "bank": "en-oo1",
        "durationMs": 4203
    },
    "The robot submitting its work on paper keeps a ticket behind the computer.": {
        "file": "48a4d7734306b98fd526.mp3",
        "bank": "en-oo1",
        "durationMs": 4267
    },
    "The robot submitting its work on paper keeps a robot beside the computer.": {
        "file": "ff73bafb1a5801057769.mp3",
        "bank": "en-oo1",
        "durationMs": 4416
    },
    "The robot submitting its work on paper keeps a robot behind the computer.": {
        "file": "e09fc3ce291c34024ff2.mp3",
        "bank": "en-oo1",
        "durationMs": 4437
    },
    "The robot submitting its work on paper keeps a fish beside the computer.": {
        "file": "24413f1126562b110930.mp3",
        "bank": "en-oo1",
        "durationMs": 4181
    },
    "The robot submitting its work on paper keeps a fish behind the computer.": {
        "file": "5809d278384ea85b5e52.mp3",
        "bank": "en-oo1",
        "durationMs": 4117
    },
    "The robot submitting its work on paper keeps a shoe beside the computer.": {
        "file": "25f890d61300b42738d1.mp3",
        "bank": "en-oo1",
        "durationMs": 4139
    },
    "The robot submitting its work on paper keeps a shoe behind the computer.": {
        "file": "f1f0651da2b73c115c81.mp3",
        "bank": "en-oo1",
        "durationMs": 4096
    },
    "The robot submitting its work on paper keeps a gift beside the computer.": {
        "file": "ee08e0d4eb6e9cd5bee6.mp3",
        "bank": "en-oo1",
        "durationMs": 4181
    },
    "The robot submitting its work on paper keeps a gift behind the computer.": {
        "file": "ae537547dbe4c3df2aa0.mp3",
        "bank": "en-oo1",
        "durationMs": 4139
    },
    "The robot submitting its work on paper keeps a bottle beside the computer.": {
        "file": "b468b78a3fb98b739805.mp3",
        "bank": "en-oo1",
        "durationMs": 4245
    },
    "The robot submitting its work on paper keeps a bottle behind the computer.": {
        "file": "efdfa155ae86bd980201.mp3",
        "bank": "en-oo1",
        "durationMs": 4267
    },
    "The robot submitting its work on paper keeps a book beside the computer.": {
        "file": "bf897019d2d45e70cb64.mp3",
        "bank": "en-oo1",
        "durationMs": 4096
    },
    "The robot submitting its work on paper keeps a book behind the computer.": {
        "file": "d5d7875a0130ceae217a.mp3",
        "bank": "en-oo1",
        "durationMs": 4117
    },
    "The robot forgetting its homework is wearing a large hat and carrying a glass.": {
        "file": "549df49d38494f73f9c2.mp3",
        "bank": "en-oo1",
        "durationMs": 4480
    },
    "The robot forgetting its homework is wearing a large hat and carrying a phone.": {
        "file": "13957326fca52f72c217.mp3",
        "bank": "en-oo1",
        "durationMs": 4480
    },
    "The robot forgetting its homework is wearing a small hat and carrying a glass.": {
        "file": "661d9c112fd63340894b.mp3",
        "bank": "en-oo1",
        "durationMs": 4459
    },
    "The robot forgetting its homework is wearing a small hat and carrying a phone.": {
        "file": "547d1aa32ab25f00a6a1.mp3",
        "bank": "en-oo1",
        "durationMs": 4437
    },
    "The robot forgetting its homework is wearing a long scarf and carrying a fish.": {
        "file": "b1abb533b0658552bb9d.mp3",
        "bank": "en-oo1",
        "durationMs": 4523
    },
    "The robot forgetting its homework is wearing a long scarf and carrying a robot.": {
        "file": "8a895e694e1cba5b690b.mp3",
        "bank": "en-oo1",
        "durationMs": 4736
    },
    "The robot forgetting its homework is wearing a short scarf and carrying a fish.": {
        "file": "431555e3871c764cc3e2.mp3",
        "bank": "en-oo1",
        "durationMs": 4544
    },
    "The robot forgetting its homework is wearing a short scarf and carrying a robot.": {
        "file": "26a82eb3deb9d4e5502c.mp3",
        "bank": "en-oo1",
        "durationMs": 4693
    },
    "The robot forgetting its homework is wearing round glasses and carrying a picture.": {
        "file": "49d3842fe1e3fc1018ba.mp3",
        "bank": "en-oo1",
        "durationMs": 4629
    },
    "The robot forgetting its homework is wearing round glasses and carrying a box.": {
        "file": "72424766693d4737e8d2.mp3",
        "bank": "en-oo1",
        "durationMs": 4587
    },
    "The robot forgetting its homework is wearing square glasses and carrying a picture.": {
        "file": "03ff975d9de9b6291429.mp3",
        "bank": "en-oo1",
        "durationMs": 4672
    },
    "The robot forgetting its homework is wearing square glasses and carrying a box.": {
        "file": "99696f0be67ab5e4e940.mp3",
        "bank": "en-oo1",
        "durationMs": 4651
    },
    "The robot forgetting its homework is wearing a jacket with two pockets and carrying a book.": {
        "file": "e84d99ff7d75d71e070a.mp3",
        "bank": "en-oo1",
        "durationMs": 5141
    },
    "The robot forgetting its homework is wearing a jacket with two pockets and carrying a pencil.": {
        "file": "ba25ea32f40302ff5662.mp3",
        "bank": "en-oo1",
        "durationMs": 5312
    },
    "The robot forgetting its homework is wearing a jacket with four pockets and carrying a book.": {
        "file": "775ae96324e65851f622.mp3",
        "bank": "en-oo1",
        "durationMs": 5205
    },
    "The robot forgetting its homework is wearing a jacket with four pockets and carrying a pencil.": {
        "file": "009ba549eaf068bb6223.mp3",
        "bank": "en-oo1",
        "durationMs": 5376
    },
    "The robot forgetting its homework is wearing a shirt with long sleeves and carrying a magazine.": {
        "file": "75fc57b83da80d216fa4.mp3",
        "bank": "en-oo1",
        "durationMs": 5376
    },
    "The robot forgetting its homework is wearing a shirt with long sleeves and carrying a hat.": {
        "file": "5df7cbe7a7ef53cf4b61.mp3",
        "bank": "en-oo1",
        "durationMs": 5013
    },
    "The robot forgetting its homework is wearing a shirt with short sleeves and carrying a magazine.": {
        "file": "70f7c5430699702b800c.mp3",
        "bank": "en-oo1",
        "durationMs": 5333
    },
    "The robot forgetting its homework is wearing a shirt with short sleeves and carrying a hat.": {
        "file": "bb8d9cb70cb49fdcca00.mp3",
        "bank": "en-oo1",
        "durationMs": 4971
    },
    "The future's washing machine returns two bags with one sock.": {
        "file": "d7bbbd741036d291a9ae.mp3",
        "bank": "en-oo1",
        "durationMs": 3776
    },
    "The future's washing machine returns two eggs with one sock.": {
        "file": "4ebb643c2e31c03f87b4.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The future's washing machine returns three bags with one sock.": {
        "file": "21d338dcc2d7cf269443.mp3",
        "bank": "en-oo1",
        "durationMs": 3883
    },
    "The future's washing machine returns three eggs with one sock.": {
        "file": "6483dc76bbe7fbd87d9a.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The future's washing machine returns two glasses with one sock.": {
        "file": "ed52364500ddc2854425.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "The future's washing machine returns two books with one sock.": {
        "file": "490ff0d70c441b0e250e.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The future's washing machine returns four glasses with one sock.": {
        "file": "789fe7526cad5d86e03a.mp3",
        "bank": "en-oo1",
        "durationMs": 3968
    },
    "The future's washing machine returns four books with one sock.": {
        "file": "3da9f20a463482f4a9de.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The future's washing machine returns two tickets with one sock.": {
        "file": "36b0ee6f5ff9b4ccfb87.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The future's washing machine returns two cups with one sock.": {
        "file": "7bdf95e3bac62b49de79.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The future's washing machine returns three tickets with one sock.": {
        "file": "1fc6889c80b994b9a3dc.mp3",
        "bank": "en-oo1",
        "durationMs": 3883
    },
    "The future's washing machine returns three cups with one sock.": {
        "file": "44dc1c825827b95d052c.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The future's washing machine returns two bottles with one sock.": {
        "file": "57f7f64e40f25b40fc5e.mp3",
        "bank": "en-oo1",
        "durationMs": 3883
    },
    "The future's washing machine returns two fish with one sock.": {
        "file": "0de2f0bba27632e77c15.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "The future's washing machine returns four bottles with one sock.": {
        "file": "5de878f1a0577c499b75.mp3",
        "bank": "en-oo1",
        "durationMs": 3883
    },
    "The future's washing machine returns four fish with one sock.": {
        "file": "bef68fc134032bd57ca4.mp3",
        "bank": "en-oo1",
        "durationMs": 3776
    },
    "The future's washing machine returns two hats with one sock.": {
        "file": "bfaf4b40f45d61672b32.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "The future's washing machine returns two pictures with one sock.": {
        "file": "f9aaee2cc316f1a5e49c.mp3",
        "bank": "en-oo1",
        "durationMs": 3947
    },
    "The future's washing machine returns three hats with one sock.": {
        "file": "2e1ce58b97edd8d00fd5.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The future's washing machine returns three pictures with one sock.": {
        "file": "d8cd9e5479de71698fa3.mp3",
        "bank": "en-oo1",
        "durationMs": 3968
    },
    "The robot fixing an old printer is holding a gift.": {
        "file": "bd742b14a612b5796c36.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The robot fixing an old printer is holding a cup.": {
        "file": "c22ab9640ff5d6e68966.mp3",
        "bank": "en-oo1",
        "durationMs": 3072
    },
    "The robot fixing an old printer is pulling a gift.": {
        "file": "056bcc6eb02356ea8bae.mp3",
        "bank": "en-oo1",
        "durationMs": 3008
    },
    "The robot fixing an old printer is pulling a cup.": {
        "file": "1b4a4b043c9b940dc72f.mp3",
        "bank": "en-oo1",
        "durationMs": 2880
    },
    "The robot fixing an old printer is holding a ticket.": {
        "file": "992938c0a687da06d928.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The robot fixing an old printer is holding a book.": {
        "file": "0a83988c615547da028f.mp3",
        "bank": "en-oo1",
        "durationMs": 3029
    },
    "The robot fixing an old printer is pulling a ticket.": {
        "file": "1e8e6d8123117844bee2.mp3",
        "bank": "en-oo1",
        "durationMs": 3008
    },
    "The robot fixing an old printer is pulling a book.": {
        "file": "7d74c8a812185eed25f9.mp3",
        "bank": "en-oo1",
        "durationMs": 2880
    },
    "The robot fixing an old printer is holding a glass.": {
        "file": "8b1d1bed0565b6d2ca04.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The robot fixing an old printer is holding a fish.": {
        "file": "b765a2966dc9d3688d36.mp3",
        "bank": "en-oo1",
        "durationMs": 3029
    },
    "The robot fixing an old printer is pulling a glass.": {
        "file": "dd525bdd2da3ceeb6c07.mp3",
        "bank": "en-oo1",
        "durationMs": 3008
    },
    "The robot fixing an old printer is pulling a fish.": {
        "file": "532a0804d11e257eb5c5.mp3",
        "bank": "en-oo1",
        "durationMs": 2859
    },
    "The robot fixing an old printer is holding a computer.": {
        "file": "77377357f11163ea0d76.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The robot fixing an old printer is holding a bag.": {
        "file": "2da0315f5a54c9ac727a.mp3",
        "bank": "en-oo1",
        "durationMs": 2987
    },
    "The robot fixing an old printer is pulling a computer.": {
        "file": "8483d3e693d49a65869f.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The robot fixing an old printer is pulling a bag.": {
        "file": "87b5b162a4a9c8fc7497.mp3",
        "bank": "en-oo1",
        "durationMs": 2944
    },
    "The robot fixing an old printer is holding a dog.": {
        "file": "2eb1a98f92f260384b76.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The robot fixing an old printer is holding a box.": {
        "file": "df8e1249f84a03b2aacf.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The robot fixing an old printer is pulling a dog.": {
        "file": "5db699a0ed314565b2a4.mp3",
        "bank": "en-oo1",
        "durationMs": 2880
    },
    "The robot fixing an old printer is pulling a box.": {
        "file": "5faa4d61a880b4b39e57.mp3",
        "bank": "en-oo1",
        "durationMs": 2987
    },
    "The charger waiting to be charged carries a large egg.": {
        "file": "9dd05c40796790ea8898.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The charger waiting to be charged carries a large computer.": {
        "file": "da7d2f30a83b48ed53f9.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The charger waiting to be charged carries a small egg.": {
        "file": "9c0676a1d8cb06e81dd5.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The charger waiting to be charged carries a small computer.": {
        "file": "9222c850b576c8874a04.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The charger waiting to be charged carries a large dog.": {
        "file": "be7c8c9abdec9caf4e34.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The charger waiting to be charged carries a large box.": {
        "file": "c66198c83d34bd4ed7c5.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The charger waiting to be charged carries a small dog.": {
        "file": "83065ed28a5bedc97052.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The charger waiting to be charged carries a small box.": {
        "file": "71f90e4fddb2c909a69b.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The charger waiting to be charged carries a large bottle.": {
        "file": "32454637df9c22b07653.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The charger waiting to be charged carries a large cup.": {
        "file": "8c807e01942c76327716.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The charger waiting to be charged carries a small bottle.": {
        "file": "5ab99dc06de4db2e915f.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The charger waiting to be charged carries a small cup.": {
        "file": "546a1dedd32a7ecf0390.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The charger waiting to be charged carries a large robot.": {
        "file": "2efd82e96e06ba74e887.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The charger waiting to be charged carries a large glass.": {
        "file": "cdcdb9df5834ffb05c04.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The charger waiting to be charged carries a small robot.": {
        "file": "9d12778dc94381d20524.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The charger waiting to be charged carries a small glass.": {
        "file": "bf1ab4ed243552117ae7.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The charger waiting to be charged carries a large ticket.": {
        "file": "3b24bb286ef8c2d55770.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The charger waiting to be charged carries a large flower.": {
        "file": "dcc26cc3c4517278d4f5.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The charger waiting to be charged carries a small ticket.": {
        "file": "98c7be25ea3884b688ca.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The charger waiting to be charged carries a small flower.": {
        "file": "c7d65cdc676d718541be.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The flying delivery box lands with a gift on its top.": {
        "file": "83c4fe9cb2ee7900634a.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The flying delivery box lands with a gift under its base.": {
        "file": "ae1b4660830685adb69e.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The flying delivery box lands with a ticket on its top.": {
        "file": "9dfca2fc18b94680ec0f.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The flying delivery box lands with a ticket under its base.": {
        "file": "97e1a13f722b5d3acdb4.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The flying delivery box lands with a box on its top.": {
        "file": "714cfb93227f76c49086.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The flying delivery box lands with a box under its base.": {
        "file": "d7be7ab5c9c0c74dce06.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The flying delivery box lands with a bottle on its top.": {
        "file": "4d3e6d8c4014d85cc368.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The flying delivery box lands with a bottle under its base.": {
        "file": "6775ebfd3e4aa4a1b81e.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The flying delivery box lands with a hat on its top.": {
        "file": "f5f0f7dbacd76c90e83b.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The flying delivery box lands with a hat under its base.": {
        "file": "c4f9acc53b93da986a62.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The flying delivery box lands with a phone on its top.": {
        "file": "3938d44d212ee4e18f35.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The flying delivery box lands with a phone under its base.": {
        "file": "8f4af2205560d73c2fbd.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The flying delivery box lands with a glass on its top.": {
        "file": "9b8fc4b99bb9923d9b47.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The flying delivery box lands with a glass under its base.": {
        "file": "725248d192411ebcf685.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The flying delivery box lands with a robot on its top.": {
        "file": "360e6ef5c5dc70be30c9.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The flying delivery box lands with a robot under its base.": {
        "file": "5bd5f70e565711bee55a.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "The flying delivery box lands with a picture on its top.": {
        "file": "7702f1ddedb08fd17ce4.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The flying delivery box lands with a picture under its base.": {
        "file": "79b5059e6497be291677.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The flying delivery box lands with a fish on its top.": {
        "file": "91d3f0e81c84927bd544.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The flying delivery box lands with a fish under its base.": {
        "file": "b47dcaafa77936201f41.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The robot cooking a very simple dinner uses two glasses.": {
        "file": "ee8a09cfa31901585aa7.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The robot cooking a very simple dinner uses two hats.": {
        "file": "896099b20b6c41567777.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The robot cooking a very simple dinner uses three glasses.": {
        "file": "506fc9f6b2940b93c871.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The robot cooking a very simple dinner uses three hats.": {
        "file": "1625f49a5e316ef20ad6.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The robot cooking a very simple dinner uses two cameras.": {
        "file": "fcf4ebe0222e08db20a6.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The robot cooking a very simple dinner uses two robots.": {
        "file": "b910278474f1f7813d2b.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The robot cooking a very simple dinner uses four cameras.": {
        "file": "01d10088cfa160ec544e.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The robot cooking a very simple dinner uses four robots.": {
        "file": "d7c5649f35e456bf53b2.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The robot cooking a very simple dinner uses two boxes.": {
        "file": "edd14b205871d8721881.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The robot cooking a very simple dinner uses two books.": {
        "file": "f632ae2bdcd609189304.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The robot cooking a very simple dinner uses three boxes.": {
        "file": "25e25b7b03867c702cc8.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The robot cooking a very simple dinner uses three books.": {
        "file": "5cb97e1412a3d08150fe.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The robot cooking a very simple dinner uses two cats.": {
        "file": "b697bab23726073023f4.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The robot cooking a very simple dinner uses two fish.": {
        "file": "3a22289861d951b2cb53.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The robot cooking a very simple dinner uses four cats.": {
        "file": "c852e0d47dafb1ffce51.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The robot cooking a very simple dinner uses four fish.": {
        "file": "4488cc29127b2aecec55.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The robot cooking a very simple dinner uses two computers.": {
        "file": "c09ca847a3a2389a61fb.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The robot cooking a very simple dinner uses two phones.": {
        "file": "c1c2111af07cb59b77b3.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The robot cooking a very simple dinner uses three computers.": {
        "file": "8a1c1d08cf4665f6e6cd.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The robot cooking a very simple dinner uses three phones.": {
        "file": "7f92e5d57b8eb7663eb3.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "At the bank for spare time, a gift is on the desk.": {
        "file": "f64fd969f0234c43def3.mp3",
        "bank": "en-oo1",
        "durationMs": 2987
    },
    "At the bank for spare time, a gift is under the desk.": {
        "file": "2b140a5994018067ec72.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "At the bank for spare time, a glass is on the desk.": {
        "file": "967f4e667e8a5b3f488b.mp3",
        "bank": "en-oo1",
        "durationMs": 3008
    },
    "At the bank for spare time, a glass is under the desk.": {
        "file": "331fba8a7232c661430e.mp3",
        "bank": "en-oo1",
        "durationMs": 3051
    },
    "At the bank for spare time, a cup is on the desk.": {
        "file": "3b743bcd6f442f2941a5.mp3",
        "bank": "en-oo1",
        "durationMs": 2837
    },
    "At the bank for spare time, a cup is under the desk.": {
        "file": "fedee1581a941c1d7c77.mp3",
        "bank": "en-oo1",
        "durationMs": 2944
    },
    "At the bank for spare time, a fish is on the desk.": {
        "file": "cf95c2cdadc040705859.mp3",
        "bank": "en-oo1",
        "durationMs": 2987
    },
    "At the bank for spare time, a fish is under the desk.": {
        "file": "4f65f8b41ef578e1f710.mp3",
        "bank": "en-oo1",
        "durationMs": 2987
    },
    "At the bank for spare time, a phone is on the desk.": {
        "file": "b9c1a263ffc11784804c.mp3",
        "bank": "en-oo1",
        "durationMs": 2965
    },
    "At the bank for spare time, a phone is under the desk.": {
        "file": "49efedfb937ec46974d9.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "At the bank for spare time, a cat is on the desk.": {
        "file": "9d7d69179bd140ccd896.mp3",
        "bank": "en-oo1",
        "durationMs": 2859
    },
    "At the bank for spare time, a cat is under the desk.": {
        "file": "a7dd5c8ead2e7945a827.mp3",
        "bank": "en-oo1",
        "durationMs": 2965
    },
    "At the bank for spare time, a computer is on the desk.": {
        "file": "8b025dea18fddae549f2.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "At the bank for spare time, a computer is under the desk.": {
        "file": "2e1da63a9019113fe2e4.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "At the bank for spare time, a ticket is on the desk.": {
        "file": "13de71bbacbb188a36e2.mp3",
        "bank": "en-oo1",
        "durationMs": 3051
    },
    "At the bank for spare time, a ticket is under the desk.": {
        "file": "21c2871f0b0f7ce9f284.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "At the bank for spare time, a bottle is on the desk.": {
        "file": "c616a0fd9a9f2d14a688.mp3",
        "bank": "en-oo1",
        "durationMs": 3051
    },
    "At the bank for spare time, a bottle is under the desk.": {
        "file": "db14efe8e9fa914095c6.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "At the bank for spare time, a shoe is on the desk.": {
        "file": "9ba638e8a124478d00ac.mp3",
        "bank": "en-oo1",
        "durationMs": 2880
    },
    "At the bank for spare time, a shoe is under the desk.": {
        "file": "7dff74dc0b46da23ad56.mp3",
        "bank": "en-oo1",
        "durationMs": 3029
    },
    "The computer taking its person for a walk is wearing a large hat and holding a box.": {
        "file": "a4d5460d21a20b509249.mp3",
        "bank": "en-oo1",
        "durationMs": 5035
    },
    "The computer taking its person for a walk is wearing a large hat and holding a glass.": {
        "file": "9f98d187438edab8a0f8.mp3",
        "bank": "en-oo1",
        "durationMs": 5056
    },
    "The computer taking its person for a walk is wearing a small hat and holding a box.": {
        "file": "1b0b98ca4832902edf1c.mp3",
        "bank": "en-oo1",
        "durationMs": 5013
    },
    "The computer taking its person for a walk is wearing a small hat and holding a glass.": {
        "file": "fbd221b3fd048db83685.mp3",
        "bank": "en-oo1",
        "durationMs": 4992
    },
    "The computer taking its person for a walk is wearing a long scarf and holding a robot.": {
        "file": "3f2c6211b3be44f38651.mp3",
        "bank": "en-oo1",
        "durationMs": 5269
    },
    "The computer taking its person for a walk is wearing a long scarf and holding a dog.": {
        "file": "23c3f4b2adb607924c93.mp3",
        "bank": "en-oo1",
        "durationMs": 5035
    },
    "The computer taking its person for a walk is wearing a short scarf and holding a robot.": {
        "file": "3537ddfb8217085ea41b.mp3",
        "bank": "en-oo1",
        "durationMs": 5312
    },
    "The computer taking its person for a walk is wearing a short scarf and holding a dog.": {
        "file": "ada41fb261a7922c9f0a.mp3",
        "bank": "en-oo1",
        "durationMs": 5077
    },
    "The computer taking its person for a walk is wearing round glasses and holding a fish.": {
        "file": "8c2e6cc048aa66214d1c.mp3",
        "bank": "en-oo1",
        "durationMs": 5013
    },
    "The computer taking its person for a walk is wearing round glasses and holding a hat.": {
        "file": "59202efedae5357790cb.mp3",
        "bank": "en-oo1",
        "durationMs": 4992
    },
    "The computer taking its person for a walk is wearing square glasses and holding a fish.": {
        "file": "c1e86522f281645a634c.mp3",
        "bank": "en-oo1",
        "durationMs": 5141
    },
    "The computer taking its person for a walk is wearing square glasses and holding a hat.": {
        "file": "b144b3b70a50fd635ca1.mp3",
        "bank": "en-oo1",
        "durationMs": 5099
    },
    "The computer taking its person for a walk is wearing a jacket with two pockets and holding a gift.": {
        "file": "f41932d664f74681b795.mp3",
        "bank": "en-oo1",
        "durationMs": 5803
    },
    "The computer taking its person for a walk is wearing a jacket with two pockets and holding an apple.": {
        "file": "674bf08d4bc65a201aa2.mp3",
        "bank": "en-oo1",
        "durationMs": 5696
    },
    "The computer taking its person for a walk is wearing a jacket with four pockets and holding a gift.": {
        "file": "68737d0c641c91b18df1.mp3",
        "bank": "en-oo1",
        "durationMs": 5931
    },
    "The computer taking its person for a walk is wearing a jacket with four pockets and holding an apple.": {
        "file": "6c5221dce712ef79eb32.mp3",
        "bank": "en-oo1",
        "durationMs": 5909
    },
    "The computer taking its person for a walk is wearing a shirt with long sleeves and holding a bottle.": {
        "file": "af24c3ab40df0349ba58.mp3",
        "bank": "en-oo1",
        "durationMs": 5717
    },
    "The computer taking its person for a walk is wearing a shirt with long sleeves and holding a bag.": {
        "file": "b9539bb5643f10045ddc.mp3",
        "bank": "en-oo1",
        "durationMs": 5611
    },
    "The computer taking its person for a walk is wearing a shirt with short sleeves and holding a bottle.": {
        "file": "393dcf0bd33a1c487a37.mp3",
        "bank": "en-oo1",
        "durationMs": 5568
    },
    "The computer taking its person for a walk is wearing a shirt with short sleeves and holding a bag.": {
        "file": "ff4880206444f0371190.mp3",
        "bank": "en-oo1",
        "durationMs": 5632
    },
    "The time traveler returning for lunch brings two gifts.": {
        "file": "9f596afe51d9911e2354.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The time traveler returning for lunch brings two fish.": {
        "file": "2fc4d3c32d9d2835cc65.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "The time traveler returning for lunch brings three gifts.": {
        "file": "d1befef1671a7e878d6b.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The time traveler returning for lunch brings three fish.": {
        "file": "d98aec43386c06ccd227.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "The time traveler returning for lunch brings two glasses.": {
        "file": "4895d6697f7f42794256.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The time traveler returning for lunch brings two books.": {
        "file": "d740230f66a5624aebbf.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "The time traveler returning for lunch brings four glasses.": {
        "file": "ccab0a8f5290443fbc22.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The time traveler returning for lunch brings four books.": {
        "file": "a944a0dfd3fa22f380de.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The time traveler returning for lunch brings two cups.": {
        "file": "61b30fd96190a22cb27f.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "The time traveler returning for lunch brings two eggs.": {
        "file": "fe6e0069b22e125b9fa5.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The time traveler returning for lunch brings three cups.": {
        "file": "3c05d176b6b05a750bf8.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The time traveler returning for lunch brings three eggs.": {
        "file": "14a1aa92ab203af7c883.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The time traveler returning for lunch brings two boxes.": {
        "file": "73625ae43433a7467823.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The time traveler returning for lunch brings two shoes.": {
        "file": "975b80525bd2aaad463e.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The time traveler returning for lunch brings four boxes.": {
        "file": "d49d9219c0b42f8ad42d.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The time traveler returning for lunch brings four shoes.": {
        "file": "33d64e7a9b3e1cb10264.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The time traveler returning for lunch brings two flowers.": {
        "file": "1464937e3cae2ff2a7d5.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The time traveler returning for lunch brings two phones.": {
        "file": "fa50c55c9a08854561bf.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The time traveler returning for lunch brings three flowers.": {
        "file": "c7db611dc84a1340b838.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The time traveler returning for lunch brings three phones.": {
        "file": "1301beed97051c53b88f.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "In the cats' survey, there are more glasses than cats.": {
        "file": "595f710de40681c7b381.mp3",
        "bank": "en-oo1",
        "durationMs": 2880
    },
    "In the cats' survey, there are more gifts than cats.": {
        "file": "45dfe2d2cb2d82ec8439.mp3",
        "bank": "en-oo1",
        "durationMs": 2731
    },
    "In the cats' survey, there are fewer glasses than cats.": {
        "file": "b68dc8cd62d714c92edf.mp3",
        "bank": "en-oo1",
        "durationMs": 3029
    },
    "In the cats' survey, there are fewer gifts than cats.": {
        "file": "69fc7302d7b27ea85b68.mp3",
        "bank": "en-oo1",
        "durationMs": 2816
    },
    "In the cats' survey, there are more bottles than cats.": {
        "file": "26c4d0b6ef63d8ea8852.mp3",
        "bank": "en-oo1",
        "durationMs": 2880
    },
    "In the cats' survey, there are more bags than cats.": {
        "file": "8f87773930b85a23df2e.mp3",
        "bank": "en-oo1",
        "durationMs": 2773
    },
    "In the cats' survey, there are fewer bottles than cats.": {
        "file": "ff48d381afc45272d3a4.mp3",
        "bank": "en-oo1",
        "durationMs": 2944
    },
    "In the cats' survey, there are fewer bags than cats.": {
        "file": "23dfad9aecc412d90ea2.mp3",
        "bank": "en-oo1",
        "durationMs": 2837
    },
    "In the cats' survey, there are more cups than cats.": {
        "file": "697d919582faf3cde1f5.mp3",
        "bank": "en-oo1",
        "durationMs": 2688
    },
    "In the cats' survey, there are more boxes than cats.": {
        "file": "45e71a83bb7b34a27569.mp3",
        "bank": "en-oo1",
        "durationMs": 2901
    },
    "In the cats' survey, there are fewer cups than cats.": {
        "file": "72c7f98ded4b8b91af1c.mp3",
        "bank": "en-oo1",
        "durationMs": 2752
    },
    "In the cats' survey, there are fewer boxes than cats.": {
        "file": "816f93a9d1d1accc3516.mp3",
        "bank": "en-oo1",
        "durationMs": 3029
    },
    "In the cats' survey, there are more robots than cats.": {
        "file": "5707c39b4b81d2b9fc95.mp3",
        "bank": "en-oo1",
        "durationMs": 2944
    },
    "In the cats' survey, there are more pictures than cats.": {
        "file": "d1c9780d4a9786818861.mp3",
        "bank": "en-oo1",
        "durationMs": 2944
    },
    "In the cats' survey, there are fewer robots than cats.": {
        "file": "682579198be2eeeff714.mp3",
        "bank": "en-oo1",
        "durationMs": 3072
    },
    "In the cats' survey, there are fewer pictures than cats.": {
        "file": "888b871091fce490162b.mp3",
        "bank": "en-oo1",
        "durationMs": 3008
    },
    "In the cats' survey, there are more eggs than cats.": {
        "file": "65bd1b5e90e0abc0607e.mp3",
        "bank": "en-oo1",
        "durationMs": 2773
    },
    "In the cats' survey, there are more dogs than cats.": {
        "file": "dcd9438644bf1c7d211a.mp3",
        "bank": "en-oo1",
        "durationMs": 2816
    },
    "In the cats' survey, there are fewer eggs than cats.": {
        "file": "06e1106cbb8b501a849e.mp3",
        "bank": "en-oo1",
        "durationMs": 2923
    },
    "In the cats' survey, there are fewer dogs than cats.": {
        "file": "c387bcd92839be4122bb.mp3",
        "bank": "en-oo1",
        "durationMs": 2901
    },
    "At the meeting about fewer meetings, there are more fish than people.": {
        "file": "5f3c9a6591d7c08e71b9.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "At the meeting about fewer meetings, there are more gifts than people.": {
        "file": "926e80fcfff804b244f9.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "At the meeting about fewer meetings, there are fewer fish than people.": {
        "file": "37caf247bf691e7f432e.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "At the meeting about fewer meetings, there are fewer gifts than people.": {
        "file": "4e2d9a4328a02226fe9c.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "At the meeting about fewer meetings, there are more coins than people.": {
        "file": "e88cccafd599e92706f0.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "At the meeting about fewer meetings, there are more chairs than people.": {
        "file": "f6a8f2419aa7b55f2344.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "At the meeting about fewer meetings, there are fewer coins than people.": {
        "file": "509547726b258cc71da5.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "At the meeting about fewer meetings, there are fewer chairs than people.": {
        "file": "79f2de4a47d495ae11c1.mp3",
        "bank": "en-oo1",
        "durationMs": 3819
    },
    "At the meeting about fewer meetings, there are more glasses than people.": {
        "file": "608d067ac8fa6f35ef6d.mp3",
        "bank": "en-oo1",
        "durationMs": 3776
    },
    "At the meeting about fewer meetings, there are more boxes than people.": {
        "file": "064968755a7c39fce76a.mp3",
        "bank": "en-oo1",
        "durationMs": 3776
    },
    "At the meeting about fewer meetings, there are fewer glasses than people.": {
        "file": "53134cd6dd47bb3b996d.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "At the meeting about fewer meetings, there are fewer boxes than people.": {
        "file": "5663f1149c4764589cf2.mp3",
        "bank": "en-oo1",
        "durationMs": 3883
    },
    "At the meeting about fewer meetings, there are more bottles than people.": {
        "file": "c3587b76918058aa41c7.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "At the meeting about fewer meetings, there are more tickets than people.": {
        "file": "a94f0a20412d049e66e4.mp3",
        "bank": "en-oo1",
        "durationMs": 3776
    },
    "At the meeting about fewer meetings, there are fewer bottles than people.": {
        "file": "c5cd7c422fe01462328b.mp3",
        "bank": "en-oo1",
        "durationMs": 3861
    },
    "At the meeting about fewer meetings, there are fewer tickets than people.": {
        "file": "64919e0d261bd1bbad8e.mp3",
        "bank": "en-oo1",
        "durationMs": 3840
    },
    "At the meeting about fewer meetings, there are more hats than people.": {
        "file": "a02557f933c268c1f4d3.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "At the meeting about fewer meetings, there are more bags than people.": {
        "file": "d0e3df59bbec6b772bdb.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "At the meeting about fewer meetings, there are fewer hats than people.": {
        "file": "c825c9a79e0be462fe23.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "At the meeting about fewer meetings, there are fewer bags than people.": {
        "file": "ef8749d373076f7fd550.mp3",
        "bank": "en-oo1",
        "durationMs": 3819
    },
    "The report about our tiny lunch is beside a large gift.": {
        "file": "b52230177bf86c89455e.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The report about our tiny lunch is beside a large glass.": {
        "file": "fa77af079dc87f1f2bac.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The report about our tiny lunch is beside a small gift.": {
        "file": "fc261dc96e2fbfc0c88c.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The report about our tiny lunch is beside a small glass.": {
        "file": "6ce6a53604456e333416.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The report about our tiny lunch is beside a large cup.": {
        "file": "35d3aa8758339dad53cb.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The report about our tiny lunch is beside a large computer.": {
        "file": "db68bdcbd4f8652566b6.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The report about our tiny lunch is beside a small cup.": {
        "file": "5762bc94954002a058fd.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The report about our tiny lunch is beside a small computer.": {
        "file": "07989b8a6679cad86778.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The report about our tiny lunch is beside a large book.": {
        "file": "bc8a517af93070f82b54.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The report about our tiny lunch is beside a large dog.": {
        "file": "8b903dd190097599c070.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The report about our tiny lunch is beside a small book.": {
        "file": "acb7afe711db7ef01bff.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The report about our tiny lunch is beside a small dog.": {
        "file": "dfdf326453478d09eff0.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The report about our tiny lunch is beside a large key.": {
        "file": "b34225d3a966c22a70f3.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The report about our tiny lunch is beside a large bag.": {
        "file": "7d00d156c35ffa35cc1a.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The report about our tiny lunch is beside a small key.": {
        "file": "e2076a87929a02cacdf7.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The report about our tiny lunch is beside a small bag.": {
        "file": "7c8ef36d86b5932fb708.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The report about our tiny lunch is beside a large flower.": {
        "file": "7838d22e57b1302f0378.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The report about our tiny lunch is beside a large hat.": {
        "file": "3c774d994193fb68454d.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The report about our tiny lunch is beside a small flower.": {
        "file": "abde31e9d4f4e9b2c002.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The report about our tiny lunch is beside a small hat.": {
        "file": "7b2abecd9f234cf74300.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The tired student studying sleep has two computers on the desk.": {
        "file": "6e7dec551bb1e33affb6.mp3",
        "bank": "en-oo1",
        "durationMs": 3669
    },
    "The tired student studying sleep has two gifts on the desk.": {
        "file": "fdbf2b84bd2a353f5937.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The tired student studying sleep has three computers on the desk.": {
        "file": "2fc60e009ef4901f51cf.mp3",
        "bank": "en-oo1",
        "durationMs": 3776
    },
    "The tired student studying sleep has three gifts on the desk.": {
        "file": "0c2dad62f087b89b50de.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The tired student studying sleep has two bags on the desk.": {
        "file": "da05013dfda3c6af688f.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The tired student studying sleep has two cats on the desk.": {
        "file": "bd17883c0af3dec3e36e.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The tired student studying sleep has four bags on the desk.": {
        "file": "a52fb898819bbc5d4c2d.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The tired student studying sleep has four cats on the desk.": {
        "file": "91208ad2e68b0471e882.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The tired student studying sleep has two boxes on the desk.": {
        "file": "ba9f9e345cb9516b2ef4.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The tired student studying sleep has two glasses on the desk.": {
        "file": "fe7fee6c9afccb402e30.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The tired student studying sleep has three boxes on the desk.": {
        "file": "409404ffca11fa827f80.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The tired student studying sleep has three glasses on the desk.": {
        "file": "e9d27a325bd3e99d58f7.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The tired student studying sleep has two robots on the desk.": {
        "file": "4ede0ed1d15e8755fae0.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The tired student studying sleep has two fish on the desk.": {
        "file": "1b8b1e36b4a91b180c25.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The tired student studying sleep has four robots on the desk.": {
        "file": "f39b42b357affa215c53.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The tired student studying sleep has four fish on the desk.": {
        "file": "0cc0ae243260adb0b379.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The tired student studying sleep has two keys on the desk.": {
        "file": "fba64ef6a9a48e3dc327.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The tired student studying sleep has two magazines on the desk.": {
        "file": "3e4f15904383682a3735.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The tired student studying sleep has three keys on the desk.": {
        "file": "de95901ee50624de2e96.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The tired student studying sleep has three magazines on the desk.": {
        "file": "15caa620344e277029b7.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The man measuring a queue for queues puts a glass on the table.": {
        "file": "ec10855047937edbabcd.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The man measuring a queue for queues puts a glass under the table.": {
        "file": "3484f6e3c6cccb7290a4.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The man measuring a queue for queues puts a cup on the table.": {
        "file": "6db5db0ba76ab8059fc9.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The man measuring a queue for queues puts a cup under the table.": {
        "file": "70ee528df19b9da204f7.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The man measuring a queue for queues puts an egg on the table.": {
        "file": "d341a7b7258d729e6348.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The man measuring a queue for queues puts an egg under the table.": {
        "file": "2f9379b7911306d769a9.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The man measuring a queue for queues puts a computer on the table.": {
        "file": "d4cbe41e5bb3f397edd3.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The man measuring a queue for queues puts a computer under the table.": {
        "file": "8d18a9148f3596e7077b.mp3",
        "bank": "en-oo1",
        "durationMs": 3776
    },
    "The man measuring a queue for queues puts a fish on the table.": {
        "file": "594433ba5a7f0c6811f3.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The man measuring a queue for queues puts a fish under the table.": {
        "file": "64fc1af73fca2ce37aba.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The man measuring a queue for queues puts a magazine on the table.": {
        "file": "def28bb71f30b28c4870.mp3",
        "bank": "en-oo1",
        "durationMs": 3819
    },
    "The man measuring a queue for queues puts a magazine under the table.": {
        "file": "ce7b1057f21825692c72.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "The man measuring a queue for queues puts a hat on the table.": {
        "file": "92d70d0a7c7a82ba25fc.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The man measuring a queue for queues puts a hat under the table.": {
        "file": "35f41e65455a314fd96a.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The man measuring a queue for queues puts a coin on the table.": {
        "file": "84b8a60c1a6b9d83280c.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The man measuring a queue for queues puts a coin under the table.": {
        "file": "c9a2e9e56019924dc21b.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The man measuring a queue for queues puts a robot on the table.": {
        "file": "0ba6e620838f7baf5a45.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The man measuring a queue for queues puts a robot under the table.": {
        "file": "c765535dfb2744aec8fb.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The man measuring a queue for queues puts a book on the table.": {
        "file": "944a7ede52c2407ac5c7.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The man measuring a queue for queues puts a book under the table.": {
        "file": "6631c108cc24c2782736.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "In our study of unwanted gifts, there are more computers than boxes.": {
        "file": "4f3a81af57ceae718324.mp3",
        "bank": "en-oo1",
        "durationMs": 4117
    },
    "In our study of unwanted gifts, there are more gifts than boxes.": {
        "file": "f22c1b0cad47386b0866.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "In our study of unwanted gifts, there are fewer computers than boxes.": {
        "file": "6b41687d7e6238e8e3bd.mp3",
        "bank": "en-oo1",
        "durationMs": 4181
    },
    "In our study of unwanted gifts, there are fewer gifts than boxes.": {
        "file": "2b8426f22fb81bbf4dc4.mp3",
        "bank": "en-oo1",
        "durationMs": 3947
    },
    "In our study of unwanted gifts, there are more dogs than boxes.": {
        "file": "fe9481415282b4a6ef70.mp3",
        "bank": "en-oo1",
        "durationMs": 3989
    },
    "In our study of unwanted gifts, there are more eggs than boxes.": {
        "file": "2eb7859fb5fc34995d4e.mp3",
        "bank": "en-oo1",
        "durationMs": 3861
    },
    "In our study of unwanted gifts, there are fewer dogs than boxes.": {
        "file": "bdc287e3f4e4b319965e.mp3",
        "bank": "en-oo1",
        "durationMs": 4075
    },
    "In our study of unwanted gifts, there are fewer eggs than boxes.": {
        "file": "cd882a06d18c0363f13e.mp3",
        "bank": "en-oo1",
        "durationMs": 4032
    },
    "In our study of unwanted gifts, there are more robots than boxes.": {
        "file": "ca2d705ea22218d9e62a.mp3",
        "bank": "en-oo1",
        "durationMs": 4139
    },
    "In our study of unwanted gifts, there are more glasses than boxes.": {
        "file": "6a57a51c6e80a14bc2ca.mp3",
        "bank": "en-oo1",
        "durationMs": 4096
    },
    "In our study of unwanted gifts, there are fewer robots than boxes.": {
        "file": "28348e6efcbafd984762.mp3",
        "bank": "en-oo1",
        "durationMs": 4181
    },
    "In our study of unwanted gifts, there are fewer glasses than boxes.": {
        "file": "6e35c4b9345e1e233816.mp3",
        "bank": "en-oo1",
        "durationMs": 4139
    },
    "In our study of unwanted gifts, there are more shoes than boxes.": {
        "file": "cef790a6f290fadd1895.mp3",
        "bank": "en-oo1",
        "durationMs": 3989
    },
    "In our study of unwanted gifts, there are more tickets than boxes.": {
        "file": "b571d863cba3521872a5.mp3",
        "bank": "en-oo1",
        "durationMs": 4053
    },
    "In our study of unwanted gifts, there are fewer shoes than boxes.": {
        "file": "58aeecacea5d756c4a89.mp3",
        "bank": "en-oo1",
        "durationMs": 3947
    },
    "In our study of unwanted gifts, there are fewer tickets than boxes.": {
        "file": "bd2dd7ee048761852c4e.mp3",
        "bank": "en-oo1",
        "durationMs": 4011
    },
    "In our study of unwanted gifts, there are more cups than boxes.": {
        "file": "60470754aa47376f9e09.mp3",
        "bank": "en-oo1",
        "durationMs": 3840
    },
    "In our study of unwanted gifts, there are more fish than boxes.": {
        "file": "76dda9c8b56b9b03d575.mp3",
        "bank": "en-oo1",
        "durationMs": 3840
    },
    "In our study of unwanted gifts, there are fewer cups than boxes.": {
        "file": "37d6a49bc372a4cf2c8b.mp3",
        "bank": "en-oo1",
        "durationMs": 3925
    },
    "In our study of unwanted gifts, there are fewer fish than boxes.": {
        "file": "a2e9ab0418e0bb340bde.mp3",
        "bank": "en-oo1",
        "durationMs": 3883
    },
    "The office chairs studying their work display two cups.": {
        "file": "c16a60cfa463c36ec2db.mp3",
        "bank": "en-oo1",
        "durationMs": 2944
    },
    "The office chairs studying their work display two eggs.": {
        "file": "625cb1956e4c8f2ef6b8.mp3",
        "bank": "en-oo1",
        "durationMs": 2859
    },
    "The office chairs studying their work display three cups.": {
        "file": "b2e8f2d65620e763c7d2.mp3",
        "bank": "en-oo1",
        "durationMs": 2923
    },
    "The office chairs studying their work display three eggs.": {
        "file": "9ad8c26e90dd1e0d3c6a.mp3",
        "bank": "en-oo1",
        "durationMs": 2859
    },
    "The office chairs studying their work display two glasses.": {
        "file": "042be75d3fe2f47a0ddf.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The office chairs studying their work display two cats.": {
        "file": "3488567e341c4b2bfd6a.mp3",
        "bank": "en-oo1",
        "durationMs": 2944
    },
    "The office chairs studying their work display four glasses.": {
        "file": "bffbdd9ecc3004bfb810.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The office chairs studying their work display four cats.": {
        "file": "0130573f02a4eea2c1ce.mp3",
        "bank": "en-oo1",
        "durationMs": 3029
    },
    "The office chairs studying their work display two gifts.": {
        "file": "e72bc4d088b7e88c2e31.mp3",
        "bank": "en-oo1",
        "durationMs": 2923
    },
    "The office chairs studying their work display two dogs.": {
        "file": "61404aaa321353005bc9.mp3",
        "bank": "en-oo1",
        "durationMs": 3051
    },
    "The office chairs studying their work display three gifts.": {
        "file": "90cc417d926e45748ea3.mp3",
        "bank": "en-oo1",
        "durationMs": 2987
    },
    "The office chairs studying their work display three dogs.": {
        "file": "449ce7af7fe8b9c82eed.mp3",
        "bank": "en-oo1",
        "durationMs": 3051
    },
    "The office chairs studying their work display two computers.": {
        "file": "dda5cbc8e4fe71a6f8d3.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The office chairs studying their work display two phones.": {
        "file": "0531b6910051c7f31511.mp3",
        "bank": "en-oo1",
        "durationMs": 3008
    },
    "The office chairs studying their work display four computers.": {
        "file": "99e985ac2fbf0f5b5ba5.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The office chairs studying their work display four phones.": {
        "file": "c4f0db51aae707ada373.mp3",
        "bank": "en-oo1",
        "durationMs": 3072
    },
    "The office chairs studying their work display two bottles.": {
        "file": "595c9dc21dfe86dbebdd.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The office chairs studying their work display two fish.": {
        "file": "c7f7982c09c5fcbd799a.mp3",
        "bank": "en-oo1",
        "durationMs": 2944
    },
    "The office chairs studying their work display three bottles.": {
        "file": "18bff2d8c93275af3c2b.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "The office chairs studying their work display three fish.": {
        "file": "fe0612c76b347ff23de6.mp3",
        "bank": "en-oo1",
        "durationMs": 2859
    },
    "In the saving money class, there are more gifts than students.": {
        "file": "aead4c1a38bc68feabad.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "In the saving money class, there are more bottles than students.": {
        "file": "a4c9e6cca2ee532def46.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "In the saving money class, there are fewer gifts than students.": {
        "file": "b2b50ea5d02bbed01472.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "In the saving money class, there are fewer bottles than students.": {
        "file": "c6ab99eb34d199fd8a1e.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "In the saving money class, there are more glasses than students.": {
        "file": "c22f32b3c7b8ae0fbf70.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "In the saving money class, there are more bags than students.": {
        "file": "49a90ebee8eaccd17edf.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "In the saving money class, there are fewer glasses than students.": {
        "file": "4d5e9c389df0ae85ae5e.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "In the saving money class, there are fewer bags than students.": {
        "file": "f94977bd586fd0f2c545.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "In the saving money class, there are more shoes than students.": {
        "file": "c284d8873e81cf3c3483.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "In the saving money class, there are more boxes than students.": {
        "file": "ff73c242a741b4b47864.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "In the saving money class, there are fewer shoes than students.": {
        "file": "bca93327fa0b0ffa9895.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "In the saving money class, there are fewer boxes than students.": {
        "file": "2e7878bdc4c8bac2a294.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "In the saving money class, there are more keys than students.": {
        "file": "0dd923c79a4abdfe085b.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "In the saving money class, there are more fish than students.": {
        "file": "b54e8544fdd8aa7f7e85.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "In the saving money class, there are fewer keys than students.": {
        "file": "d90f6020966bd1de79c1.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "In the saving money class, there are fewer fish than students.": {
        "file": "7d91c353b59756bdd620.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "In the saving money class, there are more computers than students.": {
        "file": "7e8e638ec786f674cba7.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "In the saving money class, there are more robots than students.": {
        "file": "f5a59bdab8e2c1085acc.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "In the saving money class, there are fewer computers than students.": {
        "file": "e8c323475c3c7f195ba1.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "In the saving money class, there are fewer robots than students.": {
        "file": "4878b6931c7418f162b3.mp3",
        "bank": "en-oo1",
        "durationMs": 3520
    },
    "The fish recording our swimming results has a flower beside the pool.": {
        "file": "7f996c67df8533afc651.mp3",
        "bank": "en-oo1",
        "durationMs": 3840
    },
    "The fish recording our swimming results has a flower inside the pool.": {
        "file": "947a6220194d30e3a6b2.mp3",
        "bank": "en-oo1",
        "durationMs": 3904
    },
    "The fish recording our swimming results has a bag beside the pool.": {
        "file": "b2bd033967f9410dc91e.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The fish recording our swimming results has a bag inside the pool.": {
        "file": "11f0efb4aa080f186d6a.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The fish recording our swimming results has a picture beside the pool.": {
        "file": "621cf5a0e3cffe36fc75.mp3",
        "bank": "en-oo1",
        "durationMs": 3840
    },
    "The fish recording our swimming results has a picture inside the pool.": {
        "file": "9f2b88ea99abd7bc6312.mp3",
        "bank": "en-oo1",
        "durationMs": 3925
    },
    "The fish recording our swimming results has a gift beside the pool.": {
        "file": "f394c2983669c13a1b77.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "The fish recording our swimming results has a gift inside the pool.": {
        "file": "46b9ecc1b6218fad2a34.mp3",
        "bank": "en-oo1",
        "durationMs": 3819
    },
    "The fish recording our swimming results has a newspaper beside the pool.": {
        "file": "e456b9159a121977a72f.mp3",
        "bank": "en-oo1",
        "durationMs": 4075
    },
    "The fish recording our swimming results has a newspaper inside the pool.": {
        "file": "97359a7d968aa0bcccd3.mp3",
        "bank": "en-oo1",
        "durationMs": 4309
    },
    "The fish recording our swimming results has a book beside the pool.": {
        "file": "aed8b8cf6bf210c338de.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The fish recording our swimming results has a book inside the pool.": {
        "file": "87030ce3a46a13e82a55.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The fish recording our swimming results has a fish beside the pool.": {
        "file": "711c14dc8aac477873ec.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The fish recording our swimming results has a fish inside the pool.": {
        "file": "e965fdb9721cfa204816.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The fish recording our swimming results has a cat beside the pool.": {
        "file": "4a2ec983fa743a2f5e25.mp3",
        "bank": "en-oo1",
        "durationMs": 3712
    },
    "The fish recording our swimming results has a cat inside the pool.": {
        "file": "72e81aa20ea1a5136c23.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The fish recording our swimming results has a shoe beside the pool.": {
        "file": "3a47bf4d4a078f5394ec.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The fish recording our swimming results has a shoe inside the pool.": {
        "file": "d1929c669b800772aafd.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The fish recording our swimming results has a glass beside the pool.": {
        "file": "d95e8ac33e6f637f79fb.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "The fish recording our swimming results has a glass inside the pool.": {
        "file": "0700ec3797cf7258be48.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The winner of our least popular objects survey is wearing a large hat and holding a glass.": {
        "file": "6b1007144649f8700a87.mp3",
        "bank": "en-oo1",
        "durationMs": 5397
    },
    "The winner of our least popular objects survey is wearing a large hat and holding a book.": {
        "file": "213d530b8e4549921ba1.mp3",
        "bank": "en-oo1",
        "durationMs": 5248
    },
    "The winner of our least popular objects survey is wearing a small hat and holding a glass.": {
        "file": "ea782e5cc1c9745194c9.mp3",
        "bank": "en-oo1",
        "durationMs": 5355
    },
    "The winner of our least popular objects survey is wearing a small hat and holding a book.": {
        "file": "6df78b24e61f20ad6a72.mp3",
        "bank": "en-oo1",
        "durationMs": 5269
    },
    "The winner of our least popular objects survey is wearing a long scarf and holding a hat.": {
        "file": "556c07c207c8edeac34e.mp3",
        "bank": "en-oo1",
        "durationMs": 5333
    },
    "The winner of our least popular objects survey is wearing a long scarf and holding a fish.": {
        "file": "123e9586b39d99abb7f1.mp3",
        "bank": "en-oo1",
        "durationMs": 5397
    },
    "The winner of our least popular objects survey is wearing a short scarf and holding a hat.": {
        "file": "2a537f2bd85e633645ea.mp3",
        "bank": "en-oo1",
        "durationMs": 5355
    },
    "The winner of our least popular objects survey is wearing a short scarf and holding a fish.": {
        "file": "55ced7440c202e5f06fc.mp3",
        "bank": "en-oo1",
        "durationMs": 5440
    },
    "The winner of our least popular objects survey is wearing round glasses and holding a pencil.": {
        "file": "6c0edab7c77177f2fb7b.mp3",
        "bank": "en-oo1",
        "durationMs": 5483
    },
    "The winner of our least popular objects survey is wearing round glasses and holding a computer.": {
        "file": "69a0857d192c8a9e3f69.mp3",
        "bank": "en-oo1",
        "durationMs": 5632
    },
    "The winner of our least popular objects survey is wearing square glasses and holding a pencil.": {
        "file": "679577e5b018bef0a505.mp3",
        "bank": "en-oo1",
        "durationMs": 5568
    },
    "The winner of our least popular objects survey is wearing square glasses and holding a computer.": {
        "file": "d339c2efd704b2eb426c.mp3",
        "bank": "en-oo1",
        "durationMs": 5653
    },
    "The winner of our least popular objects survey is wearing a jacket with two pockets and holding a box.": {
        "file": "438bfa309c5884dea54c.mp3",
        "bank": "en-oo1",
        "durationMs": 6272
    },
    "The winner of our least popular objects survey is wearing a jacket with two pockets and holding an umbrella.": {
        "file": "c78f53f9fbd69e8d9317.mp3",
        "bank": "en-oo1",
        "durationMs": 6464
    },
    "The winner of our least popular objects survey is wearing a jacket with four pockets and holding a box.": {
        "file": "dbf0c15ee27c5a424ded.mp3",
        "bank": "en-oo1",
        "durationMs": 6357
    },
    "The winner of our least popular objects survey is wearing a jacket with four pockets and holding an umbrella.": {
        "file": "84e85c35d7e04374c2fa.mp3",
        "bank": "en-oo1",
        "durationMs": 6485
    },
    "The winner of our least popular objects survey is wearing a shirt with long sleeves and holding a picture.": {
        "file": "1d434922425bb476989f.mp3",
        "bank": "en-oo1",
        "durationMs": 6229
    },
    "The winner of our least popular objects survey is wearing a shirt with long sleeves and holding a ticket.": {
        "file": "a5282b1f2ab5ca91e13a.mp3",
        "bank": "en-oo1",
        "durationMs": 6123
    },
    "The winner of our least popular objects survey is wearing a shirt with short sleeves and holding a picture.": {
        "file": "6c82820f695d7027c689.mp3",
        "bank": "en-oo1",
        "durationMs": 6144
    },
    "The winner of our least popular objects survey is wearing a shirt with short sleeves and holding a ticket.": {
        "file": "834a4af8ef69fa637ffa.mp3",
        "bank": "en-oo1",
        "durationMs": 6080
    },
    "The fish dressing for its job interview is wearing a large hat and carrying a clock.": {
        "file": "42261c7254deafc47e9a.mp3",
        "bank": "en-oo1",
        "durationMs": 4949
    },
    "The fish dressing for its job interview is wearing a large hat and carrying a computer.": {
        "file": "583c96e4cf896288e2d3.mp3",
        "bank": "en-oo1",
        "durationMs": 5120
    },
    "The fish dressing for its job interview is wearing a small hat and carrying a clock.": {
        "file": "3a69da32531661222e78.mp3",
        "bank": "en-oo1",
        "durationMs": 4928
    },
    "The fish dressing for its job interview is wearing a small hat and carrying a computer.": {
        "file": "99921f13b363c68290c2.mp3",
        "bank": "en-oo1",
        "durationMs": 5056
    },
    "The fish dressing for its job interview is wearing a long scarf and carrying an umbrella.": {
        "file": "478e384691bece3107e5.mp3",
        "bank": "en-oo1",
        "durationMs": 5184
    },
    "The fish dressing for its job interview is wearing a long scarf and carrying a picture.": {
        "file": "6a8a46179907cd517aa8.mp3",
        "bank": "en-oo1",
        "durationMs": 5163
    },
    "The fish dressing for its job interview is wearing a short scarf and carrying an umbrella.": {
        "file": "2285cddc108303d45ef0.mp3",
        "bank": "en-oo1",
        "durationMs": 5141
    },
    "The fish dressing for its job interview is wearing a short scarf and carrying a picture.": {
        "file": "3aa4d33b575df10b686b.mp3",
        "bank": "en-oo1",
        "durationMs": 5141
    },
    "The fish dressing for its job interview is wearing round glasses and carrying a dog.": {
        "file": "1a56d5788c4abed076ce.mp3",
        "bank": "en-oo1",
        "durationMs": 4949
    },
    "The fish dressing for its job interview is wearing round glasses and carrying a glass.": {
        "file": "4a7c2a466f21e6d11d3c.mp3",
        "bank": "en-oo1",
        "durationMs": 5056
    },
    "The fish dressing for its job interview is wearing square glasses and carrying a dog.": {
        "file": "4acbfcbf5ea1dfcfd809.mp3",
        "bank": "en-oo1",
        "durationMs": 4971
    },
    "The fish dressing for its job interview is wearing square glasses and carrying a glass.": {
        "file": "af8e7889428d49e2c7ba.mp3",
        "bank": "en-oo1",
        "durationMs": 5077
    },
    "The fish dressing for its job interview is wearing a jacket with two pockets and carrying an egg.": {
        "file": "109b30a15d220197013d.mp3",
        "bank": "en-oo1",
        "durationMs": 5653
    },
    "The fish dressing for its job interview is wearing a jacket with two pockets and carrying a ticket.": {
        "file": "58b89ee61677e88ce456.mp3",
        "bank": "en-oo1",
        "durationMs": 5760
    },
    "The fish dressing for its job interview is wearing a jacket with four pockets and carrying an egg.": {
        "file": "063e6cf3a0baddc6adee.mp3",
        "bank": "en-oo1",
        "durationMs": 5760
    },
    "The fish dressing for its job interview is wearing a jacket with four pockets and carrying a ticket.": {
        "file": "a5c9074b004d6ecf47ab.mp3",
        "bank": "en-oo1",
        "durationMs": 5867
    },
    "The fish dressing for its job interview is wearing a shirt with long sleeves and carrying a robot.": {
        "file": "206e8b07f41daf72b730.mp3",
        "bank": "en-oo1",
        "durationMs": 5803
    },
    "The fish dressing for its job interview is wearing a shirt with long sleeves and carrying a gift.": {
        "file": "0caf330deda29730a3f2.mp3",
        "bank": "en-oo1",
        "durationMs": 5632
    },
    "The fish dressing for its job interview is wearing a shirt with short sleeves and carrying a robot.": {
        "file": "41934ac7538978d2d1df.mp3",
        "bank": "en-oo1",
        "durationMs": 5760
    },
    "The fish dressing for its job interview is wearing a shirt with short sleeves and carrying a gift.": {
        "file": "41767243fa62d7856c41.mp3",
        "bank": "en-oo1",
        "durationMs": 5547
    },
    "The table getting ready for a party has a book on its top.": {
        "file": "9b76bdff2e0566c61642.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The table getting ready for a party has a book under its legs.": {
        "file": "6cb838877521de56f3a1.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The table getting ready for a party has a ticket on its top.": {
        "file": "915625e0b24a4fbf1aaf.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The table getting ready for a party has a ticket under its legs.": {
        "file": "bd427b0b2be59973e8cf.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The table getting ready for a party has a cup on its top.": {
        "file": "bea99be469d79c0b8863.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The table getting ready for a party has a cup under its legs.": {
        "file": "e71d1c5c5ce6fb4480f7.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The table getting ready for a party has a gift on its top.": {
        "file": "b037567e456815b1315c.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The table getting ready for a party has a gift under its legs.": {
        "file": "915279e25972ac945bad.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The table getting ready for a party has a fish on its top.": {
        "file": "9d30713abf95576e41c7.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The table getting ready for a party has a fish under its legs.": {
        "file": "f2501844fd1e4cdf4d48.mp3",
        "bank": "en-oo1",
        "durationMs": 3477
    },
    "The table getting ready for a party has a pencil on its top.": {
        "file": "b0da7fd658ba4a4b84f6.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The table getting ready for a party has a pencil under its legs.": {
        "file": "495b2dfde5e051b1b90f.mp3",
        "bank": "en-oo1",
        "durationMs": 3648
    },
    "The table getting ready for a party has a hat on its top.": {
        "file": "adcd4ac4a261229a10d9.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The table getting ready for a party has a hat under its legs.": {
        "file": "a46a71bd36a3a76ad90d.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The table getting ready for a party has a bag on its top.": {
        "file": "6781c1ca4966fa0e2de9.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The table getting ready for a party has a bag under its legs.": {
        "file": "7664e93835e6c58f11ed.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The table getting ready for a party has a glass on its top.": {
        "file": "c16763850a59c4e66256.mp3",
        "bank": "en-oo1",
        "durationMs": 3413
    },
    "The table getting ready for a party has a glass under its legs.": {
        "file": "358606614b6a0920fdb5.mp3",
        "bank": "en-oo1",
        "durationMs": 3605
    },
    "The table getting ready for a party has a dog on its top.": {
        "file": "32404241163249e665af.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The table getting ready for a party has a dog under its legs.": {
        "file": "2f676b78958f7bb4b21d.mp3",
        "bank": "en-oo1",
        "durationMs": 3563
    },
    "The tree choosing its winter clothes has two robots on its branches.": {
        "file": "7d44b82eca533bba5e3e.mp3",
        "bank": "en-oo1",
        "durationMs": 3925
    },
    "The tree choosing its winter clothes has two bags on its branches.": {
        "file": "4fa3fdf17ee715334bb2.mp3",
        "bank": "en-oo1",
        "durationMs": 3840
    },
    "The tree choosing its winter clothes has three robots on its branches.": {
        "file": "ae800bfae0cb4279ef8e.mp3",
        "bank": "en-oo1",
        "durationMs": 4053
    },
    "The tree choosing its winter clothes has three bags on its branches.": {
        "file": "04bb033faa828311f76d.mp3",
        "bank": "en-oo1",
        "durationMs": 3968
    },
    "The tree choosing its winter clothes has two gifts on its branches.": {
        "file": "94035c3b5ecd19caf548.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "The tree choosing its winter clothes has two shoes on its branches.": {
        "file": "17afd933674ed97acfc6.mp3",
        "bank": "en-oo1",
        "durationMs": 3776
    },
    "The tree choosing its winter clothes has four gifts on its branches.": {
        "file": "54827ceefa7766bc7c20.mp3",
        "bank": "en-oo1",
        "durationMs": 3840
    },
    "The tree choosing its winter clothes has four shoes on its branches.": {
        "file": "07ebc8867fffad91527a.mp3",
        "bank": "en-oo1",
        "durationMs": 3925
    },
    "The tree choosing its winter clothes has two pictures on its branches.": {
        "file": "0b2e9f2fc40f941bad56.mp3",
        "bank": "en-oo1",
        "durationMs": 3989
    },
    "The tree choosing its winter clothes has two glasses on its branches.": {
        "file": "fcce176d7ecc8097755b.mp3",
        "bank": "en-oo1",
        "durationMs": 3989
    },
    "The tree choosing its winter clothes has three pictures on its branches.": {
        "file": "fc9c70eaa9d3ff0b0bbf.mp3",
        "bank": "en-oo1",
        "durationMs": 4096
    },
    "The tree choosing its winter clothes has three glasses on its branches.": {
        "file": "6ee26c1d3d2509a3965c.mp3",
        "bank": "en-oo1",
        "durationMs": 4096
    },
    "The tree choosing its winter clothes has two umbrellas on its branches.": {
        "file": "d10e3d94a3cacfdb7c75.mp3",
        "bank": "en-oo1",
        "durationMs": 3989
    },
    "The tree choosing its winter clothes has two bottles on its branches.": {
        "file": "6fe06ee385df13d8daae.mp3",
        "bank": "en-oo1",
        "durationMs": 3925
    },
    "The tree choosing its winter clothes has four umbrellas on its branches.": {
        "file": "ba887bdec67513f28781.mp3",
        "bank": "en-oo1",
        "durationMs": 4181
    },
    "The tree choosing its winter clothes has four bottles on its branches.": {
        "file": "f762fba984bd472b60ed.mp3",
        "bank": "en-oo1",
        "durationMs": 3947
    },
    "The tree choosing its winter clothes has two books on its branches.": {
        "file": "868154aac5e938aebd8c.mp3",
        "bank": "en-oo1",
        "durationMs": 3776
    },
    "The tree choosing its winter clothes has two fish on its branches.": {
        "file": "72360945aa6fb84f9bd5.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "The tree choosing its winter clothes has three books on its branches.": {
        "file": "719f6a5bf67803a5d755.mp3",
        "bank": "en-oo1",
        "durationMs": 3819
    },
    "The tree choosing its winter clothes has three fish on its branches.": {
        "file": "dbbefd77034dd20c8606.mp3",
        "bank": "en-oo1",
        "durationMs": 3861
    },
    "The phone preparing for a party chooses a large glass.": {
        "file": "d7143f5335ad004d1f88.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The phone preparing for a party chooses a large magazine.": {
        "file": "26f0a9df063ad88e633c.mp3",
        "bank": "en-oo1",
        "durationMs": 3584
    },
    "The phone preparing for a party chooses a small glass.": {
        "file": "c44f307daa04efc74a7f.mp3",
        "bank": "en-oo1",
        "durationMs": 3157
    },
    "The phone preparing for a party chooses a small magazine.": {
        "file": "fb7949a04d3a339fd079.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The phone preparing for a party chooses a large box.": {
        "file": "f27e58fd3a1180aa5e86.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The phone preparing for a party chooses a large bag.": {
        "file": "5330692d6ab9570ae323.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The phone preparing for a party chooses a small box.": {
        "file": "51ccc36f29f8e0a20e20.mp3",
        "bank": "en-oo1",
        "durationMs": 3051
    },
    "The phone preparing for a party chooses a small bag.": {
        "file": "b9f0106e797eba7e49c6.mp3",
        "bank": "en-oo1",
        "durationMs": 3029
    },
    "The phone preparing for a party chooses a large fish.": {
        "file": "e60b75557c83400a72bf.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The phone preparing for a party chooses a large book.": {
        "file": "76cbdf0bff0c5f28fe4f.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The phone preparing for a party chooses a small fish.": {
        "file": "ae313bb2ef0ef7ca4f9c.mp3",
        "bank": "en-oo1",
        "durationMs": 3008
    },
    "The phone preparing for a party chooses a small book.": {
        "file": "251a8a006bfea21ee9b0.mp3",
        "bank": "en-oo1",
        "durationMs": 3051
    },
    "The phone preparing for a party chooses a large ticket.": {
        "file": "d787dc0c012a27ceec24.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The phone preparing for a party chooses a large cup.": {
        "file": "9352029501f84c578dbb.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The phone preparing for a party chooses a small ticket.": {
        "file": "4344228a331904c516cc.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The phone preparing for a party chooses a small cup.": {
        "file": "3cf6893eb181c9f4f518.mp3",
        "bank": "en-oo1",
        "durationMs": 3072
    },
    "The phone preparing for a party chooses a large gift.": {
        "file": "1dc8f09b3f6f2f268131.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The phone preparing for a party chooses a large cat.": {
        "file": "28bd301bff151c9abdc7.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The phone preparing for a party chooses a small gift.": {
        "file": "b87db0ec9f8b4eb4d1da.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "The phone preparing for a party chooses a small cat.": {
        "file": "ab3974fb99b9a0f4a143.mp3",
        "bank": "en-oo1",
        "durationMs": 3029
    },
    "The shoes getting dressed are carrying a dog.": {
        "file": "c4d23cac1cdf1468e96d.mp3",
        "bank": "en-oo1",
        "durationMs": 2389
    },
    "The shoes getting dressed are carrying a gift.": {
        "file": "fc2d5828d6cfd5c84b76.mp3",
        "bank": "en-oo1",
        "durationMs": 2325
    },
    "The shoes getting dressed are pulling a dog.": {
        "file": "32278cd9da9fbbf94472.mp3",
        "bank": "en-oo1",
        "durationMs": 2261
    },
    "The shoes getting dressed are pulling a gift.": {
        "file": "8747732b50108478fe65.mp3",
        "bank": "en-oo1",
        "durationMs": 2304
    },
    "The shoes getting dressed are carrying a computer.": {
        "file": "ff695a710b1408c3d737.mp3",
        "bank": "en-oo1",
        "durationMs": 2624
    },
    "The shoes getting dressed are carrying an egg.": {
        "file": "4c4a5097b07ef82a3fcd.mp3",
        "bank": "en-oo1",
        "durationMs": 2304
    },
    "The shoes getting dressed are pulling a computer.": {
        "file": "bbdbaddb2f34120ad7db.mp3",
        "bank": "en-oo1",
        "durationMs": 2539
    },
    "The shoes getting dressed are pulling an egg.": {
        "file": "16e9ed9519ed574e4eee.mp3",
        "bank": "en-oo1",
        "durationMs": 2197
    },
    "The shoes getting dressed are carrying a glass.": {
        "file": "385f3343bde03db484c8.mp3",
        "bank": "en-oo1",
        "durationMs": 2411
    },
    "The shoes getting dressed are carrying a fish.": {
        "file": "e7ef921b8e933a9d9aba.mp3",
        "bank": "en-oo1",
        "durationMs": 2368
    },
    "The shoes getting dressed are pulling a glass.": {
        "file": "2ab5b397d2209def8cd9.mp3",
        "bank": "en-oo1",
        "durationMs": 2347
    },
    "The shoes getting dressed are pulling a fish.": {
        "file": "a952eec41bd4101192eb.mp3",
        "bank": "en-oo1",
        "durationMs": 2304
    },
    "The shoes getting dressed are carrying a hat.": {
        "file": "8be04bfc4b64a63bd2a8.mp3",
        "bank": "en-oo1",
        "durationMs": 2283
    },
    "The shoes getting dressed are carrying a bottle.": {
        "file": "450fd48b682c32ff2806.mp3",
        "bank": "en-oo1",
        "durationMs": 2432
    },
    "The shoes getting dressed are pulling a hat.": {
        "file": "b5dc8f1b9f2d4517f053.mp3",
        "bank": "en-oo1",
        "durationMs": 2219
    },
    "The shoes getting dressed are pulling a bottle.": {
        "file": "fa5d99c034c67ed7f22e.mp3",
        "bank": "en-oo1",
        "durationMs": 2368
    },
    "The shoes getting dressed are carrying a shoe.": {
        "file": "249fdd3958f800e86df4.mp3",
        "bank": "en-oo1",
        "durationMs": 2283
    },
    "The shoes getting dressed are carrying a book.": {
        "file": "f6771f385a6b2fe44337.mp3",
        "bank": "en-oo1",
        "durationMs": 2325
    },
    "The shoes getting dressed are pulling a shoe.": {
        "file": "d1f52d52f4cd2653d3db.mp3",
        "bank": "en-oo1",
        "durationMs": 2219
    },
    "The shoes getting dressed are pulling a book.": {
        "file": "528557b399f8dd769216.mp3",
        "bank": "en-oo1",
        "durationMs": 2240
    },
    "The mirror worried about its appearance keeps a fish beside the box.": {
        "file": "63a926158f232b3d320d.mp3",
        "bank": "en-oo1",
        "durationMs": 3755
    },
    "The mirror worried about its appearance keeps a fish inside the box.": {
        "file": "208267ca57f8378bebaf.mp3",
        "bank": "en-oo1",
        "durationMs": 3840
    },
    "The mirror worried about its appearance keeps a phone beside the box.": {
        "file": "f7a9d2a92a1f7d1f4ce5.mp3",
        "bank": "en-oo1",
        "durationMs": 3819
    },
    "The mirror worried about its appearance keeps a phone inside the box.": {
        "file": "9c52dea06b96435b036a.mp3",
        "bank": "en-oo1",
        "durationMs": 4011
    },
    "The mirror worried about its appearance keeps a dog beside the box.": {
        "file": "cf1aca0b0922731bd4d9.mp3",
        "bank": "en-oo1",
        "durationMs": 3840
    },
    "The mirror worried about its appearance keeps a dog inside the box.": {
        "file": "26c762cfe598f799125e.mp3",
        "bank": "en-oo1",
        "durationMs": 3840
    },
    "The mirror worried about its appearance keeps a box beside the box.": {
        "file": "49d6c8a65a1f15938a3e.mp3",
        "bank": "en-oo1",
        "durationMs": 3797
    },
    "The mirror worried about its appearance keeps a box inside the box.": {
        "file": "951a631373b629c410af.mp3",
        "bank": "en-oo1",
        "durationMs": 3861
    },
    "The mirror worried about its appearance keeps an egg beside the box.": {
        "file": "ee5aacd480b15adaa0a6.mp3",
        "bank": "en-oo1",
        "durationMs": 3776
    },
    "The mirror worried about its appearance keeps an egg inside the box.": {
        "file": "00cca5fd99aaae049f69.mp3",
        "bank": "en-oo1",
        "durationMs": 3819
    },
    "The mirror worried about its appearance keeps a flower beside the box.": {
        "file": "37171f2d32911b704fef.mp3",
        "bank": "en-oo1",
        "durationMs": 3883
    },
    "The mirror worried about its appearance keeps a flower inside the box.": {
        "file": "f75dbfa88c7be21cc264.mp3",
        "bank": "en-oo1",
        "durationMs": 3947
    },
    "The mirror worried about its appearance keeps a hat beside the box.": {
        "file": "55a1b51161abf91724af.mp3",
        "bank": "en-oo1",
        "durationMs": 3733
    },
    "The mirror worried about its appearance keeps a hat inside the box.": {
        "file": "1f79cf8ef5be69e0826f.mp3",
        "bank": "en-oo1",
        "durationMs": 3883
    },
    "The mirror worried about its appearance keeps a robot beside the box.": {
        "file": "9eee9cbd42a55c711c89.mp3",
        "bank": "en-oo1",
        "durationMs": 3989
    },
    "The mirror worried about its appearance keeps a robot inside the box.": {
        "file": "3e3dad587ece13d66bce.mp3",
        "bank": "en-oo1",
        "durationMs": 4053
    },
    "The mirror worried about its appearance keeps a computer beside the box.": {
        "file": "2f9a74cb043dba28ec0b.mp3",
        "bank": "en-oo1",
        "durationMs": 4053
    },
    "The mirror worried about its appearance keeps a computer inside the box.": {
        "file": "319fc3913fd0ac8e6285.mp3",
        "bank": "en-oo1",
        "durationMs": 4160
    },
    "The mirror worried about its appearance keeps a cup beside the box.": {
        "file": "a44359301f7eb078369c.mp3",
        "bank": "en-oo1",
        "durationMs": 3691
    },
    "The mirror worried about its appearance keeps a cup inside the box.": {
        "file": "309fc70acb05127964ac.mp3",
        "bank": "en-oo1",
        "durationMs": 3840
    },
    "The hat shopping for a new look displays two gifts.": {
        "file": "57c31e4bec1ea032b46a.mp3",
        "bank": "en-oo1",
        "durationMs": 2837
    },
    "The hat shopping for a new look displays two scarves.": {
        "file": "8cf8dd4cafb9a6966099.mp3",
        "bank": "en-oo1",
        "durationMs": 2923
    },
    "The hat shopping for a new look displays three gifts.": {
        "file": "825a7222ab31b7f83193.mp3",
        "bank": "en-oo1",
        "durationMs": 2901
    },
    "The hat shopping for a new look displays three scarves.": {
        "file": "a1ebdb79facaa661c1f2.mp3",
        "bank": "en-oo1",
        "durationMs": 2987
    },
    "The hat shopping for a new look displays two bags.": {
        "file": "6db2dbeca3e879a53cdf.mp3",
        "bank": "en-oo1",
        "durationMs": 2837
    },
    "The hat shopping for a new look displays two hats.": {
        "file": "5588269375e39e66ab9b.mp3",
        "bank": "en-oo1",
        "durationMs": 2773
    },
    "The hat shopping for a new look displays four bags.": {
        "file": "9e047e04acac1332b30c.mp3",
        "bank": "en-oo1",
        "durationMs": 2965
    },
    "The hat shopping for a new look displays four hats.": {
        "file": "923ccda6572dd6c7c59f.mp3",
        "bank": "en-oo1",
        "durationMs": 2944
    },
    "The hat shopping for a new look displays two socks.": {
        "file": "9fbcfcb072f71e9e8c8b.mp3",
        "bank": "en-oo1",
        "durationMs": 2880
    },
    "The hat shopping for a new look displays two shoes.": {
        "file": "ada71261ac6ab1726d67.mp3",
        "bank": "en-oo1",
        "durationMs": 2795
    },
    "The hat shopping for a new look displays three socks.": {
        "file": "ee524e4a277a23223ec7.mp3",
        "bank": "en-oo1",
        "durationMs": 2965
    },
    "The hat shopping for a new look displays three shoes.": {
        "file": "669db235bcefd26df670.mp3",
        "bank": "en-oo1",
        "durationMs": 2859
    },
    "The hat shopping for a new look displays two shirts.": {
        "file": "7f7b57b823b9ec1017a8.mp3",
        "bank": "en-oo1",
        "durationMs": 2901
    },
    "The hat shopping for a new look displays two flowers.": {
        "file": "2d43e79b490d1c5b24df.mp3",
        "bank": "en-oo1",
        "durationMs": 2923
    },
    "The hat shopping for a new look displays four shirts.": {
        "file": "1daa878451f5c7814bde.mp3",
        "bank": "en-oo1",
        "durationMs": 2944
    },
    "The hat shopping for a new look displays four flowers.": {
        "file": "66b2fb4c62c3d87d88a0.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "The hat shopping for a new look displays two jackets.": {
        "file": "c2495f6281dd949de630.mp3",
        "bank": "en-oo1",
        "durationMs": 2987
    },
    "The hat shopping for a new look displays two ties.": {
        "file": "37d7493bf7e0a00fc264.mp3",
        "bank": "en-oo1",
        "durationMs": 2859
    },
    "The hat shopping for a new look displays three jackets.": {
        "file": "80e26b34714f7b07e9b9.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The hat shopping for a new look displays three ties.": {
        "file": "1609d02b8bfd41285c18.mp3",
        "bank": "en-oo1",
        "durationMs": 2944
    },
    "The cloud getting ready for a date is wearing a large hat and holding a ticket.": {
        "file": "0696d3a209f5a0009812.mp3",
        "bank": "en-oo1",
        "durationMs": 4480
    },
    "The cloud getting ready for a date is wearing a large hat and holding a picture.": {
        "file": "1c9cf94db42b2ee917c3.mp3",
        "bank": "en-oo1",
        "durationMs": 4565
    },
    "The cloud getting ready for a date is wearing a small hat and holding a ticket.": {
        "file": "c970b294e5b0a92220c8.mp3",
        "bank": "en-oo1",
        "durationMs": 4395
    },
    "The cloud getting ready for a date is wearing a small hat and holding a picture.": {
        "file": "6c59cab2e387dcafc8b9.mp3",
        "bank": "en-oo1",
        "durationMs": 4480
    },
    "The cloud getting ready for a date is wearing a long scarf and holding a computer.": {
        "file": "416ddaf5f1c305717d8c.mp3",
        "bank": "en-oo1",
        "durationMs": 4715
    },
    "The cloud getting ready for a date is wearing a long scarf and holding a box.": {
        "file": "12f4c3f1651cf355bd99.mp3",
        "bank": "en-oo1",
        "durationMs": 4544
    },
    "The cloud getting ready for a date is wearing a short scarf and holding a computer.": {
        "file": "89098f7d44c234f3efe3.mp3",
        "bank": "en-oo1",
        "durationMs": 4715
    },
    "The cloud getting ready for a date is wearing a short scarf and holding a box.": {
        "file": "1da4dd934bcc82da194f.mp3",
        "bank": "en-oo1",
        "durationMs": 4544
    },
    "The cloud getting ready for a date is wearing round glasses and holding a fish.": {
        "file": "548d159b8240da166db5.mp3",
        "bank": "en-oo1",
        "durationMs": 4373
    },
    "The cloud getting ready for a date is wearing round glasses and holding a bottle.": {
        "file": "dfff096af569988c02b7.mp3",
        "bank": "en-oo1",
        "durationMs": 4459
    },
    "The cloud getting ready for a date is wearing square glasses and holding a fish.": {
        "file": "431a2a50be787c1201df.mp3",
        "bank": "en-oo1",
        "durationMs": 4416
    },
    "The cloud getting ready for a date is wearing square glasses and holding a bottle.": {
        "file": "878344edd4eb3e9eeb8e.mp3",
        "bank": "en-oo1",
        "durationMs": 4523
    },
    "The cloud getting ready for a date is wearing a jacket with two pockets and holding a glass.": {
        "file": "a862f35d770307663c58.mp3",
        "bank": "en-oo1",
        "durationMs": 5248
    },
    "The cloud getting ready for a date is wearing a jacket with two pockets and holding a phone.": {
        "file": "69025a5a2c983e8ae08d.mp3",
        "bank": "en-oo1",
        "durationMs": 5205
    },
    "The cloud getting ready for a date is wearing a jacket with four pockets and holding a glass.": {
        "file": "a98816ccfdd9bad9160b.mp3",
        "bank": "en-oo1",
        "durationMs": 5355
    },
    "The cloud getting ready for a date is wearing a jacket with four pockets and holding a phone.": {
        "file": "960498eddb9effeab43d.mp3",
        "bank": "en-oo1",
        "durationMs": 5269
    },
    "The cloud getting ready for a date is wearing a shirt with long sleeves and holding a gift.": {
        "file": "8aa056ebc21a2360ef1d.mp3",
        "bank": "en-oo1",
        "durationMs": 5120
    },
    "The cloud getting ready for a date is wearing a shirt with long sleeves and holding an apple.": {
        "file": "4af103704e6ae7159a75.mp3",
        "bank": "en-oo1",
        "durationMs": 5120
    },
    "The cloud getting ready for a date is wearing a shirt with short sleeves and holding a gift.": {
        "file": "57f733ada62ebc614426.mp3",
        "bank": "en-oo1",
        "durationMs": 5056
    },
    "The cloud getting ready for a date is wearing a shirt with short sleeves and holding an apple.": {
        "file": "b87f00c9d47092ff9e6e.mp3",
        "bank": "en-oo1",
        "durationMs": 5077
    },
    "The suitcase choosing what to wear puts a hat beside the bed.": {
        "file": "5aabbbd8e6fdb89eb7d8.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The suitcase choosing what to wear puts a hat under the bed.": {
        "file": "fbc3b0eded2022cdc15d.mp3",
        "bank": "en-oo1",
        "durationMs": 3093
    },
    "The suitcase choosing what to wear puts a magazine beside the bed.": {
        "file": "af469f76a57102911f50.mp3",
        "bank": "en-oo1",
        "durationMs": 3627
    },
    "The suitcase choosing what to wear puts a magazine under the bed.": {
        "file": "a919bcdc3986fcce332b.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The suitcase choosing what to wear puts a glass beside the bed.": {
        "file": "9b096c091ac3d4e3ea73.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The suitcase choosing what to wear puts a glass under the bed.": {
        "file": "cdab65059081e62751bf.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The suitcase choosing what to wear puts a box beside the bed.": {
        "file": "697c7830055a1d8073b9.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The suitcase choosing what to wear puts a box under the bed.": {
        "file": "daee9cf4daed2f95009a.mp3",
        "bank": "en-oo1",
        "durationMs": 3200
    },
    "The suitcase choosing what to wear puts a bag beside the bed.": {
        "file": "3ee59530f35c3ededf59.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The suitcase choosing what to wear puts a bag under the bed.": {
        "file": "c7df04f76d4ecec47f5a.mp3",
        "bank": "en-oo1",
        "durationMs": 3115
    },
    "The suitcase choosing what to wear puts a coin beside the bed.": {
        "file": "8bea82bc05b805f64792.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The suitcase choosing what to wear puts a coin under the bed.": {
        "file": "2a1f4beb00922b7c69e5.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The suitcase choosing what to wear puts a computer beside the bed.": {
        "file": "eec072574f37ef0d2a0a.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The suitcase choosing what to wear puts a computer under the bed.": {
        "file": "0cf1d9ac33b1abeec08a.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The suitcase choosing what to wear puts a gift beside the bed.": {
        "file": "1a82924788c7158af33e.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The suitcase choosing what to wear puts a gift under the bed.": {
        "file": "1eb8ad8751206639034b.mp3",
        "bank": "en-oo1",
        "durationMs": 3179
    },
    "The suitcase choosing what to wear puts a bottle beside the bed.": {
        "file": "2487dbf9e021de81443e.mp3",
        "bank": "en-oo1",
        "durationMs": 3435
    },
    "The suitcase choosing what to wear puts a bottle under the bed.": {
        "file": "6424f653a8c223148138.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The suitcase choosing what to wear puts a fish beside the bed.": {
        "file": "c792a1bb2a047842dbbb.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The suitcase choosing what to wear puts a fish under the bed.": {
        "file": "1fc425e6fcdd0dfe165e.mp3",
        "bank": "en-oo1",
        "durationMs": 3136
    },
    "The front door dressing for a party chooses a large computer.": {
        "file": "61e44a2a86a6a1678ec2.mp3",
        "bank": "en-oo1",
        "durationMs": 3541
    },
    "The front door dressing for a party chooses a large glass.": {
        "file": "11675f3270efb46e444b.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The front door dressing for a party chooses a small computer.": {
        "file": "15cd758e53907f3bd7c2.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The front door dressing for a party chooses a small glass.": {
        "file": "870f2c8532695c6defdc.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The front door dressing for a party chooses a large gift.": {
        "file": "aa2e62900593535fd7af.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The front door dressing for a party chooses a large cup.": {
        "file": "6728b78355a98072aaa6.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    },
    "The front door dressing for a party chooses a small gift.": {
        "file": "42e1af3723f020c8ebd4.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The front door dressing for a party chooses a small cup.": {
        "file": "648700dd4c0ec63d45d1.mp3",
        "bank": "en-oo1",
        "durationMs": 3264
    },
    "The front door dressing for a party chooses a large fish.": {
        "file": "f911a125f2e7bc61667b.mp3",
        "bank": "en-oo1",
        "durationMs": 3392
    },
    "The front door dressing for a party chooses a large hat.": {
        "file": "de73f156947e8fa2dbb5.mp3",
        "bank": "en-oo1",
        "durationMs": 3371
    },
    "The front door dressing for a party chooses a small fish.": {
        "file": "1b1dd44f9ccdfb42ff06.mp3",
        "bank": "en-oo1",
        "durationMs": 3243
    },
    "The front door dressing for a party chooses a small hat.": {
        "file": "3fda0c04089d4507c495.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The front door dressing for a party chooses a large box.": {
        "file": "d5d719ad0eaa51eeecd1.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The front door dressing for a party chooses a large shoe.": {
        "file": "9cf6a30ce3cbdf9c81f3.mp3",
        "bank": "en-oo1",
        "durationMs": 3307
    },
    "The front door dressing for a party chooses a small box.": {
        "file": "3f88945840ebbcfa355e.mp3",
        "bank": "en-oo1",
        "durationMs": 3285
    },
    "The front door dressing for a party chooses a small shoe.": {
        "file": "aee3b7bdf8848df2347a.mp3",
        "bank": "en-oo1",
        "durationMs": 3221
    },
    "The front door dressing for a party chooses a large picture.": {
        "file": "6d61209a443dd651fafc.mp3",
        "bank": "en-oo1",
        "durationMs": 3499
    },
    "The front door dressing for a party chooses a large bottle.": {
        "file": "d42ce50beb4c020e951b.mp3",
        "bank": "en-oo1",
        "durationMs": 3456
    },
    "The front door dressing for a party chooses a small picture.": {
        "file": "214e3119b07fda2ba314.mp3",
        "bank": "en-oo1",
        "durationMs": 3349
    },
    "The front door dressing for a party chooses a small bottle.": {
        "file": "9329531147501e78af41.mp3",
        "bank": "en-oo1",
        "durationMs": 3328
    }
};
//# sourceMappingURL=ordinary-recordings.js.map